import * as __compactRuntime from '@midnight-ntwrk/compact-runtime-0.20';
__compactRuntime.checkRuntimeVersion('0.20.0');

const _descriptor_0 = new __compactRuntime.CompactTypeBytes(32);

class _ContractAddress_0 {
  alignment() {
    return _descriptor_0.alignment();
  }
  fromValue(value_0) {
    return {
      bytes: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0.bytes);
  }
}

const _descriptor_1 = new _ContractAddress_0();

class _AffinePoint_0 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment());
  }
  fromValue(value_0) {
    return {
      x: _descriptor_0.fromValue(value_0),
      y: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0.x).concat(_descriptor_0.toValue(value_0.y));
  }
}

const _descriptor_2 = new _AffinePoint_0();

const _descriptor_3 = new __compactRuntime.CompactTypeUnsignedInteger(255n, 1);

class _Signature_0 {
  alignment() {
    return _descriptor_2.alignment().concat(_descriptor_0.alignment().concat(_descriptor_3.alignment()));
  }
  fromValue(value_0) {
    return {
      bigR: _descriptor_2.fromValue(value_0),
      s: _descriptor_0.fromValue(value_0),
      recoveryId: _descriptor_3.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_2.toValue(value_0.bigR).concat(_descriptor_0.toValue(value_0.s).concat(_descriptor_3.toValue(value_0.recoveryId)));
  }
}

const _descriptor_4 = new _Signature_0();

class _RespondBidirectionalEvent_0 {
  alignment() {
    return _descriptor_4.alignment();
  }
  fromValue(value_0) {
    return {
      signature: _descriptor_4.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_4.toValue(value_0.signature);
  }
}

const _descriptor_5 = new _RespondBidirectionalEvent_0();

const _descriptor_6 = new __compactRuntime.CompactTypeBytes(5);

const _descriptor_7 = new __compactRuntime.CompactTypeBytes(192);

const _descriptor_8 = new __compactRuntime.CompactTypeUnsignedInteger(340282366920938463463374607431768211455n, 16);

class _ShieldedCoinInfo_0 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment()));
  }
  fromValue(value_0) {
    return {
      nonce: _descriptor_0.fromValue(value_0),
      color: _descriptor_0.fromValue(value_0),
      value: _descriptor_8.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0.nonce).concat(_descriptor_0.toValue(value_0.color).concat(_descriptor_8.toValue(value_0.value)));
  }
}

const _descriptor_9 = new _ShieldedCoinInfo_0();

const _descriptor_10 = new __compactRuntime.CompactTypeUnsignedInteger(18446744073709551615n, 8);

const _descriptor_11 = new __compactRuntime.CompactTypeBytes(20);

const _descriptor_12 = __compactRuntime.CompactTypeSecp256k1Point;

const _descriptor_13 = __compactRuntime.CompactTypeSecp256k1Scalar;

class _Secp256k1EcdsaSignature_0 {
  alignment() {
    return _descriptor_13.alignment().concat(_descriptor_13.alignment());
  }
  fromValue(value_0) {
    return {
      r: _descriptor_13.fromValue(value_0),
      s: _descriptor_13.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_13.toValue(value_0.r).concat(_descriptor_13.toValue(value_0.s));
  }
}

const _descriptor_14 = new _Secp256k1EcdsaSignature_0();

const _descriptor_15 = __compactRuntime.CompactTypeBoolean;

class _Maybe_0 {
  alignment() {
    return _descriptor_15.alignment().concat(_descriptor_9.alignment());
  }
  fromValue(value_0) {
    return {
      is_some: _descriptor_15.fromValue(value_0),
      value: _descriptor_9.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_15.toValue(value_0.is_some).concat(_descriptor_9.toValue(value_0.value));
  }
}

const _descriptor_16 = new _Maybe_0();

const _descriptor_17 = new __compactRuntime.CompactTypeBytes(1);

const _descriptor_18 = __compactRuntime.CompactTypeCurve25519Point;

const _descriptor_19 = __compactRuntime.CompactTypeCurve25519Scalar;

class _Ed25519Signature_0 {
  alignment() {
    return _descriptor_18.alignment().concat(_descriptor_19.alignment());
  }
  fromValue(value_0) {
    return {
      r: _descriptor_18.fromValue(value_0),
      s: _descriptor_19.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_18.toValue(value_0.r).concat(_descriptor_19.toValue(value_0.s));
  }
}

const _descriptor_20 = new _Ed25519Signature_0();

const _descriptor_21 = new __compactRuntime.CompactTypeVector(24, _descriptor_3);

const _descriptor_22 = new __compactRuntime.CompactTypeVector(20, _descriptor_3);

class _EdShow_0 {
  alignment() {
    return _descriptor_21.alignment().concat(_descriptor_22.alignment());
  }
  fromValue(value_0) {
    return {
      label: _descriptor_21.fromValue(value_0),
      nonce: _descriptor_22.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_21.toValue(value_0.label).concat(_descriptor_22.toValue(value_0.nonce));
  }
}

const _descriptor_23 = new _EdShow_0();

const _descriptor_24 = new __compactRuntime.CompactTypeVector(34, _descriptor_3);

class _EdAmount_0 {
  alignment() {
    return _descriptor_21.alignment().concat(_descriptor_24.alignment());
  }
  fromValue(value_0) {
    return {
      units: _descriptor_21.fromValue(value_0),
      site: _descriptor_24.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_21.toValue(value_0.units).concat(_descriptor_24.toValue(value_0.site));
  }
}

const _descriptor_25 = new _EdAmount_0();

const _descriptor_26 = new __compactRuntime.CompactTypeVector(14, _descriptor_3);

const _descriptor_27 = new __compactRuntime.CompactTypeUnsignedInteger(65535n, 2);

class _EdDeadline_0 {
  alignment() {
    return _descriptor_26.alignment().concat(_descriptor_27.alignment().concat(_descriptor_27.alignment().concat(_descriptor_27.alignment())));
  }
  fromValue(value_0) {
    return {
      digits: _descriptor_26.fromValue(value_0),
      q4: _descriptor_27.fromValue(value_0),
      q100: _descriptor_27.fromValue(value_0),
      q400: _descriptor_27.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_26.toValue(value_0.digits).concat(_descriptor_27.toValue(value_0.q4).concat(_descriptor_27.toValue(value_0.q100).concat(_descriptor_27.toValue(value_0.q400))));
  }
}

const _descriptor_28 = new _EdDeadline_0();

class _EdShowSwap_0 {
  alignment() {
    return _descriptor_21.alignment().concat(_descriptor_22.alignment().concat(_descriptor_25.alignment().concat(_descriptor_25.alignment().concat(_descriptor_28.alignment()))));
  }
  fromValue(value_0) {
    return {
      label: _descriptor_21.fromValue(value_0),
      nonce: _descriptor_22.fromValue(value_0),
      give: _descriptor_25.fromValue(value_0),
      want: _descriptor_25.fromValue(value_0),
      until: _descriptor_28.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_21.toValue(value_0.label).concat(_descriptor_22.toValue(value_0.nonce).concat(_descriptor_25.toValue(value_0.give).concat(_descriptor_25.toValue(value_0.want).concat(_descriptor_28.toValue(value_0.until)))));
  }
}

const _descriptor_29 = new _EdShowSwap_0();

class _ZswapCoinPublicKey_0 {
  alignment() {
    return _descriptor_0.alignment();
  }
  fromValue(value_0) {
    return {
      bytes: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0.bytes);
  }
}

const _descriptor_30 = new _ZswapCoinPublicKey_0();

class _EdShowAmount_0 {
  alignment() {
    return _descriptor_21.alignment().concat(_descriptor_22.alignment().concat(_descriptor_25.alignment()));
  }
  fromValue(value_0) {
    return {
      label: _descriptor_21.fromValue(value_0),
      nonce: _descriptor_22.fromValue(value_0),
      amount: _descriptor_25.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_21.toValue(value_0.label).concat(_descriptor_22.toValue(value_0.nonce).concat(_descriptor_25.toValue(value_0.amount)));
  }
}

const _descriptor_31 = new _EdShowAmount_0();

class _tuple_0 {
  alignment() {
    return _descriptor_9.alignment().concat(_descriptor_16.alignment());
  }
  fromValue(value_0) {
    return [
      _descriptor_9.fromValue(value_0),
      _descriptor_16.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_9.toValue(value_0[0]).concat(_descriptor_16.toValue(value_0[1]));
  }
}

const _descriptor_32 = new _tuple_0();

class _UserAddress_0 {
  alignment() {
    return _descriptor_0.alignment();
  }
  fromValue(value_0) {
    return {
      bytes: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0.bytes);
  }
}

const _descriptor_33 = new _UserAddress_0();

const _descriptor_34 = new __compactRuntime.CompactTypeUnsignedInteger(4294967295n, 4);

const _descriptor_35 = new __compactRuntime.CompactTypeBytes(202);

const _descriptor_36 = new __compactRuntime.CompactTypeBytes(564);

const _descriptor_37 = new __compactRuntime.CompactTypeBytes(359);

const _descriptor_38 = new __compactRuntime.CompactTypeBytes(367);

const _descriptor_39 = new __compactRuntime.CompactTypeBytes(365);

const _descriptor_40 = new __compactRuntime.CompactTypeVector(123, _descriptor_3);

const _descriptor_41 = new __compactRuntime.CompactTypeVector(163, _descriptor_3);

const _descriptor_42 = new __compactRuntime.CompactTypeVector(30, _descriptor_3);

const _descriptor_43 = new __compactRuntime.CompactTypeVector(64, _descriptor_3);

const _descriptor_44 = new __compactRuntime.CompactTypeVector(23, _descriptor_3);

const _descriptor_45 = new __compactRuntime.CompactTypeVector(16, _descriptor_3);

class _tuple_1 {
  alignment() {
    return _descriptor_3.alignment().concat(_descriptor_3.alignment());
  }
  fromValue(value_0) {
    return [
      _descriptor_3.fromValue(value_0),
      _descriptor_3.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_3.toValue(value_0[0]).concat(_descriptor_3.toValue(value_0[1]));
  }
}

const _descriptor_46 = new _tuple_1();

const _descriptor_47 = __compactRuntime.CompactTypeField;

class _QualifiedShieldedCoinInfo_0 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_10.alignment())));
  }
  fromValue(value_0) {
    return {
      nonce: _descriptor_0.fromValue(value_0),
      color: _descriptor_0.fromValue(value_0),
      value: _descriptor_8.fromValue(value_0),
      mt_index: _descriptor_10.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0.nonce).concat(_descriptor_0.toValue(value_0.color).concat(_descriptor_8.toValue(value_0.value).concat(_descriptor_10.toValue(value_0.mt_index))));
  }
}

const _descriptor_48 = new _QualifiedShieldedCoinInfo_0();

const _descriptor_49 = __compactRuntime.CompactTypeJubjubPoint;

class _Either_0 {
  alignment() {
    return _descriptor_15.alignment().concat(_descriptor_30.alignment().concat(_descriptor_1.alignment()));
  }
  fromValue(value_0) {
    return {
      is_left: _descriptor_15.fromValue(value_0),
      left: _descriptor_30.fromValue(value_0),
      right: _descriptor_1.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_15.toValue(value_0.is_left).concat(_descriptor_30.toValue(value_0.left).concat(_descriptor_1.toValue(value_0.right)));
  }
}

const _descriptor_50 = new _Either_0();

const _descriptor_51 = __compactRuntime.CompactTypeCurve25519Base;

const _descriptor_52 = __compactRuntime.CompactTypeSecp256k1Base;

class _tuple_2 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_36.alignment()));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_36.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]).concat(_descriptor_36.toValue(value_0[2])));
  }
}

const _descriptor_53 = new _tuple_2();

const _descriptor_54 = new __compactRuntime.CompactTypeBytes(64);

class _tuple_3 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_38.alignment()));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_38.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]).concat(_descriptor_38.toValue(value_0[2])));
  }
}

const _descriptor_55 = new _tuple_3();

class _tuple_4 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_35.alignment()));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_35.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]).concat(_descriptor_35.toValue(value_0[2])));
  }
}

const _descriptor_56 = new _tuple_4();

class _tuple_5 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_7.alignment()));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_7.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]).concat(_descriptor_7.toValue(value_0[2])));
  }
}

const _descriptor_57 = new _tuple_5();

class _tuple_6 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_37.alignment()));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_37.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]).concat(_descriptor_37.toValue(value_0[2])));
  }
}

const _descriptor_58 = new _tuple_6();

class _tuple_7 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_39.alignment()));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_39.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]).concat(_descriptor_39.toValue(value_0[2])));
  }
}

const _descriptor_59 = new _tuple_7();

const _descriptor_60 = __compactRuntime.CompactTypeJubjubScalar;

const _descriptor_61 = new __compactRuntime.CompactTypeBytes(416);

const _descriptor_62 = new __compactRuntime.CompactTypeBytes(66);

const _descriptor_63 = new __compactRuntime.CompactTypeBytes(384);

const _descriptor_64 = new __compactRuntime.CompactTypeBytes(160);

const _descriptor_65 = new __compactRuntime.CompactTypeBytes(256);

const _descriptor_66 = new __compactRuntime.CompactTypeVector(32, _descriptor_3);

class _tuple_8 {
  alignment() {
    return _descriptor_66.alignment().concat(_descriptor_66.alignment());
  }
  fromValue(value_0) {
    return [
      _descriptor_66.fromValue(value_0),
      _descriptor_66.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_66.toValue(value_0[0]).concat(_descriptor_66.toValue(value_0[1]));
  }
}

const _descriptor_67 = new _tuple_8();

const _descriptor_68 = new __compactRuntime.CompactTypeBytes(21);

class _CoinPreimage_0 {
  alignment() {
    return _descriptor_68.alignment().concat(_descriptor_9.alignment().concat(_descriptor_15.alignment().concat(_descriptor_0.alignment())));
  }
  fromValue(value_0) {
    return {
      domain_sep: _descriptor_68.fromValue(value_0),
      info: _descriptor_9.fromValue(value_0),
      dataType: _descriptor_15.fromValue(value_0),
      data: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_68.toValue(value_0.domain_sep).concat(_descriptor_9.toValue(value_0.info).concat(_descriptor_15.toValue(value_0.dataType).concat(_descriptor_0.toValue(value_0.data))));
  }
}

const _descriptor_69 = new _CoinPreimage_0();

class _SwapCoinPreimage_0 {
  alignment() {
    return _descriptor_68.alignment().concat(_descriptor_9.alignment().concat(_descriptor_15.alignment().concat(_descriptor_0.alignment())));
  }
  fromValue(value_0) {
    return {
      domain_sep: _descriptor_68.fromValue(value_0),
      info: _descriptor_9.fromValue(value_0),
      dataType: _descriptor_15.fromValue(value_0),
      data: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_68.toValue(value_0.domain_sep).concat(_descriptor_9.toValue(value_0.info).concat(_descriptor_15.toValue(value_0.dataType).concat(_descriptor_0.toValue(value_0.data))));
  }
}

const _descriptor_70 = new _SwapCoinPreimage_0();

class _tuple_9 {
  alignment() {
    return _descriptor_54.alignment();
  }
  fromValue(value_0) {
    return [
      _descriptor_54.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_54.toValue(value_0[0]);
  }
}

const _descriptor_71 = new _tuple_9();

class _tuple_10 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_18.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_3.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_7.alignment().concat(_descriptor_7.alignment().concat(_descriptor_10.alignment().concat(_descriptor_48.alignment().concat(_descriptor_10.alignment())))))))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_18.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_3.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_48.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_18.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_8.toValue(value_0[5]).concat(_descriptor_3.toValue(value_0[6]).concat(_descriptor_0.toValue(value_0[7]).concat(_descriptor_9.toValue(value_0[8]).concat(_descriptor_7.toValue(value_0[9]).concat(_descriptor_7.toValue(value_0[10]).concat(_descriptor_10.toValue(value_0[11]).concat(_descriptor_48.toValue(value_0[12]).concat(_descriptor_10.toValue(value_0[13]))))))))))))));
  }
}

const _descriptor_72 = new _tuple_10();

class _tuple_11 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_18.alignment().concat(_descriptor_0.alignment().concat(_descriptor_7.alignment().concat(_descriptor_10.alignment())))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_18.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_18.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_7.toValue(value_0[4]).concat(_descriptor_10.toValue(value_0[5]))))));
  }
}

const _descriptor_73 = new _tuple_11();

class _tuple_12 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_18.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_10.alignment())))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_18.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_18.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_10.toValue(value_0[5]))))));
  }
}

const _descriptor_74 = new _tuple_12();

class _tuple_13 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_18.alignment().concat(_descriptor_0.alignment().concat(_descriptor_30.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_48.alignment().concat(_descriptor_10.alignment()))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_18.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_30.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_48.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_18.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_30.toValue(value_0[4]).concat(_descriptor_0.toValue(value_0[5]).concat(_descriptor_8.toValue(value_0[6]).concat(_descriptor_48.toValue(value_0[7]).concat(_descriptor_10.toValue(value_0[8])))))))));
  }
}

const _descriptor_75 = new _tuple_13();

class _tuple_14 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_18.alignment().concat(_descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_48.alignment().concat(_descriptor_10.alignment()))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_18.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_48.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_18.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_1.toValue(value_0[4]).concat(_descriptor_0.toValue(value_0[5]).concat(_descriptor_8.toValue(value_0[6]).concat(_descriptor_48.toValue(value_0[7]).concat(_descriptor_10.toValue(value_0[8])))))))));
  }
}

const _descriptor_76 = new _tuple_14();

class _tuple_15 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_18.alignment().concat(_descriptor_34.alignment().concat(_descriptor_10.alignment()))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_18.fromValue(value_0),
      _descriptor_34.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_18.toValue(value_0[2]).concat(_descriptor_34.toValue(value_0[3]).concat(_descriptor_10.toValue(value_0[4])))));
  }
}

const _descriptor_77 = new _tuple_15();

class _tuple_16 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_18.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_33.alignment().concat(_descriptor_10.alignment())))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_18.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_33.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_18.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_8.toValue(value_0[5]).concat(_descriptor_33.toValue(value_0[6]).concat(_descriptor_10.toValue(value_0[7]))))))));
  }
}

const _descriptor_78 = new _tuple_16();

class _tuple_17 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_11.alignment().concat(_descriptor_11.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_10.alignment().concat(_descriptor_10.alignment().concat(_descriptor_8.alignment().concat(_descriptor_8.alignment().concat(_descriptor_3.alignment().concat(_descriptor_11.alignment().concat(_descriptor_48.alignment().concat(_descriptor_10.alignment())))))))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_11.fromValue(value_0),
      _descriptor_11.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_3.fromValue(value_0),
      _descriptor_11.fromValue(value_0),
      _descriptor_48.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_11.toValue(value_0[2]).concat(_descriptor_11.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_8.toValue(value_0[5]).concat(_descriptor_10.toValue(value_0[6]).concat(_descriptor_10.toValue(value_0[7]).concat(_descriptor_8.toValue(value_0[8]).concat(_descriptor_8.toValue(value_0[9]).concat(_descriptor_3.toValue(value_0[10]).concat(_descriptor_11.toValue(value_0[11]).concat(_descriptor_48.toValue(value_0[12]).concat(_descriptor_10.toValue(value_0[13]))))))))))))));
  }
}

const _descriptor_79 = new _tuple_17();

class _tuple_18 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_18.alignment()));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_18.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]).concat(_descriptor_18.toValue(value_0[2])));
  }
}

const _descriptor_80 = new _tuple_18();

class _tuple_19 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_11.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_3.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_7.alignment().concat(_descriptor_7.alignment().concat(_descriptor_10.alignment().concat(_descriptor_48.alignment().concat(_descriptor_10.alignment()))))))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_11.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_3.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_48.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_11.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_8.toValue(value_0[4]).concat(_descriptor_3.toValue(value_0[5]).concat(_descriptor_0.toValue(value_0[6]).concat(_descriptor_9.toValue(value_0[7]).concat(_descriptor_7.toValue(value_0[8]).concat(_descriptor_7.toValue(value_0[9]).concat(_descriptor_10.toValue(value_0[10]).concat(_descriptor_48.toValue(value_0[11]).concat(_descriptor_10.toValue(value_0[12])))))))))))));
  }
}

const _descriptor_81 = new _tuple_19();

class _tuple_20 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_11.alignment().concat(_descriptor_11.alignment().concat(_descriptor_8.alignment().concat(_descriptor_10.alignment().concat(_descriptor_10.alignment().concat(_descriptor_8.alignment().concat(_descriptor_8.alignment().concat(_descriptor_3.alignment().concat(_descriptor_10.alignment()))))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_11.fromValue(value_0),
      _descriptor_11.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_3.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_11.toValue(value_0[2]).concat(_descriptor_11.toValue(value_0[3]).concat(_descriptor_8.toValue(value_0[4]).concat(_descriptor_10.toValue(value_0[5]).concat(_descriptor_10.toValue(value_0[6]).concat(_descriptor_8.toValue(value_0[7]).concat(_descriptor_8.toValue(value_0[8]).concat(_descriptor_3.toValue(value_0[9]).concat(_descriptor_10.toValue(value_0[10])))))))))));
  }
}

const _descriptor_82 = new _tuple_20();

class _tuple_21 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_11.alignment().concat(_descriptor_7.alignment().concat(_descriptor_10.alignment()))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_11.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_11.toValue(value_0[2]).concat(_descriptor_7.toValue(value_0[3]).concat(_descriptor_10.toValue(value_0[4])))));
  }
}

const _descriptor_83 = new _tuple_21();

class _tuple_22 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_11.alignment().concat(_descriptor_0.alignment().concat(_descriptor_10.alignment()))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_11.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_11.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_10.toValue(value_0[4])))));
  }
}

const _descriptor_84 = new _tuple_22();

class _tuple_23 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_11.alignment().concat(_descriptor_30.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_48.alignment().concat(_descriptor_10.alignment())))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_11.fromValue(value_0),
      _descriptor_30.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_48.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_11.toValue(value_0[2]).concat(_descriptor_30.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_8.toValue(value_0[5]).concat(_descriptor_48.toValue(value_0[6]).concat(_descriptor_10.toValue(value_0[7]))))))));
  }
}

const _descriptor_85 = new _tuple_23();

class _tuple_24 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_11.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_48.alignment().concat(_descriptor_10.alignment())))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_11.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_48.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_11.toValue(value_0[2]).concat(_descriptor_1.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_8.toValue(value_0[5]).concat(_descriptor_48.toValue(value_0[6]).concat(_descriptor_10.toValue(value_0[7]))))))));
  }
}

const _descriptor_86 = new _tuple_24();

class _tuple_25 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_10.alignment())))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_10.toValue(value_0[5]))))));
  }
}

const _descriptor_87 = new _tuple_25();

class _tuple_26 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_11.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_33.alignment().concat(_descriptor_10.alignment()))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_11.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_33.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_11.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_8.toValue(value_0[4]).concat(_descriptor_33.toValue(value_0[5]).concat(_descriptor_10.toValue(value_0[6])))))));
  }
}

const _descriptor_88 = new _tuple_26();

class _tuple_27 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_48.alignment().concat(_descriptor_10.alignment()))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_48.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_1.toValue(value_0[4]).concat(_descriptor_0.toValue(value_0[5]).concat(_descriptor_8.toValue(value_0[6]).concat(_descriptor_48.toValue(value_0[7]).concat(_descriptor_10.toValue(value_0[8])))))))));
  }
}

const _descriptor_89 = new _tuple_27();

class _tuple_28 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_7.alignment().concat(_descriptor_10.alignment())))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_7.toValue(value_0[4]).concat(_descriptor_10.toValue(value_0[5]))))));
  }
}

const _descriptor_90 = new _tuple_28();

class _tuple_29 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_33.alignment().concat(_descriptor_10.alignment())))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_33.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_8.toValue(value_0[5]).concat(_descriptor_33.toValue(value_0[6]).concat(_descriptor_10.toValue(value_0[7]))))))));
  }
}

const _descriptor_91 = new _tuple_29();

class _tuple_30 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_30.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_48.alignment().concat(_descriptor_10.alignment()))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_30.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_48.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_30.toValue(value_0[4]).concat(_descriptor_0.toValue(value_0[5]).concat(_descriptor_8.toValue(value_0[6]).concat(_descriptor_48.toValue(value_0[7]).concat(_descriptor_10.toValue(value_0[8])))))))));
  }
}

const _descriptor_92 = new _tuple_30();

class _tuple_31 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_49.alignment().concat(_descriptor_49.alignment().concat(_descriptor_0.alignment().concat(_descriptor_10.alignment().concat(_descriptor_10.alignment()))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_49.fromValue(value_0),
      _descriptor_49.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_49.toValue(value_0[2]).concat(_descriptor_49.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_10.toValue(value_0[5]).concat(_descriptor_10.toValue(value_0[6])))))));
  }
}

const _descriptor_93 = new _tuple_31();

class _tuple_32 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_49.alignment().concat(_descriptor_49.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_3.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_7.alignment().concat(_descriptor_7.alignment().concat(_descriptor_10.alignment().concat(_descriptor_48.alignment().concat(_descriptor_10.alignment().concat(_descriptor_10.alignment()))))))))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_49.fromValue(value_0),
      _descriptor_49.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_3.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_9.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_48.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_49.toValue(value_0[2]).concat(_descriptor_49.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_8.toValue(value_0[5]).concat(_descriptor_3.toValue(value_0[6]).concat(_descriptor_0.toValue(value_0[7]).concat(_descriptor_9.toValue(value_0[8]).concat(_descriptor_7.toValue(value_0[9]).concat(_descriptor_7.toValue(value_0[10]).concat(_descriptor_10.toValue(value_0[11]).concat(_descriptor_48.toValue(value_0[12]).concat(_descriptor_10.toValue(value_0[13]).concat(_descriptor_10.toValue(value_0[14])))))))))))))));
  }
}

const _descriptor_94 = new _tuple_32();

class _tuple_33 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_49.alignment().concat(_descriptor_49.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_48.alignment().concat(_descriptor_10.alignment().concat(_descriptor_10.alignment())))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_49.fromValue(value_0),
      _descriptor_49.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_48.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_49.toValue(value_0[2]).concat(_descriptor_49.toValue(value_0[3]).concat(_descriptor_1.toValue(value_0[4]).concat(_descriptor_0.toValue(value_0[5]).concat(_descriptor_8.toValue(value_0[6]).concat(_descriptor_48.toValue(value_0[7]).concat(_descriptor_10.toValue(value_0[8]).concat(_descriptor_10.toValue(value_0[9]))))))))));
  }
}

const _descriptor_95 = new _tuple_33();

class _tuple_34 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_49.alignment().concat(_descriptor_49.alignment().concat(_descriptor_7.alignment().concat(_descriptor_10.alignment().concat(_descriptor_10.alignment()))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_49.fromValue(value_0),
      _descriptor_49.fromValue(value_0),
      _descriptor_7.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_49.toValue(value_0[2]).concat(_descriptor_49.toValue(value_0[3]).concat(_descriptor_7.toValue(value_0[4]).concat(_descriptor_10.toValue(value_0[5]).concat(_descriptor_10.toValue(value_0[6])))))));
  }
}

const _descriptor_96 = new _tuple_34();

class _tuple_35 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_49.alignment().concat(_descriptor_49.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_33.alignment().concat(_descriptor_10.alignment().concat(_descriptor_10.alignment()))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_49.fromValue(value_0),
      _descriptor_49.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_33.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_49.toValue(value_0[2]).concat(_descriptor_49.toValue(value_0[3]).concat(_descriptor_0.toValue(value_0[4]).concat(_descriptor_8.toValue(value_0[5]).concat(_descriptor_33.toValue(value_0[6]).concat(_descriptor_10.toValue(value_0[7]).concat(_descriptor_10.toValue(value_0[8])))))))));
  }
}

const _descriptor_97 = new _tuple_35();

class _tuple_36 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_49.alignment().concat(_descriptor_49.alignment().concat(_descriptor_30.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_48.alignment().concat(_descriptor_10.alignment().concat(_descriptor_10.alignment())))))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_49.fromValue(value_0),
      _descriptor_49.fromValue(value_0),
      _descriptor_30.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_8.fromValue(value_0),
      _descriptor_48.fromValue(value_0),
      _descriptor_10.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_49.toValue(value_0[2]).concat(_descriptor_49.toValue(value_0[3]).concat(_descriptor_30.toValue(value_0[4]).concat(_descriptor_0.toValue(value_0[5]).concat(_descriptor_8.toValue(value_0[6]).concat(_descriptor_48.toValue(value_0[7]).concat(_descriptor_10.toValue(value_0[8]).concat(_descriptor_10.toValue(value_0[9]))))))))));
  }
}

const _descriptor_98 = new _tuple_36();

const _descriptor_99 = new __compactRuntime.CompactTypeBytes(27);

class _tuple_37 {
  alignment() {
    return _descriptor_99.alignment().concat(_descriptor_0.alignment());
  }
  fromValue(value_0) {
    return [
      _descriptor_99.fromValue(value_0),
      _descriptor_0.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_99.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]));
  }
}

const _descriptor_100 = new _tuple_37();

class _tuple_38 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_3.alignment().concat(_descriptor_34.alignment().concat(_descriptor_10.alignment()))))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_3.fromValue(value_0),
      _descriptor_34.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_3.toValue(value_0[4]).concat(_descriptor_34.toValue(value_0[5]).concat(_descriptor_10.toValue(value_0[6])))))));
  }
}

const _descriptor_101 = new _tuple_38();

class _tuple_39 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_11.alignment().concat(_descriptor_34.alignment().concat(_descriptor_10.alignment()))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_11.fromValue(value_0),
      _descriptor_34.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_11.toValue(value_0[2]).concat(_descriptor_34.toValue(value_0[3]).concat(_descriptor_10.toValue(value_0[4])))));
  }
}

const _descriptor_102 = new _tuple_39();

class _tuple_40 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_11.alignment()));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_11.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]).concat(_descriptor_11.toValue(value_0[2])));
  }
}

const _descriptor_103 = new _tuple_40();

class _tuple_41 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_1.alignment().concat(_descriptor_49.alignment().concat(_descriptor_34.alignment().concat(_descriptor_10.alignment()))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_1.fromValue(value_0),
      _descriptor_49.fromValue(value_0),
      _descriptor_34.fromValue(value_0),
      _descriptor_10.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_1.toValue(value_0[1]).concat(_descriptor_49.toValue(value_0[2]).concat(_descriptor_34.toValue(value_0[3]).concat(_descriptor_10.toValue(value_0[4])))));
  }
}

const _descriptor_104 = new _tuple_41();

class _tuple_42 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_49.alignment()));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_49.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]).concat(_descriptor_49.toValue(value_0[2])));
  }
}

const _descriptor_105 = new _tuple_42();

class _tuple_43 {
  alignment() {
    return _descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment().concat(_descriptor_3.alignment()))));
  }
  fromValue(value_0) {
    return [
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_0.fromValue(value_0),
      _descriptor_3.fromValue(value_0)
    ]
  }
  toValue(value_0) {
    return _descriptor_0.toValue(value_0[0]).concat(_descriptor_0.toValue(value_0[1]).concat(_descriptor_0.toValue(value_0[2]).concat(_descriptor_0.toValue(value_0[3]).concat(_descriptor_3.toValue(value_0[4])))));
  }
}

const _descriptor_106 = new _tuple_43();

const _descriptor_107 = new __compactRuntime.CompactTypeVector(3, _descriptor_47);

const _descriptor_108 = new __compactRuntime.CompactTypeVector(2, _descriptor_47);

class _Either_1 {
  alignment() {
    return _descriptor_15.alignment().concat(_descriptor_0.alignment().concat(_descriptor_0.alignment()));
  }
  fromValue(value_0) {
    return {
      is_left: _descriptor_15.fromValue(value_0),
      left: _descriptor_0.fromValue(value_0),
      right: _descriptor_0.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_15.toValue(value_0.is_left).concat(_descriptor_0.toValue(value_0.left).concat(_descriptor_0.toValue(value_0.right)));
  }
}

const _descriptor_109 = new _Either_1();

class _Either_2 {
  alignment() {
    return _descriptor_15.alignment().concat(_descriptor_1.alignment().concat(_descriptor_33.alignment()));
  }
  fromValue(value_0) {
    return {
      is_left: _descriptor_15.fromValue(value_0),
      left: _descriptor_1.fromValue(value_0),
      right: _descriptor_33.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_15.toValue(value_0.is_left).concat(_descriptor_1.toValue(value_0.left).concat(_descriptor_33.toValue(value_0.right)));
  }
}

const _descriptor_110 = new _Either_2();

class _ShieldedSendResult_0 {
  alignment() {
    return _descriptor_16.alignment().concat(_descriptor_9.alignment());
  }
  fromValue(value_0) {
    return {
      change: _descriptor_16.fromValue(value_0),
      sent: _descriptor_9.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_16.toValue(value_0.change).concat(_descriptor_9.toValue(value_0.sent));
  }
}

const _descriptor_111 = new _ShieldedSendResult_0();

class _Maybe_1 {
  alignment() {
    return _descriptor_15.alignment().concat(_descriptor_110.alignment());
  }
  fromValue(value_0) {
    return {
      is_some: _descriptor_15.fromValue(value_0),
      value: _descriptor_110.fromValue(value_0)
    }
  }
  toValue(value_0) {
    return _descriptor_15.toValue(value_0.is_some).concat(_descriptor_110.toValue(value_0.value));
  }
}

const _descriptor_112 = new _Maybe_1();

export class Contract {
  witnesses;
  constructor(...args_0) {
    if (args_0.length !== 1) {
      throw new __compactRuntime.CompactError(`Contract constructor: expected 1 argument, received ${args_0.length}`);
    }
    const witnesses_0 = args_0[0];
    if (typeof(witnesses_0) !== 'object') {
      throw new __compactRuntime.CompactError('first (witnesses) argument to Contract constructor is not an object');
    }
    if (typeof(witnesses_0.held_coin) !== 'function') {
      throw new __compactRuntime.CompactError('first (witnesses) argument to Contract constructor does not contain a function-valued field named held_coin');
    }
    this.witnesses = witnesses_0;
    this.circuits = {
      async evm_account_alias(context, ...args_1) {
        return { result: pureCircuits.evm_account_alias(...args_1), context };
      },
      async evm_domain_separator_for(context, ...args_1) {
        return { result: pureCircuits.evm_domain_separator_for(...args_1), context };
      },
      async evm_struct_hash_withdraw_unshielded(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_withdraw_unshielded(...args_1), context };
      },
      async evm_struct_hash_withdraw_shielded(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_withdraw_shielded(...args_1), context };
      },
      async evm_struct_hash_withdraw_shielded_to_contract(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_withdraw_shielded_to_contract(...args_1), context };
      },
      async evm_struct_hash_append_inbox(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_append_inbox(...args_1), context };
      },
      async evm_struct_hash_rotate_enc_key(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_rotate_enc_key(...args_1), context };
      },
      async evm_struct_hash_add_device(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_add_device(...args_1), context };
      },
      async evm_struct_hash_remove_device(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_remove_device(...args_1), context };
      },
      async evm_struct_hash_open_swap_shielded(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_open_swap_shielded(...args_1), context };
      },
      async evm_struct_hash_bridge_deposit_start(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_bridge_deposit_start(...args_1), context };
      },
      async evm_struct_hash_bridge_withdraw_start(context, ...args_1) {
        return { result: pureCircuits.evm_struct_hash_bridge_withdraw_start(...args_1), context };
      },
      async evm_digest_withdraw_unshielded(context, ...args_1) {
        return { result: pureCircuits.evm_digest_withdraw_unshielded(...args_1), context };
      },
      async evm_digest_withdraw_shielded(context, ...args_1) {
        return { result: pureCircuits.evm_digest_withdraw_shielded(...args_1), context };
      },
      async evm_digest_withdraw_shielded_to_contract(context, ...args_1) {
        return { result: pureCircuits.evm_digest_withdraw_shielded_to_contract(...args_1), context };
      },
      async evm_digest_append_inbox(context, ...args_1) {
        return { result: pureCircuits.evm_digest_append_inbox(...args_1), context };
      },
      async evm_digest_rotate_enc_key(context, ...args_1) {
        return { result: pureCircuits.evm_digest_rotate_enc_key(...args_1), context };
      },
      async evm_digest_add_device(context, ...args_1) {
        return { result: pureCircuits.evm_digest_add_device(...args_1), context };
      },
      async evm_digest_open_swap_shielded(context, ...args_1) {
        return { result: pureCircuits.evm_digest_open_swap_shielded(...args_1), context };
      },
      async evm_digest_remove_device(context, ...args_1) {
        return { result: pureCircuits.evm_digest_remove_device(...args_1), context };
      },
      async evm_digest_bridge_deposit_start(context, ...args_1) {
        return { result: pureCircuits.evm_digest_bridge_deposit_start(...args_1), context };
      },
      async evm_digest_bridge_withdraw_start(context, ...args_1) {
        return { result: pureCircuits.evm_digest_bridge_withdraw_start(...args_1), context };
      },
      async zswapNullifierOf(context, ...args_1) {
        return { result: pureCircuits.zswapNullifierOf(...args_1), context };
      },
      async zswapCommitmentOf(context, ...args_1) {
        return { result: pureCircuits.zswapCommitmentOf(...args_1), context };
      },
      activate_initial_device_with_jubjub: async (...args_1) => {
        if (args_1.length !== 3) {
          throw new __compactRuntime.CompactError(`activate_initial_device_with_jubjub: expected 3 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const pk_0 = args_1[1];
        const salt_0 = args_1[2];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('activate_initial_device_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 535 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('activate_initial_device_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 535 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
          __compactRuntime.typeError('activate_initial_device_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 535 char 1',
                                     'Bytes<32>',
                                     salt_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_49.toValue(pk_0).concat(_descriptor_0.toValue(salt_0)),
            alignment: _descriptor_49.alignment().concat(_descriptor_0.alignment())
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._activate_initial_device_with_jubjub_0(context,
                                                                           partialProofData,
                                                                           pk_0,
                                                                           salt_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      activate_initial_device_with_k256: async (...args_1) => {
        if (args_1.length !== 4) {
          throw new __compactRuntime.CompactError(`activate_initial_device_with_k256: expected 4 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const pk_0 = args_1[1];
        const salt_0 = args_1[2];
        const envelope_0 = args_1[3];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('activate_initial_device_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 545 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('activate_initial_device_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 545 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
          __compactRuntime.typeError('activate_initial_device_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 545 char 1',
                                     'Bytes<32>',
                                     salt_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('activate_initial_device_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 545 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_12.toValue(pk_0).concat(_descriptor_0.toValue(salt_0).concat(_descriptor_3.toValue(envelope_0))),
            alignment: _descriptor_12.alignment().concat(_descriptor_0.alignment().concat(_descriptor_3.alignment()))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._activate_initial_device_with_k256_0(context,
                                                                         partialProofData,
                                                                         pk_0,
                                                                         salt_0,
                                                                         envelope_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      activate_initial_device_with_evm: async (...args_1) => {
        if (args_1.length !== 3) {
          throw new __compactRuntime.CompactError(`activate_initial_device_with_evm: expected 3 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const pk_0 = args_1[1];
        const salt_0 = args_1[2];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('activate_initial_device_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 563 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('activate_initial_device_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 563 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
          __compactRuntime.typeError('activate_initial_device_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 563 char 1',
                                     'Bytes<32>',
                                     salt_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_12.toValue(pk_0).concat(_descriptor_0.toValue(salt_0)),
            alignment: _descriptor_12.alignment().concat(_descriptor_0.alignment())
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._activate_initial_device_with_evm_0(context,
                                                                        partialProofData,
                                                                        pk_0,
                                                                        salt_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      async derive_boot_commitment_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.derive_boot_commitment_with_jubjub(...args_1), context };
      },
      async derive_boot_commitment_with_k256(context, ...args_1) {
        return { result: pureCircuits.derive_boot_commitment_with_k256(...args_1), context };
      },
      async derive_boot_commitment_with_evm(context, ...args_1) {
        return { result: pureCircuits.derive_boot_commitment_with_evm(...args_1), context };
      },
      async derive_device_entry_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.derive_device_entry_with_jubjub(...args_1), context };
      },
      async derive_device_entry_with_k256(context, ...args_1) {
        return { result: pureCircuits.derive_device_entry_with_k256(...args_1), context };
      },
      async derive_device_entry_with_evm(context, ...args_1) {
        return { result: pureCircuits.derive_device_entry_with_evm(...args_1), context };
      },
      async envelope_digest(context, ...args_1) {
        return { result: pureCircuits.envelope_digest(...args_1), context };
      },
      async compute_public_point_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.compute_public_point_with_jubjub(...args_1), context };
      },
      async compute_public_point_with_k256(context, ...args_1) {
        return { result: pureCircuits.compute_public_point_with_k256(...args_1), context };
      },
      async challenge_withdraw_unshielded_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_unshielded_with_jubjub(...args_1), context };
      },
      async challenge_withdraw_shielded_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_with_jubjub(...args_1), context };
      },
      async challenge_withdraw_shielded_to_contract_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_to_contract_with_jubjub(...args_1), context };
      },
      async challenge_append_inbox_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_append_inbox_with_jubjub(...args_1), context };
      },
      async challenge_rotate_enc_key_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_rotate_enc_key_with_jubjub(...args_1), context };
      },
      async challenge_add_device_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_add_device_with_jubjub(...args_1), context };
      },
      async challenge_remove_device_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_remove_device_with_jubjub(...args_1), context };
      },
      async challenge_open_swap_shielded_with_jubjub(context, ...args_1) {
        return { result: pureCircuits.challenge_open_swap_shielded_with_jubjub(...args_1), context };
      },
      async challenge_withdraw_unshielded_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_unshielded_with_k256(...args_1), context };
      },
      async challenge_withdraw_shielded_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_with_k256(...args_1), context };
      },
      async challenge_withdraw_shielded_to_contract_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_to_contract_with_k256(...args_1), context };
      },
      async challenge_append_inbox_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_append_inbox_with_k256(...args_1), context };
      },
      async challenge_rotate_enc_key_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_rotate_enc_key_with_k256(...args_1), context };
      },
      async challenge_add_device_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_add_device_with_k256(...args_1), context };
      },
      async challenge_remove_device_with_k256(context, ...args_1) {
        return { result: pureCircuits.challenge_remove_device_with_k256(...args_1), context };
      },
      async challenge_withdraw_unshielded_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_unshielded_with_evm(...args_1), context };
      },
      async challenge_withdraw_shielded_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_with_evm(...args_1), context };
      },
      async challenge_withdraw_shielded_to_contract_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_to_contract_with_evm(...args_1), context };
      },
      async challenge_append_inbox_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_append_inbox_with_evm(...args_1), context };
      },
      async challenge_rotate_enc_key_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_rotate_enc_key_with_evm(...args_1), context };
      },
      async challenge_add_device_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_add_device_with_evm(...args_1), context };
      },
      async challenge_remove_device_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_remove_device_with_evm(...args_1), context };
      },
      async challenge_open_swap_shielded_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_open_swap_shielded_with_evm(...args_1), context };
      },
      async challenge_bridge_deposit_start_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_bridge_deposit_start_with_evm(...args_1), context };
      },
      async challenge_bridge_withdraw_start_with_evm(context, ...args_1) {
        return { result: pureCircuits.challenge_bridge_withdraw_start_with_evm(...args_1), context };
      },
      async assert_open_swap_terms(context, ...args_1) {
        return { result: pureCircuits.assert_open_swap_terms(...args_1), context };
      },
      async swap_change_nonce(context, ...args_1) {
        return { result: pureCircuits.swap_change_nonce(...args_1), context };
      },
      deposit_unshielded: async (...args_1) => {
        if (args_1.length !== 3) {
          throw new __compactRuntime.CompactError(`deposit_unshielded: expected 3 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const color_0 = args_1[1];
        const amount_0 = args_1[2];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('deposit_unshielded',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1746 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('deposit_unshielded',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1746 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('deposit_unshielded',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1746 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0)),
            alignment: _descriptor_0.alignment().concat(_descriptor_8.alignment())
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._deposit_unshielded_0(context,
                                                          partialProofData,
                                                          color_0,
                                                          amount_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_unshielded_with_jubjub: async (...args_1) => {
        if (args_1.length !== 9) {
          throw new __compactRuntime.CompactError(`withdraw_unshielded_with_jubjub: expected 9 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const color_0 = args_1[1];
        const amount_0 = args_1[2];
        const recipient_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_r_0 = args_1[6];
        const sig_s_0 = args_1[7];
        const grind_nonce_0 = args_1[8];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1756 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1756 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1756 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1756 char 1',
                                     'struct UserAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1756 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1756 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1756 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 1756 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_jubjub',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 1756 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_33.toValue(recipient_0).concat(_descriptor_49.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_49.toValue(sig_r_0).concat(_descriptor_47.toValue(sig_s_0).concat(_descriptor_10.toValue(grind_nonce_0)))))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_33.alignment().concat(_descriptor_49.alignment().concat(_descriptor_10.alignment().concat(_descriptor_49.alignment().concat(_descriptor_47.alignment().concat(_descriptor_10.alignment())))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_unshielded_with_jubjub_0(context,
                                                                       partialProofData,
                                                                       color_0,
                                                                       amount_0,
                                                                       recipient_0,
                                                                       pk_0,
                                                                       use_counter_0,
                                                                       sig_r_0,
                                                                       sig_s_0,
                                                                       grind_nonce_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_unshielded_with_k256: async (...args_1) => {
        if (args_1.length !== 8) {
          throw new __compactRuntime.CompactError(`withdraw_unshielded_with_k256: expected 8 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const color_0 = args_1[1];
        const amount_0 = args_1[2];
        const recipient_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        const envelope_0 = args_1[7];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1773 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1773 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1773 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1773 char 1',
                                     'struct UserAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1773 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1773 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1773 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_k256',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 1773 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_33.toValue(recipient_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_33.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment().concat(_descriptor_3.alignment()))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_unshielded_with_k256_0(context,
                                                                     partialProofData,
                                                                     color_0,
                                                                     amount_0,
                                                                     recipient_0,
                                                                     pk_0,
                                                                     use_counter_0,
                                                                     sig_0,
                                                                     envelope_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_unshielded_with_evm: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`withdraw_unshielded_with_evm: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const color_0 = args_1[1];
        const amount_0 = args_1[2];
        const recipient_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1789 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1789 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1789 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1789 char 1',
                                     'struct UserAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1789 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1789 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('withdraw_unshielded_with_evm',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1789 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_33.toValue(recipient_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0)))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_33.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_unshielded_with_evm_0(context,
                                                                    partialProofData,
                                                                    color_0,
                                                                    amount_0,
                                                                    recipient_0,
                                                                    pk_0,
                                                                    use_counter_0,
                                                                    sig_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      deposit_shielded: async (...args_1) => {
        if (args_1.length !== 3) {
          throw new __compactRuntime.CompactError(`deposit_shielded: expected 3 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const coin_0 = args_1[1];
        const entry_0 = args_1[2];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('deposit_shielded',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1815 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('deposit_shielded',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1815 char 1',
                                     'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                     coin_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('deposit_shielded',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1815 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_9.toValue(coin_0).concat(_descriptor_7.toValue(entry_0)),
            alignment: _descriptor_9.alignment().concat(_descriptor_7.alignment())
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._deposit_shielded_0(context,
                                                        partialProofData,
                                                        coin_0,
                                                        entry_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      append_inbox_with_jubjub: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`append_inbox_with_jubjub: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_r_0 = args_1[4];
        const sig_s_0 = args_1[5];
        const grind_nonce_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1826 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1826 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1826 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1826 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1826 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1826 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('append_inbox_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1826 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_7.toValue(entry_0).concat(_descriptor_49.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_49.toValue(sig_r_0).concat(_descriptor_47.toValue(sig_s_0).concat(_descriptor_10.toValue(grind_nonce_0)))))),
            alignment: _descriptor_7.alignment().concat(_descriptor_49.alignment().concat(_descriptor_10.alignment().concat(_descriptor_49.alignment().concat(_descriptor_47.alignment().concat(_descriptor_10.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._append_inbox_with_jubjub_0(context,
                                                                partialProofData,
                                                                entry_0,
                                                                pk_0,
                                                                use_counter_0,
                                                                sig_r_0,
                                                                sig_s_0,
                                                                grind_nonce_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      append_inbox_with_k256: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`append_inbox_with_k256: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        const envelope_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('append_inbox_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1841 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('append_inbox_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1841 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('append_inbox_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1841 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('append_inbox_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1841 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('append_inbox_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1841 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('append_inbox_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1841 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_7.toValue(entry_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))),
            alignment: _descriptor_7.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment().concat(_descriptor_3.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._append_inbox_with_k256_0(context,
                                                              partialProofData,
                                                              entry_0,
                                                              pk_0,
                                                              use_counter_0,
                                                              sig_0,
                                                              envelope_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      append_inbox_with_evm: async (...args_1) => {
        if (args_1.length !== 5) {
          throw new __compactRuntime.CompactError(`append_inbox_with_evm: expected 5 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('append_inbox_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1858 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('append_inbox_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1858 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('append_inbox_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1858 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('append_inbox_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1858 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('append_inbox_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1858 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_7.toValue(entry_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0)))),
            alignment: _descriptor_7.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment())))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._append_inbox_with_evm_0(context,
                                                             partialProofData,
                                                             entry_0,
                                                             pk_0,
                                                             use_counter_0,
                                                             sig_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_with_jubjub: async (...args_1) => {
        if (args_1.length !== 9) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_with_jubjub: expected 9 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_r_0 = args_1[6];
        const sig_s_0 = args_1[7];
        const grind_nonce_0 = args_1[8];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_with_jubjub',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 1882 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_30.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_49.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_49.toValue(sig_r_0).concat(_descriptor_47.toValue(sig_s_0).concat(_descriptor_10.toValue(grind_nonce_0)))))))),
            alignment: _descriptor_30.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_49.alignment().concat(_descriptor_10.alignment().concat(_descriptor_49.alignment().concat(_descriptor_47.alignment().concat(_descriptor_10.alignment())))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_with_jubjub_0(context,
                                                                     partialProofData,
                                                                     recipient_0,
                                                                     color_0,
                                                                     amount_0,
                                                                     pk_0,
                                                                     use_counter_0,
                                                                     sig_r_0,
                                                                     sig_s_0,
                                                                     grind_nonce_0);
        partialProofData.output = { value: _descriptor_16.toValue(result_0), alignment: _descriptor_16.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_with_k256: async (...args_1) => {
        if (args_1.length !== 8) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_with_k256: expected 8 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        const envelope_0 = args_1[7];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1900 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1900 char 1',
                                     'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1900 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1900 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1900 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1900 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1900 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('withdraw_shielded_with_k256',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 1900 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_30.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))))),
            alignment: _descriptor_30.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment().concat(_descriptor_3.alignment()))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_with_k256_0(context,
                                                                   partialProofData,
                                                                   recipient_0,
                                                                   color_0,
                                                                   amount_0,
                                                                   pk_0,
                                                                   use_counter_0,
                                                                   sig_0,
                                                                   envelope_0);
        partialProofData.output = { value: _descriptor_16.toValue(result_0), alignment: _descriptor_16.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_with_evm: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_with_evm: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1917 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1917 char 1',
                                     'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1917 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1917 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1917 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1917 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('withdraw_shielded_with_evm',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1917 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_30.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0)))))),
            alignment: _descriptor_30.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_with_evm_0(context,
                                                                  partialProofData,
                                                                  recipient_0,
                                                                  color_0,
                                                                  amount_0,
                                                                  pk_0,
                                                                  use_counter_0,
                                                                  sig_0);
        partialProofData.output = { value: _descriptor_16.toValue(result_0), alignment: _descriptor_16.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_to_contract_with_jubjub: async (...args_1) => {
        if (args_1.length !== 9) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_to_contract_with_jubjub: expected 9 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_r_0 = args_1[6];
        const sig_s_0 = args_1[7];
        const grind_nonce_0 = args_1[8];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'struct ContractAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_jubjub',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 1955 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_1.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_49.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_49.toValue(sig_r_0).concat(_descriptor_47.toValue(sig_s_0).concat(_descriptor_10.toValue(grind_nonce_0)))))))),
            alignment: _descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_49.alignment().concat(_descriptor_10.alignment().concat(_descriptor_49.alignment().concat(_descriptor_47.alignment().concat(_descriptor_10.alignment())))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_to_contract_with_jubjub_0(context,
                                                                                 partialProofData,
                                                                                 recipient_0,
                                                                                 color_0,
                                                                                 amount_0,
                                                                                 pk_0,
                                                                                 use_counter_0,
                                                                                 sig_r_0,
                                                                                 sig_s_0,
                                                                                 grind_nonce_0);
        partialProofData.output = { value: _descriptor_32.toValue(result_0), alignment: _descriptor_32.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_to_contract_with_k256: async (...args_1) => {
        if (args_1.length !== 8) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_to_contract_with_k256: expected 8 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        const envelope_0 = args_1[7];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1973 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1973 char 1',
                                     'struct ContractAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1973 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1973 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1973 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1973 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1973 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_k256',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 1973 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_1.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))))),
            alignment: _descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment().concat(_descriptor_3.alignment()))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_to_contract_with_k256_0(context,
                                                                               partialProofData,
                                                                               recipient_0,
                                                                               color_0,
                                                                               amount_0,
                                                                               pk_0,
                                                                               use_counter_0,
                                                                               sig_0,
                                                                               envelope_0);
        partialProofData.output = { value: _descriptor_32.toValue(result_0), alignment: _descriptor_32.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_to_contract_with_evm: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_to_contract_with_evm: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 1990 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 1990 char 1',
                                     'struct ContractAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 1990 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 1990 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 1990 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 1990 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_evm',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 1990 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_1.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0)))))),
            alignment: _descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_to_contract_with_evm_0(context,
                                                                              partialProofData,
                                                                              recipient_0,
                                                                              color_0,
                                                                              amount_0,
                                                                              pk_0,
                                                                              use_counter_0,
                                                                              sig_0);
        partialProofData.output = { value: _descriptor_32.toValue(result_0), alignment: _descriptor_32.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      rotate_enc_key_with_jubjub: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`rotate_enc_key_with_jubjub: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const new_key_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_r_0 = args_1[4];
        const sig_s_0 = args_1[5];
        const grind_nonce_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2017 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2017 char 1',
                                     'Bytes<32>',
                                     new_key_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2017 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2017 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2017 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2017 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('rotate_enc_key_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2017 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(new_key_0).concat(_descriptor_49.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_49.toValue(sig_r_0).concat(_descriptor_47.toValue(sig_s_0).concat(_descriptor_10.toValue(grind_nonce_0)))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_49.alignment().concat(_descriptor_10.alignment().concat(_descriptor_49.alignment().concat(_descriptor_47.alignment().concat(_descriptor_10.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._rotate_enc_key_with_jubjub_0(context,
                                                                  partialProofData,
                                                                  new_key_0,
                                                                  pk_0,
                                                                  use_counter_0,
                                                                  sig_r_0,
                                                                  sig_s_0,
                                                                  grind_nonce_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      rotate_enc_key_with_k256: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`rotate_enc_key_with_k256: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const new_key_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        const envelope_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('rotate_enc_key_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2032 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
          __compactRuntime.typeError('rotate_enc_key_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2032 char 1',
                                     'Bytes<32>',
                                     new_key_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('rotate_enc_key_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2032 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('rotate_enc_key_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2032 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('rotate_enc_key_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2032 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('rotate_enc_key_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2032 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(new_key_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment().concat(_descriptor_3.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._rotate_enc_key_with_k256_0(context,
                                                                partialProofData,
                                                                new_key_0,
                                                                pk_0,
                                                                use_counter_0,
                                                                sig_0,
                                                                envelope_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      rotate_enc_key_with_evm: async (...args_1) => {
        if (args_1.length !== 5) {
          throw new __compactRuntime.CompactError(`rotate_enc_key_with_evm: expected 5 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const new_key_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('rotate_enc_key_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2046 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
          __compactRuntime.typeError('rotate_enc_key_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2046 char 1',
                                     'Bytes<32>',
                                     new_key_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('rotate_enc_key_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2046 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('rotate_enc_key_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2046 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('rotate_enc_key_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2046 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(new_key_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0)))),
            alignment: _descriptor_0.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment())))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._rotate_enc_key_with_evm_0(context,
                                                               partialProofData,
                                                               new_key_0,
                                                               pk_0,
                                                               use_counter_0,
                                                               sig_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      add_device_with_jubjub: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`add_device_with_jubjub: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const new_entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_r_0 = args_1[4];
        const sig_s_0 = args_1[5];
        const grind_nonce_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2129 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2129 char 1',
                                     'Bytes<32>',
                                     new_entry_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2129 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2129 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2129 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2129 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('add_device_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2129 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(new_entry_0).concat(_descriptor_49.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_49.toValue(sig_r_0).concat(_descriptor_47.toValue(sig_s_0).concat(_descriptor_10.toValue(grind_nonce_0)))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_49.alignment().concat(_descriptor_10.alignment().concat(_descriptor_49.alignment().concat(_descriptor_47.alignment().concat(_descriptor_10.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._add_device_with_jubjub_0(context,
                                                              partialProofData,
                                                              new_entry_0,
                                                              pk_0,
                                                              use_counter_0,
                                                              sig_r_0,
                                                              sig_s_0,
                                                              grind_nonce_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      add_device_with_k256: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`add_device_with_k256: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const new_entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        const envelope_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('add_device_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2144 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
          __compactRuntime.typeError('add_device_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2144 char 1',
                                     'Bytes<32>',
                                     new_entry_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('add_device_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2144 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('add_device_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2144 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('add_device_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2144 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('add_device_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2144 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(new_entry_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment().concat(_descriptor_3.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._add_device_with_k256_0(context,
                                                            partialProofData,
                                                            new_entry_0,
                                                            pk_0,
                                                            use_counter_0,
                                                            sig_0,
                                                            envelope_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      add_device_with_evm: async (...args_1) => {
        if (args_1.length !== 5) {
          throw new __compactRuntime.CompactError(`add_device_with_evm: expected 5 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const new_entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('add_device_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2158 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
          __compactRuntime.typeError('add_device_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2158 char 1',
                                     'Bytes<32>',
                                     new_entry_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('add_device_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2158 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('add_device_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2158 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('add_device_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2158 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(new_entry_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0)))),
            alignment: _descriptor_0.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment())))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._add_device_with_evm_0(context,
                                                           partialProofData,
                                                           new_entry_0,
                                                           pk_0,
                                                           use_counter_0,
                                                           sig_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      remove_device_with_jubjub: async (...args_1) => {
        if (args_1.length !== 7) {
          throw new __compactRuntime.CompactError(`remove_device_with_jubjub: expected 7 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_r_0 = args_1[4];
        const sig_s_0 = args_1[5];
        const grind_nonce_0 = args_1[6];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2181 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2181 char 1',
                                     'Bytes<32>',
                                     entry_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2181 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2181 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2181 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2181 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('remove_device_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2181 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(entry_0).concat(_descriptor_49.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_49.toValue(sig_r_0).concat(_descriptor_47.toValue(sig_s_0).concat(_descriptor_10.toValue(grind_nonce_0)))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_49.alignment().concat(_descriptor_10.alignment().concat(_descriptor_49.alignment().concat(_descriptor_47.alignment().concat(_descriptor_10.alignment())))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._remove_device_with_jubjub_0(context,
                                                                 partialProofData,
                                                                 entry_0,
                                                                 pk_0,
                                                                 use_counter_0,
                                                                 sig_r_0,
                                                                 sig_s_0,
                                                                 grind_nonce_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      remove_device_with_k256: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`remove_device_with_k256: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        const envelope_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('remove_device_with_k256',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2200 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
          __compactRuntime.typeError('remove_device_with_k256',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2200 char 1',
                                     'Bytes<32>',
                                     entry_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('remove_device_with_k256',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2200 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('remove_device_with_k256',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2200 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('remove_device_with_k256',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2200 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
          __compactRuntime.typeError('remove_device_with_k256',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2200 char 1',
                                     'Uint<0..256>',
                                     envelope_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(entry_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0).concat(_descriptor_3.toValue(envelope_0))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment().concat(_descriptor_3.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._remove_device_with_k256_0(context,
                                                               partialProofData,
                                                               entry_0,
                                                               pk_0,
                                                               use_counter_0,
                                                               sig_0,
                                                               envelope_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      remove_device_with_evm: async (...args_1) => {
        if (args_1.length !== 5) {
          throw new __compactRuntime.CompactError(`remove_device_with_evm: expected 5 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('remove_device_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2218 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
          __compactRuntime.typeError('remove_device_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2218 char 1',
                                     'Bytes<32>',
                                     entry_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('remove_device_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2218 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('remove_device_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2218 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('remove_device_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2218 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(entry_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0)))),
            alignment: _descriptor_0.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment())))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._remove_device_with_evm_0(context,
                                                              partialProofData,
                                                              entry_0,
                                                              pk_0,
                                                              use_counter_0,
                                                              sig_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      open_swap_shielded_with_jubjub: async (...args_1) => {
        if (args_1.length !== 14) {
          throw new __compactRuntime.CompactError(`open_swap_shielded_with_jubjub: expected 14 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const give_color_0 = args_1[1];
        const give_amount_0 = args_1[2];
        const recipient_kind_0 = args_1[3];
        const recipient_0 = args_1[4];
        const want_0 = args_1[5];
        const want_entry_0 = args_1[6];
        const change_entry_0 = args_1[7];
        const valid_until_0 = args_1[8];
        const pk_0 = args_1[9];
        const use_counter_0 = args_1[10];
        const sig_r_0 = args_1[11];
        const sig_s_0 = args_1[12];
        const grind_nonce_0 = args_1[13];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'Bytes<32>',
                                     give_color_0)
        }
        if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     give_amount_0)
        }
        if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'Uint<0..256>',
                                     recipient_kind_0)
        }
        if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'Bytes<32>',
                                     recipient_0)
        }
        if (!(typeof(want_0) === 'object' && want_0.nonce.buffer instanceof ArrayBuffer && want_0.nonce.BYTES_PER_ELEMENT === 1 && want_0.nonce.length === 32 && want_0.color.buffer instanceof ArrayBuffer && want_0.color.BYTES_PER_ELEMENT === 1 && want_0.color.length === 32 && typeof(want_0.value) === 'bigint' && want_0.value >= 0n && want_0.value <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                     want_0)
        }
        if (!(want_entry_0.buffer instanceof ArrayBuffer && want_entry_0.BYTES_PER_ELEMENT === 1 && want_entry_0.length === 192)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'Bytes<192>',
                                     want_entry_0)
        }
        if (!(change_entry_0.buffer instanceof ArrayBuffer && change_entry_0.BYTES_PER_ELEMENT === 1 && change_entry_0.length === 192)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'Bytes<192>',
                                     change_entry_0)
        }
        if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'Uint<0..18446744073709551616>',
                                     valid_until_0)
        }
        if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 9 (argument 10 as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'JubjubPoint',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 10 (argument 11 as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 11 (argument 12 as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'JubjubPoint',
                                     sig_r_0)
        }
        if (!(typeof(sig_s_0) === 'bigint' && sig_s_0 >= 0 && sig_s_0 <= __compactRuntime.MAX_FIELD)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 12 (argument 13 as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'Field',
                                     sig_s_0)
        }
        if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('open_swap_shielded_with_jubjub',
                                     'argument 13 (argument 14 as invoked from Typescript)',
                                     'account.compact line 2264 char 1',
                                     'Uint<0..18446744073709551616>',
                                     grind_nonce_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(give_color_0).concat(_descriptor_8.toValue(give_amount_0).concat(_descriptor_3.toValue(recipient_kind_0).concat(_descriptor_0.toValue(recipient_0).concat(_descriptor_9.toValue(want_0).concat(_descriptor_7.toValue(want_entry_0).concat(_descriptor_7.toValue(change_entry_0).concat(_descriptor_10.toValue(valid_until_0).concat(_descriptor_49.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_49.toValue(sig_r_0).concat(_descriptor_47.toValue(sig_s_0).concat(_descriptor_10.toValue(grind_nonce_0))))))))))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_3.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_7.alignment().concat(_descriptor_7.alignment().concat(_descriptor_10.alignment().concat(_descriptor_49.alignment().concat(_descriptor_10.alignment().concat(_descriptor_49.alignment().concat(_descriptor_47.alignment().concat(_descriptor_10.alignment()))))))))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._open_swap_shielded_with_jubjub_0(context,
                                                                      partialProofData,
                                                                      give_color_0,
                                                                      give_amount_0,
                                                                      recipient_kind_0,
                                                                      recipient_0,
                                                                      want_0,
                                                                      want_entry_0,
                                                                      change_entry_0,
                                                                      valid_until_0,
                                                                      pk_0,
                                                                      use_counter_0,
                                                                      sig_r_0,
                                                                      sig_s_0,
                                                                      grind_nonce_0);
        partialProofData.output = { value: _descriptor_16.toValue(result_0), alignment: _descriptor_16.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      open_swap_shielded_with_evm: async (...args_1) => {
        if (args_1.length !== 12) {
          throw new __compactRuntime.CompactError(`open_swap_shielded_with_evm: expected 12 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const give_color_0 = args_1[1];
        const give_amount_0 = args_1[2];
        const recipient_kind_0 = args_1[3];
        const recipient_0 = args_1[4];
        const want_0 = args_1[5];
        const want_entry_0 = args_1[6];
        const change_entry_0 = args_1[7];
        const valid_until_0 = args_1[8];
        const pk_0 = args_1[9];
        const use_counter_0 = args_1[10];
        const sig_0 = args_1[11];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2292 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2292 char 1',
                                     'Bytes<32>',
                                     give_color_0)
        }
        if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2292 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     give_amount_0)
        }
        if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2292 char 1',
                                     'Uint<0..256>',
                                     recipient_kind_0)
        }
        if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2292 char 1',
                                     'Bytes<32>',
                                     recipient_0)
        }
        if (!(typeof(want_0) === 'object' && want_0.nonce.buffer instanceof ArrayBuffer && want_0.nonce.BYTES_PER_ELEMENT === 1 && want_0.nonce.length === 32 && want_0.color.buffer instanceof ArrayBuffer && want_0.color.BYTES_PER_ELEMENT === 1 && want_0.color.length === 32 && typeof(want_0.value) === 'bigint' && want_0.value >= 0n && want_0.value <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2292 char 1',
                                     'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                     want_0)
        }
        if (!(want_entry_0.buffer instanceof ArrayBuffer && want_entry_0.BYTES_PER_ELEMENT === 1 && want_entry_0.length === 192)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2292 char 1',
                                     'Bytes<192>',
                                     want_entry_0)
        }
        if (!(change_entry_0.buffer instanceof ArrayBuffer && change_entry_0.BYTES_PER_ELEMENT === 1 && change_entry_0.length === 192)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 2292 char 1',
                                     'Bytes<192>',
                                     change_entry_0)
        }
        if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 2292 char 1',
                                     'Uint<0..18446744073709551616>',
                                     valid_until_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 9 (argument 10 as invoked from Typescript)',
                                     'account.compact line 2292 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 10 (argument 11 as invoked from Typescript)',
                                     'account.compact line 2292 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('open_swap_shielded_with_evm',
                                     'argument 11 (argument 12 as invoked from Typescript)',
                                     'account.compact line 2292 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(give_color_0).concat(_descriptor_8.toValue(give_amount_0).concat(_descriptor_3.toValue(recipient_kind_0).concat(_descriptor_0.toValue(recipient_0).concat(_descriptor_9.toValue(want_0).concat(_descriptor_7.toValue(want_entry_0).concat(_descriptor_7.toValue(change_entry_0).concat(_descriptor_10.toValue(valid_until_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0))))))))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_3.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_7.alignment().concat(_descriptor_7.alignment().concat(_descriptor_10.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment()))))))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._open_swap_shielded_with_evm_0(context,
                                                                   partialProofData,
                                                                   give_color_0,
                                                                   give_amount_0,
                                                                   recipient_kind_0,
                                                                   recipient_0,
                                                                   want_0,
                                                                   want_entry_0,
                                                                   change_entry_0,
                                                                   valid_until_0,
                                                                   pk_0,
                                                                   use_counter_0,
                                                                   sig_0);
        partialProofData.output = { value: _descriptor_16.toValue(result_0), alignment: _descriptor_16.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      async derive_boot_commitment_with_ed25519(context, ...args_1) {
        return { result: pureCircuits.derive_boot_commitment_with_ed25519(...args_1), context };
      },
      async derive_device_entry_with_ed25519(context, ...args_1) {
        return { result: pureCircuits.derive_device_entry_with_ed25519(...args_1), context };
      },
      activate_initial_device_with_ed25519: async (...args_1) => {
        if (args_1.length !== 3) {
          throw new __compactRuntime.CompactError(`activate_initial_device_with_ed25519: expected 3 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const pk_0 = args_1[1];
        const salt_0 = args_1[2];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('activate_initial_device_with_ed25519',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2459 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
          __compactRuntime.typeError('activate_initial_device_with_ed25519',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2459 char 1',
                                     'Curve25519Point',
                                     pk_0)
        }
        if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
          __compactRuntime.typeError('activate_initial_device_with_ed25519',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2459 char 1',
                                     'Bytes<32>',
                                     salt_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_18.toValue(pk_0).concat(_descriptor_0.toValue(salt_0)),
            alignment: _descriptor_18.alignment().concat(_descriptor_0.alignment())
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._activate_initial_device_with_ed25519_0(context,
                                                                            partialProofData,
                                                                            pk_0,
                                                                            salt_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      async challenge_withdraw_unshielded_with_ed25519(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_unshielded_with_ed25519(...args_1), context };
      },
      async challenge_withdraw_shielded_with_ed25519(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_with_ed25519(...args_1), context };
      },
      async challenge_withdraw_shielded_to_contract_with_ed25519(context, ...args_1) {
        return { result: pureCircuits.challenge_withdraw_shielded_to_contract_with_ed25519(...args_1), context };
      },
      async challenge_append_inbox_with_ed25519(context, ...args_1) {
        return { result: pureCircuits.challenge_append_inbox_with_ed25519(...args_1), context };
      },
      async challenge_rotate_enc_key_with_ed25519(context, ...args_1) {
        return { result: pureCircuits.challenge_rotate_enc_key_with_ed25519(...args_1), context };
      },
      async challenge_open_swap_shielded_with_ed25519(context, ...args_1) {
        return { result: pureCircuits.challenge_open_swap_shielded_with_ed25519(...args_1), context };
      },
      async ed25519_message_withdraw_unshielded(context, ...args_1) {
        return { result: pureCircuits.ed25519_message_withdraw_unshielded(...args_1), context };
      },
      async ed25519_message_withdraw_shielded(context, ...args_1) {
        return { result: pureCircuits.ed25519_message_withdraw_shielded(...args_1), context };
      },
      async ed25519_message_withdraw_shielded_to_contract(context, ...args_1) {
        return { result: pureCircuits.ed25519_message_withdraw_shielded_to_contract(...args_1), context };
      },
      async ed25519_message_append_inbox(context, ...args_1) {
        return { result: pureCircuits.ed25519_message_append_inbox(...args_1), context };
      },
      async ed25519_message_rotate_enc_key(context, ...args_1) {
        return { result: pureCircuits.ed25519_message_rotate_enc_key(...args_1), context };
      },
      async ed25519_message_open_swap_shielded(context, ...args_1) {
        return { result: pureCircuits.ed25519_message_open_swap_shielded(...args_1), context };
      },
      withdraw_unshielded_with_ed25519: async (...args_1) => {
        if (args_1.length !== 8) {
          throw new __compactRuntime.CompactError(`withdraw_unshielded_with_ed25519: expected 8 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const color_0 = args_1[1];
        const amount_0 = args_1[2];
        const recipient_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        const show_0 = args_1[7];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_unshielded_with_ed25519',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2838 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_ed25519',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2838 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_ed25519',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2838 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_unshielded_with_ed25519',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2838 char 1',
                                     'struct UserAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
          __compactRuntime.typeError('withdraw_unshielded_with_ed25519',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2838 char 1',
                                     'Curve25519Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_unshielded_with_ed25519',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2838 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && __compactRuntime.isValidCurve25519Point(sig_0.r) && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_CURVE25519_SCALAR)) {
          __compactRuntime.typeError('withdraw_unshielded_with_ed25519',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2838 char 1',
                                     'struct Ed25519Signature<r: Curve25519Point, s: Curve25519Scalar>',
                                     sig_0)
        }
        if (!(typeof(show_0) === 'object' && Array.isArray(show_0.label) && show_0.label.length === 24 && show_0.label.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.nonce) && show_0.nonce.length === 20 && show_0.nonce.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.amount) === 'object' && Array.isArray(show_0.amount.units) && show_0.amount.units.length === 24 && show_0.amount.units.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.amount.site) && show_0.amount.site.length === 34 && show_0.amount.site.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n))) {
          __compactRuntime.typeError('withdraw_unshielded_with_ed25519',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 2838 char 1',
                                     'struct EdShowAmount<label: Vector<24, Uint<0..256>>, nonce: Vector<20, Uint<0..256>>, amount: struct EdAmount<units: Vector<24, Uint<0..256>>, site: Vector<34, Uint<0..256>>>>',
                                     show_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_33.toValue(recipient_0).concat(_descriptor_18.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_20.toValue(sig_0).concat(_descriptor_31.toValue(show_0))))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_33.alignment().concat(_descriptor_18.alignment().concat(_descriptor_10.alignment().concat(_descriptor_20.alignment().concat(_descriptor_31.alignment()))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_unshielded_with_ed25519_0(context,
                                                                        partialProofData,
                                                                        color_0,
                                                                        amount_0,
                                                                        recipient_0,
                                                                        pk_0,
                                                                        use_counter_0,
                                                                        sig_0,
                                                                        show_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      append_inbox_with_ed25519: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`append_inbox_with_ed25519: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const entry_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        const show_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('append_inbox_with_ed25519',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2857 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('append_inbox_with_ed25519',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2857 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
          __compactRuntime.typeError('append_inbox_with_ed25519',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2857 char 1',
                                     'Curve25519Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('append_inbox_with_ed25519',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2857 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && __compactRuntime.isValidCurve25519Point(sig_0.r) && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_CURVE25519_SCALAR)) {
          __compactRuntime.typeError('append_inbox_with_ed25519',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2857 char 1',
                                     'struct Ed25519Signature<r: Curve25519Point, s: Curve25519Scalar>',
                                     sig_0)
        }
        if (!(typeof(show_0) === 'object' && Array.isArray(show_0.label) && show_0.label.length === 24 && show_0.label.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.nonce) && show_0.nonce.length === 20 && show_0.nonce.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n))) {
          __compactRuntime.typeError('append_inbox_with_ed25519',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2857 char 1',
                                     'struct EdShow<label: Vector<24, Uint<0..256>>, nonce: Vector<20, Uint<0..256>>>',
                                     show_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_7.toValue(entry_0).concat(_descriptor_18.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_20.toValue(sig_0).concat(_descriptor_23.toValue(show_0))))),
            alignment: _descriptor_7.alignment().concat(_descriptor_18.alignment().concat(_descriptor_10.alignment().concat(_descriptor_20.alignment().concat(_descriptor_23.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._append_inbox_with_ed25519_0(context,
                                                                 partialProofData,
                                                                 entry_0,
                                                                 pk_0,
                                                                 use_counter_0,
                                                                 sig_0,
                                                                 show_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_with_ed25519: async (...args_1) => {
        if (args_1.length !== 8) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_with_ed25519: expected 8 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        const show_0 = args_1[7];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_with_ed25519',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2872 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_ed25519',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2872 char 1',
                                     'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_with_ed25519',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2872 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_with_ed25519',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2872 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
          __compactRuntime.typeError('withdraw_shielded_with_ed25519',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2872 char 1',
                                     'Curve25519Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_with_ed25519',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2872 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && __compactRuntime.isValidCurve25519Point(sig_0.r) && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_CURVE25519_SCALAR)) {
          __compactRuntime.typeError('withdraw_shielded_with_ed25519',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2872 char 1',
                                     'struct Ed25519Signature<r: Curve25519Point, s: Curve25519Scalar>',
                                     sig_0)
        }
        if (!(typeof(show_0) === 'object' && Array.isArray(show_0.label) && show_0.label.length === 24 && show_0.label.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.nonce) && show_0.nonce.length === 20 && show_0.nonce.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.amount) === 'object' && Array.isArray(show_0.amount.units) && show_0.amount.units.length === 24 && show_0.amount.units.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.amount.site) && show_0.amount.site.length === 34 && show_0.amount.site.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n))) {
          __compactRuntime.typeError('withdraw_shielded_with_ed25519',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 2872 char 1',
                                     'struct EdShowAmount<label: Vector<24, Uint<0..256>>, nonce: Vector<20, Uint<0..256>>, amount: struct EdAmount<units: Vector<24, Uint<0..256>>, site: Vector<34, Uint<0..256>>>>',
                                     show_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_30.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_18.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_20.toValue(sig_0).concat(_descriptor_31.toValue(show_0))))))),
            alignment: _descriptor_30.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_18.alignment().concat(_descriptor_10.alignment().concat(_descriptor_20.alignment().concat(_descriptor_31.alignment()))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_with_ed25519_0(context,
                                                                      partialProofData,
                                                                      recipient_0,
                                                                      color_0,
                                                                      amount_0,
                                                                      pk_0,
                                                                      use_counter_0,
                                                                      sig_0,
                                                                      show_0);
        partialProofData.output = { value: _descriptor_16.toValue(result_0), alignment: _descriptor_16.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      withdraw_shielded_to_contract_with_ed25519: async (...args_1) => {
        if (args_1.length !== 8) {
          throw new __compactRuntime.CompactError(`withdraw_shielded_to_contract_with_ed25519: expected 8 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const recipient_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const pk_0 = args_1[4];
        const use_counter_0 = args_1[5];
        const sig_0 = args_1[6];
        const show_0 = args_1[7];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_ed25519',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2896 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_ed25519',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2896 char 1',
                                     'struct ContractAddress<bytes: Bytes<32>>',
                                     recipient_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_ed25519',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2896 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_ed25519',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2896 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_ed25519',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2896 char 1',
                                     'Curve25519Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_ed25519',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2896 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && __compactRuntime.isValidCurve25519Point(sig_0.r) && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_CURVE25519_SCALAR)) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_ed25519',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2896 char 1',
                                     'struct Ed25519Signature<r: Curve25519Point, s: Curve25519Scalar>',
                                     sig_0)
        }
        if (!(typeof(show_0) === 'object' && Array.isArray(show_0.label) && show_0.label.length === 24 && show_0.label.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.nonce) && show_0.nonce.length === 20 && show_0.nonce.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.amount) === 'object' && Array.isArray(show_0.amount.units) && show_0.amount.units.length === 24 && show_0.amount.units.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.amount.site) && show_0.amount.site.length === 34 && show_0.amount.site.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n))) {
          __compactRuntime.typeError('withdraw_shielded_to_contract_with_ed25519',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 2896 char 1',
                                     'struct EdShowAmount<label: Vector<24, Uint<0..256>>, nonce: Vector<20, Uint<0..256>>, amount: struct EdAmount<units: Vector<24, Uint<0..256>>, site: Vector<34, Uint<0..256>>>>',
                                     show_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_1.toValue(recipient_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_18.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_20.toValue(sig_0).concat(_descriptor_31.toValue(show_0))))))),
            alignment: _descriptor_1.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_18.alignment().concat(_descriptor_10.alignment().concat(_descriptor_20.alignment().concat(_descriptor_31.alignment()))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._withdraw_shielded_to_contract_with_ed25519_0(context,
                                                                                  partialProofData,
                                                                                  recipient_0,
                                                                                  color_0,
                                                                                  amount_0,
                                                                                  pk_0,
                                                                                  use_counter_0,
                                                                                  sig_0,
                                                                                  show_0);
        partialProofData.output = { value: _descriptor_32.toValue(result_0), alignment: _descriptor_32.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      rotate_enc_key_with_ed25519: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`rotate_enc_key_with_ed25519: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const new_key_0 = args_1[1];
        const pk_0 = args_1[2];
        const use_counter_0 = args_1[3];
        const sig_0 = args_1[4];
        const show_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('rotate_enc_key_with_ed25519',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2919 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
          __compactRuntime.typeError('rotate_enc_key_with_ed25519',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2919 char 1',
                                     'Bytes<32>',
                                     new_key_0)
        }
        if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
          __compactRuntime.typeError('rotate_enc_key_with_ed25519',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2919 char 1',
                                     'Curve25519Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('rotate_enc_key_with_ed25519',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2919 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && __compactRuntime.isValidCurve25519Point(sig_0.r) && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_CURVE25519_SCALAR)) {
          __compactRuntime.typeError('rotate_enc_key_with_ed25519',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2919 char 1',
                                     'struct Ed25519Signature<r: Curve25519Point, s: Curve25519Scalar>',
                                     sig_0)
        }
        if (!(typeof(show_0) === 'object' && Array.isArray(show_0.label) && show_0.label.length === 24 && show_0.label.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.nonce) && show_0.nonce.length === 20 && show_0.nonce.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n))) {
          __compactRuntime.typeError('rotate_enc_key_with_ed25519',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2919 char 1',
                                     'struct EdShow<label: Vector<24, Uint<0..256>>, nonce: Vector<20, Uint<0..256>>>',
                                     show_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(new_key_0).concat(_descriptor_18.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_20.toValue(sig_0).concat(_descriptor_23.toValue(show_0))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_18.alignment().concat(_descriptor_10.alignment().concat(_descriptor_20.alignment().concat(_descriptor_23.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._rotate_enc_key_with_ed25519_0(context,
                                                                   partialProofData,
                                                                   new_key_0,
                                                                   pk_0,
                                                                   use_counter_0,
                                                                   sig_0,
                                                                   show_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      open_swap_shielded_with_ed25519: async (...args_1) => {
        if (args_1.length !== 13) {
          throw new __compactRuntime.CompactError(`open_swap_shielded_with_ed25519: expected 13 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const give_color_0 = args_1[1];
        const give_amount_0 = args_1[2];
        const recipient_kind_0 = args_1[3];
        const recipient_0 = args_1[4];
        const want_0 = args_1[5];
        const want_entry_0 = args_1[6];
        const change_entry_0 = args_1[7];
        const valid_until_0 = args_1[8];
        const pk_0 = args_1[9];
        const use_counter_0 = args_1[10];
        const sig_0 = args_1[11];
        const show_0 = args_1[12];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('open_swap_shielded_with_ed25519',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 2936 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
          __compactRuntime.typeError('open_swap_shielded_with_ed25519',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 2936 char 1',
                                     'Bytes<32>',
                                     give_color_0)
        }
        if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('open_swap_shielded_with_ed25519',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 2936 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     give_amount_0)
        }
        if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
          __compactRuntime.typeError('open_swap_shielded_with_ed25519',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 2936 char 1',
                                     'Uint<0..256>',
                                     recipient_kind_0)
        }
        if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
          __compactRuntime.typeError('open_swap_shielded_with_ed25519',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 2936 char 1',
                                     'Bytes<32>',
                                     recipient_0)
        }
        if (!(typeof(want_0) === 'object' && want_0.nonce.buffer instanceof ArrayBuffer && want_0.nonce.BYTES_PER_ELEMENT === 1 && want_0.nonce.length === 32 && want_0.color.buffer instanceof ArrayBuffer && want_0.color.BYTES_PER_ELEMENT === 1 && want_0.color.length === 32 && typeof(want_0.value) === 'bigint' && want_0.value >= 0n && want_0.value <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('open_swap_shielded_with_ed25519',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 2936 char 1',
                                     'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                     want_0)
        }
        if (!(want_entry_0.buffer instanceof ArrayBuffer && want_entry_0.BYTES_PER_ELEMENT === 1 && want_entry_0.length === 192)) {
          __compactRuntime.typeError('open_swap_shielded_with_ed25519',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 2936 char 1',
                                     'Bytes<192>',
                                     want_entry_0)
        }
        if (!(change_entry_0.buffer instanceof ArrayBuffer && change_entry_0.BYTES_PER_ELEMENT === 1 && change_entry_0.length === 192)) {
          __compactRuntime.typeError('open_swap_shielded_with_ed25519',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 2936 char 1',
                                     'Bytes<192>',
                                     change_entry_0)
        }
        if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('open_swap_shielded_with_ed25519',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 2936 char 1',
                                     'Uint<0..18446744073709551616>',
                                     valid_until_0)
        }
        if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
          __compactRuntime.typeError('open_swap_shielded_with_ed25519',
                                     'argument 9 (argument 10 as invoked from Typescript)',
                                     'account.compact line 2936 char 1',
                                     'Curve25519Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('open_swap_shielded_with_ed25519',
                                     'argument 10 (argument 11 as invoked from Typescript)',
                                     'account.compact line 2936 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && __compactRuntime.isValidCurve25519Point(sig_0.r) && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_CURVE25519_SCALAR)) {
          __compactRuntime.typeError('open_swap_shielded_with_ed25519',
                                     'argument 11 (argument 12 as invoked from Typescript)',
                                     'account.compact line 2936 char 1',
                                     'struct Ed25519Signature<r: Curve25519Point, s: Curve25519Scalar>',
                                     sig_0)
        }
        if (!(typeof(show_0) === 'object' && Array.isArray(show_0.label) && show_0.label.length === 24 && show_0.label.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.nonce) && show_0.nonce.length === 20 && show_0.nonce.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.give) === 'object' && Array.isArray(show_0.give.units) && show_0.give.units.length === 24 && show_0.give.units.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.give.site) && show_0.give.site.length === 34 && show_0.give.site.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.want) === 'object' && Array.isArray(show_0.want.units) && show_0.want.units.length === 24 && show_0.want.units.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.want.site) && show_0.want.site.length === 34 && show_0.want.site.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.until) === 'object' && Array.isArray(show_0.until.digits) && show_0.until.digits.length === 14 && show_0.until.digits.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.until.q4) === 'bigint' && show_0.until.q4 >= 0n && show_0.until.q4 <= 65535n && typeof(show_0.until.q100) === 'bigint' && show_0.until.q100 >= 0n && show_0.until.q100 <= 65535n && typeof(show_0.until.q400) === 'bigint' && show_0.until.q400 >= 0n && show_0.until.q400 <= 65535n)) {
          __compactRuntime.typeError('open_swap_shielded_with_ed25519',
                                     'argument 12 (argument 13 as invoked from Typescript)',
                                     'account.compact line 2936 char 1',
                                     'struct EdShowSwap<label: Vector<24, Uint<0..256>>, nonce: Vector<20, Uint<0..256>>, give: struct EdAmount<units: Vector<24, Uint<0..256>>, site: Vector<34, Uint<0..256>>>, want: struct EdAmount<units: Vector<24, Uint<0..256>>, site: Vector<34, Uint<0..256>>>, until: struct EdDeadline<digits: Vector<14, Uint<0..256>>, q4: Uint<0..65536>, q100: Uint<0..65536>, q400: Uint<0..65536>>>',
                                     show_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(give_color_0).concat(_descriptor_8.toValue(give_amount_0).concat(_descriptor_3.toValue(recipient_kind_0).concat(_descriptor_0.toValue(recipient_0).concat(_descriptor_9.toValue(want_0).concat(_descriptor_7.toValue(want_entry_0).concat(_descriptor_7.toValue(change_entry_0).concat(_descriptor_10.toValue(valid_until_0).concat(_descriptor_18.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_20.toValue(sig_0).concat(_descriptor_29.toValue(show_0)))))))))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_3.alignment().concat(_descriptor_0.alignment().concat(_descriptor_9.alignment().concat(_descriptor_7.alignment().concat(_descriptor_7.alignment().concat(_descriptor_10.alignment().concat(_descriptor_18.alignment().concat(_descriptor_10.alignment().concat(_descriptor_20.alignment().concat(_descriptor_29.alignment())))))))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._open_swap_shielded_with_ed25519_0(context,
                                                                       partialProofData,
                                                                       give_color_0,
                                                                       give_amount_0,
                                                                       recipient_kind_0,
                                                                       recipient_0,
                                                                       want_0,
                                                                       want_entry_0,
                                                                       change_entry_0,
                                                                       valid_until_0,
                                                                       pk_0,
                                                                       use_counter_0,
                                                                       sig_0,
                                                                       show_0);
        partialProofData.output = { value: _descriptor_16.toValue(result_0), alignment: _descriptor_16.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      bridge_deposit_start_with_evm: async (...args_1) => {
        if (args_1.length !== 11) {
          throw new __compactRuntime.CompactError(`bridge_deposit_start_with_evm: expected 11 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const erc20_0 = args_1[1];
        const amount_0 = args_1[2];
        const evm_nonce_0 = args_1[3];
        const gas_limit_0 = args_1[4];
        const max_fee_0 = args_1[5];
        const max_priority_fee_0 = args_1[6];
        const key_version_0 = args_1[7];
        const pk_0 = args_1[8];
        const use_counter_0 = args_1[9];
        const sig_0 = args_1[10];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 3006 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(erc20_0.buffer instanceof ArrayBuffer && erc20_0.BYTES_PER_ELEMENT === 1 && erc20_0.length === 20)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 3006 char 1',
                                     'Bytes<20>',
                                     erc20_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 3006 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 3006 char 1',
                                     'Uint<0..18446744073709551616>',
                                     evm_nonce_0)
        }
        if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 3006 char 1',
                                     'Uint<0..18446744073709551616>',
                                     gas_limit_0)
        }
        if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 3006 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     max_fee_0)
        }
        if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 3006 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     max_priority_fee_0)
        }
        if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 3006 char 1',
                                     'Uint<0..256>',
                                     key_version_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 3006 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 9 (argument 10 as invoked from Typescript)',
                                     'account.compact line 3006 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('bridge_deposit_start_with_evm',
                                     'argument 10 (argument 11 as invoked from Typescript)',
                                     'account.compact line 3006 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_11.toValue(erc20_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_10.toValue(evm_nonce_0).concat(_descriptor_10.toValue(gas_limit_0).concat(_descriptor_8.toValue(max_fee_0).concat(_descriptor_8.toValue(max_priority_fee_0).concat(_descriptor_3.toValue(key_version_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0)))))))))),
            alignment: _descriptor_11.alignment().concat(_descriptor_8.alignment().concat(_descriptor_10.alignment().concat(_descriptor_10.alignment().concat(_descriptor_8.alignment().concat(_descriptor_8.alignment().concat(_descriptor_3.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment())))))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._bridge_deposit_start_with_evm_0(context,
                                                                     partialProofData,
                                                                     erc20_0,
                                                                     amount_0,
                                                                     evm_nonce_0,
                                                                     gas_limit_0,
                                                                     max_fee_0,
                                                                     max_priority_fee_0,
                                                                     key_version_0,
                                                                     pk_0,
                                                                     use_counter_0,
                                                                     sig_0);
        partialProofData.output = { value: [], alignment: [] };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      bridge_deposit_complete: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`bridge_deposit_complete: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const request_id_0 = args_1[1];
        const attestation_0 = args_1[2];
        const output_0 = args_1[3];
        const mint_nonce_0 = args_1[4];
        const entry_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('bridge_deposit_complete',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 3053 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(request_id_0.buffer instanceof ArrayBuffer && request_id_0.BYTES_PER_ELEMENT === 1 && request_id_0.length === 32)) {
          __compactRuntime.typeError('bridge_deposit_complete',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 3053 char 1',
                                     'Bytes<32>',
                                     request_id_0)
        }
        if (!(typeof(attestation_0) === 'object' && typeof(attestation_0.signature) === 'object' && typeof(attestation_0.signature.bigR) === 'object' && attestation_0.signature.bigR.x.buffer instanceof ArrayBuffer && attestation_0.signature.bigR.x.BYTES_PER_ELEMENT === 1 && attestation_0.signature.bigR.x.length === 32 && attestation_0.signature.bigR.y.buffer instanceof ArrayBuffer && attestation_0.signature.bigR.y.BYTES_PER_ELEMENT === 1 && attestation_0.signature.bigR.y.length === 32 && attestation_0.signature.s.buffer instanceof ArrayBuffer && attestation_0.signature.s.BYTES_PER_ELEMENT === 1 && attestation_0.signature.s.length === 32 && typeof(attestation_0.signature.recoveryId) === 'bigint' && attestation_0.signature.recoveryId >= 0n && attestation_0.signature.recoveryId <= 255n)) {
          __compactRuntime.typeError('bridge_deposit_complete',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 3053 char 1',
                                     'struct RespondBidirectionalEvent<signature: struct Signature<bigR: struct AffinePoint<x: Bytes<32>, y: Bytes<32>>, s: Bytes<32>, recoveryId: Uint<0..256>>>',
                                     attestation_0)
        }
        if (!(output_0.buffer instanceof ArrayBuffer && output_0.BYTES_PER_ELEMENT === 1 && output_0.length === 1)) {
          __compactRuntime.typeError('bridge_deposit_complete',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 3053 char 1',
                                     'Bytes<1>',
                                     output_0)
        }
        if (!(mint_nonce_0.buffer instanceof ArrayBuffer && mint_nonce_0.BYTES_PER_ELEMENT === 1 && mint_nonce_0.length === 32)) {
          __compactRuntime.typeError('bridge_deposit_complete',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 3053 char 1',
                                     'Bytes<32>',
                                     mint_nonce_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('bridge_deposit_complete',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 3053 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(request_id_0).concat(_descriptor_5.toValue(attestation_0).concat(_descriptor_17.toValue(output_0).concat(_descriptor_0.toValue(mint_nonce_0).concat(_descriptor_7.toValue(entry_0))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_5.alignment().concat(_descriptor_17.alignment().concat(_descriptor_0.alignment().concat(_descriptor_7.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._bridge_deposit_complete_0(context,
                                                               partialProofData,
                                                               request_id_0,
                                                               attestation_0,
                                                               output_0,
                                                               mint_nonce_0,
                                                               entry_0);
        partialProofData.output = { value: _descriptor_16.toValue(result_0), alignment: _descriptor_16.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      bridge_withdraw_start_with_evm: async (...args_1) => {
        if (args_1.length !== 14) {
          throw new __compactRuntime.CompactError(`bridge_withdraw_start_with_evm: expected 14 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const dest_0 = args_1[1];
        const color_0 = args_1[2];
        const amount_0 = args_1[3];
        const evm_nonce_0 = args_1[4];
        const gas_limit_0 = args_1[5];
        const max_fee_0 = args_1[6];
        const max_priority_fee_0 = args_1[7];
        const key_version_0 = args_1[8];
        const erc20_0 = args_1[9];
        const change_entry_0 = args_1[10];
        const pk_0 = args_1[11];
        const use_counter_0 = args_1[12];
        const sig_0 = args_1[13];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(dest_0.buffer instanceof ArrayBuffer && dest_0.BYTES_PER_ELEMENT === 1 && dest_0.length === 20)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'Bytes<20>',
                                     dest_0)
        }
        if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'Bytes<32>',
                                     color_0)
        }
        if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     amount_0)
        }
        if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'Uint<0..18446744073709551616>',
                                     evm_nonce_0)
        }
        if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'Uint<0..18446744073709551616>',
                                     gas_limit_0)
        }
        if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 6 (argument 7 as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     max_fee_0)
        }
        if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 7 (argument 8 as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'Uint<0..340282366920938463463374607431768211456>',
                                     max_priority_fee_0)
        }
        if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 8 (argument 9 as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'Uint<0..256>',
                                     key_version_0)
        }
        if (!(erc20_0.buffer instanceof ArrayBuffer && erc20_0.BYTES_PER_ELEMENT === 1 && erc20_0.length === 20)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 9 (argument 10 as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'Bytes<20>',
                                     erc20_0)
        }
        if (!(change_entry_0.buffer instanceof ArrayBuffer && change_entry_0.BYTES_PER_ELEMENT === 1 && change_entry_0.length === 192)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 10 (argument 11 as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'Bytes<192>',
                                     change_entry_0)
        }
        if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 11 (argument 12 as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'Secp256k1Point',
                                     pk_0)
        }
        if (!(typeof(use_counter_0) === 'bigint' && use_counter_0 >= 0n && use_counter_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 12 (argument 13 as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'Uint<0..18446744073709551616>',
                                     use_counter_0)
        }
        if (!(typeof(sig_0) === 'object' && typeof(sig_0.r) === 'bigint' && sig_0.r >= 0 && sig_0.r <= __compactRuntime.MAX_SECP256K1_SCALAR && typeof(sig_0.s) === 'bigint' && sig_0.s >= 0 && sig_0.s <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
          __compactRuntime.typeError('bridge_withdraw_start_with_evm',
                                     'argument 13 (argument 14 as invoked from Typescript)',
                                     'account.compact line 3091 char 1',
                                     'struct Secp256k1EcdsaSignature<r: Secp256k1Scalar, s: Secp256k1Scalar>',
                                     sig_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_11.toValue(dest_0).concat(_descriptor_0.toValue(color_0).concat(_descriptor_8.toValue(amount_0).concat(_descriptor_10.toValue(evm_nonce_0).concat(_descriptor_10.toValue(gas_limit_0).concat(_descriptor_8.toValue(max_fee_0).concat(_descriptor_8.toValue(max_priority_fee_0).concat(_descriptor_3.toValue(key_version_0).concat(_descriptor_11.toValue(erc20_0).concat(_descriptor_7.toValue(change_entry_0).concat(_descriptor_12.toValue(pk_0).concat(_descriptor_10.toValue(use_counter_0).concat(_descriptor_14.toValue(sig_0))))))))))))),
            alignment: _descriptor_11.alignment().concat(_descriptor_0.alignment().concat(_descriptor_8.alignment().concat(_descriptor_10.alignment().concat(_descriptor_10.alignment().concat(_descriptor_8.alignment().concat(_descriptor_8.alignment().concat(_descriptor_3.alignment().concat(_descriptor_11.alignment().concat(_descriptor_7.alignment().concat(_descriptor_12.alignment().concat(_descriptor_10.alignment().concat(_descriptor_14.alignment()))))))))))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._bridge_withdraw_start_with_evm_0(context,
                                                                      partialProofData,
                                                                      dest_0,
                                                                      color_0,
                                                                      amount_0,
                                                                      evm_nonce_0,
                                                                      gas_limit_0,
                                                                      max_fee_0,
                                                                      max_priority_fee_0,
                                                                      key_version_0,
                                                                      erc20_0,
                                                                      change_entry_0,
                                                                      pk_0,
                                                                      use_counter_0,
                                                                      sig_0);
        partialProofData.output = { value: _descriptor_16.toValue(result_0), alignment: _descriptor_16.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      bridge_withdraw_complete: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`bridge_withdraw_complete: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const request_id_0 = args_1[1];
        const attestation_0 = args_1[2];
        const output_0 = args_1[3];
        const mint_nonce_0 = args_1[4];
        const entry_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('bridge_withdraw_complete',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 3149 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(request_id_0.buffer instanceof ArrayBuffer && request_id_0.BYTES_PER_ELEMENT === 1 && request_id_0.length === 32)) {
          __compactRuntime.typeError('bridge_withdraw_complete',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 3149 char 1',
                                     'Bytes<32>',
                                     request_id_0)
        }
        if (!(typeof(attestation_0) === 'object' && typeof(attestation_0.signature) === 'object' && typeof(attestation_0.signature.bigR) === 'object' && attestation_0.signature.bigR.x.buffer instanceof ArrayBuffer && attestation_0.signature.bigR.x.BYTES_PER_ELEMENT === 1 && attestation_0.signature.bigR.x.length === 32 && attestation_0.signature.bigR.y.buffer instanceof ArrayBuffer && attestation_0.signature.bigR.y.BYTES_PER_ELEMENT === 1 && attestation_0.signature.bigR.y.length === 32 && attestation_0.signature.s.buffer instanceof ArrayBuffer && attestation_0.signature.s.BYTES_PER_ELEMENT === 1 && attestation_0.signature.s.length === 32 && typeof(attestation_0.signature.recoveryId) === 'bigint' && attestation_0.signature.recoveryId >= 0n && attestation_0.signature.recoveryId <= 255n)) {
          __compactRuntime.typeError('bridge_withdraw_complete',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 3149 char 1',
                                     'struct RespondBidirectionalEvent<signature: struct Signature<bigR: struct AffinePoint<x: Bytes<32>, y: Bytes<32>>, s: Bytes<32>, recoveryId: Uint<0..256>>>',
                                     attestation_0)
        }
        if (!(output_0.buffer instanceof ArrayBuffer && output_0.BYTES_PER_ELEMENT === 1 && output_0.length === 1)) {
          __compactRuntime.typeError('bridge_withdraw_complete',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 3149 char 1',
                                     'Bytes<1>',
                                     output_0)
        }
        if (!(mint_nonce_0.buffer instanceof ArrayBuffer && mint_nonce_0.BYTES_PER_ELEMENT === 1 && mint_nonce_0.length === 32)) {
          __compactRuntime.typeError('bridge_withdraw_complete',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 3149 char 1',
                                     'Bytes<32>',
                                     mint_nonce_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('bridge_withdraw_complete',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 3149 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(request_id_0).concat(_descriptor_5.toValue(attestation_0).concat(_descriptor_17.toValue(output_0).concat(_descriptor_0.toValue(mint_nonce_0).concat(_descriptor_7.toValue(entry_0))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_5.alignment().concat(_descriptor_17.alignment().concat(_descriptor_0.alignment().concat(_descriptor_7.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._bridge_withdraw_complete_0(context,
                                                                partialProofData,
                                                                request_id_0,
                                                                attestation_0,
                                                                output_0,
                                                                mint_nonce_0,
                                                                entry_0);
        partialProofData.output = { value: _descriptor_16.toValue(result_0), alignment: _descriptor_16.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      },
      bridge_withdraw_refund: async (...args_1) => {
        if (args_1.length !== 6) {
          throw new __compactRuntime.CompactError(`bridge_withdraw_refund: expected 6 arguments (as invoked from Typescript), received ${args_1.length}`);
        }
        const contextOrig_0 = args_1[0];
        const request_id_0 = args_1[1];
        const attestation_0 = args_1[2];
        const output_0 = args_1[3];
        const mint_nonce_0 = args_1[4];
        const entry_0 = args_1[5];
        if (!(typeof(contextOrig_0) === 'object' && contextOrig_0.callContext.currentQueryContext != undefined)) {
          __compactRuntime.typeError('bridge_withdraw_refund',
                                     'argument 1 (as invoked from Typescript)',
                                     'account.compact line 3179 char 1',
                                     'CircuitContext',
                                     contextOrig_0)
        }
        if (!(request_id_0.buffer instanceof ArrayBuffer && request_id_0.BYTES_PER_ELEMENT === 1 && request_id_0.length === 32)) {
          __compactRuntime.typeError('bridge_withdraw_refund',
                                     'argument 1 (argument 2 as invoked from Typescript)',
                                     'account.compact line 3179 char 1',
                                     'Bytes<32>',
                                     request_id_0)
        }
        if (!(typeof(attestation_0) === 'object' && typeof(attestation_0.signature) === 'object' && typeof(attestation_0.signature.bigR) === 'object' && attestation_0.signature.bigR.x.buffer instanceof ArrayBuffer && attestation_0.signature.bigR.x.BYTES_PER_ELEMENT === 1 && attestation_0.signature.bigR.x.length === 32 && attestation_0.signature.bigR.y.buffer instanceof ArrayBuffer && attestation_0.signature.bigR.y.BYTES_PER_ELEMENT === 1 && attestation_0.signature.bigR.y.length === 32 && attestation_0.signature.s.buffer instanceof ArrayBuffer && attestation_0.signature.s.BYTES_PER_ELEMENT === 1 && attestation_0.signature.s.length === 32 && typeof(attestation_0.signature.recoveryId) === 'bigint' && attestation_0.signature.recoveryId >= 0n && attestation_0.signature.recoveryId <= 255n)) {
          __compactRuntime.typeError('bridge_withdraw_refund',
                                     'argument 2 (argument 3 as invoked from Typescript)',
                                     'account.compact line 3179 char 1',
                                     'struct RespondBidirectionalEvent<signature: struct Signature<bigR: struct AffinePoint<x: Bytes<32>, y: Bytes<32>>, s: Bytes<32>, recoveryId: Uint<0..256>>>',
                                     attestation_0)
        }
        if (!(output_0.buffer instanceof ArrayBuffer && output_0.BYTES_PER_ELEMENT === 1 && output_0.length === 5)) {
          __compactRuntime.typeError('bridge_withdraw_refund',
                                     'argument 3 (argument 4 as invoked from Typescript)',
                                     'account.compact line 3179 char 1',
                                     'Bytes<5>',
                                     output_0)
        }
        if (!(mint_nonce_0.buffer instanceof ArrayBuffer && mint_nonce_0.BYTES_PER_ELEMENT === 1 && mint_nonce_0.length === 32)) {
          __compactRuntime.typeError('bridge_withdraw_refund',
                                     'argument 4 (argument 5 as invoked from Typescript)',
                                     'account.compact line 3179 char 1',
                                     'Bytes<32>',
                                     mint_nonce_0)
        }
        if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
          __compactRuntime.typeError('bridge_withdraw_refund',
                                     'argument 5 (argument 6 as invoked from Typescript)',
                                     'account.compact line 3179 char 1',
                                     'Bytes<192>',
                                     entry_0)
        }
        const context = __compactRuntime.copyCircuitContext(contextOrig_0);
        const partialProofData = {
          input: {
            value: _descriptor_0.toValue(request_id_0).concat(_descriptor_5.toValue(attestation_0).concat(_descriptor_6.toValue(output_0).concat(_descriptor_0.toValue(mint_nonce_0).concat(_descriptor_7.toValue(entry_0))))),
            alignment: _descriptor_0.alignment().concat(_descriptor_5.alignment().concat(_descriptor_6.alignment().concat(_descriptor_0.alignment().concat(_descriptor_7.alignment()))))
          },
          output: undefined,
          publicTranscript: [],
          privateTranscriptOutputs: []
        };
        const result_0 = await this._bridge_withdraw_refund_0(context,
                                                              partialProofData,
                                                              request_id_0,
                                                              attestation_0,
                                                              output_0,
                                                              mint_nonce_0,
                                                              entry_0);
        partialProofData.output = { value: _descriptor_9.toValue(result_0), alignment: _descriptor_9.alignment() };
        __compactRuntime.finalizeCallProofData(context, partialProofData);
        return { result: result_0, context: context, gasCost: context.callContext.currentGasCost };
      }
    };
    this.impureCircuits = {
      activate_initial_device_with_jubjub: this.circuits.activate_initial_device_with_jubjub,
      activate_initial_device_with_k256: this.circuits.activate_initial_device_with_k256,
      activate_initial_device_with_evm: this.circuits.activate_initial_device_with_evm,
      deposit_unshielded: this.circuits.deposit_unshielded,
      withdraw_unshielded_with_jubjub: this.circuits.withdraw_unshielded_with_jubjub,
      withdraw_unshielded_with_k256: this.circuits.withdraw_unshielded_with_k256,
      withdraw_unshielded_with_evm: this.circuits.withdraw_unshielded_with_evm,
      deposit_shielded: this.circuits.deposit_shielded,
      append_inbox_with_jubjub: this.circuits.append_inbox_with_jubjub,
      append_inbox_with_k256: this.circuits.append_inbox_with_k256,
      append_inbox_with_evm: this.circuits.append_inbox_with_evm,
      withdraw_shielded_with_jubjub: this.circuits.withdraw_shielded_with_jubjub,
      withdraw_shielded_with_k256: this.circuits.withdraw_shielded_with_k256,
      withdraw_shielded_with_evm: this.circuits.withdraw_shielded_with_evm,
      withdraw_shielded_to_contract_with_jubjub: this.circuits.withdraw_shielded_to_contract_with_jubjub,
      withdraw_shielded_to_contract_with_k256: this.circuits.withdraw_shielded_to_contract_with_k256,
      withdraw_shielded_to_contract_with_evm: this.circuits.withdraw_shielded_to_contract_with_evm,
      rotate_enc_key_with_jubjub: this.circuits.rotate_enc_key_with_jubjub,
      rotate_enc_key_with_k256: this.circuits.rotate_enc_key_with_k256,
      rotate_enc_key_with_evm: this.circuits.rotate_enc_key_with_evm,
      add_device_with_jubjub: this.circuits.add_device_with_jubjub,
      add_device_with_k256: this.circuits.add_device_with_k256,
      add_device_with_evm: this.circuits.add_device_with_evm,
      remove_device_with_jubjub: this.circuits.remove_device_with_jubjub,
      remove_device_with_k256: this.circuits.remove_device_with_k256,
      remove_device_with_evm: this.circuits.remove_device_with_evm,
      open_swap_shielded_with_jubjub: this.circuits.open_swap_shielded_with_jubjub,
      open_swap_shielded_with_evm: this.circuits.open_swap_shielded_with_evm,
      activate_initial_device_with_ed25519: this.circuits.activate_initial_device_with_ed25519,
      withdraw_unshielded_with_ed25519: this.circuits.withdraw_unshielded_with_ed25519,
      append_inbox_with_ed25519: this.circuits.append_inbox_with_ed25519,
      withdraw_shielded_with_ed25519: this.circuits.withdraw_shielded_with_ed25519,
      withdraw_shielded_to_contract_with_ed25519: this.circuits.withdraw_shielded_to_contract_with_ed25519,
      rotate_enc_key_with_ed25519: this.circuits.rotate_enc_key_with_ed25519,
      open_swap_shielded_with_ed25519: this.circuits.open_swap_shielded_with_ed25519,
      bridge_deposit_start_with_evm: this.circuits.bridge_deposit_start_with_evm,
      bridge_deposit_complete: this.circuits.bridge_deposit_complete,
      bridge_withdraw_start_with_evm: this.circuits.bridge_withdraw_start_with_evm,
      bridge_withdraw_complete: this.circuits.bridge_withdraw_complete,
      bridge_withdraw_refund: this.circuits.bridge_withdraw_refund
    };
    this.provableCircuits = {
      activate_initial_device_with_jubjub: this.circuits.activate_initial_device_with_jubjub,
      activate_initial_device_with_k256: this.circuits.activate_initial_device_with_k256,
      activate_initial_device_with_evm: this.circuits.activate_initial_device_with_evm,
      deposit_unshielded: this.circuits.deposit_unshielded,
      withdraw_unshielded_with_jubjub: this.circuits.withdraw_unshielded_with_jubjub,
      withdraw_unshielded_with_k256: this.circuits.withdraw_unshielded_with_k256,
      withdraw_unshielded_with_evm: this.circuits.withdraw_unshielded_with_evm,
      deposit_shielded: this.circuits.deposit_shielded,
      append_inbox_with_jubjub: this.circuits.append_inbox_with_jubjub,
      append_inbox_with_k256: this.circuits.append_inbox_with_k256,
      append_inbox_with_evm: this.circuits.append_inbox_with_evm,
      withdraw_shielded_with_jubjub: this.circuits.withdraw_shielded_with_jubjub,
      withdraw_shielded_with_k256: this.circuits.withdraw_shielded_with_k256,
      withdraw_shielded_with_evm: this.circuits.withdraw_shielded_with_evm,
      withdraw_shielded_to_contract_with_jubjub: this.circuits.withdraw_shielded_to_contract_with_jubjub,
      withdraw_shielded_to_contract_with_k256: this.circuits.withdraw_shielded_to_contract_with_k256,
      withdraw_shielded_to_contract_with_evm: this.circuits.withdraw_shielded_to_contract_with_evm,
      rotate_enc_key_with_jubjub: this.circuits.rotate_enc_key_with_jubjub,
      rotate_enc_key_with_k256: this.circuits.rotate_enc_key_with_k256,
      rotate_enc_key_with_evm: this.circuits.rotate_enc_key_with_evm,
      add_device_with_jubjub: this.circuits.add_device_with_jubjub,
      add_device_with_k256: this.circuits.add_device_with_k256,
      add_device_with_evm: this.circuits.add_device_with_evm,
      remove_device_with_jubjub: this.circuits.remove_device_with_jubjub,
      remove_device_with_k256: this.circuits.remove_device_with_k256,
      remove_device_with_evm: this.circuits.remove_device_with_evm,
      open_swap_shielded_with_jubjub: this.circuits.open_swap_shielded_with_jubjub,
      open_swap_shielded_with_evm: this.circuits.open_swap_shielded_with_evm,
      activate_initial_device_with_ed25519: this.circuits.activate_initial_device_with_ed25519,
      withdraw_unshielded_with_ed25519: this.circuits.withdraw_unshielded_with_ed25519,
      append_inbox_with_ed25519: this.circuits.append_inbox_with_ed25519,
      withdraw_shielded_with_ed25519: this.circuits.withdraw_shielded_with_ed25519,
      withdraw_shielded_to_contract_with_ed25519: this.circuits.withdraw_shielded_to_contract_with_ed25519,
      rotate_enc_key_with_ed25519: this.circuits.rotate_enc_key_with_ed25519,
      open_swap_shielded_with_ed25519: this.circuits.open_swap_shielded_with_ed25519,
      bridge_deposit_start_with_evm: this.circuits.bridge_deposit_start_with_evm,
      bridge_deposit_complete: this.circuits.bridge_deposit_complete,
      bridge_withdraw_start_with_evm: this.circuits.bridge_withdraw_start_with_evm,
      bridge_withdraw_complete: this.circuits.bridge_withdraw_complete,
      bridge_withdraw_refund: this.circuits.bridge_withdraw_refund
    };
  }
  async initialState(...args_0) {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`Contract state constructor: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const constructorContext_0 = args_0[0];
    const initial_device_boot_0 = args_0[1];
    const encryption_key_0 = args_0[2];
    const evm_domain_0 = args_0[3];
    const vault_ref_0 = args_0[4];
    const vault_addr_0 = args_0[5];
    if (typeof(constructorContext_0) !== 'object') {
      throw new __compactRuntime.CompactError(`Contract state constructor: expected 'constructorContext' in argument 1 (as invoked from Typescript) to be an object`);
    }
    if (!('initialPrivateState' in constructorContext_0)) {
      throw new __compactRuntime.CompactError(`Contract state constructor: expected 'initialPrivateState' in argument 1 (as invoked from Typescript)`);
    }
    if (!('initialZswapLocalState' in constructorContext_0)) {
      throw new __compactRuntime.CompactError(`Contract state constructor: expected 'initialZswapLocalState' in argument 1 (as invoked from Typescript)`);
    }
    if (typeof(constructorContext_0.initialZswapLocalState) !== 'object') {
      throw new __compactRuntime.CompactError(`Contract state constructor: expected 'initialZswapLocalState' in argument 1 (as invoked from Typescript) to be an object`);
    }
    if (!(initial_device_boot_0.buffer instanceof ArrayBuffer && initial_device_boot_0.BYTES_PER_ELEMENT === 1 && initial_device_boot_0.length === 32)) {
      __compactRuntime.typeError('Contract state constructor',
                                 'argument 1 (argument 2 as invoked from Typescript)',
                                 'account.compact line 490 char 1',
                                 'Bytes<32>',
                                 initial_device_boot_0)
    }
    if (!(encryption_key_0.buffer instanceof ArrayBuffer && encryption_key_0.BYTES_PER_ELEMENT === 1 && encryption_key_0.length === 32)) {
      __compactRuntime.typeError('Contract state constructor',
                                 'argument 2 (argument 3 as invoked from Typescript)',
                                 'account.compact line 490 char 1',
                                 'Bytes<32>',
                                 encryption_key_0)
    }
    if (!(evm_domain_0.buffer instanceof ArrayBuffer && evm_domain_0.BYTES_PER_ELEMENT === 1 && evm_domain_0.length === 32)) {
      __compactRuntime.typeError('Contract state constructor',
                                 'argument 3 (argument 4 as invoked from Typescript)',
                                 'account.compact line 490 char 1',
                                 'Bytes<32>',
                                 evm_domain_0)
    }
    if (!(typeof(vault_ref_0) === 'object' && vault_ref_0.bytes.buffer instanceof ArrayBuffer && vault_ref_0.bytes.BYTES_PER_ELEMENT === 1 && vault_ref_0.bytes.length === 32)) {
      __compactRuntime.typeError('Contract state constructor',
                                 'argument 4 (argument 5 as invoked from Typescript)',
                                 'account.compact line 490 char 1',
                                 'contract Erc20Vault[startDeposit(Uint<0..18446744073709551616>, Uint<0..18446744073709551616>, Uint<0..340282366920938463463374607431768211456>, Uint<0..340282366920938463463374607431768211456>, Uint<0..256>, Bytes<20>, Uint<0..340282366920938463463374607431768211456>, struct Either<is_left: Boolean, left: struct ZswapCoinPublicKey<bytes: Bytes<32>>, right: struct ContractAddress<bytes: Bytes<32>>>): [], completeDeposit(Bytes<32>, struct RespondBidirectionalEvent<signature: struct Signature<bigR: struct AffinePoint<x: Bytes<32>, y: Bytes<32>>, s: Bytes<32>, recoveryId: Uint<0..256>>>, Bytes<1>, Bytes<32>): struct Maybe<is_some: Boolean, value: struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>>, startWithdraw(Uint<0..18446744073709551616>, Uint<0..18446744073709551616>, Uint<0..340282366920938463463374607431768211456>, Uint<0..340282366920938463463374607431768211456>, Uint<0..256>, Bytes<20>, Uint<0..340282366920938463463374607431768211456>, Bytes<20>, struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>, struct Either<is_left: Boolean, left: struct ZswapCoinPublicKey<bytes: Bytes<32>>, right: struct ContractAddress<bytes: Bytes<32>>>): [], completeWithdraw(Bytes<32>, struct RespondBidirectionalEvent<signature: struct Signature<bigR: struct AffinePoint<x: Bytes<32>, y: Bytes<32>>, s: Bytes<32>, recoveryId: Uint<0..256>>>, Bytes<1>, Bytes<32>): struct Maybe<is_some: Boolean, value: struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>>, refundWithdraw(Bytes<32>, struct RespondBidirectionalEvent<signature: struct Signature<bigR: struct AffinePoint<x: Bytes<32>, y: Bytes<32>>, s: Bytes<32>, recoveryId: Uint<0..256>>>, Bytes<5>, Bytes<32>): struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>]',
                                 vault_ref_0)
    }
    if (!(typeof(vault_addr_0) === 'object' && vault_addr_0.bytes.buffer instanceof ArrayBuffer && vault_addr_0.bytes.BYTES_PER_ELEMENT === 1 && vault_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('Contract state constructor',
                                 'argument 5 (argument 6 as invoked from Typescript)',
                                 'account.compact line 490 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 vault_addr_0)
    }
    const state_0 = new __compactRuntime.ContractState();
    let stateValue_0 = __compactRuntime.StateValue.newArray();
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    stateValue_0 = stateValue_0.arrayPush(__compactRuntime.StateValue.newNull());
    state_0.data = new __compactRuntime.ChargedState(stateValue_0);
    state_0.setOperation('activate_initial_device_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('activate_initial_device_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('activate_initial_device_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('deposit_unshielded', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_unshielded_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_unshielded_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_unshielded_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('deposit_shielded', new __compactRuntime.ContractOperation());
    state_0.setOperation('append_inbox_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('append_inbox_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('append_inbox_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_to_contract_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_to_contract_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_to_contract_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('rotate_enc_key_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('rotate_enc_key_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('rotate_enc_key_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('add_device_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('add_device_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('add_device_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('remove_device_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('remove_device_with_k256', new __compactRuntime.ContractOperation());
    state_0.setOperation('remove_device_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('open_swap_shielded_with_jubjub', new __compactRuntime.ContractOperation());
    state_0.setOperation('open_swap_shielded_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('activate_initial_device_with_ed25519', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_unshielded_with_ed25519', new __compactRuntime.ContractOperation());
    state_0.setOperation('append_inbox_with_ed25519', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_with_ed25519', new __compactRuntime.ContractOperation());
    state_0.setOperation('withdraw_shielded_to_contract_with_ed25519', new __compactRuntime.ContractOperation());
    state_0.setOperation('rotate_enc_key_with_ed25519', new __compactRuntime.ContractOperation());
    state_0.setOperation('open_swap_shielded_with_ed25519', new __compactRuntime.ContractOperation());
    state_0.setOperation('bridge_deposit_start_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('bridge_deposit_complete', new __compactRuntime.ContractOperation());
    state_0.setOperation('bridge_withdraw_start_with_evm', new __compactRuntime.ContractOperation());
    state_0.setOperation('bridge_withdraw_complete', new __compactRuntime.ContractOperation());
    state_0.setOperation('bridge_withdraw_refund', new __compactRuntime.ContractOperation());
    const context = __compactRuntime.createCircuitContext({circuitId: 'constructor', contractAddress: __compactRuntime.dummyContractAddress(), coinPublicKeyOrZswapState: constructorContext_0.initialZswapLocalState.coinPublicKey, contractState: state_0.data, privateState: constructorContext_0.initialPrivateState});
    const partialProofData = {
      input: { value: [], alignment: [] },
      output: undefined,
      publicTranscript: [],
      privateTranscriptOutputs: []
    };
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(0n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(0n),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(1n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(new Uint8Array(32)),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(2n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newMap(
                                                          new __compactRuntime.StateMap()
                                                        ).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(3n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(0n),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(4n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newMap(
                                                          new __compactRuntime.StateMap()
                                                        ).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(5n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_34.toValue(0n),
                                                                                              alignment: _descriptor_34.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(6n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newMap(
                                                          new __compactRuntime.StateMap()
                                                        ).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(7n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_34.toValue(0n),
                                                                                              alignment: _descriptor_34.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(8n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(0n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(0n),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(10n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(new Uint8Array(32)),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(11n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_15.toValue(false),
                                                                                              alignment: _descriptor_15.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(12n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(new Uint8Array(32)),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(13n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_1.toValue({ bytes: new Uint8Array(32) }),
                                                                                              alignment: _descriptor_1.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(14n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_1.toValue({ bytes: new Uint8Array(32) }),
                                                                                              alignment: _descriptor_1.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    const tmp_0 = 0n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(0n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_0),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(1n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(encryption_key_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    const tmp_1 = 0n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(3n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_1),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    const tmp_2 = 1n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(5n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_34.toValue(tmp_2),
                                                                                              alignment: _descriptor_34.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(10n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(initial_device_boot_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(11n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_15.toValue(false),
                                                                                              alignment: _descriptor_15.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    const tmp_3 = 0n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(7n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_34.toValue(tmp_3),
                                                                                              alignment: _descriptor_34.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    const tmp_4 = 0n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(8n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(tmp_4),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    const tmp_5 = 0n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_5),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(12n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(evm_domain_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(13n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_1.toValue(vault_ref_0),
                                                                                              alignment: _descriptor_1.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(14n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_1.toValue(vault_addr_0),
                                                                                              alignment: _descriptor_1.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    state_0.data = new __compactRuntime.ChargedState(context.callContext.currentQueryContext.state.state);
    return {
      currentContractState: state_0,
      currentPrivateState: context.callContext.currentPrivateState,
      currentZswapLocalState: context.callContext.currentZswapLocalState
    }
  }
  _some_0(value_0) { return { is_some: true, value: value_0 }; }
  _none_0() {
    return { is_some: false,
             value:
               { nonce: new Uint8Array(32), color: new Uint8Array(32), value: 0n } };
  }
  _left_0(value_0) {
    return { is_left: true, left: value_0, right: new Uint8Array(32) };
  }
  _left_1(value_0) {
    return { is_left: true, left: value_0, right: { bytes: new Uint8Array(32) } };
  }
  _right_0(value_0) {
    return { is_left: false, left: { bytes: new Uint8Array(32) }, right: value_0 };
  }
  _right_1(value_0) {
    return { is_left: false, left: { bytes: new Uint8Array(32) }, right: value_0 };
  }
  _evolveNonce_0(index_0, nonce_0) {
    return this._upgradeFromTransient_0(this._transientHash_0([__compactRuntime.convertBytesToUint(52435875175126190479447740508185965837690552500527637822603658699938581184512n,
                                                                                                   28,
                                                                                                   new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 107, 101, 114, 110, 101, 108, 58, 110, 111, 110, 99, 101, 95, 101, 118, 111, 108, 118, 101]),
                                                                                                   'Field',
                                                                                                   '<standard library>'),
                                                               index_0,
                                                               this._degradeToTransient_0(nonce_0)]));
  }
  async _receiveShielded_0(context, partialProofData, coin_0) {
    const recipient_0 = this._right_1(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                partialProofData,
                                                                                                [
                                                                                                 { dup: { n: 2 } },
                                                                                                 { idx: { cached: true,
                                                                                                          pushPath: false,
                                                                                                          path: [
                                                                                                                 { tag: 'value',
                                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                 { popeq: { cached: true,
                                                                                                            result: undefined } }]).value));
    this._createZswapOutput_0(context, partialProofData, coin_0, recipient_0);
    const tmp_0 = this._coinCommitment_0(coin_0, recipient_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(1n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    return [];
  }
  async _sendShielded_0(context, partialProofData, input_0, recipient_0, value_0)
  {
    const selfAddr_0 = _descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                 partialProofData,
                                                                                 [
                                                                                  { dup: { n: 2 } },
                                                                                  { idx: { cached: true,
                                                                                           pushPath: false,
                                                                                           path: [
                                                                                                  { tag: 'value',
                                                                                                    value: { value: _descriptor_3.toValue(0n),
                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                  { popeq: { cached: true,
                                                                                             result: undefined } }]).value);
    this._createZswapInput_0(context, partialProofData, input_0);
    const tmp_0 = this._coinNullifier_0(this._downcastQualifiedCoin_0(input_0),
                                        selfAddr_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(0n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    let t_0;
    const change_0 = (t_0 = input_0.value,
                      (__compactRuntime.assert(t_0 >= value_0,
                                               'result of subtraction would be negative'),
                       t_0 - value_0));
    const output_0 = { nonce:
                         this._upgradeFromTransient_0(this._transientHash_1([__compactRuntime.convertBytesToUint(52435875175126190479447740508185965837690552500527637822603658699938581184512n,
                                                                                                                 28,
                                                                                                                 new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 107, 101, 114, 110, 101, 108, 58, 110, 111, 110, 99, 101, 95, 101, 118, 111, 108, 118, 101]),
                                                                                                                 'Field',
                                                                                                                 '<standard library>'),
                                                                             this._degradeToTransient_0(input_0.nonce)])),
                       color: input_0.color,
                       value: value_0 };
    this._createZswapOutput_0(context, partialProofData, output_0, recipient_0);
    const tmp_1 = this._coinCommitment_0(output_0, recipient_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(2n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_1),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    if (!recipient_0.is_left
        &&
        this._equal_0(recipient_0.right.bytes, selfAddr_0.bytes))
    {
      const tmp_2 = this._coinCommitment_0(output_0, recipient_0);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(1n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_2),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newNull().encode() } },
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
    }
    if (change_0 === 0n) {
      return { change: this._none_0(), sent: output_0 };
    } else {
      const changeCoin_0 = { nonce:
                               this._upgradeFromTransient_0(this._transientHash_1([__compactRuntime.convertBytesToUint(52435875175126190479447740508185965837690552500527637822603658699938581184512n,
                                                                                                                       30,
                                                                                                                       new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 107, 101, 114, 110, 101, 108, 58, 110, 111, 110, 99, 101, 95, 101, 118, 111, 108, 118, 101, 47, 50]),
                                                                                                                       'Field',
                                                                                                                       '<standard library>'),
                                                                                   this._degradeToTransient_0(input_0.nonce)])),
                             color: input_0.color,
                             value: change_0 };
      this._createZswapOutput_0(context,
                                partialProofData,
                                changeCoin_0,
                                this._right_1(selfAddr_0));
      const cm_0 = this._coinCommitment_0(changeCoin_0,
                                          this._right_1(selfAddr_0));
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(2n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(cm_0),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newNull().encode() } },
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(1n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(cm_0),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newNull().encode() } },
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
      return { change: this._some_0(changeCoin_0), sent: output_0 };
    }
  }
  _downcastQualifiedCoin_0(coin_0) {
    return { nonce: coin_0.nonce, color: coin_0.color, value: coin_0.value };
  }
  _coinCommitment_0(coin_0, recipient_0) {
    return this._persistentHash_36({ domain_sep:
                                       new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 122, 115, 119, 97, 112, 45, 99, 99, 91, 118, 49, 93]),
                                     info: coin_0,
                                     dataType: recipient_0.is_left,
                                     data:
                                       recipient_0.is_left ?
                                       recipient_0.left.bytes :
                                       recipient_0.right.bytes });
  }
  _coinNullifier_0(coin_0, addr_0) {
    return this._persistentHash_36({ domain_sep:
                                       new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 122, 115, 119, 97, 112, 45, 99, 110, 91, 118, 49, 93]),
                                     info: coin_0,
                                     dataType: false,
                                     data: addr_0.bytes });
  }
  async _blockTimeLt_0(context, partialProofData, time_0) {
    return _descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                      partialProofData,
                                                                      [
                                                                       { dup: { n: 2 } },
                                                                       { idx: { cached: true,
                                                                                pushPath: false,
                                                                                path: [
                                                                                       { tag: 'value',
                                                                                         value: { value: _descriptor_3.toValue(2n),
                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                       { push: { storage: false,
                                                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(time_0),
                                                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                                                       'lt',
                                                                       { popeq: { cached: true,
                                                                                  result: undefined } }]).value);
  }
  async _sendUnshielded_0(context,
                          partialProofData,
                          color_0,
                          amount_0,
                          recipient_0)
  {
    const tmp_0 = this._left_0(color_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(7n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_109.toValue(tmp_0),
                                                                                              alignment: _descriptor_109.alignment() }).encode() } },
                                       { dup: { n: 1 } },
                                       { dup: { n: 1 } },
                                       'member',
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_8.toValue(amount_0),
                                                                                              alignment: _descriptor_8.alignment() }).encode() } },
                                       { swap: { n: 0 } },
                                       'neg',
                                       { branch: { skip: 4 } },
                                       { dup: { n: 2 } },
                                       { dup: { n: 2 } },
                                       { idx: { cached: true,
                                                pushPath: false,
                                                path: [ { tag: 'stack' }] } },
                                       'add',
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    const tmp_1 = this._left_0(color_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(8n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell(__compactRuntime.alignedConcat(
                                                                                              { value: _descriptor_109.toValue(tmp_1),
                                                                                                alignment: _descriptor_109.alignment() },
                                                                                              { value: _descriptor_110.toValue(recipient_0),
                                                                                                alignment: _descriptor_110.alignment() }
                                                                                            )).encode() } },
                                       { dup: { n: 1 } },
                                       { dup: { n: 1 } },
                                       'member',
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_8.toValue(amount_0),
                                                                                              alignment: _descriptor_8.alignment() }).encode() } },
                                       { swap: { n: 0 } },
                                       'neg',
                                       { branch: { skip: 4 } },
                                       { dup: { n: 2 } },
                                       { dup: { n: 2 } },
                                       { idx: { cached: true,
                                                pushPath: false,
                                                path: [ { tag: 'stack' }] } },
                                       'add',
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    if (recipient_0.is_left
        &&
        this._equal_1(recipient_0.left.bytes,
                      _descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 2 } },
                                                                                 { idx: { cached: true,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: true,
                                                                                            result: undefined } }]).value).bytes))
    {
      const tmp_2 = this._left_0(color_0);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(6n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_109.toValue(tmp_2),
                                                                                                alignment: _descriptor_109.alignment() }).encode() } },
                                         { dup: { n: 1 } },
                                         { dup: { n: 1 } },
                                         'member',
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_8.toValue(amount_0),
                                                                                                alignment: _descriptor_8.alignment() }).encode() } },
                                         { swap: { n: 0 } },
                                         'neg',
                                         { branch: { skip: 4 } },
                                         { dup: { n: 2 } },
                                         { dup: { n: 2 } },
                                         { idx: { cached: true,
                                                  pushPath: false,
                                                  path: [ { tag: 'stack' }] } },
                                         'add',
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
    }
    return [];
  }
  async _receiveUnshielded_0(context, partialProofData, color_0, amount_0) {
    const tmp_0 = this._left_0(color_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_109.toValue(tmp_0),
                                                                                              alignment: _descriptor_109.alignment() }).encode() } },
                                       { dup: { n: 1 } },
                                       { dup: { n: 1 } },
                                       'member',
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_8.toValue(amount_0),
                                                                                              alignment: _descriptor_8.alignment() }).encode() } },
                                       { swap: { n: 0 } },
                                       'neg',
                                       { branch: { skip: 4 } },
                                       { dup: { n: 2 } },
                                       { dup: { n: 2 } },
                                       { idx: { cached: true,
                                                pushPath: false,
                                                path: [ { tag: 'stack' }] } },
                                       'add',
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    return [];
  }
  _reverseBytes32_0(b_0) {
    const v_0 = Array.from(b_0, BigInt);
    return Uint8Array.from([v_0[31],
                            v_0[30],
                            v_0[29],
                            v_0[28],
                            v_0[27],
                            v_0[26],
                            v_0[25],
                            v_0[24],
                            v_0[23],
                            v_0[22],
                            v_0[21],
                            v_0[20],
                            v_0[19],
                            v_0[18],
                            v_0[17],
                            v_0[16],
                            v_0[15],
                            v_0[14],
                            v_0[13],
                            v_0[12],
                            v_0[11],
                            v_0[10],
                            v_0[9],
                            v_0[8],
                            v_0[7],
                            v_0[6],
                            v_0[5],
                            v_0[4],
                            v_0[3],
                            v_0[2],
                            v_0[1],
                            v_0[0]],
                           Number);
  }
  _secp256k1EcdsaVerify_0(msgHash_0, sig_0, pk_0) {
    __compactRuntime.assert(!this._equal_2(pk_0,
                                           ({x: 0n, y: 0n, identity: true})),
                            'Secp256k1Point identity is not a permitted secp256k1EcdsaVerify verification key');
    const z_0 = __compactRuntime.convertBytesToField(115792089237316195423570985008687907852837564279074904382605163141518161494336n,
                                                     32,
                                                     this._reverseBytes32_0(msgHash_0),
                                                     'Secp256k1Scalar',
                                                     '<standard library>');
    const __compact_pattern_tmp3_0 = sig_0;
    const r_0 = __compact_pattern_tmp3_0.r;
    const s_0 = __compact_pattern_tmp3_0.s;
    const w_0 = this._inv_0(s_0);
    const u1_0 = __compactRuntime.secp256k1ScalarMul(z_0, w_0);
    const u2_0 = __compactRuntime.secp256k1ScalarMul(r_0, w_0);
    const point_0 = this._ecAdd_1(this._ecMulGenerator_1(u1_0),
                                  this._ecMul_1(pk_0, u2_0));
    return __compactRuntime.convertBytesToField(115792089237316195423570985008687907852837564279074904382605163141518161494336n,
                                                32,
                                                __compactRuntime.convertBigintToBytes(32,
                                                                                      this._secp256k1PointX_0(point_0),
                                                                                      '<standard library>'),
                                                'Secp256k1Scalar',
                                                '<standard library>')
           ===
           r_0;
  }
  _secp256k1BaseBigEndian_0(b_0) {
    const vec_0 = Array.from(__compactRuntime.convertBigintToBytes(32,
                                                                   b_0,
                                                                   '<standard library>'),
                             BigInt);
    return [vec_0[31],
            vec_0[30],
            vec_0[29],
            vec_0[28],
            vec_0[27],
            vec_0[26],
            vec_0[25],
            vec_0[24],
            vec_0[23],
            vec_0[22],
            vec_0[21],
            vec_0[20],
            vec_0[19],
            vec_0[18],
            vec_0[17],
            vec_0[16],
            vec_0[15],
            vec_0[14],
            vec_0[13],
            vec_0[12],
            vec_0[11],
            vec_0[10],
            vec_0[9],
            vec_0[8],
            vec_0[7],
            vec_0[6],
            vec_0[5],
            vec_0[4],
            vec_0[3],
            vec_0[2],
            vec_0[1],
            vec_0[0]];
  }
  _secp256k1EthereumAddress_0(pk_0) {
    __compactRuntime.assert(!this._equal_3(pk_0,
                                           ({x: 0n, y: 0n, identity: true})),
                            'Secp256k1Point identity is not a permitted input to secp256k1EthereumAddress');
    const hash_0 = this._keccak256_0([this._secp256k1BaseBigEndian_0(this._secp256k1PointX_0(pk_0)),
                                      this._secp256k1BaseBigEndian_0(this._secp256k1PointY_0(pk_0))]);
    return ((e, i) => e.slice(i, i+20))(hash_0, Number(12n));
  }
  _curve25519BaseIsOdd_0(x_0) {
    const b_0 = Array.from(__compactRuntime.convertBigintToBytes(32,
                                                                 x_0,
                                                                 '<standard library>'),
                           BigInt)[0];
    const b6_0 = b_0 >= 128n ?
                 (__compactRuntime.assert(b_0 >= 128n,
                                          'result of subtraction would be negative'),
                  b_0 - 128n)
                 :
                 b_0;
    const b5_0 = b6_0 >= 64n ?
                 (__compactRuntime.assert(b6_0 >= 64n,
                                          'result of subtraction would be negative'),
                  b6_0 - 64n)
                 :
                 b6_0;
    const b4_0 = b5_0 >= 32n ?
                 (__compactRuntime.assert(b5_0 >= 32n,
                                          'result of subtraction would be negative'),
                  b5_0 - 32n)
                 :
                 b5_0;
    const b3_0 = b4_0 >= 16n ?
                 (__compactRuntime.assert(b4_0 >= 16n,
                                          'result of subtraction would be negative'),
                  b4_0 - 16n)
                 :
                 b4_0;
    const b2_0 = b3_0 >= 8n ?
                 (__compactRuntime.assert(b3_0 >= 8n,
                                          'result of subtraction would be negative'),
                  b3_0 - 8n)
                 :
                 b3_0;
    const b1_0 = b2_0 >= 4n ?
                 (__compactRuntime.assert(b2_0 >= 4n,
                                          'result of subtraction would be negative'),
                  b2_0 - 4n)
                 :
                 b2_0;
    return (b1_0 >= 2n ?
            (__compactRuntime.assert(b1_0 >= 2n,
                                     'result of subtraction would be negative'),
             b1_0 - 2n)
            :
            b1_0)
           ===
           1n;
  }
  _ed25519Encode_0(p_0) {
    const y_0 = Array.from(__compactRuntime.convertBigintToBytes(32,
                                                                 this._curve25519PointY_0(p_0),
                                                                 '<standard library>'),
                           BigInt);
    const sign_0 = this._curve25519BaseIsOdd_0(this._curve25519PointX_0(p_0)) ?
                   128n :
                   0n;
    return Uint8Array.from([y_0[0],
                            y_0[1],
                            y_0[2],
                            y_0[3],
                            y_0[4],
                            y_0[5],
                            y_0[6],
                            y_0[7],
                            y_0[8],
                            y_0[9],
                            y_0[10],
                            y_0[11],
                            y_0[12],
                            y_0[13],
                            y_0[14],
                            y_0[15],
                            y_0[16],
                            y_0[17],
                            y_0[18],
                            y_0[19],
                            y_0[20],
                            y_0[21],
                            y_0[22],
                            y_0[23],
                            y_0[24],
                            y_0[25],
                            y_0[26],
                            y_0[27],
                            y_0[28],
                            y_0[29],
                            y_0[30],
                            ((t1) => {
                              if (t1 > 255n) {
                                throw new __compactRuntime.CompactError('<standard library>: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 255');
                              }
                              return t1;
                            })(y_0[31] + sign_0)],
                           Number);
  }
  _ed25519Verify_0(msg_0, sig_0, pk_0) {
    __compactRuntime.assert(!this._equal_4(__compactRuntime.convertBigintToBytes(32,
                                                                                 this._curve25519PointX_0(pk_0),
                                                                                 '<standard library>'),
                                           new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                            'Curve25519Point identity is not a permitted ed25519Verify verification key');
    const __compact_pattern_tmp1_0 = sig_0;
    const r_0 = __compact_pattern_tmp1_0.r;
    const s_0 = __compact_pattern_tmp1_0.s;
    const k_0 = __compactRuntime.convertBytesToField(7237005577332262213973186563042994240857116359379907606001950938285454250988n,
                                                     64,
                                                     this._sha512_0([this._ed25519Encode_0(r_0),
                                                                     this._ed25519Encode_0(pk_0),
                                                                     msg_0]),
                                                     'Curve25519Scalar',
                                                     '<standard library>');
    return this._equal_5(this._ecMulGenerator_2(s_0),
                         this._ecAdd_2(r_0, this._ecMul_2(pk_0, k_0)));
  }
  _ed25519Verify_1(msg_0, sig_0, pk_0) {
    __compactRuntime.assert(!this._equal_6(__compactRuntime.convertBigintToBytes(32,
                                                                                 this._curve25519PointX_0(pk_0),
                                                                                 '<standard library>'),
                                           new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                            'Curve25519Point identity is not a permitted ed25519Verify verification key');
    const __compact_pattern_tmp1_0 = sig_0;
    const r_0 = __compact_pattern_tmp1_0.r;
    const s_0 = __compact_pattern_tmp1_0.s;
    const k_0 = __compactRuntime.convertBytesToField(7237005577332262213973186563042994240857116359379907606001950938285454250988n,
                                                     64,
                                                     this._sha512_1([this._ed25519Encode_0(r_0),
                                                                     this._ed25519Encode_0(pk_0),
                                                                     msg_0]),
                                                     'Curve25519Scalar',
                                                     '<standard library>');
    return this._equal_7(this._ecMulGenerator_2(s_0),
                         this._ecAdd_2(r_0, this._ecMul_2(pk_0, k_0)));
  }
  _ed25519Verify_2(msg_0, sig_0, pk_0) {
    __compactRuntime.assert(!this._equal_8(__compactRuntime.convertBigintToBytes(32,
                                                                                 this._curve25519PointX_0(pk_0),
                                                                                 '<standard library>'),
                                           new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                            'Curve25519Point identity is not a permitted ed25519Verify verification key');
    const __compact_pattern_tmp1_0 = sig_0;
    const r_0 = __compact_pattern_tmp1_0.r;
    const s_0 = __compact_pattern_tmp1_0.s;
    const k_0 = __compactRuntime.convertBytesToField(7237005577332262213973186563042994240857116359379907606001950938285454250988n,
                                                     64,
                                                     this._sha512_2([this._ed25519Encode_0(r_0),
                                                                     this._ed25519Encode_0(pk_0),
                                                                     msg_0]),
                                                     'Curve25519Scalar',
                                                     '<standard library>');
    return this._equal_9(this._ecMulGenerator_2(s_0),
                         this._ecAdd_2(r_0, this._ecMul_2(pk_0, k_0)));
  }
  _ed25519Verify_3(msg_0, sig_0, pk_0) {
    __compactRuntime.assert(!this._equal_10(__compactRuntime.convertBigintToBytes(32,
                                                                                  this._curve25519PointX_0(pk_0),
                                                                                  '<standard library>'),
                                            new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                            'Curve25519Point identity is not a permitted ed25519Verify verification key');
    const __compact_pattern_tmp1_0 = sig_0;
    const r_0 = __compact_pattern_tmp1_0.r;
    const s_0 = __compact_pattern_tmp1_0.s;
    const k_0 = __compactRuntime.convertBytesToField(7237005577332262213973186563042994240857116359379907606001950938285454250988n,
                                                     64,
                                                     this._sha512_3([this._ed25519Encode_0(r_0),
                                                                     this._ed25519Encode_0(pk_0),
                                                                     msg_0]),
                                                     'Curve25519Scalar',
                                                     '<standard library>');
    return this._equal_11(this._ecMulGenerator_2(s_0),
                          this._ecAdd_2(r_0, this._ecMul_2(pk_0, k_0)));
  }
  _ed25519Verify_4(msg_0, sig_0, pk_0) {
    __compactRuntime.assert(!this._equal_12(__compactRuntime.convertBigintToBytes(32,
                                                                                  this._curve25519PointX_0(pk_0),
                                                                                  '<standard library>'),
                                            new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                            'Curve25519Point identity is not a permitted ed25519Verify verification key');
    const __compact_pattern_tmp1_0 = sig_0;
    const r_0 = __compact_pattern_tmp1_0.r;
    const s_0 = __compact_pattern_tmp1_0.s;
    const k_0 = __compactRuntime.convertBytesToField(7237005577332262213973186563042994240857116359379907606001950938285454250988n,
                                                     64,
                                                     this._sha512_4([this._ed25519Encode_0(r_0),
                                                                     this._ed25519Encode_0(pk_0),
                                                                     msg_0]),
                                                     'Curve25519Scalar',
                                                     '<standard library>');
    return this._equal_13(this._ecMulGenerator_2(s_0),
                          this._ecAdd_2(r_0, this._ecMul_2(pk_0, k_0)));
  }
  _ed25519Verify_5(msg_0, sig_0, pk_0) {
    __compactRuntime.assert(!this._equal_14(__compactRuntime.convertBigintToBytes(32,
                                                                                  this._curve25519PointX_0(pk_0),
                                                                                  '<standard library>'),
                                            new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                            'Curve25519Point identity is not a permitted ed25519Verify verification key');
    const __compact_pattern_tmp1_0 = sig_0;
    const r_0 = __compact_pattern_tmp1_0.r;
    const s_0 = __compact_pattern_tmp1_0.s;
    const k_0 = __compactRuntime.convertBytesToField(7237005577332262213973186563042994240857116359379907606001950938285454250988n,
                                                     64,
                                                     this._sha512_5([this._ed25519Encode_0(r_0),
                                                                     this._ed25519Encode_0(pk_0),
                                                                     msg_0]),
                                                     'Curve25519Scalar',
                                                     '<standard library>');
    return this._equal_15(this._ecMulGenerator_2(s_0),
                          this._ecAdd_2(r_0, this._ecMul_2(pk_0, k_0)));
  }
  _transientHash_0(value_0) {
    const result_0 = __compactRuntime.transientHash(_descriptor_107, value_0);
    return result_0;
  }
  _transientHash_1(value_0) {
    const result_0 = __compactRuntime.transientHash(_descriptor_108, value_0);
    return result_0;
  }
  _persistentHash_0(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_105, value_0);
    return result_0;
  }
  _persistentHash_1(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_106, value_0);
    return result_0;
  }
  _persistentHash_2(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_103, value_0);
    return result_0;
  }
  _persistentHash_3(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_104, value_0);
    return result_0;
  }
  _persistentHash_4(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_101, value_0);
    return result_0;
  }
  _persistentHash_5(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_102, value_0);
    return result_0;
  }
  _persistentHash_6(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_0, value_0);
    return result_0;
  }
  _persistentHash_7(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_100, value_0);
    return result_0;
  }
  _persistentHash_8(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_97, value_0);
    return result_0;
  }
  _persistentHash_9(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_98, value_0);
    return result_0;
  }
  _persistentHash_10(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_95, value_0);
    return result_0;
  }
  _persistentHash_11(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_96, value_0);
    return result_0;
  }
  _persistentHash_12(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_93, value_0);
    return result_0;
  }
  _persistentHash_13(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_94, value_0);
    return result_0;
  }
  _persistentHash_14(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_91, value_0);
    return result_0;
  }
  _persistentHash_15(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_92, value_0);
    return result_0;
  }
  _persistentHash_16(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_89, value_0);
    return result_0;
  }
  _persistentHash_17(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_90, value_0);
    return result_0;
  }
  _persistentHash_18(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_87, value_0);
    return result_0;
  }
  _persistentHash_19(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_88, value_0);
    return result_0;
  }
  _persistentHash_20(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_85, value_0);
    return result_0;
  }
  _persistentHash_21(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_86, value_0);
    return result_0;
  }
  _persistentHash_22(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_83, value_0);
    return result_0;
  }
  _persistentHash_23(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_84, value_0);
    return result_0;
  }
  _persistentHash_24(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_81, value_0);
    return result_0;
  }
  _persistentHash_25(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_82, value_0);
    return result_0;
  }
  _persistentHash_26(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_79, value_0);
    return result_0;
  }
  _persistentHash_27(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_80, value_0);
    return result_0;
  }
  _persistentHash_28(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_77, value_0);
    return result_0;
  }
  _persistentHash_29(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_78, value_0);
    return result_0;
  }
  _persistentHash_30(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_75, value_0);
    return result_0;
  }
  _persistentHash_31(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_76, value_0);
    return result_0;
  }
  _persistentHash_32(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_73, value_0);
    return result_0;
  }
  _persistentHash_33(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_74, value_0);
    return result_0;
  }
  _persistentHash_34(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_71, value_0);
    return result_0;
  }
  _persistentHash_35(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_72, value_0);
    return result_0;
  }
  _persistentHash_36(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_69, value_0);
    return result_0;
  }
  _persistentHash_37(value_0) {
    const result_0 = __compactRuntime.persistentHash(_descriptor_70, value_0);
    return result_0;
  }
  _degradeToTransient_0(x_0) {
    const result_0 = __compactRuntime.degradeToTransient(x_0);
    return result_0;
  }
  _upgradeFromTransient_0(x_0) {
    const result_0 = __compactRuntime.upgradeFromTransient(x_0);
    return result_0;
  }
  _keccak256_0(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_67, value_0);
    return result_0;
  }
  _keccak256_1(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_0, value_0);
    return result_0;
  }
  _keccak256_2(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_64, value_0);
    return result_0;
  }
  _keccak256_3(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_65, value_0);
    return result_0;
  }
  _keccak256_4(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_7, value_0);
    return result_0;
  }
  _keccak256_5(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_63, value_0);
    return result_0;
  }
  _keccak256_6(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_61, value_0);
    return result_0;
  }
  _keccak256_7(value_0) {
    const result_0 = __compactRuntime.keccak256(_descriptor_62, value_0);
    return result_0;
  }
  _ecAdd_0(a_0, b_0) {
    const result_0 = __compactRuntime.ecAdd(a_0, b_0);
    return result_0;
  }
  _ecMul_0(a_0, b_0) {
    const result_0 = __compactRuntime.ecMul(a_0, b_0);
    return result_0;
  }
  _ecMulGenerator_0(b_0) {
    const result_0 = __compactRuntime.ecMulGenerator(b_0);
    return result_0;
  }
  _createZswapInput_0(context, partialProofData, coin_0) {
    const result_0 = __compactRuntime.createZswapInput(context, coin_0);
    partialProofData.privateTranscriptOutputs.push({
      value: [],
      alignment: []
    });
    return result_0;
  }
  _createZswapOutput_0(context, partialProofData, coin_0, recipient_0) {
    const result_0 = __compactRuntime.createZswapOutput(context,
                                                        coin_0,
                                                        recipient_0);
    partialProofData.privateTranscriptOutputs.push({
      value: [],
      alignment: []
    });
    return result_0;
  }
  _sha512_0(value_0) {
    const result_0 = __compactRuntime.sha512(_descriptor_59, value_0);
    return result_0;
  }
  _sha512_1(value_0) {
    const result_0 = __compactRuntime.sha512(_descriptor_57, value_0);
    return result_0;
  }
  _sha512_2(value_0) {
    const result_0 = __compactRuntime.sha512(_descriptor_58, value_0);
    return result_0;
  }
  _sha512_3(value_0) {
    const result_0 = __compactRuntime.sha512(_descriptor_55, value_0);
    return result_0;
  }
  _sha512_4(value_0) {
    const result_0 = __compactRuntime.sha512(_descriptor_56, value_0);
    return result_0;
  }
  _sha512_5(value_0) {
    const result_0 = __compactRuntime.sha512(_descriptor_53, value_0);
    return result_0;
  }
  _inv_0(s_0) {
    const result_0 = __compactRuntime.secp256k1ScalarInv(s_0);
    return result_0;
  }
  _secp256k1PointX_0(pt_0) {
    const result_0 = __compactRuntime.secp256k1PointX(pt_0);
    return result_0;
  }
  _secp256k1PointY_0(pt_0) {
    const result_0 = __compactRuntime.secp256k1PointY(pt_0);
    return result_0;
  }
  _ecAdd_1(a_0, b_0) {
    const result_0 = __compactRuntime.secp256k1Add(a_0, b_0);
    return result_0;
  }
  _ecMul_1(a_0, b_0) {
    const result_0 = __compactRuntime.secp256k1Mul(a_0, b_0);
    return result_0;
  }
  _ecMulGenerator_1(b_0) {
    const result_0 = __compactRuntime.secp256k1MulGenerator(b_0);
    return result_0;
  }
  _curve25519PointX_0(pt_0) {
    const result_0 = __compactRuntime.curve25519PointX(pt_0);
    return result_0;
  }
  _curve25519PointY_0(pt_0) {
    const result_0 = __compactRuntime.curve25519PointY(pt_0);
    return result_0;
  }
  _ecAdd_2(a_0, b_0) {
    const result_0 = __compactRuntime.curve25519Add(a_0, b_0);
    return result_0;
  }
  _ecMul_2(a_0, b_0) {
    const result_0 = __compactRuntime.curve25519Mul(a_0, b_0);
    return result_0;
  }
  _ecMulGenerator_2(b_0) {
    const result_0 = __compactRuntime.curve25519MulGenerator(b_0);
    return result_0;
  }
  _domain_type_hash_0() {
    return Uint8Array.from([54n,
                            194n,
                            93n,
                            227n,
                            229n,
                            65n,
                            213n,
                            217n,
                            112n,
                            246n,
                            110n,
                            66n,
                            16n,
                            215n,
                            40n,
                            114n,
                            18n,
                            32n,
                            255n,
                            245n,
                            192n,
                            119n,
                            204n,
                            108n,
                            208n,
                            8n,
                            179n,
                            160n,
                            198n,
                            42n,
                            218n,
                            183n],
                           Number);
  }
  _domain_name_hash_0() {
    return Uint8Array.from([100n,
                            209n,
                            201n,
                            35n,
                            229n,
                            157n,
                            162n,
                            13n,
                            2n,
                            201n,
                            45n,
                            192n,
                            214n,
                            202n,
                            160n,
                            134n,
                            140n,
                            181n,
                            200n,
                            171n,
                            23n,
                            238n,
                            6n,
                            88n,
                            170n,
                            252n,
                            95n,
                            11n,
                            114n,
                            213n,
                            108n,
                            133n],
                           Number);
  }
  _domain_version_hash_0() {
    return Uint8Array.from([200n,
                            158n,
                            253n,
                            170n,
                            84n,
                            192n,
                            242n,
                            12n,
                            122n,
                            223n,
                            97n,
                            40n,
                            130n,
                            223n,
                            9n,
                            80n,
                            245n,
                            169n,
                            81n,
                            99n,
                            126n,
                            3n,
                            7n,
                            205n,
                            203n,
                            76n,
                            103n,
                            47n,
                            41n,
                            139n,
                            139n,
                            198n],
                           Number);
  }
  _type_hash_withdraw_unshielded_0() {
    return Uint8Array.from([58n,
                            172n,
                            195n,
                            110n,
                            139n,
                            24n,
                            204n,
                            253n,
                            159n,
                            65n,
                            97n,
                            41n,
                            187n,
                            137n,
                            24n,
                            177n,
                            127n,
                            62n,
                            241n,
                            233n,
                            15n,
                            81n,
                            131n,
                            181n,
                            213n,
                            47n,
                            145n,
                            192n,
                            253n,
                            187n,
                            45n,
                            248n],
                           Number);
  }
  _type_hash_withdraw_shielded_0() {
    return Uint8Array.from([127n,
                            200n,
                            19n,
                            97n,
                            70n,
                            150n,
                            150n,
                            206n,
                            28n,
                            133n,
                            21n,
                            103n,
                            62n,
                            92n,
                            44n,
                            175n,
                            168n,
                            194n,
                            88n,
                            161n,
                            74n,
                            31n,
                            138n,
                            186n,
                            55n,
                            55n,
                            48n,
                            248n,
                            133n,
                            52n,
                            2n,
                            182n],
                           Number);
  }
  _type_hash_withdraw_shielded_to_contract_0() {
    return Uint8Array.from([104n,
                            189n,
                            103n,
                            248n,
                            225n,
                            248n,
                            31n,
                            173n,
                            61n,
                            193n,
                            42n,
                            91n,
                            13n,
                            219n,
                            71n,
                            15n,
                            234n,
                            228n,
                            162n,
                            219n,
                            83n,
                            141n,
                            233n,
                            4n,
                            128n,
                            32n,
                            75n,
                            234n,
                            158n,
                            175n,
                            64n,
                            35n],
                           Number);
  }
  _type_hash_append_inbox_0() {
    return Uint8Array.from([62n,
                            107n,
                            196n,
                            66n,
                            244n,
                            143n,
                            164n,
                            41n,
                            201n,
                            78n,
                            230n,
                            55n,
                            13n,
                            162n,
                            246n,
                            176n,
                            209n,
                            7n,
                            141n,
                            225n,
                            102n,
                            182n,
                            98n,
                            184n,
                            14n,
                            248n,
                            119n,
                            252n,
                            17n,
                            179n,
                            229n,
                            82n],
                           Number);
  }
  _type_hash_rotate_enc_key_0() {
    return Uint8Array.from([90n,
                            44n,
                            49n,
                            193n,
                            138n,
                            84n,
                            184n,
                            132n,
                            148n,
                            136n,
                            188n,
                            174n,
                            90n,
                            242n,
                            41n,
                            59n,
                            220n,
                            222n,
                            16n,
                            24n,
                            120n,
                            228n,
                            195n,
                            110n,
                            120n,
                            61n,
                            170n,
                            96n,
                            161n,
                            41n,
                            82n,
                            161n],
                           Number);
  }
  _type_hash_add_device_0() {
    return Uint8Array.from([143n,
                            205n,
                            110n,
                            39n,
                            168n,
                            143n,
                            24n,
                            63n,
                            180n,
                            194n,
                            171n,
                            253n,
                            25n,
                            5n,
                            167n,
                            145n,
                            221n,
                            176n,
                            69n,
                            136n,
                            183n,
                            133n,
                            233n,
                            115n,
                            196n,
                            219n,
                            252n,
                            18n,
                            171n,
                            180n,
                            215n,
                            228n],
                           Number);
  }
  _type_hash_remove_device_0() {
    return Uint8Array.from([193n,
                            50n,
                            144n,
                            26n,
                            197n,
                            167n,
                            18n,
                            178n,
                            198n,
                            39n,
                            200n,
                            233n,
                            235n,
                            108n,
                            213n,
                            135n,
                            150n,
                            111n,
                            176n,
                            33n,
                            78n,
                            123n,
                            227n,
                            108n,
                            192n,
                            227n,
                            99n,
                            227n,
                            176n,
                            84n,
                            23n,
                            212n],
                           Number);
  }
  _type_hash_open_swap_shielded_0() {
    return Uint8Array.from([52n,
                            98n,
                            103n,
                            147n,
                            171n,
                            215n,
                            198n,
                            125n,
                            33n,
                            225n,
                            166n,
                            26n,
                            153n,
                            241n,
                            207n,
                            255n,
                            79n,
                            130n,
                            174n,
                            14n,
                            35n,
                            37n,
                            166n,
                            186n,
                            157n,
                            253n,
                            196n,
                            255n,
                            18n,
                            214n,
                            104n,
                            174n],
                           Number);
  }
  _type_hash_bridge_deposit_start_0() {
    return Uint8Array.from([103n,
                            55n,
                            198n,
                            139n,
                            32n,
                            211n,
                            223n,
                            43n,
                            32n,
                            182n,
                            101n,
                            60n,
                            123n,
                            105n,
                            152n,
                            54n,
                            49n,
                            174n,
                            231n,
                            32n,
                            127n,
                            216n,
                            30n,
                            64n,
                            20n,
                            189n,
                            38n,
                            139n,
                            1n,
                            118n,
                            37n,
                            238n],
                           Number);
  }
  _type_hash_bridge_withdraw_start_0() {
    return Uint8Array.from([127n,
                            202n,
                            95n,
                            59n,
                            156n,
                            97n,
                            215n,
                            155n,
                            236n,
                            239n,
                            240n,
                            159n,
                            178n,
                            16n,
                            22n,
                            136n,
                            167n,
                            66n,
                            46n,
                            234n,
                            171n,
                            37n,
                            5n,
                            177n,
                            88n,
                            184n,
                            7n,
                            96n,
                            194n,
                            120n,
                            178n,
                            96n],
                           Number);
  }
  _evm_account_alias_0(account_0) {
    return ((e, i) => e.slice(i, i+20))(this._keccak256_1(account_0),
                                        Number(12n));
  }
  _evm_domain_separator_for_0(account_0, salt_0) {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 160))([...Array.from(this._domain_type_hash_0(),
                                                                               BigInt),
                                                                 ...Array.from(this._domain_name_hash_0(),
                                                                               BigInt),
                                                                 ...Array.from(this._domain_version_hash_0(),
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(this._evm_account_alias_0(account_0)),
                                                                               BigInt),
                                                                 ...Array.from(salt_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_2(preimage_0);
  }
  _evm_struct_hash_withdraw_unshielded_0(account_0,
                                         owner_0,
                                         auth_nonce_value_0,
                                         color_0,
                                         amount_0,
                                         recipient_0,
                                         challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 256))([...Array.from(this._type_hash_withdraw_unshielded_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(color_0,
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(amount_0),
                                                                               BigInt),
                                                                 ...Array.from(recipient_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_3(preimage_0);
  }
  _evm_struct_hash_withdraw_shielded_0(account_0,
                                       owner_0,
                                       auth_nonce_value_0,
                                       color_0,
                                       amount_0,
                                       recipient_coin_public_key_0,
                                       challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 256))([...Array.from(this._type_hash_withdraw_shielded_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(color_0,
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(amount_0),
                                                                               BigInt),
                                                                 ...Array.from(recipient_coin_public_key_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_3(preimage_0);
  }
  _evm_struct_hash_withdraw_shielded_to_contract_0(account_0,
                                                   owner_0,
                                                   auth_nonce_value_0,
                                                   color_0,
                                                   amount_0,
                                                   recipient_contract_0,
                                                   challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 256))([...Array.from(this._type_hash_withdraw_shielded_to_contract_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(color_0,
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(amount_0),
                                                                               BigInt),
                                                                 ...Array.from(recipient_contract_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_3(preimage_0);
  }
  _evm_struct_hash_append_inbox_0(account_0,
                                  owner_0,
                                  auth_nonce_value_0,
                                  entry_hash_0,
                                  challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 192))([...Array.from(this._type_hash_append_inbox_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(entry_hash_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_4(preimage_0);
  }
  _evm_struct_hash_rotate_enc_key_0(account_0,
                                    owner_0,
                                    auth_nonce_value_0,
                                    new_key_0,
                                    challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 192))([...Array.from(this._type_hash_rotate_enc_key_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(new_key_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_4(preimage_0);
  }
  _evm_struct_hash_add_device_0(account_0,
                                owner_0,
                                auth_nonce_value_0,
                                new_entry_0,
                                challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 192))([...Array.from(this._type_hash_add_device_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(new_entry_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_4(preimage_0);
  }
  _evm_struct_hash_remove_device_0(account_0,
                                   owner_0,
                                   auth_nonce_value_0,
                                   entry_0,
                                   challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 192))([...Array.from(this._type_hash_remove_device_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(entry_0,
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_4(preimage_0);
  }
  _evm_struct_hash_open_swap_shielded_0(account_0,
                                        owner_0,
                                        auth_nonce_value_0,
                                        give_color_0,
                                        give_amount_0,
                                        recipient_kind_0,
                                        recipient_0,
                                        want_nonce_0,
                                        want_color_0,
                                        want_amount_0,
                                        valid_until_0,
                                        challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 416))([...Array.from(this._type_hash_open_swap_shielded_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(give_color_0,
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(give_amount_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint8Word_0(recipient_kind_0),
                                                                               BigInt),
                                                                 ...Array.from(recipient_0,
                                                                               BigInt),
                                                                 ...Array.from(want_nonce_0,
                                                                               BigInt),
                                                                 ...Array.from(want_color_0,
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(want_amount_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(valid_until_0),
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_6(preimage_0);
  }
  _evm_struct_hash_bridge_deposit_start_0(account_0,
                                          owner_0,
                                          auth_nonce_value_0,
                                          erc20_0,
                                          amount_0,
                                          evm_nonce_0,
                                          gas_limit_0,
                                          max_fee_0,
                                          max_priority_fee_0,
                                          key_version_0,
                                          challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 384))([...Array.from(this._type_hash_bridge_deposit_start_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(erc20_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(amount_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(evm_nonce_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(gas_limit_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(max_fee_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(max_priority_fee_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint8Word_0(key_version_0),
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_5(preimage_0);
  }
  _evm_struct_hash_bridge_withdraw_start_0(account_0,
                                           owner_0,
                                           auth_nonce_value_0,
                                           dest_0,
                                           color_0,
                                           amount_0,
                                           evm_nonce_0,
                                           gas_limit_0,
                                           max_fee_0,
                                           max_priority_fee_0,
                                           key_version_0,
                                           challenge_0)
  {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 416))([...Array.from(this._type_hash_bridge_withdraw_start_0(),
                                                                               BigInt),
                                                                 ...Array.from(account_0,
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(owner_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(auth_nonce_value_0),
                                                                               BigInt),
                                                                 ...Array.from(this._addressWord_0(dest_0),
                                                                               BigInt),
                                                                 ...Array.from(color_0,
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(amount_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(evm_nonce_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint64Word_0(gas_limit_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(max_fee_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint128Word_0(max_priority_fee_0),
                                                                               BigInt),
                                                                 ...Array.from(this._uint8Word_0(key_version_0),
                                                                               BigInt),
                                                                 ...Array.from(challenge_0,
                                                                               BigInt)]),
                                       Number);
    return this._keccak256_6(preimage_0);
  }
  _eip712_digest_0(separator_0, struct_hash_0) {
    const preimage_0 = Uint8Array.from(((e) => e.slice(0, 66))([25n,
                                                                1n,
                                                                ...Array.from(separator_0,
                                                                              BigInt),
                                                                ...Array.from(struct_hash_0,
                                                                              BigInt)]),
                                       Number);
    return this._keccak256_7(preimage_0);
  }
  _evm_digest_withdraw_unshielded_0(account_0,
                                    salt_0,
                                    owner_0,
                                    auth_nonce_value_0,
                                    color_0,
                                    amount_0,
                                    recipient_0,
                                    challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_withdraw_unshielded_0(account_0,
                                                                             owner_0,
                                                                             auth_nonce_value_0,
                                                                             color_0,
                                                                             amount_0,
                                                                             recipient_0,
                                                                             challenge_0));
  }
  _evm_digest_withdraw_shielded_0(account_0,
                                  salt_0,
                                  owner_0,
                                  auth_nonce_value_0,
                                  color_0,
                                  amount_0,
                                  recipient_coin_public_key_0,
                                  challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_withdraw_shielded_0(account_0,
                                                                           owner_0,
                                                                           auth_nonce_value_0,
                                                                           color_0,
                                                                           amount_0,
                                                                           recipient_coin_public_key_0,
                                                                           challenge_0));
  }
  _evm_digest_withdraw_shielded_to_contract_0(account_0,
                                              salt_0,
                                              owner_0,
                                              auth_nonce_value_0,
                                              color_0,
                                              amount_0,
                                              recipient_contract_0,
                                              challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_withdraw_shielded_to_contract_0(account_0,
                                                                                       owner_0,
                                                                                       auth_nonce_value_0,
                                                                                       color_0,
                                                                                       amount_0,
                                                                                       recipient_contract_0,
                                                                                       challenge_0));
  }
  _evm_digest_append_inbox_0(account_0,
                             salt_0,
                             owner_0,
                             auth_nonce_value_0,
                             entry_hash_0,
                             challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_append_inbox_0(account_0,
                                                                      owner_0,
                                                                      auth_nonce_value_0,
                                                                      entry_hash_0,
                                                                      challenge_0));
  }
  _evm_digest_rotate_enc_key_0(account_0,
                               salt_0,
                               owner_0,
                               auth_nonce_value_0,
                               new_key_0,
                               challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_rotate_enc_key_0(account_0,
                                                                        owner_0,
                                                                        auth_nonce_value_0,
                                                                        new_key_0,
                                                                        challenge_0));
  }
  _evm_digest_add_device_0(account_0,
                           salt_0,
                           owner_0,
                           auth_nonce_value_0,
                           new_entry_0,
                           challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_add_device_0(account_0,
                                                                    owner_0,
                                                                    auth_nonce_value_0,
                                                                    new_entry_0,
                                                                    challenge_0));
  }
  _evm_digest_open_swap_shielded_0(account_0,
                                   salt_0,
                                   owner_0,
                                   auth_nonce_value_0,
                                   give_color_0,
                                   give_amount_0,
                                   recipient_kind_0,
                                   recipient_0,
                                   want_nonce_0,
                                   want_color_0,
                                   want_amount_0,
                                   valid_until_0,
                                   challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_open_swap_shielded_0(account_0,
                                                                            owner_0,
                                                                            auth_nonce_value_0,
                                                                            give_color_0,
                                                                            give_amount_0,
                                                                            recipient_kind_0,
                                                                            recipient_0,
                                                                            want_nonce_0,
                                                                            want_color_0,
                                                                            want_amount_0,
                                                                            valid_until_0,
                                                                            challenge_0));
  }
  _evm_digest_remove_device_0(account_0,
                              salt_0,
                              owner_0,
                              auth_nonce_value_0,
                              entry_0,
                              challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_remove_device_0(account_0,
                                                                       owner_0,
                                                                       auth_nonce_value_0,
                                                                       entry_0,
                                                                       challenge_0));
  }
  _evm_digest_bridge_deposit_start_0(account_0,
                                     salt_0,
                                     owner_0,
                                     auth_nonce_value_0,
                                     erc20_0,
                                     amount_0,
                                     evm_nonce_0,
                                     gas_limit_0,
                                     max_fee_0,
                                     max_priority_fee_0,
                                     key_version_0,
                                     challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_bridge_deposit_start_0(account_0,
                                                                              owner_0,
                                                                              auth_nonce_value_0,
                                                                              erc20_0,
                                                                              amount_0,
                                                                              evm_nonce_0,
                                                                              gas_limit_0,
                                                                              max_fee_0,
                                                                              max_priority_fee_0,
                                                                              key_version_0,
                                                                              challenge_0));
  }
  _evm_digest_bridge_withdraw_start_0(account_0,
                                      salt_0,
                                      owner_0,
                                      auth_nonce_value_0,
                                      dest_0,
                                      color_0,
                                      amount_0,
                                      evm_nonce_0,
                                      gas_limit_0,
                                      max_fee_0,
                                      max_priority_fee_0,
                                      key_version_0,
                                      challenge_0)
  {
    return this._eip712_digest_0(this._evm_domain_separator_for_0(account_0,
                                                                  salt_0),
                                 this._evm_struct_hash_bridge_withdraw_start_0(account_0,
                                                                               owner_0,
                                                                               auth_nonce_value_0,
                                                                               dest_0,
                                                                               color_0,
                                                                               amount_0,
                                                                               evm_nonce_0,
                                                                               gas_limit_0,
                                                                               max_fee_0,
                                                                               max_priority_fee_0,
                                                                               key_version_0,
                                                                               challenge_0));
  }
  _uint8Word_0(value_0) {
    const b_0 = __compactRuntime.convertBigintToBytes(1,
                                                      value_0,
                                                      'ByteCodec.compact line 37 char 15');
    return Uint8Array.from([0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            BigInt(b_0[0n])],
                           Number);
  }
  _uint64Word_0(value_0) {
    const b_0 = __compactRuntime.convertBigintToBytes(8,
                                                      value_0,
                                                      'ByteCodec.compact line 47 char 15');
    return Uint8Array.from([0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            BigInt(b_0[7n]),
                            BigInt(b_0[6n]),
                            BigInt(b_0[5n]),
                            BigInt(b_0[4n]),
                            BigInt(b_0[3n]),
                            BigInt(b_0[2n]),
                            BigInt(b_0[1n]),
                            BigInt(b_0[0n])],
                           Number);
  }
  _uint128Word_0(value_0) {
    const b_0 = __compactRuntime.convertBigintToBytes(16,
                                                      value_0,
                                                      'ByteCodec.compact line 55 char 15');
    return Uint8Array.from([0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            0n,
                            BigInt(b_0[15n]),
                            BigInt(b_0[14n]),
                            BigInt(b_0[13n]),
                            BigInt(b_0[12n]),
                            BigInt(b_0[11n]),
                            BigInt(b_0[10n]),
                            BigInt(b_0[9n]),
                            BigInt(b_0[8n]),
                            BigInt(b_0[7n]),
                            BigInt(b_0[6n]),
                            BigInt(b_0[5n]),
                            BigInt(b_0[4n]),
                            BigInt(b_0[3n]),
                            BigInt(b_0[2n]),
                            BigInt(b_0[1n]),
                            BigInt(b_0[0n])],
                           Number);
  }
  _addressWord_0(value_0) {
    return Uint8Array.from(((e) => e.slice(0, 32))([...Array.from(new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
                                                                  BigInt),
                                                    ...Array.from(value_0,
                                                                  BigInt)]),
                           Number);
  }
  _zswapCoinCommitment_0(coin_0, recipient_0) {
    return this._persistentHash_37({ domain_sep:
                                       new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 122, 115, 119, 97, 112, 45, 99, 99, 91, 118, 49, 93]),
                                     info: coin_0,
                                     dataType: recipient_0.is_left,
                                     data:
                                       recipient_0.is_left ?
                                       recipient_0.left.bytes :
                                       recipient_0.right.bytes });
  }
  _zswapCoinNullifier_0(coin_0, addr_0) {
    return this._persistentHash_37({ domain_sep:
                                       new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 122, 115, 119, 97, 112, 45, 99, 110, 91, 118, 49, 93]),
                                     info: coin_0,
                                     dataType: false,
                                     data: addr_0.bytes });
  }
  _dropMerkleIndex_0(coin_0) {
    return { nonce: coin_0.nonce, color: coin_0.color, value: coin_0.value };
  }
  _zswapNullifierOf_0(coin_0, addr_0) {
    return this._zswapCoinNullifier_0(coin_0, addr_0);
  }
  _zswapCommitmentOf_0(coin_0, recipient_0) {
    return this._zswapCoinCommitment_0(coin_0, recipient_0);
  }
  _held_coin_0(context, partialProofData, color_0) {
    const witnessContext_0 = __compactRuntime.createWitnessContext(ledger(context.callContext.currentQueryContext.state), context.callContext.currentPrivateState, context.callContext.currentQueryContext.address);
    const [nextPrivateState_0, result_0] = this.witnesses.held_coin(witnessContext_0,
                                                                    color_0);
    context.callContext.currentPrivateState = nextPrivateState_0;
    if (!(typeof(result_0) === 'object' && result_0.nonce.buffer instanceof ArrayBuffer && result_0.nonce.BYTES_PER_ELEMENT === 1 && result_0.nonce.length === 32 && result_0.color.buffer instanceof ArrayBuffer && result_0.color.BYTES_PER_ELEMENT === 1 && result_0.color.length === 32 && typeof(result_0.value) === 'bigint' && result_0.value >= 0n && result_0.value <= 340282366920938463463374607431768211455n && typeof(result_0.mt_index) === 'bigint' && result_0.mt_index >= 0n && result_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('held_coin',
                                 'return value',
                                 'account.compact line 379 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 result_0)
    }
    partialProofData.privateTranscriptOutputs.push({
      value: _descriptor_48.toValue(result_0),
      alignment: _descriptor_48.alignment()
    });
    return result_0;
  }
  async _do_activate_initial_device_0(context, partialProofData, entry_0) {
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = 1n;
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(8n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(tmp_0),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(11n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_15.toValue(true),
                                                                                              alignment: _descriptor_15.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(10n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _activate_initial_device_with_jubjub_0(context,
                                               partialProofData,
                                               pk_0,
                                               salt_0)
  {
    __compactRuntime.assert(!_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                        partialProofData,
                                                                                        [
                                                                                         { dup: { n: 0 } },
                                                                                         { idx: { cached: false,
                                                                                                  pushPath: false,
                                                                                                  path: [
                                                                                                         { tag: 'value',
                                                                                                           value: { value: _descriptor_3.toValue(11n),
                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                         { popeq: { cached: false,
                                                                                                    result: undefined } }]).value),
                            'already activated');
    __compactRuntime.assert(!this._equal_16(this._ecMul_0(pk_0,
                                                          __compactRuntime.convertNumericToJubjubScalar(8n)),
                                            this._ecMulGenerator_0(__compactRuntime.convertNumericToJubjubScalar(0n))),
                            'device key has small order');
    __compactRuntime.assert(this._equal_17(this._derive_boot_commitment_with_jubjub_0(salt_0,
                                                                                      pk_0),
                                           _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                     partialProofData,
                                                                                                     [
                                                                                                      { dup: { n: 0 } },
                                                                                                      { idx: { cached: false,
                                                                                                               pushPath: false,
                                                                                                               path: [
                                                                                                                      { tag: 'value',
                                                                                                                        value: { value: _descriptor_3.toValue(10n),
                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                      { popeq: { cached: false,
                                                                                                                 result: undefined } }]).value)),
                            'boot commitment mismatch');
    await this._do_activate_initial_device_0(context,
                                             partialProofData,
                                             this._derive_device_entry_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                               partialProofData,
                                                                                                                                               [
                                                                                                                                                { dup: { n: 2 } },
                                                                                                                                                { idx: { cached: true,
                                                                                                                                                         pushPath: false,
                                                                                                                                                         path: [
                                                                                                                                                                { tag: 'value',
                                                                                                                                                                  value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                { popeq: { cached: true,
                                                                                                                                                           result: undefined } }]).value),
                                                                                     pk_0,
                                                                                     _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                                partialProofData,
                                                                                                                                                [
                                                                                                                                                 { dup: { n: 0 } },
                                                                                                                                                 { idx: { cached: false,
                                                                                                                                                          pushPath: false,
                                                                                                                                                          path: [
                                                                                                                                                                 { tag: 'value',
                                                                                                                                                                   value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                 { popeq: { cached: false,
                                                                                                                                                            result: undefined } }]).value),
                                                                                     0n));
    return [];
  }
  async _activate_initial_device_with_k256_0(context,
                                             partialProofData,
                                             pk_0,
                                             salt_0,
                                             envelope_0)
  {
    __compactRuntime.assert(!_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                        partialProofData,
                                                                                        [
                                                                                         { dup: { n: 0 } },
                                                                                         { idx: { cached: false,
                                                                                                  pushPath: false,
                                                                                                  path: [
                                                                                                         { tag: 'value',
                                                                                                           value: { value: _descriptor_3.toValue(11n),
                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                         { popeq: { cached: false,
                                                                                                    result: undefined } }]).value),
                            'already activated');
    this._require_live_k256_key_0(pk_0);
    __compactRuntime.assert(this._equal_18(this._derive_boot_commitment_with_k256_0(salt_0,
                                                                                    pk_0,
                                                                                    envelope_0),
                                           _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                     partialProofData,
                                                                                                     [
                                                                                                      { dup: { n: 0 } },
                                                                                                      { idx: { cached: false,
                                                                                                               pushPath: false,
                                                                                                               path: [
                                                                                                                      { tag: 'value',
                                                                                                                        value: { value: _descriptor_3.toValue(10n),
                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                      { popeq: { cached: false,
                                                                                                                 result: undefined } }]).value)),
                            'boot commitment mismatch');
    await this._do_activate_initial_device_0(context,
                                             partialProofData,
                                             this._derive_device_entry_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                             partialProofData,
                                                                                                                                             [
                                                                                                                                              { dup: { n: 2 } },
                                                                                                                                              { idx: { cached: true,
                                                                                                                                                       pushPath: false,
                                                                                                                                                       path: [
                                                                                                                                                              { tag: 'value',
                                                                                                                                                                value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                              { popeq: { cached: true,
                                                                                                                                                         result: undefined } }]).value),
                                                                                   pk_0,
                                                                                   envelope_0,
                                                                                   _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                              partialProofData,
                                                                                                                                              [
                                                                                                                                               { dup: { n: 0 } },
                                                                                                                                               { idx: { cached: false,
                                                                                                                                                        pushPath: false,
                                                                                                                                                        path: [
                                                                                                                                                               { tag: 'value',
                                                                                                                                                                 value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                               { popeq: { cached: false,
                                                                                                                                                          result: undefined } }]).value),
                                                                                   0n));
    return [];
  }
  async _activate_initial_device_with_evm_0(context,
                                            partialProofData,
                                            pk_0,
                                            salt_0)
  {
    __compactRuntime.assert(!_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                        partialProofData,
                                                                                        [
                                                                                         { dup: { n: 0 } },
                                                                                         { idx: { cached: false,
                                                                                                  pushPath: false,
                                                                                                  path: [
                                                                                                         { tag: 'value',
                                                                                                           value: { value: _descriptor_3.toValue(11n),
                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                         { popeq: { cached: false,
                                                                                                    result: undefined } }]).value),
                            'already activated');
    this._require_live_k256_key_0(pk_0);
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    __compactRuntime.assert(this._equal_19(this._derive_boot_commitment_with_evm_0(salt_0,
                                                                                   address_0),
                                           _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                     partialProofData,
                                                                                                     [
                                                                                                      { dup: { n: 0 } },
                                                                                                      { idx: { cached: false,
                                                                                                               pushPath: false,
                                                                                                               path: [
                                                                                                                      { tag: 'value',
                                                                                                                        value: { value: _descriptor_3.toValue(10n),
                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                      { popeq: { cached: false,
                                                                                                                 result: undefined } }]).value)),
                            'boot commitment mismatch');
    await this._do_activate_initial_device_0(context,
                                             partialProofData,
                                             this._derive_device_entry_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                            partialProofData,
                                                                                                                                            [
                                                                                                                                             { dup: { n: 2 } },
                                                                                                                                             { idx: { cached: true,
                                                                                                                                                      pushPath: false,
                                                                                                                                                      path: [
                                                                                                                                                             { tag: 'value',
                                                                                                                                                               value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                             { popeq: { cached: true,
                                                                                                                                                        result: undefined } }]).value),
                                                                                  address_0,
                                                                                  _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                             partialProofData,
                                                                                                                                             [
                                                                                                                                              { dup: { n: 0 } },
                                                                                                                                              { idx: { cached: false,
                                                                                                                                                       pushPath: false,
                                                                                                                                                       path: [
                                                                                                                                                              { tag: 'value',
                                                                                                                                                                value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                              { popeq: { cached: false,
                                                                                                                                                         result: undefined } }]).value),
                                                                                  0n));
    return [];
  }
  _derive_boot_commitment_with_jubjub_0(salt_0, pk_0) {
    return this._persistentHash_0([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 98, 111, 111, 116, 58, 118, 49, 0, 0, 0, 0, 0, 0, 0, 0]),
                                   salt_0,
                                   pk_0]);
  }
  _derive_boot_commitment_with_k256_0(salt_0, pk_0, envelope_0) {
    return this._persistentHash_1([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 98, 111, 111, 116, 58, 107, 49, 58, 118, 50, 0, 0, 0, 0, 0]),
                                   salt_0,
                                   __compactRuntime.convertBigintToBytes(32,
                                                                         this._secp256k1PointX_0(pk_0),
                                                                         'account.compact line 596 char 6'),
                                   __compactRuntime.convertBigintToBytes(32,
                                                                         this._secp256k1PointY_0(pk_0),
                                                                         'account.compact line 596 char 40'),
                                   envelope_0]);
  }
  _derive_boot_commitment_with_evm_0(salt_0, address_0) {
    return this._persistentHash_2([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 98, 111, 111, 116, 58, 101, 118, 109, 58, 118, 49, 0, 0, 0, 0]),
                                   salt_0,
                                   address_0]);
  }
  _derive_device_entry_with_jubjub_0(self_addr_0, pk_0, epoch_0, counter_0) {
    return this._persistentHash_3([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 100, 101, 118, 105, 99, 101, 58, 118, 49, 0, 0, 0, 0, 0, 0]),
                                   self_addr_0,
                                   pk_0,
                                   epoch_0,
                                   counter_0]);
  }
  _derive_device_entry_with_k256_0(self_addr_0,
                                   pk_0,
                                   envelope_0,
                                   epoch_0,
                                   counter_0)
  {
    return this._persistentHash_4([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 100, 101, 118, 105, 99, 101, 58, 107, 49, 58, 118, 50, 0, 0, 0]),
                                   self_addr_0,
                                   __compactRuntime.convertBigintToBytes(32,
                                                                         this._secp256k1PointX_0(pk_0),
                                                                         'account.compact line 658 char 6'),
                                   __compactRuntime.convertBigintToBytes(32,
                                                                         this._secp256k1PointY_0(pk_0),
                                                                         'account.compact line 658 char 40'),
                                   envelope_0,
                                   epoch_0,
                                   counter_0]);
  }
  _derive_device_entry_with_evm_0(self_addr_0, address_0, epoch_0, counter_0) {
    return this._persistentHash_5([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 100, 101, 118, 105, 99, 101, 58, 101, 118, 109, 58, 118, 49, 0, 0]),
                                   self_addr_0,
                                   address_0,
                                   epoch_0,
                                   counter_0]);
  }
  _require_live_k256_key_0(pk_0) {
    __compactRuntime.assert(!(this._equal_20(__compactRuntime.convertBigintToBytes(32,
                                                                                   this._secp256k1PointX_0(pk_0),
                                                                                   'account.compact line 711 char 8'),
                                             new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]))
                              &&
                              this._equal_21(__compactRuntime.convertBigintToBytes(32,
                                                                                   this._secp256k1PointY_0(pk_0),
                                                                                   'account.compact line 712 char 11'),
                                             new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]))),
                            'device key is the point at infinity');
    return [];
  }
  _envelope_digest_0(envelope_0, challenge_0) {
    __compactRuntime.assert(envelope_0 <= 1n, 'unknown envelope');
    const none_0 = this._persistentHash_6(challenge_0);
    const connector_0 = this._persistentHash_7([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 95, 115, 105, 103, 110, 101, 100, 95, 109, 101, 115, 115, 97, 103, 101, 58, 51, 50, 58]),
                                                challenge_0]);
    if (envelope_0 === 1n) { return connector_0; } else { return none_0; }
  }
  _compute_public_point_with_jubjub_0(scalar_0) {
    return this._ecMulGenerator_0(__compactRuntime.convertNumericToJubjubScalar(scalar_0));
  }
  _compute_public_point_with_k256_0(scalar_0) {
    return this._ecMulGenerator_1(scalar_0);
  }
  _challenge_withdraw_unshielded_with_jubjub_0(self_addr_0,
                                               sig_r_0,
                                               pk_0,
                                               color_0,
                                               amount_0,
                                               recipient_0,
                                               nonce_value_0,
                                               grind_nonce_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 117, 110, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_8([dst_0,
                                   self_addr_0,
                                   sig_r_0,
                                   pk_0,
                                   color_0,
                                   amount_0,
                                   recipient_0,
                                   nonce_value_0,
                                   grind_nonce_0]);
  }
  _challenge_withdraw_shielded_with_jubjub_0(self_addr_0,
                                             sig_r_0,
                                             pk_0,
                                             recipient_0,
                                             color_0,
                                             amount_0,
                                             coin_0,
                                             nonce_value_0,
                                             grind_nonce_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_9([dst_0,
                                   self_addr_0,
                                   sig_r_0,
                                   pk_0,
                                   recipient_0,
                                   color_0,
                                   amount_0,
                                   coin_0,
                                   nonce_value_0,
                                   grind_nonce_0]);
  }
  _challenge_withdraw_shielded_to_contract_with_jubjub_0(self_addr_0,
                                                         sig_r_0,
                                                         pk_0,
                                                         recipient_0,
                                                         color_0,
                                                         amount_0,
                                                         coin_0,
                                                         nonce_value_0,
                                                         grind_nonce_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 95, 116, 111, 95, 99, 111, 110, 116, 114, 97, 99, 116, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_10([dst_0,
                                    self_addr_0,
                                    sig_r_0,
                                    pk_0,
                                    recipient_0,
                                    color_0,
                                    amount_0,
                                    coin_0,
                                    nonce_value_0,
                                    grind_nonce_0]);
  }
  _challenge_append_inbox_with_jubjub_0(self_addr_0,
                                        sig_r_0,
                                        pk_0,
                                        entry_0,
                                        nonce_value_0,
                                        grind_nonce_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 97, 112, 112, 101, 110, 100, 95, 105, 110, 98, 111, 120, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_11([dst_0,
                                    self_addr_0,
                                    sig_r_0,
                                    pk_0,
                                    entry_0,
                                    nonce_value_0,
                                    grind_nonce_0]);
  }
  _challenge_rotate_enc_key_with_jubjub_0(self_addr_0,
                                          sig_r_0,
                                          pk_0,
                                          new_key_0,
                                          nonce_value_0,
                                          grind_nonce_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 114, 111, 116, 97, 116, 101, 95, 101, 110, 99, 95, 107, 101, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_12([dst_0,
                                    self_addr_0,
                                    sig_r_0,
                                    pk_0,
                                    new_key_0,
                                    nonce_value_0,
                                    grind_nonce_0]);
  }
  _challenge_add_device_with_jubjub_0(self_addr_0,
                                      sig_r_0,
                                      pk_0,
                                      new_entry_0,
                                      nonce_value_0,
                                      grind_nonce_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 97, 100, 100, 95, 100, 101, 118, 105, 99, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_12([dst_0,
                                    self_addr_0,
                                    sig_r_0,
                                    pk_0,
                                    new_entry_0,
                                    nonce_value_0,
                                    grind_nonce_0]);
  }
  _challenge_remove_device_with_jubjub_0(self_addr_0,
                                         sig_r_0,
                                         pk_0,
                                         entry_0,
                                         nonce_value_0,
                                         grind_nonce_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 114, 101, 109, 111, 118, 101, 95, 100, 101, 118, 105, 99, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_12([dst_0,
                                    self_addr_0,
                                    sig_r_0,
                                    pk_0,
                                    entry_0,
                                    nonce_value_0,
                                    grind_nonce_0]);
  }
  _challenge_open_swap_shielded_with_jubjub_0(self_addr_0,
                                              sig_r_0,
                                              pk_0,
                                              give_color_0,
                                              give_amount_0,
                                              recipient_kind_0,
                                              recipient_0,
                                              want_0,
                                              want_entry_0,
                                              change_entry_0,
                                              valid_until_0,
                                              coin_0,
                                              nonce_value_0,
                                              grind_nonce_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 118, 49, 58, 111, 112, 101, 110, 95, 115, 119, 97, 112, 95, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_13([dst_0,
                                    self_addr_0,
                                    sig_r_0,
                                    pk_0,
                                    give_color_0,
                                    give_amount_0,
                                    recipient_kind_0,
                                    recipient_0,
                                    want_0,
                                    want_entry_0,
                                    change_entry_0,
                                    valid_until_0,
                                    coin_0,
                                    nonce_value_0,
                                    grind_nonce_0]);
  }
  _challenge_withdraw_unshielded_with_k256_0(self_addr_0,
                                             pk_0,
                                             color_0,
                                             amount_0,
                                             recipient_0,
                                             nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 117, 110, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_14([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 942 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 942 char 40'),
                                    color_0,
                                    amount_0,
                                    recipient_0,
                                    nonce_value_0]);
  }
  _challenge_withdraw_shielded_with_k256_0(self_addr_0,
                                           pk_0,
                                           recipient_0,
                                           color_0,
                                           amount_0,
                                           coin_0,
                                           nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_15([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 961 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 961 char 40'),
                                    recipient_0,
                                    color_0,
                                    amount_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  _challenge_withdraw_shielded_to_contract_with_k256_0(self_addr_0,
                                                       pk_0,
                                                       recipient_0,
                                                       color_0,
                                                       amount_0,
                                                       coin_0,
                                                       nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 95, 116, 111, 95, 99, 111, 110, 116, 114, 97, 99, 116, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_16([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 980 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 980 char 40'),
                                    recipient_0,
                                    color_0,
                                    amount_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  _challenge_append_inbox_with_k256_0(self_addr_0, pk_0, entry_0, nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 97, 112, 112, 101, 110, 100, 95, 105, 110, 98, 111, 120, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_17([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 996 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 996 char 40'),
                                    entry_0,
                                    nonce_value_0]);
  }
  _challenge_rotate_enc_key_with_k256_0(self_addr_0,
                                        pk_0,
                                        new_key_0,
                                        nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 114, 111, 116, 97, 116, 101, 95, 101, 110, 99, 95, 107, 101, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_18([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 1012 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 1012 char 40'),
                                    new_key_0,
                                    nonce_value_0]);
  }
  _challenge_add_device_with_k256_0(self_addr_0,
                                    pk_0,
                                    new_entry_0,
                                    nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 97, 100, 100, 95, 100, 101, 118, 105, 99, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_18([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 1028 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 1028 char 40'),
                                    new_entry_0,
                                    nonce_value_0]);
  }
  _challenge_remove_device_with_k256_0(self_addr_0, pk_0, entry_0, nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 107, 49, 58, 118, 49, 58, 114, 101, 109, 111, 118, 101, 95, 100, 101, 118, 105, 99, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_18([dst_0,
                                    self_addr_0,
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointX_0(pk_0),
                                                                          'account.compact line 1044 char 6'),
                                    __compactRuntime.convertBigintToBytes(32,
                                                                          this._secp256k1PointY_0(pk_0),
                                                                          'account.compact line 1044 char 40'),
                                    entry_0,
                                    nonce_value_0]);
  }
  _challenge_withdraw_unshielded_with_evm_0(self_addr_0,
                                            address_0,
                                            color_0,
                                            amount_0,
                                            recipient_0,
                                            nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 117, 110, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_19([dst_0,
                                    self_addr_0,
                                    address_0,
                                    color_0,
                                    amount_0,
                                    recipient_0,
                                    nonce_value_0]);
  }
  _challenge_withdraw_shielded_with_evm_0(self_addr_0,
                                          address_0,
                                          recipient_0,
                                          color_0,
                                          amount_0,
                                          coin_0,
                                          nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_20([dst_0,
                                    self_addr_0,
                                    address_0,
                                    recipient_0,
                                    color_0,
                                    amount_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  _challenge_withdraw_shielded_to_contract_with_evm_0(self_addr_0,
                                                      address_0,
                                                      recipient_0,
                                                      color_0,
                                                      amount_0,
                                                      coin_0,
                                                      nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 95, 116, 111, 95, 99, 111, 110, 116, 114, 97, 99, 116, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_21([dst_0,
                                    self_addr_0,
                                    address_0,
                                    recipient_0,
                                    color_0,
                                    amount_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  _challenge_append_inbox_with_evm_0(self_addr_0,
                                     address_0,
                                     entry_0,
                                     nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 97, 112, 112, 101, 110, 100, 95, 105, 110, 98, 111, 120, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_22([dst_0,
                                    self_addr_0,
                                    address_0,
                                    entry_0,
                                    nonce_value_0]);
  }
  _challenge_rotate_enc_key_with_evm_0(self_addr_0,
                                       address_0,
                                       new_key_0,
                                       nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 114, 111, 116, 97, 116, 101, 95, 101, 110, 99, 95, 107, 101, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_23([dst_0,
                                    self_addr_0,
                                    address_0,
                                    new_key_0,
                                    nonce_value_0]);
  }
  _challenge_add_device_with_evm_0(self_addr_0,
                                   address_0,
                                   new_entry_0,
                                   nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 97, 100, 100, 95, 100, 101, 118, 105, 99, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_23([dst_0,
                                    self_addr_0,
                                    address_0,
                                    new_entry_0,
                                    nonce_value_0]);
  }
  _challenge_remove_device_with_evm_0(self_addr_0,
                                      address_0,
                                      entry_0,
                                      nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 114, 101, 109, 111, 118, 101, 95, 100, 101, 118, 105, 99, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_23([dst_0,
                                    self_addr_0,
                                    address_0,
                                    entry_0,
                                    nonce_value_0]);
  }
  _challenge_open_swap_shielded_with_evm_0(self_addr_0,
                                           address_0,
                                           give_color_0,
                                           give_amount_0,
                                           recipient_kind_0,
                                           recipient_0,
                                           want_0,
                                           want_entry_0,
                                           change_entry_0,
                                           valid_until_0,
                                           coin_0,
                                           nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 111, 112, 101, 110, 95, 115, 119, 97, 112, 95, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_24([dst_0,
                                    self_addr_0,
                                    address_0,
                                    give_color_0,
                                    give_amount_0,
                                    recipient_kind_0,
                                    recipient_0,
                                    want_0,
                                    want_entry_0,
                                    change_entry_0,
                                    valid_until_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  _challenge_bridge_deposit_start_with_evm_0(self_addr_0,
                                             address_0,
                                             erc20_0,
                                             amount_0,
                                             evm_nonce_0,
                                             gas_limit_0,
                                             max_fee_0,
                                             max_priority_fee_0,
                                             key_version_0,
                                             nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 98, 114, 105, 100, 103, 101, 95, 100, 101, 112, 111, 115, 105, 116, 95, 115, 116, 97, 114, 116, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_25([dst_0,
                                    self_addr_0,
                                    address_0,
                                    erc20_0,
                                    amount_0,
                                    evm_nonce_0,
                                    gas_limit_0,
                                    max_fee_0,
                                    max_priority_fee_0,
                                    key_version_0,
                                    nonce_value_0]);
  }
  _challenge_bridge_withdraw_start_with_evm_0(self_addr_0,
                                              address_0,
                                              dest_0,
                                              color_0,
                                              amount_0,
                                              evm_nonce_0,
                                              gas_limit_0,
                                              max_fee_0,
                                              max_priority_fee_0,
                                              key_version_0,
                                              erc20_0,
                                              coin_0,
                                              nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 118, 109, 58, 118, 49, 58, 98, 114, 105, 100, 103, 101, 95, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 116, 97, 114, 116, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_26([dst_0,
                                    self_addr_0,
                                    address_0,
                                    dest_0,
                                    color_0,
                                    amount_0,
                                    evm_nonce_0,
                                    gas_limit_0,
                                    max_fee_0,
                                    max_priority_fee_0,
                                    key_version_0,
                                    erc20_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  async _require_authorised_with_jubjub_0(context,
                                          partialProofData,
                                          pk_0,
                                          use_counter_0,
                                          sig_r_0,
                                          sig_s_0,
                                          challenge_0)
  {
    __compactRuntime.assert(!this._equal_22(this._ecMul_0(pk_0,
                                                          __compactRuntime.convertNumericToJubjubScalar(8n)),
                                            this._ecMulGenerator_0(__compactRuntime.convertNumericToJubjubScalar(0n))),
                            'device key has small order');
    const entry_0 = this._derive_device_entry_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 2 } },
                                                                                                                       { idx: { cached: true,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: true,
                                                                                                                                  result: undefined } }]).value),
                                                            pk_0,
                                                            _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 0 } },
                                                                                                                        { idx: { cached: false,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: false,
                                                                                                                                   result: undefined } }]).value),
                                                            use_counter_0);
    __compactRuntime.assert(_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(6n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { push: { storage: false,
                                                                                                  value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                                                                               alignment: _descriptor_0.alignment() }).encode() } },
                                                                                        'member',
                                                                                        { popeq: { cached: true,
                                                                                                   result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = this._derive_device_entry_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                    partialProofData,
                                                                                                                    [
                                                                                                                     { dup: { n: 2 } },
                                                                                                                     { idx: { cached: true,
                                                                                                                              pushPath: false,
                                                                                                                              path: [
                                                                                                                                     { tag: 'value',
                                                                                                                                       value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                     { popeq: { cached: true,
                                                                                                                                result: undefined } }]).value),
                                                          pk_0,
                                                          _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 0 } },
                                                                                                                      { idx: { cached: false,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: false,
                                                                                                                                 result: undefined } }]).value),
                                                          ((t1) => {
                                                            if (t1 > 18446744073709551615n) {
                                                              throw new __compactRuntime.CompactError('account.compact line 1317 char 39: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                            }
                                                            return t1;
                                                          })(use_counter_0 + 1n));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    const c_0 = __compactRuntime.convertBytesToUint(52435875175126190479447740508185965837690552500527637822603658699938581184512n,
                                                    32,
                                                    challenge_0,
                                                    'Field',
                                                    'account.compact line 1322 char 13');
    __compactRuntime.assert(this._equal_23(this._ecMulGenerator_0(__compactRuntime.convertNumericToJubjubScalar(sig_s_0)),
                                           this._ecAdd_0(sig_r_0,
                                                         this._ecMul_0(pk_0,
                                                                       __compactRuntime.convertNumericToJubjubScalar(c_0)))),
                            'invalid signature');
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 1327 char 17: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_1),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _require_authorised_with_k256_0(context,
                                        partialProofData,
                                        pk_0,
                                        use_counter_0,
                                        sig_0,
                                        challenge_0,
                                        envelope_0)
  {
    this._require_live_k256_key_0(pk_0);
    const entry_0 = this._derive_device_entry_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                    partialProofData,
                                                                                                                    [
                                                                                                                     { dup: { n: 2 } },
                                                                                                                     { idx: { cached: true,
                                                                                                                              pushPath: false,
                                                                                                                              path: [
                                                                                                                                     { tag: 'value',
                                                                                                                                       value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                     { popeq: { cached: true,
                                                                                                                                result: undefined } }]).value),
                                                          pk_0,
                                                          envelope_0,
                                                          _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 0 } },
                                                                                                                      { idx: { cached: false,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: false,
                                                                                                                                 result: undefined } }]).value),
                                                          use_counter_0);
    __compactRuntime.assert(_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(6n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { push: { storage: false,
                                                                                                  value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                                                                               alignment: _descriptor_0.alignment() }).encode() } },
                                                                                        'member',
                                                                                        { popeq: { cached: true,
                                                                                                   result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = this._derive_device_entry_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                  partialProofData,
                                                                                                                  [
                                                                                                                   { dup: { n: 2 } },
                                                                                                                   { idx: { cached: true,
                                                                                                                            pushPath: false,
                                                                                                                            path: [
                                                                                                                                   { tag: 'value',
                                                                                                                                     value: { value: _descriptor_3.toValue(0n),
                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                   { popeq: { cached: true,
                                                                                                                              result: undefined } }]).value),
                                                        pk_0,
                                                        envelope_0,
                                                        _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                   partialProofData,
                                                                                                                   [
                                                                                                                    { dup: { n: 0 } },
                                                                                                                    { idx: { cached: false,
                                                                                                                             pushPath: false,
                                                                                                                             path: [
                                                                                                                                    { tag: 'value',
                                                                                                                                      value: { value: _descriptor_3.toValue(7n),
                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                    { popeq: { cached: false,
                                                                                                                               result: undefined } }]).value),
                                                        ((t1) => {
                                                          if (t1 > 18446744073709551615n) {
                                                            throw new __compactRuntime.CompactError('account.compact line 1346 char 6: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                          }
                                                          return t1;
                                                        })(use_counter_0 + 1n));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    const digest_0 = this._envelope_digest_0(envelope_0, challenge_0);
    __compactRuntime.assert(this._secp256k1EcdsaVerify_0(digest_0, sig_0, pk_0),
                            'invalid signature');
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 1360 char 17: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_1),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _require_authorised_with_evm_0(context,
                                       partialProofData,
                                       pk_0,
                                       use_counter_0,
                                       sig_0,
                                       digest_0,
                                       address_0)
  {
    this._require_live_k256_key_0(pk_0);
    const entry_0 = this._derive_device_entry_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                   partialProofData,
                                                                                                                   [
                                                                                                                    { dup: { n: 2 } },
                                                                                                                    { idx: { cached: true,
                                                                                                                             pushPath: false,
                                                                                                                             path: [
                                                                                                                                    { tag: 'value',
                                                                                                                                      value: { value: _descriptor_3.toValue(0n),
                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                    { popeq: { cached: true,
                                                                                                                               result: undefined } }]).value),
                                                         address_0,
                                                         _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                    partialProofData,
                                                                                                                    [
                                                                                                                     { dup: { n: 0 } },
                                                                                                                     { idx: { cached: false,
                                                                                                                              pushPath: false,
                                                                                                                              path: [
                                                                                                                                     { tag: 'value',
                                                                                                                                       value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                     { popeq: { cached: false,
                                                                                                                                result: undefined } }]).value),
                                                         use_counter_0);
    __compactRuntime.assert(_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(6n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { push: { storage: false,
                                                                                                  value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                                                                               alignment: _descriptor_0.alignment() }).encode() } },
                                                                                        'member',
                                                                                        { popeq: { cached: true,
                                                                                                   result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = this._derive_device_entry_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                 partialProofData,
                                                                                                                 [
                                                                                                                  { dup: { n: 2 } },
                                                                                                                  { idx: { cached: true,
                                                                                                                           pushPath: false,
                                                                                                                           path: [
                                                                                                                                  { tag: 'value',
                                                                                                                                    value: { value: _descriptor_3.toValue(0n),
                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                  { popeq: { cached: true,
                                                                                                                             result: undefined } }]).value),
                                                       address_0,
                                                       _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                  partialProofData,
                                                                                                                  [
                                                                                                                   { dup: { n: 0 } },
                                                                                                                   { idx: { cached: false,
                                                                                                                            pushPath: false,
                                                                                                                            path: [
                                                                                                                                   { tag: 'value',
                                                                                                                                     value: { value: _descriptor_3.toValue(7n),
                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                   { popeq: { cached: false,
                                                                                                                              result: undefined } }]).value),
                                                       ((t1) => {
                                                         if (t1 > 18446744073709551615n) {
                                                           throw new __compactRuntime.CompactError('account.compact line 1391 char 6: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                         }
                                                         return t1;
                                                       })(use_counter_0 + 1n));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    __compactRuntime.assert(this._secp256k1EcdsaVerify_0(digest_0, sig_0, pk_0),
                            'invalid signature');
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 1401 char 17: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_1),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _bump_round_0(context, partialProofData) {
    const tmp_0 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 1406 char 12: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(0n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_0),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    return [];
  }
  async _credit_unshielded_0(context, partialProofData, color_0, amount_0) {
    if (_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                   partialProofData,
                                                                   [
                                                                    { dup: { n: 0 } },
                                                                    { idx: { cached: false,
                                                                             pushPath: false,
                                                                             path: [
                                                                                    { tag: 'value',
                                                                                      value: { value: _descriptor_3.toValue(4n),
                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                    { push: { storage: false,
                                                                              value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(color_0),
                                                                                                                           alignment: _descriptor_0.alignment() }).encode() } },
                                                                    'member',
                                                                    { popeq: { cached: true,
                                                                               result: undefined } }]).value))
    {
      const tmp_0 = ((t1) => {
                      if (t1 > 340282366920938463463374607431768211455n) {
                        throw new __compactRuntime.CompactError('account.compact line 1415 char 8: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 340282366920938463463374607431768211455');
                      }
                      return t1;
                    })(_descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                 partialProofData,
                                                                                 [
                                                                                  { dup: { n: 0 } },
                                                                                  { idx: { cached: false,
                                                                                           pushPath: false,
                                                                                           path: [
                                                                                                  { tag: 'value',
                                                                                                    value: { value: _descriptor_3.toValue(4n),
                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                  { idx: { cached: false,
                                                                                           pushPath: false,
                                                                                           path: [
                                                                                                  { tag: 'value',
                                                                                                    value: { value: _descriptor_0.toValue(color_0),
                                                                                                             alignment: _descriptor_0.alignment() } }] } },
                                                                                  { popeq: { cached: false,
                                                                                             result: undefined } }]).value)
                       +
                       amount_0);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { idx: { cached: false,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(4n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(color_0),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: true,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_8.toValue(tmp_0),
                                                                                                alignment: _descriptor_8.alignment() }).encode() } },
                                         { ins: { cached: false, n: 1 } },
                                         { ins: { cached: true, n: 1 } }]);
    } else {
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { idx: { cached: false,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(4n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(color_0),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: true,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_8.toValue(amount_0),
                                                                                                alignment: _descriptor_8.alignment() }).encode() } },
                                         { ins: { cached: false, n: 1 } },
                                         { ins: { cached: true, n: 1 } }]);
    }
    return [];
  }
  async _debit_unshielded_0(context, partialProofData, color_0, amount_0) {
    __compactRuntime.assert(_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(4n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { push: { storage: false,
                                                                                                  value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(color_0),
                                                                                                                                               alignment: _descriptor_0.alignment() }).encode() } },
                                                                                        'member',
                                                                                        { popeq: { cached: true,
                                                                                                   result: undefined } }]).value),
                            'no balance for color');
    const bal_0 = _descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                            partialProofData,
                                                                            [
                                                                             { dup: { n: 0 } },
                                                                             { idx: { cached: false,
                                                                                      pushPath: false,
                                                                                      path: [
                                                                                             { tag: 'value',
                                                                                               value: { value: _descriptor_3.toValue(4n),
                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                             { idx: { cached: false,
                                                                                      pushPath: false,
                                                                                      path: [
                                                                                             { tag: 'value',
                                                                                               value: { value: _descriptor_0.toValue(color_0),
                                                                                                        alignment: _descriptor_0.alignment() } }] } },
                                                                             { popeq: { cached: false,
                                                                                        result: undefined } }]).value);
    __compactRuntime.assert(bal_0 >= amount_0, 'insufficient balance');
    const tmp_0 = (__compactRuntime.assert(bal_0 >= amount_0,
                                           'result of subtraction would be negative'),
                   bal_0 - amount_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(4n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(color_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_8.toValue(tmp_0),
                                                                                              alignment: _descriptor_8.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    return [];
  }
  async _do_withdraw_unshielded_0(context,
                                  partialProofData,
                                  color_0,
                                  amount_0,
                                  recipient_0)
  {
    const c_0 = color_0;
    const a_0 = amount_0;
    await this._debit_unshielded_0(context, partialProofData, c_0, a_0);
    await this._sendUnshielded_0(context,
                                 partialProofData,
                                 c_0,
                                 a_0,
                                 this._right_0(recipient_0));
    return [];
  }
  async _do_append_inbox_0(context, partialProofData, entry_0) {
    const tmp_0 = _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                             partialProofData,
                                                                             [
                                                                              { dup: { n: 0 } },
                                                                              { idx: { cached: false,
                                                                                       pushPath: false,
                                                                                       path: [
                                                                                              { tag: 'value',
                                                                                                value: { value: _descriptor_3.toValue(3n),
                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                              { popeq: { cached: false,
                                                                                         result: undefined } }]).value);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(2n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_0),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_7.toValue(entry_0),
                                                                                              alignment: _descriptor_7.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 1450 char 18: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(3n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(3n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_1),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    return [];
  }
  async _do_withdraw_shielded_0(context,
                                partialProofData,
                                recipient_0,
                                amount_0,
                                coin_0)
  {
    const result_0 = await this._sendShielded_0(context,
                                                partialProofData,
                                                coin_0,
                                                this._left_1(recipient_0),
                                                amount_0);
    if (result_0.change.is_some) {
      return this._some_0(result_0.change.value);
    } else {
      return this._none_0();
    }
  }
  async _do_withdraw_shielded_to_contract_0(context,
                                            partialProofData,
                                            recipient_0,
                                            amount_0,
                                            coin_0)
  {
    const result_0 = await this._sendShielded_0(context,
                                                partialProofData,
                                                coin_0,
                                                this._right_1(recipient_0),
                                                amount_0);
    if (result_0.change.is_some) {
      return [result_0.sent, this._some_0(result_0.change.value)];
    } else {
      return [result_0.sent, this._none_0()];
    }
  }
  async _do_rotate_enc_key_0(context, partialProofData, new_key_0) {
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(1n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(new_key_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    return [];
  }
  async _do_add_device_0(context, partialProofData, new_entry_0) {
    const e_0 = new_entry_0;
    __compactRuntime.assert(!_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                        partialProofData,
                                                                                        [
                                                                                         { dup: { n: 0 } },
                                                                                         { idx: { cached: false,
                                                                                                  pushPath: false,
                                                                                                  path: [
                                                                                                         { tag: 'value',
                                                                                                           value: { value: _descriptor_3.toValue(6n),
                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                         { push: { storage: false,
                                                                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(e_0),
                                                                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                                                                         'member',
                                                                                         { popeq: { cached: true,
                                                                                                    result: undefined } }]).value),
                            'device entry already present');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(e_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = ((t1) => {
                    if (t1 > 255n) {
                      throw new __compactRuntime.CompactError('account.compact line 1504 char 19: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 255');
                    }
                    return t1;
                  })(_descriptor_3.fromValue(__compactRuntime.queryLedgerState(context,
                                                                               partialProofData,
                                                                               [
                                                                                { dup: { n: 0 } },
                                                                                { idx: { cached: false,
                                                                                         pushPath: false,
                                                                                         path: [
                                                                                                { tag: 'value',
                                                                                                  value: { value: _descriptor_3.toValue(8n),
                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                { popeq: { cached: false,
                                                                                           result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(8n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(tmp_0),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    return [];
  }
  async _do_remove_device_0(context, partialProofData, entry_0, caller_entry_0)
  {
    const e_0 = entry_0;
    let t_0;
    __compactRuntime.assert((t_0 = _descriptor_3.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                             partialProofData,
                                                                                             [
                                                                                              { dup: { n: 0 } },
                                                                                              { idx: { cached: false,
                                                                                                       pushPath: false,
                                                                                                       path: [
                                                                                                              { tag: 'value',
                                                                                                                value: { value: _descriptor_3.toValue(8n),
                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                              { popeq: { cached: false,
                                                                                                         result: undefined } }]).value),
                             t_0 > 1n),
                            'cannot remove last device');
    __compactRuntime.assert(!this._equal_24(e_0, caller_entry_0),
                            'cannot remove the authorising device');
    __compactRuntime.assert(_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(6n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { push: { storage: false,
                                                                                                  value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(e_0),
                                                                                                                                               alignment: _descriptor_0.alignment() }).encode() } },
                                                                                        'member',
                                                                                        { popeq: { cached: true,
                                                                                                   result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(e_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    let t_1, t_2;
    const tmp_0 = (t_1 = _descriptor_3.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                   partialProofData,
                                                                                   [
                                                                                    { dup: { n: 0 } },
                                                                                    { idx: { cached: false,
                                                                                             pushPath: false,
                                                                                             path: [
                                                                                                    { tag: 'value',
                                                                                                      value: { value: _descriptor_3.toValue(8n),
                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                    { popeq: { cached: false,
                                                                                               result: undefined } }]).value),
                   (t_2 = 1n,
                    (__compactRuntime.assert(t_1 >= t_2,
                                             'result of subtraction would be negative'),
                     t_1 - t_2)));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(8n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(tmp_0),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    return [];
  }
  _assert_open_swap_terms_0(give_color_0,
                            give_amount_0,
                            recipient_kind_0,
                            recipient_0,
                            want_0,
                            coin_color_0,
                            coin_value_0)
  {
    __compactRuntime.assert(give_amount_0 > 0n,
                            'swap must give a positive amount');
    let t_0;
    __compactRuntime.assert((t_0 = want_0.value, t_0 > 0n),
                            'swap must want a positive amount');
    __compactRuntime.assert(!this._equal_25(give_color_0, want_0.color),
                            'swap legs must be different colours');
    __compactRuntime.assert(recipient_kind_0 <= 2n,
                            'swap recipient kind is invalid');
    __compactRuntime.assert(recipient_kind_0 <= 1n,
                            'swap to a contract taker is not supported');
    if (recipient_kind_0 === 0n) {
      __compactRuntime.assert(this._equal_26(recipient_0, new Uint8Array(32)),
                              'open swap recipient must be zero');
    } else {
      __compactRuntime.assert(!this._equal_27(recipient_0, new Uint8Array(32)),
                              'named swap recipient must be nonzero');
    }
    __compactRuntime.assert(this._equal_28(coin_color_0, give_color_0),
                            'held coin colour does not match the give colour');
    __compactRuntime.assert(coin_value_0 >= give_amount_0,
                            'held coin is smaller than the give amount');
    return [];
  }
  _swap_change_nonce_0(coin_nonce_0) {
    return this._evolveNonce_0(2n, coin_nonce_0);
  }
  async _assert_offer_live_0(context, partialProofData, valid_until_0) {
    const deadline_0 = valid_until_0;
    if (deadline_0 !== 0n) {
      __compactRuntime.assert(await this._blockTimeLt_0(context,
                                                        partialProofData,
                                                        deadline_0),
                              'offer authorisation has expired');
    }
    return [];
  }
  async _do_open_swap_0(context,
                        partialProofData,
                        coin_0,
                        give_amount_0,
                        recipient_kind_0,
                        recipient_0,
                        want_0,
                        want_entry_0,
                        change_entry_0)
  {
    const self_addr_0 = _descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                  partialProofData,
                                                                                  [
                                                                                   { dup: { n: 2 } },
                                                                                   { idx: { cached: true,
                                                                                            pushPath: false,
                                                                                            path: [
                                                                                                   { tag: 'value',
                                                                                                     value: { value: _descriptor_3.toValue(0n),
                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                   { popeq: { cached: true,
                                                                                              result: undefined } }]).value);
    const self_rcpt_0 = this._right_1(self_addr_0);
    const c_0 = coin_0;
    const give_0 = give_amount_0;
    const kind_0 = recipient_kind_0;
    let t_0; const safe_give_0 = (t_0 = c_0.value, t_0 >= give_0) ? give_0 : 0n;
    let t_1;
    const change_value_0 = (t_1 = c_0.value,
                            (__compactRuntime.assert(t_1 >= safe_give_0,
                                                     'result of subtraction would be negative'),
                             t_1 - safe_give_0));
    const has_change_0 = change_value_0 > 0n;
    const change_coin_0 = { nonce: this._evolveNonce_0(2n, c_0.nonce),
                            color: c_0.color,
                            value: change_value_0 };
    this._createZswapInput_0(context, partialProofData, c_0);
    const tmp_0 = this._zswapCoinNullifier_0(this._dropMerkleIndex_0(c_0),
                                             self_addr_0);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { swap: { n: 0 } },
                                       { idx: { cached: true,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(0n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: true, n: 2 } },
                                       { swap: { n: 0 } }]);
    if (kind_0 !== 0n) {
      const payout_0 = { nonce: this._evolveNonce_0(1n, c_0.nonce),
                         color: c_0.color,
                         value: safe_give_0 };
      const payout_rcpt_0 = this._left_1({ bytes: recipient_0 });
      this._createZswapOutput_0(context,
                                partialProofData,
                                payout_0,
                                payout_rcpt_0);
      const tmp_1 = this._zswapCoinCommitment_0(payout_0, payout_rcpt_0);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(2n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_1),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newNull().encode() } },
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
    }
    if (has_change_0) {
      this._createZswapOutput_0(context,
                                partialProofData,
                                change_coin_0,
                                self_rcpt_0);
      const cm_0 = this._zswapCoinCommitment_0(change_coin_0, self_rcpt_0);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(2n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(cm_0),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newNull().encode() } },
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
      __compactRuntime.queryLedgerState(context,
                                        partialProofData,
                                        [
                                         { swap: { n: 0 } },
                                         { idx: { cached: true,
                                                  pushPath: true,
                                                  path: [
                                                         { tag: 'value',
                                                           value: { value: _descriptor_3.toValue(1n),
                                                                    alignment: _descriptor_3.alignment() } }] } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(cm_0),
                                                                                                alignment: _descriptor_0.alignment() }).encode() } },
                                         { push: { storage: false,
                                                   value: __compactRuntime.StateValue.newNull().encode() } },
                                         { ins: { cached: true, n: 2 } },
                                         { swap: { n: 0 } }]);
    }
    await this._receiveShielded_0(context, partialProofData, want_0);
    if (has_change_0) {
      await this._do_append_inbox_0(context, partialProofData, change_entry_0);
    }
    await this._do_append_inbox_0(context, partialProofData, want_entry_0);
    if (has_change_0) {
      return this._some_0(change_coin_0);
    } else {
      return this._none_0();
    }
  }
  async _deposit_unshielded_0(context, partialProofData, color_0, amount_0) {
    const c_0 = color_0;
    const a_0 = amount_0;
    await this._receiveUnshielded_0(context, partialProofData, c_0, a_0);
    await this._credit_unshielded_0(context, partialProofData, c_0, a_0);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _withdraw_unshielded_with_jubjub_0(context,
                                           partialProofData,
                                           color_0,
                                           amount_0,
                                           recipient_0,
                                           pk_0,
                                           use_counter_0,
                                           sig_r_0,
                                           sig_s_0,
                                           grind_nonce_0)
  {
    const challenge_0 = this._challenge_withdraw_unshielded_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                    partialProofData,
                                                                                                                                    [
                                                                                                                                     { dup: { n: 2 } },
                                                                                                                                     { idx: { cached: true,
                                                                                                                                              pushPath: false,
                                                                                                                                              path: [
                                                                                                                                                     { tag: 'value',
                                                                                                                                                       value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                     { popeq: { cached: true,
                                                                                                                                                result: undefined } }]).value),
                                                                          sig_r_0,
                                                                          pk_0,
                                                                          color_0,
                                                                          amount_0,
                                                                          recipient_0,
                                                                          _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                     partialProofData,
                                                                                                                                     [
                                                                                                                                      { dup: { n: 0 } },
                                                                                                                                      { idx: { cached: false,
                                                                                                                                               pushPath: false,
                                                                                                                                               path: [
                                                                                                                                                      { tag: 'value',
                                                                                                                                                        value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                      { popeq: { cached: false,
                                                                                                                                                 result: undefined } }]).value),
                                                                          grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    await this._do_withdraw_unshielded_0(context,
                                         partialProofData,
                                         color_0,
                                         amount_0,
                                         recipient_0);
    return [];
  }
  async _withdraw_unshielded_with_k256_0(context,
                                         partialProofData,
                                         color_0,
                                         amount_0,
                                         recipient_0,
                                         pk_0,
                                         use_counter_0,
                                         sig_0,
                                         envelope_0)
  {
    const challenge_0 = this._challenge_withdraw_unshielded_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                  partialProofData,
                                                                                                                                  [
                                                                                                                                   { dup: { n: 2 } },
                                                                                                                                   { idx: { cached: true,
                                                                                                                                            pushPath: false,
                                                                                                                                            path: [
                                                                                                                                                   { tag: 'value',
                                                                                                                                                     value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                   { popeq: { cached: true,
                                                                                                                                              result: undefined } }]).value),
                                                                        pk_0,
                                                                        color_0,
                                                                        amount_0,
                                                                        recipient_0,
                                                                        _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 0 } },
                                                                                                                                    { idx: { cached: false,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: false,
                                                                                                                                               result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    await this._do_withdraw_unshielded_0(context,
                                         partialProofData,
                                         color_0,
                                         amount_0,
                                         recipient_0);
    return [];
  }
  async _withdraw_unshielded_with_evm_0(context,
                                        partialProofData,
                                        color_0,
                                        amount_0,
                                        recipient_0,
                                        pk_0,
                                        use_counter_0,
                                        sig_0)
  {
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_withdraw_unshielded_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                 partialProofData,
                                                                                                                                 [
                                                                                                                                  { dup: { n: 2 } },
                                                                                                                                  { idx: { cached: true,
                                                                                                                                           pushPath: false,
                                                                                                                                           path: [
                                                                                                                                                  { tag: 'value',
                                                                                                                                                    value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                  { popeq: { cached: true,
                                                                                                                                             result: undefined } }]).value),
                                                                       address_0,
                                                                       color_0,
                                                                       amount_0,
                                                                       recipient_0,
                                                                       _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                  partialProofData,
                                                                                                                                  [
                                                                                                                                   { dup: { n: 0 } },
                                                                                                                                   { idx: { cached: false,
                                                                                                                                            pushPath: false,
                                                                                                                                            path: [
                                                                                                                                                   { tag: 'value',
                                                                                                                                                     value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                   { popeq: { cached: false,
                                                                                                                                              result: undefined } }]).value));
    const digest_0 = this._evm_digest_withdraw_unshielded_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 2 } },
                                                                                                                       { idx: { cached: true,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: true,
                                                                                                                                  result: undefined } }]).value).bytes,
                                                            _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 0 } },
                                                                                                                       { idx: { cached: false,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: false,
                                                                                                                                  result: undefined } }]).value),
                                                            address_0,
                                                            _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 0 } },
                                                                                                                        { idx: { cached: false,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: false,
                                                                                                                                   result: undefined } }]).value),
                                                            color_0,
                                                            amount_0,
                                                            recipient_0.bytes,
                                                            challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    await this._do_withdraw_unshielded_0(context,
                                         partialProofData,
                                         color_0,
                                         amount_0,
                                         recipient_0);
    return [];
  }
  async _deposit_shielded_0(context, partialProofData, coin_0, entry_0) {
    await this._receiveShielded_0(context, partialProofData, coin_0);
    const tmp_0 = _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                             partialProofData,
                                                                             [
                                                                              { dup: { n: 0 } },
                                                                              { idx: { cached: false,
                                                                                       pushPath: false,
                                                                                       path: [
                                                                                              { tag: 'value',
                                                                                                value: { value: _descriptor_3.toValue(3n),
                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                              { popeq: { cached: false,
                                                                                         result: undefined } }]).value);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(2n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_0),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_7.toValue(entry_0),
                                                                                              alignment: _descriptor_7.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 1818 char 18: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(3n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(3n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_1),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _append_inbox_with_jubjub_0(context,
                                    partialProofData,
                                    entry_0,
                                    pk_0,
                                    use_counter_0,
                                    sig_r_0,
                                    sig_s_0,
                                    grind_nonce_0)
  {
    const challenge_0 = this._challenge_append_inbox_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                             partialProofData,
                                                                                                                             [
                                                                                                                              { dup: { n: 2 } },
                                                                                                                              { idx: { cached: true,
                                                                                                                                       pushPath: false,
                                                                                                                                       path: [
                                                                                                                                              { tag: 'value',
                                                                                                                                                value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                              { popeq: { cached: true,
                                                                                                                                         result: undefined } }]).value),
                                                                   sig_r_0,
                                                                   pk_0,
                                                                   entry_0,
                                                                   _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                              partialProofData,
                                                                                                                              [
                                                                                                                               { dup: { n: 0 } },
                                                                                                                               { idx: { cached: false,
                                                                                                                                        pushPath: false,
                                                                                                                                        path: [
                                                                                                                                               { tag: 'value',
                                                                                                                                                 value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                                               { popeq: { cached: false,
                                                                                                                                          result: undefined } }]).value),
                                                                   grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    await this._do_append_inbox_0(context, partialProofData, entry_0);
    return [];
  }
  async _append_inbox_with_k256_0(context,
                                  partialProofData,
                                  entry_0,
                                  pk_0,
                                  use_counter_0,
                                  sig_0,
                                  envelope_0)
  {
    const challenge_0 = this._challenge_append_inbox_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                           partialProofData,
                                                                                                                           [
                                                                                                                            { dup: { n: 2 } },
                                                                                                                            { idx: { cached: true,
                                                                                                                                     pushPath: false,
                                                                                                                                     path: [
                                                                                                                                            { tag: 'value',
                                                                                                                                              value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                       alignment: _descriptor_3.alignment() } }] } },
                                                                                                                            { popeq: { cached: true,
                                                                                                                                       result: undefined } }]).value),
                                                                 pk_0,
                                                                 entry_0,
                                                                 _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                            partialProofData,
                                                                                                                            [
                                                                                                                             { dup: { n: 0 } },
                                                                                                                             { idx: { cached: false,
                                                                                                                                      pushPath: false,
                                                                                                                                      path: [
                                                                                                                                             { tag: 'value',
                                                                                                                                               value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                             { popeq: { cached: false,
                                                                                                                                        result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    await this._do_append_inbox_0(context, partialProofData, entry_0);
    return [];
  }
  async _append_inbox_with_evm_0(context,
                                 partialProofData,
                                 entry_0,
                                 pk_0,
                                 use_counter_0,
                                 sig_0)
  {
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_append_inbox_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                          partialProofData,
                                                                                                                          [
                                                                                                                           { dup: { n: 2 } },
                                                                                                                           { idx: { cached: true,
                                                                                                                                    pushPath: false,
                                                                                                                                    path: [
                                                                                                                                           { tag: 'value',
                                                                                                                                             value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                                                                           { popeq: { cached: true,
                                                                                                                                      result: undefined } }]).value),
                                                                address_0,
                                                                entry_0,
                                                                _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                           partialProofData,
                                                                                                                           [
                                                                                                                            { dup: { n: 0 } },
                                                                                                                            { idx: { cached: false,
                                                                                                                                     pushPath: false,
                                                                                                                                     path: [
                                                                                                                                            { tag: 'value',
                                                                                                                                              value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                       alignment: _descriptor_3.alignment() } }] } },
                                                                                                                            { popeq: { cached: false,
                                                                                                                                       result: undefined } }]).value));
    const digest_0 = this._evm_digest_append_inbox_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                               partialProofData,
                                                                                                               [
                                                                                                                { dup: { n: 2 } },
                                                                                                                { idx: { cached: true,
                                                                                                                         pushPath: false,
                                                                                                                         path: [
                                                                                                                                { tag: 'value',
                                                                                                                                  value: { value: _descriptor_3.toValue(0n),
                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                { popeq: { cached: true,
                                                                                                                           result: undefined } }]).value).bytes,
                                                     _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                               partialProofData,
                                                                                                               [
                                                                                                                { dup: { n: 0 } },
                                                                                                                { idx: { cached: false,
                                                                                                                         pushPath: false,
                                                                                                                         path: [
                                                                                                                                { tag: 'value',
                                                                                                                                  value: { value: _descriptor_3.toValue(12n),
                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                { popeq: { cached: false,
                                                                                                                           result: undefined } }]).value),
                                                     address_0,
                                                     _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                partialProofData,
                                                                                                                [
                                                                                                                 { dup: { n: 0 } },
                                                                                                                 { idx: { cached: false,
                                                                                                                          pushPath: false,
                                                                                                                          path: [
                                                                                                                                 { tag: 'value',
                                                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                 { popeq: { cached: false,
                                                                                                                            result: undefined } }]).value),
                                                     this._keccak256_4(entry_0),
                                                     challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    await this._do_append_inbox_0(context, partialProofData, entry_0);
    return [];
  }
  async _withdraw_shielded_with_jubjub_0(context,
                                         partialProofData,
                                         recipient_0,
                                         color_0,
                                         amount_0,
                                         pk_0,
                                         use_counter_0,
                                         sig_r_0,
                                         sig_s_0,
                                         grind_nonce_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const challenge_0 = this._challenge_withdraw_shielded_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                  partialProofData,
                                                                                                                                  [
                                                                                                                                   { dup: { n: 2 } },
                                                                                                                                   { idx: { cached: true,
                                                                                                                                            pushPath: false,
                                                                                                                                            path: [
                                                                                                                                                   { tag: 'value',
                                                                                                                                                     value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                   { popeq: { cached: true,
                                                                                                                                              result: undefined } }]).value),
                                                                        sig_r_0,
                                                                        pk_0,
                                                                        recipient_0,
                                                                        color_0,
                                                                        amount_0,
                                                                        coin_0,
                                                                        _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 0 } },
                                                                                                                                    { idx: { cached: false,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: false,
                                                                                                                                               result: undefined } }]).value),
                                                                        grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    return await this._do_withdraw_shielded_0(context,
                                              partialProofData,
                                              recipient_0,
                                              amount_0,
                                              coin_0);
  }
  async _withdraw_shielded_with_k256_0(context,
                                       partialProofData,
                                       recipient_0,
                                       color_0,
                                       amount_0,
                                       pk_0,
                                       use_counter_0,
                                       sig_0,
                                       envelope_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const challenge_0 = this._challenge_withdraw_shielded_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 2 } },
                                                                                                                                 { idx: { cached: true,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: true,
                                                                                                                                            result: undefined } }]).value),
                                                                      pk_0,
                                                                      recipient_0,
                                                                      color_0,
                                                                      amount_0,
                                                                      coin_0,
                                                                      _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                 partialProofData,
                                                                                                                                 [
                                                                                                                                  { dup: { n: 0 } },
                                                                                                                                  { idx: { cached: false,
                                                                                                                                           pushPath: false,
                                                                                                                                           path: [
                                                                                                                                                  { tag: 'value',
                                                                                                                                                    value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                  { popeq: { cached: false,
                                                                                                                                             result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    return await this._do_withdraw_shielded_0(context,
                                              partialProofData,
                                              recipient_0,
                                              amount_0,
                                              coin_0);
  }
  async _withdraw_shielded_with_evm_0(context,
                                      partialProofData,
                                      recipient_0,
                                      color_0,
                                      amount_0,
                                      pk_0,
                                      use_counter_0,
                                      sig_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_withdraw_shielded_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                               partialProofData,
                                                                                                                               [
                                                                                                                                { dup: { n: 2 } },
                                                                                                                                { idx: { cached: true,
                                                                                                                                         pushPath: false,
                                                                                                                                         path: [
                                                                                                                                                { tag: 'value',
                                                                                                                                                  value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                { popeq: { cached: true,
                                                                                                                                           result: undefined } }]).value),
                                                                     address_0,
                                                                     recipient_0,
                                                                     color_0,
                                                                     amount_0,
                                                                     coin_0,
                                                                     _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 0 } },
                                                                                                                                 { idx: { cached: false,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: false,
                                                                                                                                            result: undefined } }]).value));
    const digest_0 = this._evm_digest_withdraw_shielded_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                    partialProofData,
                                                                                                                    [
                                                                                                                     { dup: { n: 2 } },
                                                                                                                     { idx: { cached: true,
                                                                                                                              pushPath: false,
                                                                                                                              path: [
                                                                                                                                     { tag: 'value',
                                                                                                                                       value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                     { popeq: { cached: true,
                                                                                                                                result: undefined } }]).value).bytes,
                                                          _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                    partialProofData,
                                                                                                                    [
                                                                                                                     { dup: { n: 0 } },
                                                                                                                     { idx: { cached: false,
                                                                                                                              pushPath: false,
                                                                                                                              path: [
                                                                                                                                     { tag: 'value',
                                                                                                                                       value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                     { popeq: { cached: false,
                                                                                                                                result: undefined } }]).value),
                                                          address_0,
                                                          _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 0 } },
                                                                                                                      { idx: { cached: false,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: false,
                                                                                                                                 result: undefined } }]).value),
                                                          color_0,
                                                          amount_0,
                                                          recipient_0.bytes,
                                                          challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    return await this._do_withdraw_shielded_0(context,
                                              partialProofData,
                                              recipient_0,
                                              amount_0,
                                              coin_0);
  }
  async _withdraw_shielded_to_contract_with_jubjub_0(context,
                                                     partialProofData,
                                                     recipient_0,
                                                     color_0,
                                                     amount_0,
                                                     pk_0,
                                                     use_counter_0,
                                                     sig_r_0,
                                                     sig_s_0,
                                                     grind_nonce_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const challenge_0 = this._challenge_withdraw_shielded_to_contract_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                              partialProofData,
                                                                                                                                              [
                                                                                                                                               { dup: { n: 2 } },
                                                                                                                                               { idx: { cached: true,
                                                                                                                                                        pushPath: false,
                                                                                                                                                        path: [
                                                                                                                                                               { tag: 'value',
                                                                                                                                                                 value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                               { popeq: { cached: true,
                                                                                                                                                          result: undefined } }]).value),
                                                                                    sig_r_0,
                                                                                    pk_0,
                                                                                    recipient_0,
                                                                                    color_0,
                                                                                    amount_0,
                                                                                    coin_0,
                                                                                    _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                               partialProofData,
                                                                                                                                               [
                                                                                                                                                { dup: { n: 0 } },
                                                                                                                                                { idx: { cached: false,
                                                                                                                                                         pushPath: false,
                                                                                                                                                         path: [
                                                                                                                                                                { tag: 'value',
                                                                                                                                                                  value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                { popeq: { cached: false,
                                                                                                                                                           result: undefined } }]).value),
                                                                                    grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    return await this._do_withdraw_shielded_to_contract_0(context,
                                                          partialProofData,
                                                          recipient_0,
                                                          amount_0,
                                                          coin_0);
  }
  async _withdraw_shielded_to_contract_with_k256_0(context,
                                                   partialProofData,
                                                   recipient_0,
                                                   color_0,
                                                   amount_0,
                                                   pk_0,
                                                   use_counter_0,
                                                   sig_0,
                                                   envelope_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const challenge_0 = this._challenge_withdraw_shielded_to_contract_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                            partialProofData,
                                                                                                                                            [
                                                                                                                                             { dup: { n: 2 } },
                                                                                                                                             { idx: { cached: true,
                                                                                                                                                      pushPath: false,
                                                                                                                                                      path: [
                                                                                                                                                             { tag: 'value',
                                                                                                                                                               value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                             { popeq: { cached: true,
                                                                                                                                                        result: undefined } }]).value),
                                                                                  pk_0,
                                                                                  recipient_0,
                                                                                  color_0,
                                                                                  amount_0,
                                                                                  coin_0,
                                                                                  _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                             partialProofData,
                                                                                                                                             [
                                                                                                                                              { dup: { n: 0 } },
                                                                                                                                              { idx: { cached: false,
                                                                                                                                                       pushPath: false,
                                                                                                                                                       path: [
                                                                                                                                                              { tag: 'value',
                                                                                                                                                                value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                              { popeq: { cached: false,
                                                                                                                                                         result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    return await this._do_withdraw_shielded_to_contract_0(context,
                                                          partialProofData,
                                                          recipient_0,
                                                          amount_0,
                                                          coin_0);
  }
  async _withdraw_shielded_to_contract_with_evm_0(context,
                                                  partialProofData,
                                                  recipient_0,
                                                  color_0,
                                                  amount_0,
                                                  pk_0,
                                                  use_counter_0,
                                                  sig_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_withdraw_shielded_to_contract_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                           partialProofData,
                                                                                                                                           [
                                                                                                                                            { dup: { n: 2 } },
                                                                                                                                            { idx: { cached: true,
                                                                                                                                                     pushPath: false,
                                                                                                                                                     path: [
                                                                                                                                                            { tag: 'value',
                                                                                                                                                              value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                       alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                            { popeq: { cached: true,
                                                                                                                                                       result: undefined } }]).value),
                                                                                 address_0,
                                                                                 recipient_0,
                                                                                 color_0,
                                                                                 amount_0,
                                                                                 coin_0,
                                                                                 _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                            partialProofData,
                                                                                                                                            [
                                                                                                                                             { dup: { n: 0 } },
                                                                                                                                             { idx: { cached: false,
                                                                                                                                                      pushPath: false,
                                                                                                                                                      path: [
                                                                                                                                                             { tag: 'value',
                                                                                                                                                               value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                             { popeq: { cached: false,
                                                                                                                                                        result: undefined } }]).value));
    const digest_0 = this._evm_digest_withdraw_shielded_to_contract_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 2 } },
                                                                                                                                 { idx: { cached: true,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: true,
                                                                                                                                            result: undefined } }]).value).bytes,
                                                                      _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 0 } },
                                                                                                                                 { idx: { cached: false,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: false,
                                                                                                                                            result: undefined } }]).value),
                                                                      address_0,
                                                                      _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                 partialProofData,
                                                                                                                                 [
                                                                                                                                  { dup: { n: 0 } },
                                                                                                                                  { idx: { cached: false,
                                                                                                                                           pushPath: false,
                                                                                                                                           path: [
                                                                                                                                                  { tag: 'value',
                                                                                                                                                    value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                  { popeq: { cached: false,
                                                                                                                                             result: undefined } }]).value),
                                                                      color_0,
                                                                      amount_0,
                                                                      recipient_0.bytes,
                                                                      challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    return await this._do_withdraw_shielded_to_contract_0(context,
                                                          partialProofData,
                                                          recipient_0,
                                                          amount_0,
                                                          coin_0);
  }
  async _rotate_enc_key_with_jubjub_0(context,
                                      partialProofData,
                                      new_key_0,
                                      pk_0,
                                      use_counter_0,
                                      sig_r_0,
                                      sig_s_0,
                                      grind_nonce_0)
  {
    const challenge_0 = this._challenge_rotate_enc_key_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                               partialProofData,
                                                                                                                               [
                                                                                                                                { dup: { n: 2 } },
                                                                                                                                { idx: { cached: true,
                                                                                                                                         pushPath: false,
                                                                                                                                         path: [
                                                                                                                                                { tag: 'value',
                                                                                                                                                  value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                { popeq: { cached: true,
                                                                                                                                           result: undefined } }]).value),
                                                                     sig_r_0,
                                                                     pk_0,
                                                                     new_key_0,
                                                                     _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 0 } },
                                                                                                                                 { idx: { cached: false,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: false,
                                                                                                                                            result: undefined } }]).value),
                                                                     grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    await this._do_rotate_enc_key_0(context, partialProofData, new_key_0);
    return [];
  }
  async _rotate_enc_key_with_k256_0(context,
                                    partialProofData,
                                    new_key_0,
                                    pk_0,
                                    use_counter_0,
                                    sig_0,
                                    envelope_0)
  {
    const challenge_0 = this._challenge_rotate_enc_key_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                             partialProofData,
                                                                                                                             [
                                                                                                                              { dup: { n: 2 } },
                                                                                                                              { idx: { cached: true,
                                                                                                                                       pushPath: false,
                                                                                                                                       path: [
                                                                                                                                              { tag: 'value',
                                                                                                                                                value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                              { popeq: { cached: true,
                                                                                                                                         result: undefined } }]).value),
                                                                   pk_0,
                                                                   new_key_0,
                                                                   _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                              partialProofData,
                                                                                                                              [
                                                                                                                               { dup: { n: 0 } },
                                                                                                                               { idx: { cached: false,
                                                                                                                                        pushPath: false,
                                                                                                                                        path: [
                                                                                                                                               { tag: 'value',
                                                                                                                                                 value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                                               { popeq: { cached: false,
                                                                                                                                          result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    await this._do_rotate_enc_key_0(context, partialProofData, new_key_0);
    return [];
  }
  async _rotate_enc_key_with_evm_0(context,
                                   partialProofData,
                                   new_key_0,
                                   pk_0,
                                   use_counter_0,
                                   sig_0)
  {
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_rotate_enc_key_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                            partialProofData,
                                                                                                                            [
                                                                                                                             { dup: { n: 2 } },
                                                                                                                             { idx: { cached: true,
                                                                                                                                      pushPath: false,
                                                                                                                                      path: [
                                                                                                                                             { tag: 'value',
                                                                                                                                               value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                             { popeq: { cached: true,
                                                                                                                                        result: undefined } }]).value),
                                                                  address_0,
                                                                  new_key_0,
                                                                  _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                             partialProofData,
                                                                                                                             [
                                                                                                                              { dup: { n: 0 } },
                                                                                                                              { idx: { cached: false,
                                                                                                                                       pushPath: false,
                                                                                                                                       path: [
                                                                                                                                              { tag: 'value',
                                                                                                                                                value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                              { popeq: { cached: false,
                                                                                                                                         result: undefined } }]).value));
    const digest_0 = this._evm_digest_rotate_enc_key_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                 partialProofData,
                                                                                                                 [
                                                                                                                  { dup: { n: 2 } },
                                                                                                                  { idx: { cached: true,
                                                                                                                           pushPath: false,
                                                                                                                           path: [
                                                                                                                                  { tag: 'value',
                                                                                                                                    value: { value: _descriptor_3.toValue(0n),
                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                  { popeq: { cached: true,
                                                                                                                             result: undefined } }]).value).bytes,
                                                       _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                 partialProofData,
                                                                                                                 [
                                                                                                                  { dup: { n: 0 } },
                                                                                                                  { idx: { cached: false,
                                                                                                                           pushPath: false,
                                                                                                                           path: [
                                                                                                                                  { tag: 'value',
                                                                                                                                    value: { value: _descriptor_3.toValue(12n),
                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                  { popeq: { cached: false,
                                                                                                                             result: undefined } }]).value),
                                                       address_0,
                                                       _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                  partialProofData,
                                                                                                                  [
                                                                                                                   { dup: { n: 0 } },
                                                                                                                   { idx: { cached: false,
                                                                                                                            pushPath: false,
                                                                                                                            path: [
                                                                                                                                   { tag: 'value',
                                                                                                                                     value: { value: _descriptor_3.toValue(9n),
                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                   { popeq: { cached: false,
                                                                                                                              result: undefined } }]).value),
                                                       new_key_0,
                                                       challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    await this._do_rotate_enc_key_0(context, partialProofData, new_key_0);
    return [];
  }
  async _add_device_with_jubjub_0(context,
                                  partialProofData,
                                  new_entry_0,
                                  pk_0,
                                  use_counter_0,
                                  sig_r_0,
                                  sig_s_0,
                                  grind_nonce_0)
  {
    const challenge_0 = this._challenge_add_device_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                           partialProofData,
                                                                                                                           [
                                                                                                                            { dup: { n: 2 } },
                                                                                                                            { idx: { cached: true,
                                                                                                                                     pushPath: false,
                                                                                                                                     path: [
                                                                                                                                            { tag: 'value',
                                                                                                                                              value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                       alignment: _descriptor_3.alignment() } }] } },
                                                                                                                            { popeq: { cached: true,
                                                                                                                                       result: undefined } }]).value),
                                                                 sig_r_0,
                                                                 pk_0,
                                                                 new_entry_0,
                                                                 _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                            partialProofData,
                                                                                                                            [
                                                                                                                             { dup: { n: 0 } },
                                                                                                                             { idx: { cached: false,
                                                                                                                                      pushPath: false,
                                                                                                                                      path: [
                                                                                                                                             { tag: 'value',
                                                                                                                                               value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                             { popeq: { cached: false,
                                                                                                                                        result: undefined } }]).value),
                                                                 grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    await this._do_add_device_0(context, partialProofData, new_entry_0);
    return [];
  }
  async _add_device_with_k256_0(context,
                                partialProofData,
                                new_entry_0,
                                pk_0,
                                use_counter_0,
                                sig_0,
                                envelope_0)
  {
    const challenge_0 = this._challenge_add_device_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                         partialProofData,
                                                                                                                         [
                                                                                                                          { dup: { n: 2 } },
                                                                                                                          { idx: { cached: true,
                                                                                                                                   pushPath: false,
                                                                                                                                   path: [
                                                                                                                                          { tag: 'value',
                                                                                                                                            value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                                                                          { popeq: { cached: true,
                                                                                                                                     result: undefined } }]).value),
                                                               pk_0,
                                                               new_entry_0,
                                                               _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                          partialProofData,
                                                                                                                          [
                                                                                                                           { dup: { n: 0 } },
                                                                                                                           { idx: { cached: false,
                                                                                                                                    pushPath: false,
                                                                                                                                    path: [
                                                                                                                                           { tag: 'value',
                                                                                                                                             value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                                                                           { popeq: { cached: false,
                                                                                                                                      result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    await this._do_add_device_0(context, partialProofData, new_entry_0);
    return [];
  }
  async _add_device_with_evm_0(context,
                               partialProofData,
                               new_entry_0,
                               pk_0,
                               use_counter_0,
                               sig_0)
  {
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_add_device_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 2 } },
                                                                                                                         { idx: { cached: true,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: true,
                                                                                                                                    result: undefined } }]).value),
                                                              address_0,
                                                              new_entry_0,
                                                              _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                         partialProofData,
                                                                                                                         [
                                                                                                                          { dup: { n: 0 } },
                                                                                                                          { idx: { cached: false,
                                                                                                                                   pushPath: false,
                                                                                                                                   path: [
                                                                                                                                          { tag: 'value',
                                                                                                                                            value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                                                                          { popeq: { cached: false,
                                                                                                                                     result: undefined } }]).value));
    const digest_0 = this._evm_digest_add_device_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                             partialProofData,
                                                                                                             [
                                                                                                              { dup: { n: 2 } },
                                                                                                              { idx: { cached: true,
                                                                                                                       pushPath: false,
                                                                                                                       path: [
                                                                                                                              { tag: 'value',
                                                                                                                                value: { value: _descriptor_3.toValue(0n),
                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                              { popeq: { cached: true,
                                                                                                                         result: undefined } }]).value).bytes,
                                                   _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                             partialProofData,
                                                                                                             [
                                                                                                              { dup: { n: 0 } },
                                                                                                              { idx: { cached: false,
                                                                                                                       pushPath: false,
                                                                                                                       path: [
                                                                                                                              { tag: 'value',
                                                                                                                                value: { value: _descriptor_3.toValue(12n),
                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                              { popeq: { cached: false,
                                                                                                                         result: undefined } }]).value),
                                                   address_0,
                                                   _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                              partialProofData,
                                                                                                              [
                                                                                                               { dup: { n: 0 } },
                                                                                                               { idx: { cached: false,
                                                                                                                        pushPath: false,
                                                                                                                        path: [
                                                                                                                               { tag: 'value',
                                                                                                                                 value: { value: _descriptor_3.toValue(9n),
                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                               { popeq: { cached: false,
                                                                                                                          result: undefined } }]).value),
                                                   new_entry_0,
                                                   challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    await this._do_add_device_0(context, partialProofData, new_entry_0);
    return [];
  }
  async _remove_device_with_jubjub_0(context,
                                     partialProofData,
                                     entry_0,
                                     pk_0,
                                     use_counter_0,
                                     sig_r_0,
                                     sig_s_0,
                                     grind_nonce_0)
  {
    const challenge_0 = this._challenge_remove_device_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                              partialProofData,
                                                                                                                              [
                                                                                                                               { dup: { n: 2 } },
                                                                                                                               { idx: { cached: true,
                                                                                                                                        pushPath: false,
                                                                                                                                        path: [
                                                                                                                                               { tag: 'value',
                                                                                                                                                 value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                                               { popeq: { cached: true,
                                                                                                                                          result: undefined } }]).value),
                                                                    sig_r_0,
                                                                    pk_0,
                                                                    entry_0,
                                                                    _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                               partialProofData,
                                                                                                                               [
                                                                                                                                { dup: { n: 0 } },
                                                                                                                                { idx: { cached: false,
                                                                                                                                         pushPath: false,
                                                                                                                                         path: [
                                                                                                                                                { tag: 'value',
                                                                                                                                                  value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                { popeq: { cached: false,
                                                                                                                                           result: undefined } }]).value),
                                                                    grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    await this._do_remove_device_0(context,
                                   partialProofData,
                                   entry_0,
                                   this._derive_device_entry_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                     partialProofData,
                                                                                                                                     [
                                                                                                                                      { dup: { n: 2 } },
                                                                                                                                      { idx: { cached: true,
                                                                                                                                               pushPath: false,
                                                                                                                                               path: [
                                                                                                                                                      { tag: 'value',
                                                                                                                                                        value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                      { popeq: { cached: true,
                                                                                                                                                 result: undefined } }]).value),
                                                                           pk_0,
                                                                           _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                      partialProofData,
                                                                                                                                      [
                                                                                                                                       { dup: { n: 0 } },
                                                                                                                                       { idx: { cached: false,
                                                                                                                                                pushPath: false,
                                                                                                                                                path: [
                                                                                                                                                       { tag: 'value',
                                                                                                                                                         value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                       { popeq: { cached: false,
                                                                                                                                                  result: undefined } }]).value),
                                                                           ((t1) => {
                                                                             if (t1 > 18446744073709551615n) {
                                                                               throw new __compactRuntime.CompactError('account.compact line 2196 char 39: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                                             }
                                                                             return t1;
                                                                           })(use_counter_0
                                                                              +
                                                                              1n)));
    return [];
  }
  async _remove_device_with_k256_0(context,
                                   partialProofData,
                                   entry_0,
                                   pk_0,
                                   use_counter_0,
                                   sig_0,
                                   envelope_0)
  {
    const challenge_0 = this._challenge_remove_device_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                            partialProofData,
                                                                                                                            [
                                                                                                                             { dup: { n: 2 } },
                                                                                                                             { idx: { cached: true,
                                                                                                                                      pushPath: false,
                                                                                                                                      path: [
                                                                                                                                             { tag: 'value',
                                                                                                                                               value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                             { popeq: { cached: true,
                                                                                                                                        result: undefined } }]).value),
                                                                  pk_0,
                                                                  entry_0,
                                                                  _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                             partialProofData,
                                                                                                                             [
                                                                                                                              { dup: { n: 0 } },
                                                                                                                              { idx: { cached: false,
                                                                                                                                       pushPath: false,
                                                                                                                                       path: [
                                                                                                                                              { tag: 'value',
                                                                                                                                                value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                         alignment: _descriptor_3.alignment() } }] } },
                                                                                                                              { popeq: { cached: false,
                                                                                                                                         result: undefined } }]).value));
    await this._require_authorised_with_k256_0(context,
                                               partialProofData,
                                               pk_0,
                                               use_counter_0,
                                               sig_0,
                                               challenge_0,
                                               envelope_0);
    await this._do_remove_device_0(context,
                                   partialProofData,
                                   entry_0,
                                   this._derive_device_entry_with_k256_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 2 } },
                                                                                                                                    { idx: { cached: true,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: true,
                                                                                                                                               result: undefined } }]).value),
                                                                         pk_0,
                                                                         envelope_0,
                                                                         _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                    partialProofData,
                                                                                                                                    [
                                                                                                                                     { dup: { n: 0 } },
                                                                                                                                     { idx: { cached: false,
                                                                                                                                              pushPath: false,
                                                                                                                                              path: [
                                                                                                                                                     { tag: 'value',
                                                                                                                                                       value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                     { popeq: { cached: false,
                                                                                                                                                result: undefined } }]).value),
                                                                         ((t1) => {
                                                                           if (t1 > 18446744073709551615n) {
                                                                             throw new __compactRuntime.CompactError('account.compact line 2214 char 6: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                                           }
                                                                           return t1;
                                                                         })(use_counter_0
                                                                            +
                                                                            1n)));
    return [];
  }
  async _remove_device_with_evm_0(context,
                                  partialProofData,
                                  entry_0,
                                  pk_0,
                                  use_counter_0,
                                  sig_0)
  {
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_remove_device_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                           partialProofData,
                                                                                                                           [
                                                                                                                            { dup: { n: 2 } },
                                                                                                                            { idx: { cached: true,
                                                                                                                                     pushPath: false,
                                                                                                                                     path: [
                                                                                                                                            { tag: 'value',
                                                                                                                                              value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                       alignment: _descriptor_3.alignment() } }] } },
                                                                                                                            { popeq: { cached: true,
                                                                                                                                       result: undefined } }]).value),
                                                                 address_0,
                                                                 entry_0,
                                                                 _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                            partialProofData,
                                                                                                                            [
                                                                                                                             { dup: { n: 0 } },
                                                                                                                             { idx: { cached: false,
                                                                                                                                      pushPath: false,
                                                                                                                                      path: [
                                                                                                                                             { tag: 'value',
                                                                                                                                               value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                        alignment: _descriptor_3.alignment() } }] } },
                                                                                                                             { popeq: { cached: false,
                                                                                                                                        result: undefined } }]).value));
    const digest_0 = this._evm_digest_remove_device_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                partialProofData,
                                                                                                                [
                                                                                                                 { dup: { n: 2 } },
                                                                                                                 { idx: { cached: true,
                                                                                                                          pushPath: false,
                                                                                                                          path: [
                                                                                                                                 { tag: 'value',
                                                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                 { popeq: { cached: true,
                                                                                                                            result: undefined } }]).value).bytes,
                                                      _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                partialProofData,
                                                                                                                [
                                                                                                                 { dup: { n: 0 } },
                                                                                                                 { idx: { cached: false,
                                                                                                                          pushPath: false,
                                                                                                                          path: [
                                                                                                                                 { tag: 'value',
                                                                                                                                   value: { value: _descriptor_3.toValue(12n),
                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                 { popeq: { cached: false,
                                                                                                                            result: undefined } }]).value),
                                                      address_0,
                                                      _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                 partialProofData,
                                                                                                                 [
                                                                                                                  { dup: { n: 0 } },
                                                                                                                  { idx: { cached: false,
                                                                                                                           pushPath: false,
                                                                                                                           path: [
                                                                                                                                  { tag: 'value',
                                                                                                                                    value: { value: _descriptor_3.toValue(9n),
                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                  { popeq: { cached: false,
                                                                                                                             result: undefined } }]).value),
                                                      entry_0,
                                                      challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    await this._do_remove_device_0(context,
                                   partialProofData,
                                   entry_0,
                                   this._derive_device_entry_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                  partialProofData,
                                                                                                                                  [
                                                                                                                                   { dup: { n: 2 } },
                                                                                                                                   { idx: { cached: true,
                                                                                                                                            pushPath: false,
                                                                                                                                            path: [
                                                                                                                                                   { tag: 'value',
                                                                                                                                                     value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                   { popeq: { cached: true,
                                                                                                                                              result: undefined } }]).value),
                                                                        address_0,
                                                                        _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 0 } },
                                                                                                                                    { idx: { cached: false,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: false,
                                                                                                                                               result: undefined } }]).value),
                                                                        ((t1) => {
                                                                          if (t1 > 18446744073709551615n) {
                                                                            throw new __compactRuntime.CompactError('account.compact line 2235 char 6: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                                          }
                                                                          return t1;
                                                                        })(use_counter_0
                                                                           +
                                                                           1n)));
    return [];
  }
  async _open_swap_shielded_with_jubjub_0(context,
                                          partialProofData,
                                          give_color_0,
                                          give_amount_0,
                                          recipient_kind_0,
                                          recipient_0,
                                          want_0,
                                          want_entry_0,
                                          change_entry_0,
                                          valid_until_0,
                                          pk_0,
                                          use_counter_0,
                                          sig_r_0,
                                          sig_s_0,
                                          grind_nonce_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, give_color_0);
    this._assert_open_swap_terms_0(give_color_0,
                                   give_amount_0,
                                   recipient_kind_0,
                                   recipient_0,
                                   want_0,
                                   coin_0.color,
                                   coin_0.value);
    await this._assert_offer_live_0(context, partialProofData, valid_until_0);
    const challenge_0 = this._challenge_open_swap_shielded_with_jubjub_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 2 } },
                                                                                                                                    { idx: { cached: true,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: true,
                                                                                                                                               result: undefined } }]).value),
                                                                         sig_r_0,
                                                                         pk_0,
                                                                         give_color_0,
                                                                         give_amount_0,
                                                                         recipient_kind_0,
                                                                         recipient_0,
                                                                         want_0,
                                                                         want_entry_0,
                                                                         change_entry_0,
                                                                         valid_until_0,
                                                                         coin_0,
                                                                         _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                    partialProofData,
                                                                                                                                    [
                                                                                                                                     { dup: { n: 0 } },
                                                                                                                                     { idx: { cached: false,
                                                                                                                                              pushPath: false,
                                                                                                                                              path: [
                                                                                                                                                     { tag: 'value',
                                                                                                                                                       value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                     { popeq: { cached: false,
                                                                                                                                                result: undefined } }]).value),
                                                                         grind_nonce_0);
    await this._require_authorised_with_jubjub_0(context,
                                                 partialProofData,
                                                 pk_0,
                                                 use_counter_0,
                                                 sig_r_0,
                                                 sig_s_0,
                                                 challenge_0);
    return await this._do_open_swap_0(context,
                                      partialProofData,
                                      coin_0,
                                      give_amount_0,
                                      recipient_kind_0,
                                      recipient_0,
                                      want_0,
                                      want_entry_0,
                                      change_entry_0);
  }
  async _open_swap_shielded_with_evm_0(context,
                                       partialProofData,
                                       give_color_0,
                                       give_amount_0,
                                       recipient_kind_0,
                                       recipient_0,
                                       want_0,
                                       want_entry_0,
                                       change_entry_0,
                                       valid_until_0,
                                       pk_0,
                                       use_counter_0,
                                       sig_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, give_color_0);
    this._assert_open_swap_terms_0(give_color_0,
                                   give_amount_0,
                                   recipient_kind_0,
                                   recipient_0,
                                   want_0,
                                   coin_0.color,
                                   coin_0.value);
    await this._assert_offer_live_0(context, partialProofData, valid_until_0);
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_open_swap_shielded_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 2 } },
                                                                                                                                 { idx: { cached: true,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: true,
                                                                                                                                            result: undefined } }]).value),
                                                                      address_0,
                                                                      give_color_0,
                                                                      give_amount_0,
                                                                      recipient_kind_0,
                                                                      recipient_0,
                                                                      want_0,
                                                                      want_entry_0,
                                                                      change_entry_0,
                                                                      valid_until_0,
                                                                      coin_0,
                                                                      _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                 partialProofData,
                                                                                                                                 [
                                                                                                                                  { dup: { n: 0 } },
                                                                                                                                  { idx: { cached: false,
                                                                                                                                           pushPath: false,
                                                                                                                                           path: [
                                                                                                                                                  { tag: 'value',
                                                                                                                                                    value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                  { popeq: { cached: false,
                                                                                                                                             result: undefined } }]).value));
    const digest_0 = this._evm_digest_open_swap_shielded_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 2 } },
                                                                                                                      { idx: { cached: true,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: true,
                                                                                                                                 result: undefined } }]).value).bytes,
                                                           _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 0 } },
                                                                                                                      { idx: { cached: false,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: false,
                                                                                                                                 result: undefined } }]).value),
                                                           address_0,
                                                           _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 0 } },
                                                                                                                       { idx: { cached: false,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: false,
                                                                                                                                  result: undefined } }]).value),
                                                           give_color_0,
                                                           give_amount_0,
                                                           recipient_kind_0,
                                                           recipient_0,
                                                           want_0.nonce,
                                                           want_0.color,
                                                           want_0.value,
                                                           valid_until_0,
                                                           challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    return await this._do_open_swap_0(context,
                                      partialProofData,
                                      coin_0,
                                      give_amount_0,
                                      recipient_kind_0,
                                      recipient_0,
                                      want_0,
                                      want_entry_0,
                                      change_entry_0);
  }
  _derive_boot_commitment_with_ed25519_0(salt_0, pk_0) {
    return this._persistentHash_27([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 98, 111, 111, 116, 58, 101, 100, 58, 118, 49, 0, 0, 0, 0, 0]),
                                    salt_0,
                                    pk_0]);
  }
  _derive_device_entry_with_ed25519_0(self_addr_0, pk_0, epoch_0, counter_0) {
    return this._persistentHash_28([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 100, 101, 118, 105, 99, 101, 58, 101, 100, 58, 118, 49, 0, 0, 0]),
                                    self_addr_0,
                                    pk_0,
                                    epoch_0,
                                    counter_0]);
  }
  _require_live_ed25519_key_0(pk_0) {
    __compactRuntime.assert(!this._equal_29(__compactRuntime.convertBigintToBytes(32,
                                                                                  this._curve25519PointX_0(pk_0),
                                                                                  'account.compact line 2456 char 11'),
                                            new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                            'device key is the identity');
    return [];
  }
  async _activate_initial_device_with_ed25519_0(context,
                                                partialProofData,
                                                pk_0,
                                                salt_0)
  {
    __compactRuntime.assert(!_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                        partialProofData,
                                                                                        [
                                                                                         { dup: { n: 0 } },
                                                                                         { idx: { cached: false,
                                                                                                  pushPath: false,
                                                                                                  path: [
                                                                                                         { tag: 'value',
                                                                                                           value: { value: _descriptor_3.toValue(11n),
                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                         { popeq: { cached: false,
                                                                                                    result: undefined } }]).value),
                            'already activated');
    this._require_live_ed25519_key_0(pk_0);
    __compactRuntime.assert(this._equal_30(this._derive_boot_commitment_with_ed25519_0(salt_0,
                                                                                       pk_0),
                                           _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                     partialProofData,
                                                                                                     [
                                                                                                      { dup: { n: 0 } },
                                                                                                      { idx: { cached: false,
                                                                                                               pushPath: false,
                                                                                                               path: [
                                                                                                                      { tag: 'value',
                                                                                                                        value: { value: _descriptor_3.toValue(10n),
                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                      { popeq: { cached: false,
                                                                                                                 result: undefined } }]).value)),
                            'boot commitment mismatch');
    await this._do_activate_initial_device_0(context,
                                             partialProofData,
                                             this._derive_device_entry_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                                partialProofData,
                                                                                                                                                [
                                                                                                                                                 { dup: { n: 2 } },
                                                                                                                                                 { idx: { cached: true,
                                                                                                                                                          pushPath: false,
                                                                                                                                                          path: [
                                                                                                                                                                 { tag: 'value',
                                                                                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                 { popeq: { cached: true,
                                                                                                                                                            result: undefined } }]).value),
                                                                                      pk_0,
                                                                                      _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                                 partialProofData,
                                                                                                                                                 [
                                                                                                                                                  { dup: { n: 0 } },
                                                                                                                                                  { idx: { cached: false,
                                                                                                                                                           pushPath: false,
                                                                                                                                                           path: [
                                                                                                                                                                  { tag: 'value',
                                                                                                                                                                    value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                  { popeq: { cached: false,
                                                                                                                                                             result: undefined } }]).value),
                                                                                      0n));
    return [];
  }
  _challenge_withdraw_unshielded_with_ed25519_0(self_addr_0,
                                                pk_0,
                                                network_0,
                                                color_0,
                                                amount_0,
                                                recipient_0,
                                                nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 100, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 117, 110, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_29([dst_0,
                                    self_addr_0,
                                    pk_0,
                                    network_0,
                                    color_0,
                                    amount_0,
                                    recipient_0,
                                    nonce_value_0]);
  }
  _challenge_withdraw_shielded_with_ed25519_0(self_addr_0,
                                              pk_0,
                                              network_0,
                                              recipient_0,
                                              color_0,
                                              amount_0,
                                              coin_0,
                                              nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 100, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_30([dst_0,
                                    self_addr_0,
                                    pk_0,
                                    network_0,
                                    recipient_0,
                                    color_0,
                                    amount_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  _challenge_withdraw_shielded_to_contract_with_ed25519_0(self_addr_0,
                                                          pk_0,
                                                          network_0,
                                                          recipient_0,
                                                          color_0,
                                                          amount_0,
                                                          coin_0,
                                                          nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 100, 58, 118, 49, 58, 119, 105, 116, 104, 100, 114, 97, 119, 95, 115, 104, 105, 101, 108, 100, 101, 100, 95, 116, 111, 95, 99, 111, 110, 116, 114, 97, 99, 116, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_31([dst_0,
                                    self_addr_0,
                                    pk_0,
                                    network_0,
                                    recipient_0,
                                    color_0,
                                    amount_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  _challenge_append_inbox_with_ed25519_0(self_addr_0,
                                         pk_0,
                                         network_0,
                                         entry_0,
                                         nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 100, 58, 118, 49, 58, 97, 112, 112, 101, 110, 100, 95, 105, 110, 98, 111, 120, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_32([dst_0,
                                    self_addr_0,
                                    pk_0,
                                    network_0,
                                    entry_0,
                                    nonce_value_0]);
  }
  _challenge_rotate_enc_key_with_ed25519_0(self_addr_0,
                                           pk_0,
                                           network_0,
                                           new_key_0,
                                           nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 100, 58, 118, 49, 58, 114, 111, 116, 97, 116, 101, 95, 101, 110, 99, 95, 107, 101, 121, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_33([dst_0,
                                    self_addr_0,
                                    pk_0,
                                    network_0,
                                    new_key_0,
                                    nonce_value_0]);
  }
  _challenge_open_swap_shielded_with_ed25519_0(self_addr_0,
                                               pk_0,
                                               network_0,
                                               give_color_0,
                                               give_amount_0,
                                               recipient_kind_0,
                                               recipient_0,
                                               want_0,
                                               want_entry_0,
                                               change_entry_0,
                                               valid_until_0,
                                               coin_0,
                                               nonce_value_0)
  {
    const dst_0 = this._persistentHash_34([new Uint8Array([109, 105, 100, 110, 105, 103, 104, 116, 58, 97, 99, 99, 111, 117, 110, 116, 58, 97, 117, 116, 104, 58, 101, 100, 58, 118, 49, 58, 111, 112, 101, 110, 95, 115, 119, 97, 112, 95, 115, 104, 105, 101, 108, 100, 101, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])]);
    return this._persistentHash_35([dst_0,
                                    self_addr_0,
                                    pk_0,
                                    network_0,
                                    give_color_0,
                                    give_amount_0,
                                    recipient_kind_0,
                                    recipient_0,
                                    want_0,
                                    want_entry_0,
                                    change_entry_0,
                                    valid_until_0,
                                    coin_0,
                                    nonce_value_0]);
  }
  _ed_uint_text_0(value_0, t_0) {
    const r_0 = this._folder_0(((a_0, c_0) =>
                                {
                                  const space_0 = c_0 === 32n;
                                  const digit_0 = c_0 >= 48n && c_0 <= 57n;
                                  const ended_0 = a_0[1] || space_0;
                                  return [ended_0 ?
                                          a_0[0] :
                                          __compactRuntime.addField(__compactRuntime.mulField(a_0[0],
                                                                                              10n),
                                                                    __compactRuntime.subField(c_0,
                                                                                              48n)),
                                          ended_0,
                                          a_0[2]
                                          &&
                                          (space_0 || digit_0 && !a_0[1])];
                                }),
                               [0n, false, true],
                               t_0);
    __compactRuntime.assert(r_0[2] && t_0[0] !== 32n,
                            'display: not a left-aligned decimal');
    __compactRuntime.assert(t_0[0] !== 48n || t_0[1] === 32n,
                            'display: leading zero');
    __compactRuntime.assert(r_0[0] === value_0,
                            'display: digits do not match the value');
    return t_0;
  }
  _ed_uint_text_1(value_0, t_0) {
    const r_0 = this._folder_1(((a_0, c_0) =>
                                {
                                  const space_0 = c_0 === 32n;
                                  const digit_0 = c_0 >= 48n && c_0 <= 57n;
                                  const ended_0 = a_0[1] || space_0;
                                  return [ended_0 ?
                                          a_0[0] :
                                          __compactRuntime.addField(__compactRuntime.mulField(a_0[0],
                                                                                              10n),
                                                                    __compactRuntime.subField(c_0,
                                                                                              48n)),
                                          ended_0,
                                          a_0[2]
                                          &&
                                          (space_0 || digit_0 && !a_0[1])];
                                }),
                               [0n, false, true],
                               t_0);
    __compactRuntime.assert(r_0[2] && t_0[0] !== 32n,
                            'display: not a left-aligned decimal');
    __compactRuntime.assert(t_0[0] !== 48n || t_0[1] === 32n,
                            'display: leading zero');
    __compactRuntime.assert(r_0[0] === value_0,
                            'display: digits do not match the value');
    return t_0;
  }
  _ed_site_text_0(value_0, t_0) {
    const r_0 = this._folder_2(((a_0, c_0) =>
                                {
                                  const space_0 = c_0 === 32n;
                                  const dot_0 = c_0 === 46n;
                                  const digit_0 = c_0 >= 48n && c_0 <= 57n;
                                  const shown_0 = c_0 >= 33n && c_0 <= 126n;
                                  const p_0 = a_0[1];
                                  const whole_0 = p_0 === 0n;
                                  const frac_0 = p_0 === 1n;
                                  const sym_0 = p_0 === 2n;
                                  const ok_0 = whole_0 ?
                                               digit_0
                                               ||
                                               (dot_0 || space_0)
                                               &&
                                               a_0[2] !== 0n
                                               :
                                               frac_0 ?
                                               digit_0
                                               ||
                                               space_0 && a_0[3] !== 0n
                                               :
                                               sym_0 ?
                                               shown_0
                                               ||
                                               space_0 && a_0[4] !== 0n
                                               :
                                               space_0;
                                  const next_0 = whole_0 ?
                                                 dot_0 ? 1n : space_0 ? 2n : 0n
                                                 :
                                                 frac_0 ?
                                                 space_0 ? 2n : 1n :
                                                 sym_0 ? space_0 ? 3n : 2n : 3n;
                                  const number_0 = (whole_0 || frac_0)
                                                   &&
                                                   digit_0;
                                  return [number_0 ?
                                          __compactRuntime.addField(__compactRuntime.mulField(a_0[0],
                                                                                              10n),
                                                                    __compactRuntime.subField(c_0,
                                                                                              48n))
                                          :
                                          a_0[0],
                                          next_0,
                                          ((t1) => {
                                            if (t1 > 255n) {
                                              throw new __compactRuntime.CompactError('account.compact line 2593 char 13: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 255');
                                            }
                                            return t1;
                                          })(whole_0 && digit_0 ?
                                             a_0[2] + 1n :
                                             a_0[2]),
                                          ((t1) => {
                                            if (t1 > 255n) {
                                              throw new __compactRuntime.CompactError('account.compact line 2594 char 13: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 255');
                                            }
                                            return t1;
                                          })(frac_0 && digit_0 ?
                                             a_0[3] + 1n :
                                             a_0[3]),
                                          ((t1) => {
                                            if (t1 > 255n) {
                                              throw new __compactRuntime.CompactError('account.compact line 2595 char 13: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 255');
                                            }
                                            return t1;
                                          })(sym_0 && shown_0 ?
                                             a_0[4] + 1n :
                                             a_0[4]),
                                          a_0[5] && ok_0];
                                }),
                               [0n, 0n, 0n, 0n, 0n, true],
                               t_0);
    __compactRuntime.assert(r_0[5]
                            &&
                            (r_0[1] === 3n || r_0[1] === 2n && r_0[4] !== 0n),
                            'display: not a site label');
    let t_1;
    __compactRuntime.assert((t_1 = r_0[3], t_1 <= 18n),
                            'display: more than 18 decimals');
    let t_2;
    __compactRuntime.assert((t_2 = r_0[4], t_2 <= 8n),
                            'display: symbol longer than 8');
    __compactRuntime.assert(t_0[0] !== 48n || t_0[1] === 46n || t_0[1] === 32n,
                            'display: leading zero');
    __compactRuntime.assert(r_0[0] === value_0,
                            'display: digits do not match the value');
    return t_0;
  }
  _ed_hexdigit_0(n_0) {
    return ((t1) => {
             if (t1 > 255n) {
               throw new __compactRuntime.CompactError('account.compact line 2607 char 10: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 255');
             }
             return t1;
           })(n_0 < 10n ? n_0 + 48n : n_0 + 87n);
  }
  _ed_hexpair_0(b_0) {
    const h8_0 = b_0 >= 128n;
    const b1_0 = h8_0 ?
                 (__compactRuntime.assert(b_0 >= 128n,
                                          'result of subtraction would be negative'),
                  b_0 - 128n)
                 :
                 b_0;
    const h4_0 = b1_0 >= 64n;
    const b2_0 = h4_0 ?
                 (__compactRuntime.assert(b1_0 >= 64n,
                                          'result of subtraction would be negative'),
                  b1_0 - 64n)
                 :
                 b1_0;
    const h2_0 = b2_0 >= 32n;
    const b3_0 = h2_0 ?
                 (__compactRuntime.assert(b2_0 >= 32n,
                                          'result of subtraction would be negative'),
                  b2_0 - 32n)
                 :
                 b2_0;
    const h1_0 = b3_0 >= 16n;
    const lo_0 = h1_0 ?
                 (__compactRuntime.assert(b3_0 >= 16n,
                                          'result of subtraction would be negative'),
                  b3_0 - 16n)
                 :
                 b3_0;
    const hi_0 = (h8_0 ? 8n : 0n) + (h4_0 ? 4n : 0n) + (h2_0 ? 2n : 0n)
                 +
                 (h1_0 ? 1n : 0n);
    return [this._ed_hexdigit_0(hi_0), this._ed_hexdigit_0(lo_0)];
  }
  _ed_hex8_0(b_0) {
    const p_0 = this._mapper_0((...args_0) => this._ed_hexpair_0(...args_0),
                               Array.from(((e, i) => e.slice(i, i+8))(b_0,
                                                                      Number(0n)),
                                          BigInt));
    return [...p_0[0],
            ...p_0[1],
            ...p_0[2],
            ...p_0[3],
            ...p_0[4],
            ...p_0[5],
            ...p_0[6],
            ...p_0[7]];
  }
  _ed_hex8_1(b_0) {
    const p_0 = this._mapper_1((...args_0) => this._ed_hexpair_0(...args_0),
                               Array.from(((e, i) => e.slice(i, i+8))(b_0,
                                                                      Number(0n)),
                                          BigInt));
    return [...p_0[0],
            ...p_0[1],
            ...p_0[2],
            ...p_0[3],
            ...p_0[4],
            ...p_0[5],
            ...p_0[6],
            ...p_0[7]];
  }
  _ed_hex32_0(b_0) {
    const p_0 = this._mapper_2((...args_0) => this._ed_hexpair_0(...args_0),
                               Array.from(b_0, BigInt));
    return [...p_0[0],
            ...p_0[1],
            ...p_0[2],
            ...p_0[3],
            ...p_0[4],
            ...p_0[5],
            ...p_0[6],
            ...p_0[7],
            ...p_0[8],
            ...p_0[9],
            ...p_0[10],
            ...p_0[11],
            ...p_0[12],
            ...p_0[13],
            ...p_0[14],
            ...p_0[15],
            ...p_0[16],
            ...p_0[17],
            ...p_0[18],
            ...p_0[19],
            ...p_0[20],
            ...p_0[21],
            ...p_0[22],
            ...p_0[23],
            ...p_0[24],
            ...p_0[25],
            ...p_0[26],
            ...p_0[27],
            ...p_0[28],
            ...p_0[29],
            ...p_0[30],
            ...p_0[31]];
  }
  _ed_deadline_0(value_0, d_0) {
    const g_0 = d_0.digits;
    this._folder_3(((t_0, x_0) =>
                    {
                      __compactRuntime.assert(x_0 <= 9n,
                                              'display: date digit out of range');
                      return t_0;
                    }),
                   [],
                   g_0);
    const year_0 = __compactRuntime.addField(__compactRuntime.addField(__compactRuntime.addField(__compactRuntime.mulField(g_0[0],
                                                                                                                           1000n),
                                                                                                 __compactRuntime.mulField(g_0[1],
                                                                                                                           100n)),
                                                                       __compactRuntime.mulField(g_0[2],
                                                                                                 10n)),
                                             g_0[3]);
    const month_0 = g_0[4] * 10n + g_0[5];
    const day_0 = g_0[6] * 10n + g_0[7];
    const hour_0 = g_0[8] * 10n + g_0[9];
    const min_0 = g_0[10] * 10n + g_0[11];
    const sec_0 = g_0[12] * 10n + g_0[13];
    let t_1;
    __compactRuntime.assert((t_1 = ((t1) => {
                                     if (t1 > 65535n) {
                                       throw new __compactRuntime.CompactError('account.compact line 2655 char 11: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 65535');
                                     }
                                     return t1;
                                   })(year_0),
                             t_1 >= 1970n),
                            'display: year before 1970');
    __compactRuntime.assert(month_0 >= 1n && month_0 <= 12n,
                            'display: month out of range');
    __compactRuntime.assert(hour_0 <= 23n && min_0 <= 59n && sec_0 <= 59n,
                            'display: time out of range');
    const before_0 = __compactRuntime.subField(year_0, 1n);
    const r4_0 = ((t1) => {
                   if (t1 > 3n) {
                     throw new __compactRuntime.CompactError('account.compact line 2660 char 16: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 3');
                   }
                   return t1;
                 })(__compactRuntime.subField(before_0,
                                              __compactRuntime.mulField(d_0.q4,
                                                                        4n)));
    const r100_0 = ((t1) => {
                     if (t1 > 99n) {
                       throw new __compactRuntime.CompactError('account.compact line 2661 char 16: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 99');
                     }
                     return t1;
                   })(__compactRuntime.subField(before_0,
                                                __compactRuntime.mulField(d_0.q100,
                                                                          100n)));
    const r400_0 = ((t1) => {
                     if (t1 > 399n) {
                       throw new __compactRuntime.CompactError('account.compact line 2662 char 16: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 399');
                     }
                     return t1;
                   })(__compactRuntime.subField(before_0,
                                                __compactRuntime.mulField(d_0.q400,
                                                                          400n)));
    const leap_0 = r4_0 === 3n && (r100_0 !== 99n || r400_0 === 399n);
    const months_0 = [1n, 2n, 3n, 4n, 5n, 6n, 7n, 8n, 9n, 10n, 11n, 12n];
    const before_month_0 = [0n,
                            31n,
                            59n,
                            90n,
                            120n,
                            151n,
                            181n,
                            212n,
                            243n,
                            273n,
                            304n,
                            334n];
    const month_days_0 = [31n,
                          28n,
                          31n,
                          30n,
                          31n,
                          30n,
                          31n,
                          31n,
                          30n,
                          31n,
                          30n,
                          31n];
    const m_0 = this._folder_4(((acc_0, k_0, b_0, n_0) =>
                                {
                                  if (month_0 === k_0) {
                                    return [b_0, n_0];
                                  } else {
                                    return acc_0;
                                  }
                                }),
                               [0n, 0n],
                               months_0,
                               before_month_0,
                               month_days_0);
    const feb_0 = leap_0 && month_0 === 2n;
    __compactRuntime.assert(day_0 >= 1n
                            &&
                            day_0 <= (feb_0 ? m_0[1] + 1n : m_0[1]),
                            'display: day out of range');
    const leap_days_0 = __compactRuntime.subField(__compactRuntime.addField(__compactRuntime.subField(d_0.q4,
                                                                                                      d_0.q100),
                                                                            d_0.q400),
                                                  477n);
    const days_0 = __compactRuntime.subField(__compactRuntime.addField(__compactRuntime.addField(__compactRuntime.addField(__compactRuntime.addField(__compactRuntime.mulField(__compactRuntime.subField(year_0,
                                                                                                                                                                                                         1970n),
                                                                                                                                                                               365n),
                                                                                                                                                     leap_days_0),
                                                                                                                           m_0[0]),
                                                                                                 leap_0
                                                                                                 &&
                                                                                                 month_0
                                                                                                 >
                                                                                                 2n
                                                                                                 ?
                                                                                                 1n
                                                                                                 :
                                                                                                 0n),
                                                                       day_0),
                                             1n);
    const seconds_0 = __compactRuntime.addField(__compactRuntime.addField(__compactRuntime.addField(__compactRuntime.mulField(days_0,
                                                                                                                              86400n),
                                                                                                    __compactRuntime.mulField(hour_0,
                                                                                                                              3600n)),
                                                                          __compactRuntime.mulField(min_0,
                                                                                                    60n)),
                                                sec_0);
    __compactRuntime.assert(seconds_0 === value_0,
                            'display: the date does not match the deadline');
    const c_0 = this._mapper_3((...args_0) => this._ed_digit_char_0(...args_0),
                               g_0);
    const date_0 = [c_0[0],
                    c_0[1],
                    c_0[2],
                    c_0[3],
                    45n,
                    c_0[4],
                    c_0[5],
                    45n,
                    c_0[6],
                    c_0[7],
                    32n,
                    c_0[8],
                    c_0[9],
                    58n,
                    c_0[10],
                    c_0[11],
                    58n,
                    c_0[12],
                    c_0[13],
                    32n,
                    85n,
                    84n,
                    67n];
    const never_0 = Array.from(new Uint8Array([110, 101, 118, 101, 114, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
                               BigInt);
    return this._mapper_4(((n_1, v_0) =>
                           {
                             if (value_0 === 0n) {
                               if (n_1 === 0n) {
                                 return 32n;
                               } else {
                                 return n_1;
                               }
                             } else {
                               return v_0;
                             }
                           }),
                          never_0,
                          date_0);
  }
  _ed_digit_char_0(x_0) {
    return ((t1) => {
             if (t1 > 255n) {
               throw new __compactRuntime.CompactError('account.compact line 2686 char 10: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 255');
             }
             return t1;
           })(x_0 + 48n);
  }
  _ed_label_0(label_0) {
    const r_0 = this._folder_5(((a_0, c_0) =>
                                {
                                  const space_0 = c_0 === 32n;
                                  const shown_0 = c_0 >= 33n && c_0 <= 126n;
                                  return [space_0,
                                          a_0[1] || space_0 && a_0[0],
                                          a_0[2]
                                          &&
                                          (space_0 || shown_0 && !a_0[1])];
                                }),
                               [false, false, true],
                               label_0);
    __compactRuntime.assert(r_0[2] && label_0[0] !== 32n,
                            'display: the site label must be printable words with single spaces');
    return [...Array.from(new Uint8Array([83, 105, 116, 101, 58, 32]), BigInt),
            ...label_0];
  }
  _ed_tail_0(self_addr_0, nonce_value_0, nonce_0, challenge_0) {
    return [...Array.from(new Uint8Array([65, 99, 99, 111, 117, 110, 116, 32]),
                          BigInt),
            ...this._ed_hex8_1(self_addr_0.bytes),
            ...Array.from(new Uint8Array([32, 110, 111, 110, 99, 101, 32]),
                          BigInt),
            ...this._ed_uint_text_0(nonce_value_0, nonce_0),
            10n,
            ...Array.from(new Uint8Array([68, 105, 103, 101, 115, 116, 32]),
                          BigInt),
            ...this._ed_hex32_0(challenge_0)];
  }
  _ed_amount_lines_0(value_0, color_0, a_0) {
    return [...Array.from(new Uint8Array([66, 97, 115, 101, 32, 117, 110, 105, 116, 115, 32]),
                          BigInt),
            ...this._ed_uint_text_1(value_0, a_0.units),
            10n,
            ...Array.from(new Uint8Array([84, 111, 107, 101, 110, 32]), BigInt),
            ...this._ed_hex32_0(color_0),
            10n,
            ...Array.from(new Uint8Array([84, 104, 105, 115, 32, 115, 105, 116, 101, 32, 108, 97, 98, 101, 108, 115, 32, 105, 116, 58, 32]),
                          BigInt),
            ...this._ed_site_text_0(value_0, a_0.site),
            10n];
  }
  _ed25519_message_withdraw_unshielded_0(self_addr_0,
                                         challenge_0,
                                         nonce_value_0,
                                         color_0,
                                         amount_0,
                                         recipient_0,
                                         show_0)
  {
    return Uint8Array.from([...this._ed_label_0(show_0.label),
                            10n,
                            ...Array.from(new Uint8Array([87, 105, 116, 104, 100, 114, 97, 119, 32, 117, 110, 115, 104, 105, 101, 108, 100, 101, 100]),
                                          BigInt),
                            10n,
                            ...this._ed_amount_lines_0(amount_0,
                                                       color_0,
                                                       show_0.amount),
                            ...Array.from(new Uint8Array([84, 111, 32, 97, 100, 100, 114, 101, 115, 115, 32]),
                                          BigInt),
                            ...this._ed_hex8_1(recipient_0.bytes),
                            10n,
                            ...this._ed_tail_0(self_addr_0,
                                               nonce_value_0,
                                               show_0.nonce,
                                               challenge_0)],
                           Number);
  }
  _ed25519_message_withdraw_shielded_0(self_addr_0,
                                       challenge_0,
                                       nonce_value_0,
                                       recipient_0,
                                       color_0,
                                       amount_0,
                                       show_0)
  {
    return Uint8Array.from([...this._ed_label_0(show_0.label),
                            10n,
                            ...Array.from(new Uint8Array([87, 105, 116, 104, 100, 114, 97, 119, 32, 115, 104, 105, 101, 108, 100, 101, 100]),
                                          BigInt),
                            10n,
                            ...this._ed_amount_lines_0(amount_0,
                                                       color_0,
                                                       show_0.amount),
                            ...Array.from(new Uint8Array([84, 111, 32, 107, 101, 121, 32]),
                                          BigInt),
                            ...this._ed_hex8_1(recipient_0.bytes),
                            10n,
                            ...this._ed_tail_0(self_addr_0,
                                               nonce_value_0,
                                               show_0.nonce,
                                               challenge_0)],
                           Number);
  }
  _ed25519_message_withdraw_shielded_to_contract_0(self_addr_0,
                                                   challenge_0,
                                                   nonce_value_0,
                                                   recipient_0,
                                                   color_0,
                                                   amount_0,
                                                   show_0)
  {
    return Uint8Array.from([...this._ed_label_0(show_0.label),
                            10n,
                            ...Array.from(new Uint8Array([87, 105, 116, 104, 100, 114, 97, 119, 32, 116, 111, 32, 99, 111, 110, 116, 114, 97, 99, 116]),
                                          BigInt),
                            10n,
                            ...this._ed_amount_lines_0(amount_0,
                                                       color_0,
                                                       show_0.amount),
                            ...Array.from(new Uint8Array([84, 111, 32, 99, 111, 110, 116, 114, 97, 99, 116, 32]),
                                          BigInt),
                            ...this._ed_hex8_1(recipient_0.bytes),
                            10n,
                            ...this._ed_tail_0(self_addr_0,
                                               nonce_value_0,
                                               show_0.nonce,
                                               challenge_0)],
                           Number);
  }
  _ed25519_message_append_inbox_0(self_addr_0,
                                  challenge_0,
                                  nonce_value_0,
                                  entry_0,
                                  show_0)
  {
    return Uint8Array.from([...this._ed_label_0(show_0.label),
                            10n,
                            ...Array.from(new Uint8Array([70, 105, 108, 101, 32, 105, 110, 98, 111, 120, 32, 110, 111, 116, 101]),
                                          BigInt),
                            10n,
                            ...Array.from(new Uint8Array([78, 111, 116, 101, 32]),
                                          BigInt),
                            ...this._ed_hex8_0(entry_0),
                            10n,
                            ...this._ed_tail_0(self_addr_0,
                                               nonce_value_0,
                                               show_0.nonce,
                                               challenge_0)],
                           Number);
  }
  _ed25519_message_rotate_enc_key_0(self_addr_0,
                                    challenge_0,
                                    nonce_value_0,
                                    new_key_0,
                                    current_key_0,
                                    show_0)
  {
    const keep_0 = this._equal_31(new_key_0, current_key_0);
    const title_0 = this._mapper_5(((c_0, r_0) =>
                                    {
                                      if (keep_0) {
                                        return c_0;
                                      } else {
                                        if (r_0 === 0n) {
                                          return 32n;
                                        } else {
                                          return r_0;
                                        }
                                      }
                                    }),
                                   Array.from(new Uint8Array([67, 97, 110, 99, 101, 108, 32, 97, 108, 108, 32, 111, 112, 101, 110, 32, 111, 102, 102, 101, 114, 115]),
                                              BigInt),
                                   Array.from(new Uint8Array([82, 111, 116, 97, 116, 101, 32, 101, 110, 99, 114, 121, 112, 116, 105, 111, 110, 32, 107, 101, 121, 0]),
                                              BigInt));
    const rotated_0 = [...Array.from(new Uint8Array([78, 101, 119, 32, 107, 101, 121, 32]),
                                     BigInt),
                       ...this._ed_hex8_1(new_key_0)];
    const line_0 = this._mapper_6(((c_1, r_1) =>
                                   {
                                     if (keep_0) {
                                       return c_1;
                                     } else {
                                       return r_1;
                                     }
                                   }),
                                  Array.from(new Uint8Array([89, 111, 117, 114, 32, 107, 101, 121, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 104, 97, 110, 103, 101]),
                                             BigInt),
                                  rotated_0);
    return Uint8Array.from([...this._ed_label_0(show_0.label),
                            10n,
                            ...title_0,
                            10n,
                            ...line_0,
                            10n,
                            ...this._ed_tail_0(self_addr_0,
                                               nonce_value_0,
                                               show_0.nonce,
                                               challenge_0)],
                           Number);
  }
  _ed25519_message_open_swap_shielded_0(self_addr_0,
                                        challenge_0,
                                        nonce_value_0,
                                        give_color_0,
                                        give_amount_0,
                                        recipient_kind_0,
                                        recipient_0,
                                        want_0,
                                        valid_until_0,
                                        show_0)
  {
    const named_0 = this._ed_hex8_1(recipient_0);
    const anyone_0 = Array.from(new Uint8Array([97, 110, 121, 111, 110, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
                                BigInt);
    const open_0 = recipient_kind_0 === 0n;
    const taker_0 = this._mapper_7(((a_0, n_0) =>
                                    {
                                      if (open_0) {
                                        if (a_0 === 0n) {
                                          return 32n;
                                        } else {
                                          return a_0;
                                        }
                                      } else {
                                        return n_0;
                                      }
                                    }),
                                   anyone_0,
                                   named_0);
    return Uint8Array.from([...this._ed_label_0(show_0.label),
                            10n,
                            ...Array.from(new Uint8Array([83, 119, 97, 112, 32, 111, 102, 102, 101, 114]),
                                          BigInt),
                            10n,
                            ...Array.from(new Uint8Array([71, 105, 118, 101, 32, 98, 97, 115, 101, 32, 117, 110, 105, 116, 115, 32]),
                                          BigInt),
                            ...this._ed_uint_text_1(give_amount_0,
                                                    show_0.give.units),
                            10n,
                            ...Array.from(new Uint8Array([71, 105, 118, 101, 32, 116, 111, 107, 101, 110, 32]),
                                          BigInt),
                            ...this._ed_hex32_0(give_color_0),
                            10n,
                            ...Array.from(new Uint8Array([84, 104, 105, 115, 32, 115, 105, 116, 101, 32, 108, 97, 98, 101, 108, 115, 32, 105, 116, 58, 32]),
                                          BigInt),
                            ...this._ed_site_text_0(give_amount_0,
                                                    show_0.give.site),
                            10n,
                            ...Array.from(new Uint8Array([71, 101, 116, 32, 98, 97, 115, 101, 32, 117, 110, 105, 116, 115, 32]),
                                          BigInt),
                            ...this._ed_uint_text_1(want_0.value,
                                                    show_0.want.units),
                            10n,
                            ...Array.from(new Uint8Array([71, 101, 116, 32, 116, 111, 107, 101, 110, 32]),
                                          BigInt),
                            ...this._ed_hex32_0(want_0.color),
                            10n,
                            ...Array.from(new Uint8Array([84, 104, 105, 115, 32, 115, 105, 116, 101, 32, 108, 97, 98, 101, 108, 115, 32, 105, 116, 58, 32]),
                                          BigInt),
                            ...this._ed_site_text_0(want_0.value,
                                                    show_0.want.site),
                            10n,
                            ...Array.from(new Uint8Array([84, 97, 107, 101, 114, 32]),
                                          BigInt),
                            ...taker_0,
                            10n,
                            ...Array.from(new Uint8Array([69, 120, 112, 105, 114, 101, 115, 32]),
                                          BigInt),
                            ...this._ed_deadline_0(valid_until_0, show_0.until),
                            10n,
                            ...this._ed_tail_0(self_addr_0,
                                               nonce_value_0,
                                               show_0.nonce,
                                               challenge_0)],
                           Number);
  }
  async _require_authorised_with_ed25519_0(context,
                                           partialProofData,
                                           pk_0,
                                           use_counter_0,
                                           sig_0,
                                           msg_0)
  {
    const entry_0 = this._derive_device_entry_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 2 } },
                                                                                                                        { idx: { cached: true,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: true,
                                                                                                                                   result: undefined } }]).value),
                                                             pk_0,
                                                             _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 0 } },
                                                                                                                         { idx: { cached: false,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: false,
                                                                                                                                    result: undefined } }]).value),
                                                             use_counter_0);
    __compactRuntime.assert(_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(6n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { push: { storage: false,
                                                                                                  value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                                                                               alignment: _descriptor_0.alignment() }).encode() } },
                                                                                        'member',
                                                                                        { popeq: { cached: true,
                                                                                                   result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = this._derive_device_entry_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 2 } },
                                                                                                                      { idx: { cached: true,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: true,
                                                                                                                                 result: undefined } }]).value),
                                                           pk_0,
                                                           _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 0 } },
                                                                                                                       { idx: { cached: false,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: false,
                                                                                                                                  result: undefined } }]).value),
                                                           ((t1) => {
                                                             if (t1 > 18446744073709551615n) {
                                                               throw new __compactRuntime.CompactError('account.compact line 2825 char 39: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                             }
                                                             return t1;
                                                           })(use_counter_0 + 1n));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    __compactRuntime.assert(!this._equal_32(__compactRuntime.convertBigintToBytes(32,
                                                                                  this._curve25519PointX_0(sig_0.r),
                                                                                  'account.compact line 2829 char 11'),
                                            new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                            'R is the identity');
    __compactRuntime.assert(this._ed25519Verify_0(msg_0, sig_0, pk_0),
                            'invalid signature');
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 2832 char 17: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_1),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _require_authorised_with_ed25519_1(context,
                                           partialProofData,
                                           pk_0,
                                           use_counter_0,
                                           sig_0,
                                           msg_0)
  {
    const entry_0 = this._derive_device_entry_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 2 } },
                                                                                                                        { idx: { cached: true,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: true,
                                                                                                                                   result: undefined } }]).value),
                                                             pk_0,
                                                             _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 0 } },
                                                                                                                         { idx: { cached: false,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: false,
                                                                                                                                    result: undefined } }]).value),
                                                             use_counter_0);
    __compactRuntime.assert(_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(6n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { push: { storage: false,
                                                                                                  value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                                                                               alignment: _descriptor_0.alignment() }).encode() } },
                                                                                        'member',
                                                                                        { popeq: { cached: true,
                                                                                                   result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = this._derive_device_entry_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 2 } },
                                                                                                                      { idx: { cached: true,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: true,
                                                                                                                                 result: undefined } }]).value),
                                                           pk_0,
                                                           _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 0 } },
                                                                                                                       { idx: { cached: false,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: false,
                                                                                                                                  result: undefined } }]).value),
                                                           ((t1) => {
                                                             if (t1 > 18446744073709551615n) {
                                                               throw new __compactRuntime.CompactError('account.compact line 2825 char 39: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                             }
                                                             return t1;
                                                           })(use_counter_0 + 1n));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    __compactRuntime.assert(!this._equal_33(__compactRuntime.convertBigintToBytes(32,
                                                                                  this._curve25519PointX_0(sig_0.r),
                                                                                  'account.compact line 2829 char 11'),
                                            new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                            'R is the identity');
    __compactRuntime.assert(this._ed25519Verify_1(msg_0, sig_0, pk_0),
                            'invalid signature');
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 2832 char 17: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_1),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _require_authorised_with_ed25519_2(context,
                                           partialProofData,
                                           pk_0,
                                           use_counter_0,
                                           sig_0,
                                           msg_0)
  {
    const entry_0 = this._derive_device_entry_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 2 } },
                                                                                                                        { idx: { cached: true,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: true,
                                                                                                                                   result: undefined } }]).value),
                                                             pk_0,
                                                             _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 0 } },
                                                                                                                         { idx: { cached: false,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: false,
                                                                                                                                    result: undefined } }]).value),
                                                             use_counter_0);
    __compactRuntime.assert(_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(6n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { push: { storage: false,
                                                                                                  value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                                                                               alignment: _descriptor_0.alignment() }).encode() } },
                                                                                        'member',
                                                                                        { popeq: { cached: true,
                                                                                                   result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = this._derive_device_entry_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 2 } },
                                                                                                                      { idx: { cached: true,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: true,
                                                                                                                                 result: undefined } }]).value),
                                                           pk_0,
                                                           _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 0 } },
                                                                                                                       { idx: { cached: false,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: false,
                                                                                                                                  result: undefined } }]).value),
                                                           ((t1) => {
                                                             if (t1 > 18446744073709551615n) {
                                                               throw new __compactRuntime.CompactError('account.compact line 2825 char 39: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                             }
                                                             return t1;
                                                           })(use_counter_0 + 1n));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    __compactRuntime.assert(!this._equal_34(__compactRuntime.convertBigintToBytes(32,
                                                                                  this._curve25519PointX_0(sig_0.r),
                                                                                  'account.compact line 2829 char 11'),
                                            new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                            'R is the identity');
    __compactRuntime.assert(this._ed25519Verify_2(msg_0, sig_0, pk_0),
                            'invalid signature');
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 2832 char 17: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_1),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _require_authorised_with_ed25519_3(context,
                                           partialProofData,
                                           pk_0,
                                           use_counter_0,
                                           sig_0,
                                           msg_0)
  {
    const entry_0 = this._derive_device_entry_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 2 } },
                                                                                                                        { idx: { cached: true,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: true,
                                                                                                                                   result: undefined } }]).value),
                                                             pk_0,
                                                             _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 0 } },
                                                                                                                         { idx: { cached: false,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: false,
                                                                                                                                    result: undefined } }]).value),
                                                             use_counter_0);
    __compactRuntime.assert(_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(6n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { push: { storage: false,
                                                                                                  value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                                                                               alignment: _descriptor_0.alignment() }).encode() } },
                                                                                        'member',
                                                                                        { popeq: { cached: true,
                                                                                                   result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = this._derive_device_entry_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 2 } },
                                                                                                                      { idx: { cached: true,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: true,
                                                                                                                                 result: undefined } }]).value),
                                                           pk_0,
                                                           _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 0 } },
                                                                                                                       { idx: { cached: false,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: false,
                                                                                                                                  result: undefined } }]).value),
                                                           ((t1) => {
                                                             if (t1 > 18446744073709551615n) {
                                                               throw new __compactRuntime.CompactError('account.compact line 2825 char 39: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                             }
                                                             return t1;
                                                           })(use_counter_0 + 1n));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    __compactRuntime.assert(!this._equal_35(__compactRuntime.convertBigintToBytes(32,
                                                                                  this._curve25519PointX_0(sig_0.r),
                                                                                  'account.compact line 2829 char 11'),
                                            new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                            'R is the identity');
    __compactRuntime.assert(this._ed25519Verify_3(msg_0, sig_0, pk_0),
                            'invalid signature');
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 2832 char 17: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_1),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _require_authorised_with_ed25519_4(context,
                                           partialProofData,
                                           pk_0,
                                           use_counter_0,
                                           sig_0,
                                           msg_0)
  {
    const entry_0 = this._derive_device_entry_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 2 } },
                                                                                                                        { idx: { cached: true,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: true,
                                                                                                                                   result: undefined } }]).value),
                                                             pk_0,
                                                             _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 0 } },
                                                                                                                         { idx: { cached: false,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: false,
                                                                                                                                    result: undefined } }]).value),
                                                             use_counter_0);
    __compactRuntime.assert(_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(6n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { push: { storage: false,
                                                                                                  value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                                                                               alignment: _descriptor_0.alignment() }).encode() } },
                                                                                        'member',
                                                                                        { popeq: { cached: true,
                                                                                                   result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = this._derive_device_entry_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 2 } },
                                                                                                                      { idx: { cached: true,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: true,
                                                                                                                                 result: undefined } }]).value),
                                                           pk_0,
                                                           _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 0 } },
                                                                                                                       { idx: { cached: false,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: false,
                                                                                                                                  result: undefined } }]).value),
                                                           ((t1) => {
                                                             if (t1 > 18446744073709551615n) {
                                                               throw new __compactRuntime.CompactError('account.compact line 2825 char 39: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                             }
                                                             return t1;
                                                           })(use_counter_0 + 1n));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    __compactRuntime.assert(!this._equal_36(__compactRuntime.convertBigintToBytes(32,
                                                                                  this._curve25519PointX_0(sig_0.r),
                                                                                  'account.compact line 2829 char 11'),
                                            new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                            'R is the identity');
    __compactRuntime.assert(this._ed25519Verify_4(msg_0, sig_0, pk_0),
                            'invalid signature');
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 2832 char 17: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_1),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _require_authorised_with_ed25519_5(context,
                                           partialProofData,
                                           pk_0,
                                           use_counter_0,
                                           sig_0,
                                           msg_0)
  {
    const entry_0 = this._derive_device_entry_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 2 } },
                                                                                                                        { idx: { cached: true,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: true,
                                                                                                                                   result: undefined } }]).value),
                                                             pk_0,
                                                             _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 0 } },
                                                                                                                         { idx: { cached: false,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: false,
                                                                                                                                    result: undefined } }]).value),
                                                             use_counter_0);
    __compactRuntime.assert(_descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                       partialProofData,
                                                                                       [
                                                                                        { dup: { n: 0 } },
                                                                                        { idx: { cached: false,
                                                                                                 pushPath: false,
                                                                                                 path: [
                                                                                                        { tag: 'value',
                                                                                                          value: { value: _descriptor_3.toValue(6n),
                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                        { push: { storage: false,
                                                                                                  value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                                                                               alignment: _descriptor_0.alignment() }).encode() } },
                                                                                        'member',
                                                                                        { popeq: { cached: true,
                                                                                                   result: undefined } }]).value),
                            'unknown device entry');
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(entry_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { rem: { cached: false } },
                                       { ins: { cached: true, n: 1 } }]);
    const tmp_0 = this._derive_device_entry_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                     partialProofData,
                                                                                                                     [
                                                                                                                      { dup: { n: 2 } },
                                                                                                                      { idx: { cached: true,
                                                                                                                               pushPath: false,
                                                                                                                               path: [
                                                                                                                                      { tag: 'value',
                                                                                                                                        value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                      { popeq: { cached: true,
                                                                                                                                 result: undefined } }]).value),
                                                           pk_0,
                                                           _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 0 } },
                                                                                                                       { idx: { cached: false,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(7n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: false,
                                                                                                                                  result: undefined } }]).value),
                                                           ((t1) => {
                                                             if (t1 > 18446744073709551615n) {
                                                               throw new __compactRuntime.CompactError('account.compact line 2825 char 39: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                                                             }
                                                             return t1;
                                                           })(use_counter_0 + 1n));
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { idx: { cached: false,
                                                pushPath: true,
                                                path: [
                                                       { tag: 'value',
                                                         value: { value: _descriptor_3.toValue(6n),
                                                                  alignment: _descriptor_3.alignment() } }] } },
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(tmp_0),
                                                                                              alignment: _descriptor_0.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newNull().encode() } },
                                       { ins: { cached: false, n: 1 } },
                                       { ins: { cached: true, n: 1 } }]);
    __compactRuntime.assert(!this._equal_37(__compactRuntime.convertBigintToBytes(32,
                                                                                  this._curve25519PointX_0(sig_0.r),
                                                                                  'account.compact line 2829 char 11'),
                                            new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])),
                            'R is the identity');
    __compactRuntime.assert(this._ed25519Verify_5(msg_0, sig_0, pk_0),
                            'invalid signature');
    const tmp_1 = ((t1) => {
                    if (t1 > 18446744073709551615n) {
                      throw new __compactRuntime.CompactError('account.compact line 2832 char 17: cast from Field or Uint value to smaller Uint value failed: ' + t1 + ' is greater than 18446744073709551615');
                    }
                    return t1;
                  })(_descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                partialProofData,
                                                                                [
                                                                                 { dup: { n: 0 } },
                                                                                 { idx: { cached: false,
                                                                                          pushPath: false,
                                                                                          path: [
                                                                                                 { tag: 'value',
                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                 { popeq: { cached: false,
                                                                                            result: undefined } }]).value)
                     +
                     1n);
    __compactRuntime.queryLedgerState(context,
                                      partialProofData,
                                      [
                                       { push: { storage: false,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_3.toValue(9n),
                                                                                              alignment: _descriptor_3.alignment() }).encode() } },
                                       { push: { storage: true,
                                                 value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(tmp_1),
                                                                                              alignment: _descriptor_10.alignment() }).encode() } },
                                       { ins: { cached: false, n: 1 } }]);
    await this._bump_round_0(context, partialProofData);
    return [];
  }
  async _withdraw_unshielded_with_ed25519_0(context,
                                            partialProofData,
                                            color_0,
                                            amount_0,
                                            recipient_0,
                                            pk_0,
                                            use_counter_0,
                                            sig_0,
                                            show_0)
  {
    const challenge_0 = this._challenge_withdraw_unshielded_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                     partialProofData,
                                                                                                                                     [
                                                                                                                                      { dup: { n: 2 } },
                                                                                                                                      { idx: { cached: true,
                                                                                                                                               pushPath: false,
                                                                                                                                               path: [
                                                                                                                                                      { tag: 'value',
                                                                                                                                                        value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                      { popeq: { cached: true,
                                                                                                                                                 result: undefined } }]).value),
                                                                           pk_0,
                                                                           _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                     partialProofData,
                                                                                                                                     [
                                                                                                                                      { dup: { n: 0 } },
                                                                                                                                      { idx: { cached: false,
                                                                                                                                               pushPath: false,
                                                                                                                                               path: [
                                                                                                                                                      { tag: 'value',
                                                                                                                                                        value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                      { popeq: { cached: false,
                                                                                                                                                 result: undefined } }]).value),
                                                                           color_0,
                                                                           amount_0,
                                                                           recipient_0,
                                                                           _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                      partialProofData,
                                                                                                                                      [
                                                                                                                                       { dup: { n: 0 } },
                                                                                                                                       { idx: { cached: false,
                                                                                                                                                pushPath: false,
                                                                                                                                                path: [
                                                                                                                                                       { tag: 'value',
                                                                                                                                                         value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                       { popeq: { cached: false,
                                                                                                                                                  result: undefined } }]).value));
    const msg_0 = this._ed25519_message_withdraw_unshielded_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 2 } },
                                                                                                                         { idx: { cached: true,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: true,
                                                                                                                                    result: undefined } }]).value),
                                                              challenge_0,
                                                              _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                         partialProofData,
                                                                                                                         [
                                                                                                                          { dup: { n: 0 } },
                                                                                                                          { idx: { cached: false,
                                                                                                                                   pushPath: false,
                                                                                                                                   path: [
                                                                                                                                          { tag: 'value',
                                                                                                                                            value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                                                                          { popeq: { cached: false,
                                                                                                                                     result: undefined } }]).value),
                                                              color_0,
                                                              amount_0,
                                                              recipient_0,
                                                              show_0);
    await this._require_authorised_with_ed25519_0(context,
                                                  partialProofData,
                                                  pk_0,
                                                  use_counter_0,
                                                  sig_0,
                                                  msg_0);
    await this._do_withdraw_unshielded_0(context,
                                         partialProofData,
                                         color_0,
                                         amount_0,
                                         recipient_0);
    return [];
  }
  async _append_inbox_with_ed25519_0(context,
                                     partialProofData,
                                     entry_0,
                                     pk_0,
                                     use_counter_0,
                                     sig_0,
                                     show_0)
  {
    const challenge_0 = this._challenge_append_inbox_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                              partialProofData,
                                                                                                                              [
                                                                                                                               { dup: { n: 2 } },
                                                                                                                               { idx: { cached: true,
                                                                                                                                        pushPath: false,
                                                                                                                                        path: [
                                                                                                                                               { tag: 'value',
                                                                                                                                                 value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                                               { popeq: { cached: true,
                                                                                                                                          result: undefined } }]).value),
                                                                    pk_0,
                                                                    _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                              partialProofData,
                                                                                                                              [
                                                                                                                               { dup: { n: 0 } },
                                                                                                                               { idx: { cached: false,
                                                                                                                                        pushPath: false,
                                                                                                                                        path: [
                                                                                                                                               { tag: 'value',
                                                                                                                                                 value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                          alignment: _descriptor_3.alignment() } }] } },
                                                                                                                               { popeq: { cached: false,
                                                                                                                                          result: undefined } }]).value),
                                                                    entry_0,
                                                                    _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                               partialProofData,
                                                                                                                               [
                                                                                                                                { dup: { n: 0 } },
                                                                                                                                { idx: { cached: false,
                                                                                                                                         pushPath: false,
                                                                                                                                         path: [
                                                                                                                                                { tag: 'value',
                                                                                                                                                  value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                { popeq: { cached: false,
                                                                                                                                           result: undefined } }]).value));
    const msg_0 = this._ed25519_message_append_inbox_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                 partialProofData,
                                                                                                                 [
                                                                                                                  { dup: { n: 2 } },
                                                                                                                  { idx: { cached: true,
                                                                                                                           pushPath: false,
                                                                                                                           path: [
                                                                                                                                  { tag: 'value',
                                                                                                                                    value: { value: _descriptor_3.toValue(0n),
                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                  { popeq: { cached: true,
                                                                                                                             result: undefined } }]).value),
                                                       challenge_0,
                                                       _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                  partialProofData,
                                                                                                                  [
                                                                                                                   { dup: { n: 0 } },
                                                                                                                   { idx: { cached: false,
                                                                                                                            pushPath: false,
                                                                                                                            path: [
                                                                                                                                   { tag: 'value',
                                                                                                                                     value: { value: _descriptor_3.toValue(9n),
                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                   { popeq: { cached: false,
                                                                                                                              result: undefined } }]).value),
                                                       entry_0,
                                                       show_0);
    await this._require_authorised_with_ed25519_1(context,
                                                  partialProofData,
                                                  pk_0,
                                                  use_counter_0,
                                                  sig_0,
                                                  msg_0);
    await this._do_append_inbox_0(context, partialProofData, entry_0);
    return [];
  }
  async _withdraw_shielded_with_ed25519_0(context,
                                          partialProofData,
                                          recipient_0,
                                          color_0,
                                          amount_0,
                                          pk_0,
                                          use_counter_0,
                                          sig_0,
                                          show_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    __compactRuntime.assert(this._equal_38(coin_0.color, color_0),
                            'held coin colour does not match the withdrawn colour');
    const challenge_0 = this._challenge_withdraw_shielded_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 2 } },
                                                                                                                                    { idx: { cached: true,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: true,
                                                                                                                                               result: undefined } }]).value),
                                                                         pk_0,
                                                                         _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 0 } },
                                                                                                                                    { idx: { cached: false,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: false,
                                                                                                                                               result: undefined } }]).value),
                                                                         recipient_0,
                                                                         color_0,
                                                                         amount_0,
                                                                         coin_0,
                                                                         _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                    partialProofData,
                                                                                                                                    [
                                                                                                                                     { dup: { n: 0 } },
                                                                                                                                     { idx: { cached: false,
                                                                                                                                              pushPath: false,
                                                                                                                                              path: [
                                                                                                                                                     { tag: 'value',
                                                                                                                                                       value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                     { popeq: { cached: false,
                                                                                                                                                result: undefined } }]).value));
    const msg_0 = this._ed25519_message_withdraw_shielded_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 2 } },
                                                                                                                       { idx: { cached: true,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: true,
                                                                                                                                  result: undefined } }]).value),
                                                            challenge_0,
                                                            _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 0 } },
                                                                                                                        { idx: { cached: false,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: false,
                                                                                                                                   result: undefined } }]).value),
                                                            recipient_0,
                                                            color_0,
                                                            amount_0,
                                                            show_0);
    await this._require_authorised_with_ed25519_2(context,
                                                  partialProofData,
                                                  pk_0,
                                                  use_counter_0,
                                                  sig_0,
                                                  msg_0);
    return await this._do_withdraw_shielded_0(context,
                                              partialProofData,
                                              recipient_0,
                                              amount_0,
                                              coin_0);
  }
  async _withdraw_shielded_to_contract_with_ed25519_0(context,
                                                      partialProofData,
                                                      recipient_0,
                                                      color_0,
                                                      amount_0,
                                                      pk_0,
                                                      use_counter_0,
                                                      sig_0,
                                                      show_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    __compactRuntime.assert(this._equal_39(coin_0.color, color_0),
                            'held coin colour does not match the withdrawn colour');
    const challenge_0 = this._challenge_withdraw_shielded_to_contract_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                               partialProofData,
                                                                                                                                               [
                                                                                                                                                { dup: { n: 2 } },
                                                                                                                                                { idx: { cached: true,
                                                                                                                                                         pushPath: false,
                                                                                                                                                         path: [
                                                                                                                                                                { tag: 'value',
                                                                                                                                                                  value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                { popeq: { cached: true,
                                                                                                                                                           result: undefined } }]).value),
                                                                                     pk_0,
                                                                                     _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                               partialProofData,
                                                                                                                                               [
                                                                                                                                                { dup: { n: 0 } },
                                                                                                                                                { idx: { cached: false,
                                                                                                                                                         pushPath: false,
                                                                                                                                                         path: [
                                                                                                                                                                { tag: 'value',
                                                                                                                                                                  value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                                           alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                { popeq: { cached: false,
                                                                                                                                                           result: undefined } }]).value),
                                                                                     recipient_0,
                                                                                     color_0,
                                                                                     amount_0,
                                                                                     coin_0,
                                                                                     _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                                partialProofData,
                                                                                                                                                [
                                                                                                                                                 { dup: { n: 0 } },
                                                                                                                                                 { idx: { cached: false,
                                                                                                                                                          pushPath: false,
                                                                                                                                                          path: [
                                                                                                                                                                 { tag: 'value',
                                                                                                                                                                   value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                                 { popeq: { cached: false,
                                                                                                                                                            result: undefined } }]).value));
    const msg_0 = this._ed25519_message_withdraw_shielded_to_contract_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                  partialProofData,
                                                                                                                                  [
                                                                                                                                   { dup: { n: 2 } },
                                                                                                                                   { idx: { cached: true,
                                                                                                                                            pushPath: false,
                                                                                                                                            path: [
                                                                                                                                                   { tag: 'value',
                                                                                                                                                     value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                   { popeq: { cached: true,
                                                                                                                                              result: undefined } }]).value),
                                                                        challenge_0,
                                                                        _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 0 } },
                                                                                                                                    { idx: { cached: false,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: false,
                                                                                                                                               result: undefined } }]).value),
                                                                        recipient_0,
                                                                        color_0,
                                                                        amount_0,
                                                                        show_0);
    await this._require_authorised_with_ed25519_3(context,
                                                  partialProofData,
                                                  pk_0,
                                                  use_counter_0,
                                                  sig_0,
                                                  msg_0);
    return await this._do_withdraw_shielded_to_contract_0(context,
                                                          partialProofData,
                                                          recipient_0,
                                                          amount_0,
                                                          coin_0);
  }
  async _rotate_enc_key_with_ed25519_0(context,
                                       partialProofData,
                                       new_key_0,
                                       pk_0,
                                       use_counter_0,
                                       sig_0,
                                       show_0)
  {
    const challenge_0 = this._challenge_rotate_enc_key_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 2 } },
                                                                                                                                 { idx: { cached: true,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: true,
                                                                                                                                            result: undefined } }]).value),
                                                                      pk_0,
                                                                      _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                partialProofData,
                                                                                                                                [
                                                                                                                                 { dup: { n: 0 } },
                                                                                                                                 { idx: { cached: false,
                                                                                                                                          pushPath: false,
                                                                                                                                          path: [
                                                                                                                                                 { tag: 'value',
                                                                                                                                                   value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                            alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                 { popeq: { cached: false,
                                                                                                                                            result: undefined } }]).value),
                                                                      new_key_0,
                                                                      _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                 partialProofData,
                                                                                                                                 [
                                                                                                                                  { dup: { n: 0 } },
                                                                                                                                  { idx: { cached: false,
                                                                                                                                           pushPath: false,
                                                                                                                                           path: [
                                                                                                                                                  { tag: 'value',
                                                                                                                                                    value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                             alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                  { popeq: { cached: false,
                                                                                                                                             result: undefined } }]).value));
    const msg_0 = this._ed25519_message_rotate_enc_key_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                   partialProofData,
                                                                                                                   [
                                                                                                                    { dup: { n: 2 } },
                                                                                                                    { idx: { cached: true,
                                                                                                                             pushPath: false,
                                                                                                                             path: [
                                                                                                                                    { tag: 'value',
                                                                                                                                      value: { value: _descriptor_3.toValue(0n),
                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                    { popeq: { cached: true,
                                                                                                                               result: undefined } }]).value),
                                                         challenge_0,
                                                         _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                    partialProofData,
                                                                                                                    [
                                                                                                                     { dup: { n: 0 } },
                                                                                                                     { idx: { cached: false,
                                                                                                                              pushPath: false,
                                                                                                                              path: [
                                                                                                                                     { tag: 'value',
                                                                                                                                       value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                     { popeq: { cached: false,
                                                                                                                                result: undefined } }]).value),
                                                         new_key_0,
                                                         _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                   partialProofData,
                                                                                                                   [
                                                                                                                    { dup: { n: 0 } },
                                                                                                                    { idx: { cached: false,
                                                                                                                             pushPath: false,
                                                                                                                             path: [
                                                                                                                                    { tag: 'value',
                                                                                                                                      value: { value: _descriptor_3.toValue(1n),
                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                    { popeq: { cached: false,
                                                                                                                               result: undefined } }]).value),
                                                         show_0);
    await this._require_authorised_with_ed25519_4(context,
                                                  partialProofData,
                                                  pk_0,
                                                  use_counter_0,
                                                  sig_0,
                                                  msg_0);
    await this._do_rotate_enc_key_0(context, partialProofData, new_key_0);
    return [];
  }
  async _open_swap_shielded_with_ed25519_0(context,
                                           partialProofData,
                                           give_color_0,
                                           give_amount_0,
                                           recipient_kind_0,
                                           recipient_0,
                                           want_0,
                                           want_entry_0,
                                           change_entry_0,
                                           valid_until_0,
                                           pk_0,
                                           use_counter_0,
                                           sig_0,
                                           show_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, give_color_0);
    this._assert_open_swap_terms_0(give_color_0,
                                   give_amount_0,
                                   recipient_kind_0,
                                   recipient_0,
                                   want_0,
                                   coin_0.color,
                                   coin_0.value);
    await this._assert_offer_live_0(context, partialProofData, valid_until_0);
    const challenge_0 = this._challenge_open_swap_shielded_with_ed25519_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                    partialProofData,
                                                                                                                                    [
                                                                                                                                     { dup: { n: 2 } },
                                                                                                                                     { idx: { cached: true,
                                                                                                                                              pushPath: false,
                                                                                                                                              path: [
                                                                                                                                                     { tag: 'value',
                                                                                                                                                       value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                     { popeq: { cached: true,
                                                                                                                                                result: undefined } }]).value),
                                                                          pk_0,
                                                                          _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                    partialProofData,
                                                                                                                                    [
                                                                                                                                     { dup: { n: 0 } },
                                                                                                                                     { idx: { cached: false,
                                                                                                                                              pushPath: false,
                                                                                                                                              path: [
                                                                                                                                                     { tag: 'value',
                                                                                                                                                       value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                     { popeq: { cached: false,
                                                                                                                                                result: undefined } }]).value),
                                                                          give_color_0,
                                                                          give_amount_0,
                                                                          recipient_kind_0,
                                                                          recipient_0,
                                                                          want_0,
                                                                          want_entry_0,
                                                                          change_entry_0,
                                                                          valid_until_0,
                                                                          coin_0,
                                                                          _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                     partialProofData,
                                                                                                                                     [
                                                                                                                                      { dup: { n: 0 } },
                                                                                                                                      { idx: { cached: false,
                                                                                                                                               pushPath: false,
                                                                                                                                               path: [
                                                                                                                                                      { tag: 'value',
                                                                                                                                                        value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                 alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                      { popeq: { cached: false,
                                                                                                                                                 result: undefined } }]).value));
    const msg_0 = this._ed25519_message_open_swap_shielded_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 2 } },
                                                                                                                        { idx: { cached: true,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: true,
                                                                                                                                   result: undefined } }]).value),
                                                             challenge_0,
                                                             _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 0 } },
                                                                                                                         { idx: { cached: false,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: false,
                                                                                                                                    result: undefined } }]).value),
                                                             give_color_0,
                                                             give_amount_0,
                                                             recipient_kind_0,
                                                             recipient_0,
                                                             want_0,
                                                             valid_until_0,
                                                             show_0);
    await this._require_authorised_with_ed25519_5(context,
                                                  partialProofData,
                                                  pk_0,
                                                  use_counter_0,
                                                  sig_0,
                                                  msg_0);
    return await this._do_open_swap_0(context,
                                      partialProofData,
                                      coin_0,
                                      give_amount_0,
                                      recipient_kind_0,
                                      recipient_0,
                                      want_0,
                                      want_entry_0,
                                      change_entry_0);
  }
  async _bridge_deposit_start_with_evm_0(context,
                                         partialProofData,
                                         erc20_0,
                                         amount_0,
                                         evm_nonce_0,
                                         gas_limit_0,
                                         max_fee_0,
                                         max_priority_fee_0,
                                         key_version_0,
                                         pk_0,
                                         use_counter_0,
                                         sig_0)
  {
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_bridge_deposit_start_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                  partialProofData,
                                                                                                                                  [
                                                                                                                                   { dup: { n: 2 } },
                                                                                                                                   { idx: { cached: true,
                                                                                                                                            pushPath: false,
                                                                                                                                            path: [
                                                                                                                                                   { tag: 'value',
                                                                                                                                                     value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                              alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                   { popeq: { cached: true,
                                                                                                                                              result: undefined } }]).value),
                                                                        address_0,
                                                                        erc20_0,
                                                                        amount_0,
                                                                        evm_nonce_0,
                                                                        gas_limit_0,
                                                                        max_fee_0,
                                                                        max_priority_fee_0,
                                                                        key_version_0,
                                                                        _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 0 } },
                                                                                                                                    { idx: { cached: false,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: false,
                                                                                                                                               result: undefined } }]).value));
    const digest_0 = this._evm_digest_bridge_deposit_start_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 2 } },
                                                                                                                        { idx: { cached: true,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: true,
                                                                                                                                   result: undefined } }]).value).bytes,
                                                             _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                       partialProofData,
                                                                                                                       [
                                                                                                                        { dup: { n: 0 } },
                                                                                                                        { idx: { cached: false,
                                                                                                                                 pushPath: false,
                                                                                                                                 path: [
                                                                                                                                        { tag: 'value',
                                                                                                                                          value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                        { popeq: { cached: false,
                                                                                                                                   result: undefined } }]).value),
                                                             address_0,
                                                             _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 0 } },
                                                                                                                         { idx: { cached: false,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: false,
                                                                                                                                    result: undefined } }]).value),
                                                             erc20_0,
                                                             amount_0,
                                                             evm_nonce_0,
                                                             gas_limit_0,
                                                             max_fee_0,
                                                             max_priority_fee_0,
                                                             key_version_0,
                                                             challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    await __compactRuntime.crossContractCall({
     context,
     interfaceName: 'Erc20Vault',
     declaration: declaredInterfaces['Erc20Vault'],
     calleeCircuitId: 'startDeposit',
     calleeAddress: __compactRuntime.decodeContractAddress((_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 0 } },
                                                                                                                       { idx: { cached: false,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(13n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: false,
                                                                                                                                  result: undefined } }]).value)).bytes),
     partialProofData,
     args: [evm_nonce_0,
            gas_limit_0,
            max_fee_0,
            max_priority_fee_0,
            key_version_0,
            erc20_0,
            amount_0,
            this._right_1(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                    partialProofData,
                                                                                    [
                                                                                     { dup: { n: 2 } },
                                                                                     { idx: { cached: true,
                                                                                              pushPath: false,
                                                                                              path: [
                                                                                                     { tag: 'value',
                                                                                                       value: { value: _descriptor_3.toValue(0n),
                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                     { popeq: { cached: true,
                                                                                                result: undefined } }]).value))]
    });
    return [];
  }
  async _bridge_deposit_complete_0(context,
                                   partialProofData,
                                   request_id_0,
                                   attestation_0,
                                   output_0,
                                   mint_nonce_0,
                                   entry_0)
  {
    const minted_0 = await __compactRuntime.crossContractCall({
                      context,
                      interfaceName: 'Erc20Vault',
                      declaration: declaredInterfaces['Erc20Vault'],
                      calleeCircuitId: 'completeDeposit',
                      calleeAddress: __compactRuntime.decodeContractAddress((_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                       partialProofData,
                                                                                                                                       [
                                                                                                                                        { dup: { n: 0 } },
                                                                                                                                        { idx: { cached: false,
                                                                                                                                                 pushPath: false,
                                                                                                                                                 path: [
                                                                                                                                                        { tag: 'value',
                                                                                                                                                          value: { value: _descriptor_3.toValue(13n),
                                                                                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                        { popeq: { cached: false,
                                                                                                                                                   result: undefined } }]).value)).bytes),
                      partialProofData,
                      args: [request_id_0, attestation_0, output_0, mint_nonce_0]
                     });
    if (minted_0.is_some) {
      await this._receiveShielded_0(context, partialProofData, minted_0.value);
      await this._do_append_inbox_0(context, partialProofData, entry_0);
      await this._bump_round_0(context, partialProofData);
      return this._some_0(minted_0.value);
    } else {
      await this._bump_round_0(context, partialProofData);
      return this._none_0();
    }
  }
  async _bridge_withdraw_start_with_evm_0(context,
                                          partialProofData,
                                          dest_0,
                                          color_0,
                                          amount_0,
                                          evm_nonce_0,
                                          gas_limit_0,
                                          max_fee_0,
                                          max_priority_fee_0,
                                          key_version_0,
                                          erc20_0,
                                          change_entry_0,
                                          pk_0,
                                          use_counter_0,
                                          sig_0)
  {
    const coin_0 = this._held_coin_0(context, partialProofData, color_0);
    const address_0 = this._secp256k1EthereumAddress_0(pk_0);
    const challenge_0 = this._challenge_bridge_withdraw_start_with_evm_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                   partialProofData,
                                                                                                                                   [
                                                                                                                                    { dup: { n: 2 } },
                                                                                                                                    { idx: { cached: true,
                                                                                                                                             pushPath: false,
                                                                                                                                             path: [
                                                                                                                                                    { tag: 'value',
                                                                                                                                                      value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                               alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                    { popeq: { cached: true,
                                                                                                                                               result: undefined } }]).value),
                                                                         address_0,
                                                                         dest_0,
                                                                         color_0,
                                                                         amount_0,
                                                                         evm_nonce_0,
                                                                         gas_limit_0,
                                                                         max_fee_0,
                                                                         max_priority_fee_0,
                                                                         key_version_0,
                                                                         erc20_0,
                                                                         coin_0,
                                                                         _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                    partialProofData,
                                                                                                                                    [
                                                                                                                                     { dup: { n: 0 } },
                                                                                                                                     { idx: { cached: false,
                                                                                                                                              pushPath: false,
                                                                                                                                              path: [
                                                                                                                                                     { tag: 'value',
                                                                                                                                                       value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                     { popeq: { cached: false,
                                                                                                                                                result: undefined } }]).value));
    const digest_0 = this._evm_digest_bridge_withdraw_start_0(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 2 } },
                                                                                                                         { idx: { cached: true,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(0n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: true,
                                                                                                                                    result: undefined } }]).value).bytes,
                                                              _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 0 } },
                                                                                                                         { idx: { cached: false,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(12n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: false,
                                                                                                                                    result: undefined } }]).value),
                                                              address_0,
                                                              _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                         partialProofData,
                                                                                                                         [
                                                                                                                          { dup: { n: 0 } },
                                                                                                                          { idx: { cached: false,
                                                                                                                                   pushPath: false,
                                                                                                                                   path: [
                                                                                                                                          { tag: 'value',
                                                                                                                                            value: { value: _descriptor_3.toValue(9n),
                                                                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                                                                          { popeq: { cached: false,
                                                                                                                                     result: undefined } }]).value),
                                                              dest_0,
                                                              color_0,
                                                              amount_0,
                                                              evm_nonce_0,
                                                              gas_limit_0,
                                                              max_fee_0,
                                                              max_priority_fee_0,
                                                              key_version_0,
                                                              challenge_0);
    await this._require_authorised_with_evm_0(context,
                                              partialProofData,
                                              pk_0,
                                              use_counter_0,
                                              sig_0,
                                              digest_0,
                                              address_0);
    const result_0 = await this._sendShielded_0(context,
                                                partialProofData,
                                                coin_0,
                                                this._right_1(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                        partialProofData,
                                                                                                                        [
                                                                                                                         { dup: { n: 0 } },
                                                                                                                         { idx: { cached: false,
                                                                                                                                  pushPath: false,
                                                                                                                                  path: [
                                                                                                                                         { tag: 'value',
                                                                                                                                           value: { value: _descriptor_3.toValue(14n),
                                                                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                                                                         { popeq: { cached: false,
                                                                                                                                    result: undefined } }]).value)),
                                                amount_0);
    await __compactRuntime.crossContractCall({
     context,
     interfaceName: 'Erc20Vault',
     declaration: declaredInterfaces['Erc20Vault'],
     calleeCircuitId: 'startWithdraw',
     calleeAddress: __compactRuntime.decodeContractAddress((_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                      partialProofData,
                                                                                                                      [
                                                                                                                       { dup: { n: 0 } },
                                                                                                                       { idx: { cached: false,
                                                                                                                                pushPath: false,
                                                                                                                                path: [
                                                                                                                                       { tag: 'value',
                                                                                                                                         value: { value: _descriptor_3.toValue(13n),
                                                                                                                                                  alignment: _descriptor_3.alignment() } }] } },
                                                                                                                       { popeq: { cached: false,
                                                                                                                                  result: undefined } }]).value)).bytes),
     partialProofData,
     args: [evm_nonce_0,
            gas_limit_0,
            max_fee_0,
            max_priority_fee_0,
            key_version_0,
            erc20_0,
            amount_0,
            dest_0,
            result_0.sent,
            this._right_1(_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                    partialProofData,
                                                                                    [
                                                                                     { dup: { n: 2 } },
                                                                                     { idx: { cached: true,
                                                                                              pushPath: false,
                                                                                              path: [
                                                                                                     { tag: 'value',
                                                                                                       value: { value: _descriptor_3.toValue(0n),
                                                                                                                alignment: _descriptor_3.alignment() } }] } },
                                                                                     { popeq: { cached: true,
                                                                                                result: undefined } }]).value))]
    });
    if (result_0.change.is_some) {
      await this._do_append_inbox_0(context, partialProofData, change_entry_0);
      return this._some_0(result_0.change.value);
    } else {
      return this._none_0();
    }
  }
  async _bridge_withdraw_complete_0(context,
                                    partialProofData,
                                    request_id_0,
                                    attestation_0,
                                    output_0,
                                    mint_nonce_0,
                                    entry_0)
  {
    const refunded_0 = await __compactRuntime.crossContractCall({
                        context,
                        interfaceName: 'Erc20Vault',
                        declaration: declaredInterfaces['Erc20Vault'],
                        calleeCircuitId: 'completeWithdraw',
                        calleeAddress: __compactRuntime.decodeContractAddress((_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                         partialProofData,
                                                                                                                                         [
                                                                                                                                          { dup: { n: 0 } },
                                                                                                                                          { idx: { cached: false,
                                                                                                                                                   pushPath: false,
                                                                                                                                                   path: [
                                                                                                                                                          { tag: 'value',
                                                                                                                                                            value: { value: _descriptor_3.toValue(13n),
                                                                                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                          { popeq: { cached: false,
                                                                                                                                                     result: undefined } }]).value)).bytes),
                        partialProofData,
                        args: [request_id_0,
                               attestation_0,
                               output_0,
                               mint_nonce_0]
                       });
    if (refunded_0.is_some) {
      await this._receiveShielded_0(context, partialProofData, refunded_0.value);
      await this._do_append_inbox_0(context, partialProofData, entry_0);
      await this._bump_round_0(context, partialProofData);
      return this._some_0(refunded_0.value);
    } else {
      await this._bump_round_0(context, partialProofData);
      return this._none_0();
    }
  }
  async _bridge_withdraw_refund_0(context,
                                  partialProofData,
                                  request_id_0,
                                  attestation_0,
                                  output_0,
                                  mint_nonce_0,
                                  entry_0)
  {
    const refunded_0 = await __compactRuntime.crossContractCall({
                        context,
                        interfaceName: 'Erc20Vault',
                        declaration: declaredInterfaces['Erc20Vault'],
                        calleeCircuitId: 'refundWithdraw',
                        calleeAddress: __compactRuntime.decodeContractAddress((_descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                                                                                         partialProofData,
                                                                                                                                         [
                                                                                                                                          { dup: { n: 0 } },
                                                                                                                                          { idx: { cached: false,
                                                                                                                                                   pushPath: false,
                                                                                                                                                   path: [
                                                                                                                                                          { tag: 'value',
                                                                                                                                                            value: { value: _descriptor_3.toValue(13n),
                                                                                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                                                                                          { popeq: { cached: false,
                                                                                                                                                     result: undefined } }]).value)).bytes),
                        partialProofData,
                        args: [request_id_0,
                               attestation_0,
                               output_0,
                               mint_nonce_0]
                       });
    await this._receiveShielded_0(context, partialProofData, refunded_0);
    await this._do_append_inbox_0(context, partialProofData, entry_0);
    await this._bump_round_0(context, partialProofData);
    return refunded_0;
  }
  _equal_0(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_1(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_2(x0, y0) {
    if (x0.identity) { return y0.identity; }
    if (y0.identity || x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_3(x0, y0) {
    if (x0.identity) { return y0.identity; }
    if (y0.identity || x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_4(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_5(x0, y0) {
    if (x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_6(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_7(x0, y0) {
    if (x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_8(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_9(x0, y0) {
    if (x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_10(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_11(x0, y0) {
    if (x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_12(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_13(x0, y0) {
    if (x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_14(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_15(x0, y0) {
    if (x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_16(x0, y0) {
    if (x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_17(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_18(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_19(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_20(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_21(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_22(x0, y0) {
    if (x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_23(x0, y0) {
    if (x0.x != y0.x || x0.y != y0.y) {
      return false;
    }
    return true;
  }
  _equal_24(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_25(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_26(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_27(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_28(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_29(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_30(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _folder_0(f, x, a0) {
    for (let i = 0; i < 20; i++) { x = f(x, a0[i]); }
    return x;
  }
  _folder_1(f, x, a0) {
    for (let i = 0; i < 24; i++) { x = f(x, a0[i]); }
    return x;
  }
  _folder_2(f, x, a0) {
    for (let i = 0; i < 34; i++) { x = f(x, a0[i]); }
    return x;
  }
  _mapper_0(f, a0) {
    let a = [];
    for (let i = 0; i < 8; i++) { a[i] = f(a0[i]); }
    return a;
  }
  _mapper_1(f, a0) {
    let a = [];
    for (let i = 0; i < 8; i++) { a[i] = f(a0[i]); }
    return a;
  }
  _mapper_2(f, a0) {
    let a = [];
    for (let i = 0; i < 32; i++) { a[i] = f(a0[i]); }
    return a;
  }
  _folder_3(f, x, a0) {
    for (let i = 0; i < 14; i++) { x = f(x, a0[i]); }
    return x;
  }
  _folder_4(f, x, a0, a1, a2) {
    for (let i = 0; i < 12; i++) { x = f(x, a0[i], a1[i], a2[i]); }
    return x;
  }
  _mapper_3(f, a0) {
    let a = [];
    for (let i = 0; i < 14; i++) { a[i] = f(a0[i]); }
    return a;
  }
  _mapper_4(f, a0, a1) {
    let a = [];
    for (let i = 0; i < 23; i++) { a[i] = f(a0[i], a1[i]); }
    return a;
  }
  _folder_5(f, x, a0) {
    for (let i = 0; i < 24; i++) { x = f(x, a0[i]); }
    return x;
  }
  _equal_31(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _mapper_5(f, a0, a1) {
    let a = [];
    for (let i = 0; i < 22; i++) { a[i] = f(a0[i], a1[i]); }
    return a;
  }
  _mapper_6(f, a0, a1) {
    let a = [];
    for (let i = 0; i < 24; i++) { a[i] = f(a0[i], a1[i]); }
    return a;
  }
  _mapper_7(f, a0, a1) {
    let a = [];
    for (let i = 0; i < 16; i++) { a[i] = f(a0[i], a1[i]); }
    return a;
  }
  _equal_32(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_33(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_34(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_35(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_36(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_37(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_38(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
  _equal_39(x0, y0) {
    if (!x0.every((x, i) => y0[i] === x)) { return false; }
    return true;
  }
}
export function ledger(stateOrChargedState) {
  const state = stateOrChargedState instanceof __compactRuntime.StateValue ? stateOrChargedState : stateOrChargedState.state;
  const chargedState = stateOrChargedState instanceof __compactRuntime.StateValue ? new __compactRuntime.ChargedState(stateOrChargedState) : stateOrChargedState;
  const context = {
    callContext: { currentQueryContext: new __compactRuntime.QueryContext(chargedState, __compactRuntime.dummyContractAddress()), currentGasCost: __compactRuntime.emptyRunningCost() },
    costModel: __compactRuntime.CostModel.initialCostModel()
  };
  const partialProofData = {
    input: { value: [], alignment: [] },
    output: undefined,
    publicTranscript: [],
    privateTranscriptOutputs: []
  };
  return {
    get round() {
      return _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                        partialProofData,
                                                                        [
                                                                         { dup: { n: 0 } },
                                                                         { idx: { cached: false,
                                                                                  pushPath: false,
                                                                                  path: [
                                                                                         { tag: 'value',
                                                                                           value: { value: _descriptor_3.toValue(0n),
                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                         { popeq: { cached: false,
                                                                                    result: undefined } }]).value);
    },
    get enc_key() {
      return _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                       partialProofData,
                                                                       [
                                                                        { dup: { n: 0 } },
                                                                        { idx: { cached: false,
                                                                                 pushPath: false,
                                                                                 path: [
                                                                                        { tag: 'value',
                                                                                          value: { value: _descriptor_3.toValue(1n),
                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                        { popeq: { cached: false,
                                                                                   result: undefined } }]).value);
    },
    inbox: {
      isEmpty(...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`isEmpty: expected 0 arguments, received ${args_0.length}`);
        }
        return _descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                          partialProofData,
                                                                          [
                                                                           { dup: { n: 0 } },
                                                                           { idx: { cached: false,
                                                                                    pushPath: false,
                                                                                    path: [
                                                                                           { tag: 'value',
                                                                                             value: { value: _descriptor_3.toValue(2n),
                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                           'size',
                                                                           { push: { storage: false,
                                                                                     value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(0n),
                                                                                                                                  alignment: _descriptor_10.alignment() }).encode() } },
                                                                           'eq',
                                                                           { popeq: { cached: true,
                                                                                      result: undefined } }]).value);
      },
      size(...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`size: expected 0 arguments, received ${args_0.length}`);
        }
        return _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                          partialProofData,
                                                                          [
                                                                           { dup: { n: 0 } },
                                                                           { idx: { cached: false,
                                                                                    pushPath: false,
                                                                                    path: [
                                                                                           { tag: 'value',
                                                                                             value: { value: _descriptor_3.toValue(2n),
                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                           'size',
                                                                           { popeq: { cached: true,
                                                                                      result: undefined } }]).value);
      },
      member(...args_0) {
        if (args_0.length !== 1) {
          throw new __compactRuntime.CompactError(`member: expected 1 argument, received ${args_0.length}`);
        }
        const key_0 = args_0[0];
        if (!(typeof(key_0) === 'bigint' && key_0 >= 0n && key_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('member',
                                     'argument 1',
                                     'account.compact line 392 char 1',
                                     'Uint<0..18446744073709551616>',
                                     key_0)
        }
        return _descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                          partialProofData,
                                                                          [
                                                                           { dup: { n: 0 } },
                                                                           { idx: { cached: false,
                                                                                    pushPath: false,
                                                                                    path: [
                                                                                           { tag: 'value',
                                                                                             value: { value: _descriptor_3.toValue(2n),
                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                           { push: { storage: false,
                                                                                     value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(key_0),
                                                                                                                                  alignment: _descriptor_10.alignment() }).encode() } },
                                                                           'member',
                                                                           { popeq: { cached: true,
                                                                                      result: undefined } }]).value);
      },
      lookup(...args_0) {
        if (args_0.length !== 1) {
          throw new __compactRuntime.CompactError(`lookup: expected 1 argument, received ${args_0.length}`);
        }
        const key_0 = args_0[0];
        if (!(typeof(key_0) === 'bigint' && key_0 >= 0n && key_0 <= 18446744073709551615n)) {
          __compactRuntime.typeError('lookup',
                                     'argument 1',
                                     'account.compact line 392 char 1',
                                     'Uint<0..18446744073709551616>',
                                     key_0)
        }
        return _descriptor_7.fromValue(__compactRuntime.queryLedgerState(context,
                                                                         partialProofData,
                                                                         [
                                                                          { dup: { n: 0 } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_3.toValue(2n),
                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_10.toValue(key_0),
                                                                                                     alignment: _descriptor_10.alignment() } }] } },
                                                                          { popeq: { cached: false,
                                                                                     result: undefined } }]).value);
      },
      [Symbol.iterator](...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`iter: expected 0 arguments, received ${args_0.length}`);
        }
        const self_0 = state.asArray()[2];
        return self_0.asMap().keys().map(  (key) => {    const value = self_0.asMap().get(key).asCell();    return [      _descriptor_10.fromValue(key.value),      _descriptor_7.fromValue(value.value)    ];  })[Symbol.iterator]();
      }
    },
    get inbox_count() {
      return _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                        partialProofData,
                                                                        [
                                                                         { dup: { n: 0 } },
                                                                         { idx: { cached: false,
                                                                                  pushPath: false,
                                                                                  path: [
                                                                                         { tag: 'value',
                                                                                           value: { value: _descriptor_3.toValue(3n),
                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                         { popeq: { cached: false,
                                                                                    result: undefined } }]).value);
    },
    unshielded_balances: {
      isEmpty(...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`isEmpty: expected 0 arguments, received ${args_0.length}`);
        }
        return _descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                          partialProofData,
                                                                          [
                                                                           { dup: { n: 0 } },
                                                                           { idx: { cached: false,
                                                                                    pushPath: false,
                                                                                    path: [
                                                                                           { tag: 'value',
                                                                                             value: { value: _descriptor_3.toValue(4n),
                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                           'size',
                                                                           { push: { storage: false,
                                                                                     value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(0n),
                                                                                                                                  alignment: _descriptor_10.alignment() }).encode() } },
                                                                           'eq',
                                                                           { popeq: { cached: true,
                                                                                      result: undefined } }]).value);
      },
      size(...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`size: expected 0 arguments, received ${args_0.length}`);
        }
        return _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                          partialProofData,
                                                                          [
                                                                           { dup: { n: 0 } },
                                                                           { idx: { cached: false,
                                                                                    pushPath: false,
                                                                                    path: [
                                                                                           { tag: 'value',
                                                                                             value: { value: _descriptor_3.toValue(4n),
                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                           'size',
                                                                           { popeq: { cached: true,
                                                                                      result: undefined } }]).value);
      },
      member(...args_0) {
        if (args_0.length !== 1) {
          throw new __compactRuntime.CompactError(`member: expected 1 argument, received ${args_0.length}`);
        }
        const key_0 = args_0[0];
        if (!(key_0.buffer instanceof ArrayBuffer && key_0.BYTES_PER_ELEMENT === 1 && key_0.length === 32)) {
          __compactRuntime.typeError('member',
                                     'argument 1',
                                     'account.compact line 397 char 1',
                                     'Bytes<32>',
                                     key_0)
        }
        return _descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                          partialProofData,
                                                                          [
                                                                           { dup: { n: 0 } },
                                                                           { idx: { cached: false,
                                                                                    pushPath: false,
                                                                                    path: [
                                                                                           { tag: 'value',
                                                                                             value: { value: _descriptor_3.toValue(4n),
                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                           { push: { storage: false,
                                                                                     value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(key_0),
                                                                                                                                  alignment: _descriptor_0.alignment() }).encode() } },
                                                                           'member',
                                                                           { popeq: { cached: true,
                                                                                      result: undefined } }]).value);
      },
      lookup(...args_0) {
        if (args_0.length !== 1) {
          throw new __compactRuntime.CompactError(`lookup: expected 1 argument, received ${args_0.length}`);
        }
        const key_0 = args_0[0];
        if (!(key_0.buffer instanceof ArrayBuffer && key_0.BYTES_PER_ELEMENT === 1 && key_0.length === 32)) {
          __compactRuntime.typeError('lookup',
                                     'argument 1',
                                     'account.compact line 397 char 1',
                                     'Bytes<32>',
                                     key_0)
        }
        return _descriptor_8.fromValue(__compactRuntime.queryLedgerState(context,
                                                                         partialProofData,
                                                                         [
                                                                          { dup: { n: 0 } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_3.toValue(4n),
                                                                                                     alignment: _descriptor_3.alignment() } }] } },
                                                                          { idx: { cached: false,
                                                                                   pushPath: false,
                                                                                   path: [
                                                                                          { tag: 'value',
                                                                                            value: { value: _descriptor_0.toValue(key_0),
                                                                                                     alignment: _descriptor_0.alignment() } }] } },
                                                                          { popeq: { cached: false,
                                                                                     result: undefined } }]).value);
      },
      [Symbol.iterator](...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`iter: expected 0 arguments, received ${args_0.length}`);
        }
        const self_0 = state.asArray()[4];
        return self_0.asMap().keys().map(  (key) => {    const value = self_0.asMap().get(key).asCell();    return [      _descriptor_0.fromValue(key.value),      _descriptor_8.fromValue(value.value)    ];  })[Symbol.iterator]();
      }
    },
    get spec_version() {
      return _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                        partialProofData,
                                                                        [
                                                                         { dup: { n: 0 } },
                                                                         { idx: { cached: false,
                                                                                  pushPath: false,
                                                                                  path: [
                                                                                         { tag: 'value',
                                                                                           value: { value: _descriptor_3.toValue(5n),
                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                         { popeq: { cached: false,
                                                                                    result: undefined } }]).value);
    },
    devices: {
      isEmpty(...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`isEmpty: expected 0 arguments, received ${args_0.length}`);
        }
        return _descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                          partialProofData,
                                                                          [
                                                                           { dup: { n: 0 } },
                                                                           { idx: { cached: false,
                                                                                    pushPath: false,
                                                                                    path: [
                                                                                           { tag: 'value',
                                                                                             value: { value: _descriptor_3.toValue(6n),
                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                           'size',
                                                                           { push: { storage: false,
                                                                                     value: __compactRuntime.StateValue.newCell({ value: _descriptor_10.toValue(0n),
                                                                                                                                  alignment: _descriptor_10.alignment() }).encode() } },
                                                                           'eq',
                                                                           { popeq: { cached: true,
                                                                                      result: undefined } }]).value);
      },
      size(...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`size: expected 0 arguments, received ${args_0.length}`);
        }
        return _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                          partialProofData,
                                                                          [
                                                                           { dup: { n: 0 } },
                                                                           { idx: { cached: false,
                                                                                    pushPath: false,
                                                                                    path: [
                                                                                           { tag: 'value',
                                                                                             value: { value: _descriptor_3.toValue(6n),
                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                           'size',
                                                                           { popeq: { cached: true,
                                                                                      result: undefined } }]).value);
      },
      member(...args_0) {
        if (args_0.length !== 1) {
          throw new __compactRuntime.CompactError(`member: expected 1 argument, received ${args_0.length}`);
        }
        const elem_0 = args_0[0];
        if (!(elem_0.buffer instanceof ArrayBuffer && elem_0.BYTES_PER_ELEMENT === 1 && elem_0.length === 32)) {
          __compactRuntime.typeError('member',
                                     'argument 1',
                                     'account.compact line 406 char 1',
                                     'Bytes<32>',
                                     elem_0)
        }
        return _descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                          partialProofData,
                                                                          [
                                                                           { dup: { n: 0 } },
                                                                           { idx: { cached: false,
                                                                                    pushPath: false,
                                                                                    path: [
                                                                                           { tag: 'value',
                                                                                             value: { value: _descriptor_3.toValue(6n),
                                                                                                      alignment: _descriptor_3.alignment() } }] } },
                                                                           { push: { storage: false,
                                                                                     value: __compactRuntime.StateValue.newCell({ value: _descriptor_0.toValue(elem_0),
                                                                                                                                  alignment: _descriptor_0.alignment() }).encode() } },
                                                                           'member',
                                                                           { popeq: { cached: true,
                                                                                      result: undefined } }]).value);
      },
      [Symbol.iterator](...args_0) {
        if (args_0.length !== 0) {
          throw new __compactRuntime.CompactError(`iter: expected 0 arguments, received ${args_0.length}`);
        }
        const self_0 = state.asArray()[6];
        return self_0.asMap().keys().map((elem) => _descriptor_0.fromValue(elem.value))[Symbol.iterator]();
      }
    },
    get device_epoch() {
      return _descriptor_34.fromValue(__compactRuntime.queryLedgerState(context,
                                                                        partialProofData,
                                                                        [
                                                                         { dup: { n: 0 } },
                                                                         { idx: { cached: false,
                                                                                  pushPath: false,
                                                                                  path: [
                                                                                         { tag: 'value',
                                                                                           value: { value: _descriptor_3.toValue(7n),
                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                         { popeq: { cached: false,
                                                                                    result: undefined } }]).value);
    },
    get device_count() {
      return _descriptor_3.fromValue(__compactRuntime.queryLedgerState(context,
                                                                       partialProofData,
                                                                       [
                                                                        { dup: { n: 0 } },
                                                                        { idx: { cached: false,
                                                                                 pushPath: false,
                                                                                 path: [
                                                                                        { tag: 'value',
                                                                                          value: { value: _descriptor_3.toValue(8n),
                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                        { popeq: { cached: false,
                                                                                   result: undefined } }]).value);
    },
    get auth_nonce() {
      return _descriptor_10.fromValue(__compactRuntime.queryLedgerState(context,
                                                                        partialProofData,
                                                                        [
                                                                         { dup: { n: 0 } },
                                                                         { idx: { cached: false,
                                                                                  pushPath: false,
                                                                                  path: [
                                                                                         { tag: 'value',
                                                                                           value: { value: _descriptor_3.toValue(9n),
                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                         { popeq: { cached: false,
                                                                                    result: undefined } }]).value);
    },
    get boot() {
      return _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                       partialProofData,
                                                                       [
                                                                        { dup: { n: 0 } },
                                                                        { idx: { cached: false,
                                                                                 pushPath: false,
                                                                                 path: [
                                                                                        { tag: 'value',
                                                                                          value: { value: _descriptor_3.toValue(10n),
                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                        { popeq: { cached: false,
                                                                                   result: undefined } }]).value);
    },
    get booted() {
      return _descriptor_15.fromValue(__compactRuntime.queryLedgerState(context,
                                                                        partialProofData,
                                                                        [
                                                                         { dup: { n: 0 } },
                                                                         { idx: { cached: false,
                                                                                  pushPath: false,
                                                                                  path: [
                                                                                         { tag: 'value',
                                                                                           value: { value: _descriptor_3.toValue(11n),
                                                                                                    alignment: _descriptor_3.alignment() } }] } },
                                                                         { popeq: { cached: false,
                                                                                    result: undefined } }]).value);
    },
    get evm_domain_salt() {
      return _descriptor_0.fromValue(__compactRuntime.queryLedgerState(context,
                                                                       partialProofData,
                                                                       [
                                                                        { dup: { n: 0 } },
                                                                        { idx: { cached: false,
                                                                                 pushPath: false,
                                                                                 path: [
                                                                                        { tag: 'value',
                                                                                          value: { value: _descriptor_3.toValue(12n),
                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                        { popeq: { cached: false,
                                                                                   result: undefined } }]).value);
    },
    get vault() {
      return _descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                       partialProofData,
                                                                       [
                                                                        { dup: { n: 0 } },
                                                                        { idx: { cached: false,
                                                                                 pushPath: false,
                                                                                 path: [
                                                                                        { tag: 'value',
                                                                                          value: { value: _descriptor_3.toValue(13n),
                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                        { popeq: { cached: false,
                                                                                   result: undefined } }]).value);
    },
    get vault_address() {
      return _descriptor_1.fromValue(__compactRuntime.queryLedgerState(context,
                                                                       partialProofData,
                                                                       [
                                                                        { dup: { n: 0 } },
                                                                        { idx: { cached: false,
                                                                                 pushPath: false,
                                                                                 path: [
                                                                                        { tag: 'value',
                                                                                          value: { value: _descriptor_3.toValue(14n),
                                                                                                   alignment: _descriptor_3.alignment() } }] } },
                                                                        { popeq: { cached: false,
                                                                                   result: undefined } }]).value);
    }
  };
}
const _emptyContext = {
  callContext: { currentQueryContext: new __compactRuntime.QueryContext(new __compactRuntime.ContractState().data, __compactRuntime.dummyContractAddress()), currentGasCost: __compactRuntime.emptyRunningCost() }
};
const _dummyContract = new Contract({ held_coin: (...args) => undefined });
export const pureCircuits = {
  evm_account_alias: (...args_0) => {
    if (args_0.length !== 1) {
      throw new __compactRuntime.CompactError(`evm_account_alias: expected 1 argument (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_account_alias',
                                 'argument 1',
                                 'Eip712.compact line 202 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    return _dummyContract._evm_account_alias_0(account_0);
  },
  evm_domain_separator_for: (...args_0) => {
    if (args_0.length !== 2) {
      throw new __compactRuntime.CompactError(`evm_domain_separator_for: expected 2 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_domain_separator_for',
                                 'argument 1',
                                 'Eip712.compact line 209 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_domain_separator_for',
                                 'argument 2',
                                 'Eip712.compact line 209 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    return _dummyContract._evm_domain_separator_for_0(account_0, salt_0);
  },
  evm_struct_hash_withdraw_unshielded: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_withdraw_unshielded: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const recipient_0 = args_0[5];
    const challenge_0 = args_0[6];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 1',
                                 'Eip712.compact line 225 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 2',
                                 'Eip712.compact line 225 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 3',
                                 'Eip712.compact line 225 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 4',
                                 'Eip712.compact line 225 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 5',
                                 'Eip712.compact line 225 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 6',
                                 'Eip712.compact line 225 char 3',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_unshielded',
                                 'argument 7',
                                 'Eip712.compact line 225 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_withdraw_unshielded_0(account_0,
                                                                 owner_0,
                                                                 auth_nonce_value_0,
                                                                 color_0,
                                                                 amount_0,
                                                                 recipient_0,
                                                                 challenge_0);
  },
  evm_struct_hash_withdraw_shielded: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_withdraw_shielded: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const recipient_coin_public_key_0 = args_0[5];
    const challenge_0 = args_0[6];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 1',
                                 'Eip712.compact line 243 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 2',
                                 'Eip712.compact line 243 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 3',
                                 'Eip712.compact line 243 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 4',
                                 'Eip712.compact line 243 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 5',
                                 'Eip712.compact line 243 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(recipient_coin_public_key_0.buffer instanceof ArrayBuffer && recipient_coin_public_key_0.BYTES_PER_ELEMENT === 1 && recipient_coin_public_key_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 6',
                                 'Eip712.compact line 243 char 3',
                                 'Bytes<32>',
                                 recipient_coin_public_key_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded',
                                 'argument 7',
                                 'Eip712.compact line 243 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_withdraw_shielded_0(account_0,
                                                               owner_0,
                                                               auth_nonce_value_0,
                                                               color_0,
                                                               amount_0,
                                                               recipient_coin_public_key_0,
                                                               challenge_0);
  },
  evm_struct_hash_withdraw_shielded_to_contract: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_withdraw_shielded_to_contract: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const recipient_contract_0 = args_0[5];
    const challenge_0 = args_0[6];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 1',
                                 'Eip712.compact line 261 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 2',
                                 'Eip712.compact line 261 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 3',
                                 'Eip712.compact line 261 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 4',
                                 'Eip712.compact line 261 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 5',
                                 'Eip712.compact line 261 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(recipient_contract_0.buffer instanceof ArrayBuffer && recipient_contract_0.BYTES_PER_ELEMENT === 1 && recipient_contract_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 6',
                                 'Eip712.compact line 261 char 3',
                                 'Bytes<32>',
                                 recipient_contract_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_withdraw_shielded_to_contract',
                                 'argument 7',
                                 'Eip712.compact line 261 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_withdraw_shielded_to_contract_0(account_0,
                                                                           owner_0,
                                                                           auth_nonce_value_0,
                                                                           color_0,
                                                                           amount_0,
                                                                           recipient_contract_0,
                                                                           challenge_0);
  },
  evm_struct_hash_append_inbox: (...args_0) => {
    if (args_0.length !== 5) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_append_inbox: expected 5 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const entry_hash_0 = args_0[3];
    const challenge_0 = args_0[4];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_append_inbox',
                                 'argument 1',
                                 'Eip712.compact line 282 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_append_inbox',
                                 'argument 2',
                                 'Eip712.compact line 282 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_append_inbox',
                                 'argument 3',
                                 'Eip712.compact line 282 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(entry_hash_0.buffer instanceof ArrayBuffer && entry_hash_0.BYTES_PER_ELEMENT === 1 && entry_hash_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_append_inbox',
                                 'argument 4',
                                 'Eip712.compact line 282 char 3',
                                 'Bytes<32>',
                                 entry_hash_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_append_inbox',
                                 'argument 5',
                                 'Eip712.compact line 282 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_append_inbox_0(account_0,
                                                          owner_0,
                                                          auth_nonce_value_0,
                                                          entry_hash_0,
                                                          challenge_0);
  },
  evm_struct_hash_rotate_enc_key: (...args_0) => {
    if (args_0.length !== 5) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_rotate_enc_key: expected 5 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const new_key_0 = args_0[3];
    const challenge_0 = args_0[4];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_rotate_enc_key',
                                 'argument 1',
                                 'Eip712.compact line 297 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_rotate_enc_key',
                                 'argument 2',
                                 'Eip712.compact line 297 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_rotate_enc_key',
                                 'argument 3',
                                 'Eip712.compact line 297 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_rotate_enc_key',
                                 'argument 4',
                                 'Eip712.compact line 297 char 3',
                                 'Bytes<32>',
                                 new_key_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_rotate_enc_key',
                                 'argument 5',
                                 'Eip712.compact line 297 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_rotate_enc_key_0(account_0,
                                                            owner_0,
                                                            auth_nonce_value_0,
                                                            new_key_0,
                                                            challenge_0);
  },
  evm_struct_hash_add_device: (...args_0) => {
    if (args_0.length !== 5) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_add_device: expected 5 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const new_entry_0 = args_0[3];
    const challenge_0 = args_0[4];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_add_device',
                                 'argument 1',
                                 'Eip712.compact line 312 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_add_device',
                                 'argument 2',
                                 'Eip712.compact line 312 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_add_device',
                                 'argument 3',
                                 'Eip712.compact line 312 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_add_device',
                                 'argument 4',
                                 'Eip712.compact line 312 char 3',
                                 'Bytes<32>',
                                 new_entry_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_add_device',
                                 'argument 5',
                                 'Eip712.compact line 312 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_add_device_0(account_0,
                                                        owner_0,
                                                        auth_nonce_value_0,
                                                        new_entry_0,
                                                        challenge_0);
  },
  evm_struct_hash_remove_device: (...args_0) => {
    if (args_0.length !== 5) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_remove_device: expected 5 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const entry_0 = args_0[3];
    const challenge_0 = args_0[4];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_remove_device',
                                 'argument 1',
                                 'Eip712.compact line 327 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_remove_device',
                                 'argument 2',
                                 'Eip712.compact line 327 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_remove_device',
                                 'argument 3',
                                 'Eip712.compact line 327 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_remove_device',
                                 'argument 4',
                                 'Eip712.compact line 327 char 3',
                                 'Bytes<32>',
                                 entry_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_remove_device',
                                 'argument 5',
                                 'Eip712.compact line 327 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_remove_device_0(account_0,
                                                           owner_0,
                                                           auth_nonce_value_0,
                                                           entry_0,
                                                           challenge_0);
  },
  evm_struct_hash_open_swap_shielded: (...args_0) => {
    if (args_0.length !== 12) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_open_swap_shielded: expected 12 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const give_color_0 = args_0[3];
    const give_amount_0 = args_0[4];
    const recipient_kind_0 = args_0[5];
    const recipient_0 = args_0[6];
    const want_nonce_0 = args_0[7];
    const want_color_0 = args_0[8];
    const want_amount_0 = args_0[9];
    const valid_until_0 = args_0[10];
    const challenge_0 = args_0[11];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 1',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 2',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 3',
                                 'Eip712.compact line 353 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 4',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<32>',
                                 give_color_0)
    }
    if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 5',
                                 'Eip712.compact line 353 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 give_amount_0)
    }
    if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 6',
                                 'Eip712.compact line 353 char 3',
                                 'Uint<0..256>',
                                 recipient_kind_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 7',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(want_nonce_0.buffer instanceof ArrayBuffer && want_nonce_0.BYTES_PER_ELEMENT === 1 && want_nonce_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 8',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<32>',
                                 want_nonce_0)
    }
    if (!(want_color_0.buffer instanceof ArrayBuffer && want_color_0.BYTES_PER_ELEMENT === 1 && want_color_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 9',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<32>',
                                 want_color_0)
    }
    if (!(typeof(want_amount_0) === 'bigint' && want_amount_0 >= 0n && want_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 10',
                                 'Eip712.compact line 353 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 want_amount_0)
    }
    if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 11',
                                 'Eip712.compact line 353 char 3',
                                 'Uint<0..18446744073709551616>',
                                 valid_until_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_open_swap_shielded',
                                 'argument 12',
                                 'Eip712.compact line 353 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_open_swap_shielded_0(account_0,
                                                                owner_0,
                                                                auth_nonce_value_0,
                                                                give_color_0,
                                                                give_amount_0,
                                                                recipient_kind_0,
                                                                recipient_0,
                                                                want_nonce_0,
                                                                want_color_0,
                                                                want_amount_0,
                                                                valid_until_0,
                                                                challenge_0);
  },
  evm_struct_hash_bridge_deposit_start: (...args_0) => {
    if (args_0.length !== 11) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_bridge_deposit_start: expected 11 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const erc20_0 = args_0[3];
    const amount_0 = args_0[4];
    const evm_nonce_0 = args_0[5];
    const gas_limit_0 = args_0[6];
    const max_fee_0 = args_0[7];
    const max_priority_fee_0 = args_0[8];
    const key_version_0 = args_0[9];
    const challenge_0 = args_0[10];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 1',
                                 'Eip712.compact line 386 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 2',
                                 'Eip712.compact line 386 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 3',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(erc20_0.buffer instanceof ArrayBuffer && erc20_0.BYTES_PER_ELEMENT === 1 && erc20_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 4',
                                 'Eip712.compact line 386 char 3',
                                 'Bytes<20>',
                                 erc20_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 5',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 6',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..18446744073709551616>',
                                 evm_nonce_0)
    }
    if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 7',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..18446744073709551616>',
                                 gas_limit_0)
    }
    if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 8',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_fee_0)
    }
    if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 9',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_priority_fee_0)
    }
    if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 10',
                                 'Eip712.compact line 386 char 3',
                                 'Uint<0..256>',
                                 key_version_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_deposit_start',
                                 'argument 11',
                                 'Eip712.compact line 386 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_bridge_deposit_start_0(account_0,
                                                                  owner_0,
                                                                  auth_nonce_value_0,
                                                                  erc20_0,
                                                                  amount_0,
                                                                  evm_nonce_0,
                                                                  gas_limit_0,
                                                                  max_fee_0,
                                                                  max_priority_fee_0,
                                                                  key_version_0,
                                                                  challenge_0);
  },
  evm_struct_hash_bridge_withdraw_start: (...args_0) => {
    if (args_0.length !== 12) {
      throw new __compactRuntime.CompactError(`evm_struct_hash_bridge_withdraw_start: expected 12 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const owner_0 = args_0[1];
    const auth_nonce_value_0 = args_0[2];
    const dest_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const evm_nonce_0 = args_0[6];
    const gas_limit_0 = args_0[7];
    const max_fee_0 = args_0[8];
    const max_priority_fee_0 = args_0[9];
    const key_version_0 = args_0[10];
    const challenge_0 = args_0[11];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 1',
                                 'Eip712.compact line 415 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 2',
                                 'Eip712.compact line 415 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 3',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(dest_0.buffer instanceof ArrayBuffer && dest_0.BYTES_PER_ELEMENT === 1 && dest_0.length === 20)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 4',
                                 'Eip712.compact line 415 char 3',
                                 'Bytes<20>',
                                 dest_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 5',
                                 'Eip712.compact line 415 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 6',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 7',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..18446744073709551616>',
                                 evm_nonce_0)
    }
    if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 8',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..18446744073709551616>',
                                 gas_limit_0)
    }
    if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 9',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_fee_0)
    }
    if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 10',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_priority_fee_0)
    }
    if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 11',
                                 'Eip712.compact line 415 char 3',
                                 'Uint<0..256>',
                                 key_version_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_struct_hash_bridge_withdraw_start',
                                 'argument 12',
                                 'Eip712.compact line 415 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_struct_hash_bridge_withdraw_start_0(account_0,
                                                                   owner_0,
                                                                   auth_nonce_value_0,
                                                                   dest_0,
                                                                   color_0,
                                                                   amount_0,
                                                                   evm_nonce_0,
                                                                   gas_limit_0,
                                                                   max_fee_0,
                                                                   max_priority_fee_0,
                                                                   key_version_0,
                                                                   challenge_0);
  },
  evm_digest_withdraw_unshielded: (...args_0) => {
    if (args_0.length !== 8) {
      throw new __compactRuntime.CompactError(`evm_digest_withdraw_unshielded: expected 8 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const recipient_0 = args_0[6];
    const challenge_0 = args_0[7];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 1',
                                 'Eip712.compact line 447 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 2',
                                 'Eip712.compact line 447 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 3',
                                 'Eip712.compact line 447 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 4',
                                 'Eip712.compact line 447 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 5',
                                 'Eip712.compact line 447 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 6',
                                 'Eip712.compact line 447 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 7',
                                 'Eip712.compact line 447 char 3',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_unshielded',
                                 'argument 8',
                                 'Eip712.compact line 447 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_withdraw_unshielded_0(account_0,
                                                            salt_0,
                                                            owner_0,
                                                            auth_nonce_value_0,
                                                            color_0,
                                                            amount_0,
                                                            recipient_0,
                                                            challenge_0);
  },
  evm_digest_withdraw_shielded: (...args_0) => {
    if (args_0.length !== 8) {
      throw new __compactRuntime.CompactError(`evm_digest_withdraw_shielded: expected 8 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const recipient_coin_public_key_0 = args_0[6];
    const challenge_0 = args_0[7];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 1',
                                 'Eip712.compact line 463 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 2',
                                 'Eip712.compact line 463 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 3',
                                 'Eip712.compact line 463 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 4',
                                 'Eip712.compact line 463 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 5',
                                 'Eip712.compact line 463 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 6',
                                 'Eip712.compact line 463 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(recipient_coin_public_key_0.buffer instanceof ArrayBuffer && recipient_coin_public_key_0.BYTES_PER_ELEMENT === 1 && recipient_coin_public_key_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 7',
                                 'Eip712.compact line 463 char 3',
                                 'Bytes<32>',
                                 recipient_coin_public_key_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded',
                                 'argument 8',
                                 'Eip712.compact line 463 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_withdraw_shielded_0(account_0,
                                                          salt_0,
                                                          owner_0,
                                                          auth_nonce_value_0,
                                                          color_0,
                                                          amount_0,
                                                          recipient_coin_public_key_0,
                                                          challenge_0);
  },
  evm_digest_withdraw_shielded_to_contract: (...args_0) => {
    if (args_0.length !== 8) {
      throw new __compactRuntime.CompactError(`evm_digest_withdraw_shielded_to_contract: expected 8 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const recipient_contract_0 = args_0[6];
    const challenge_0 = args_0[7];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 1',
                                 'Eip712.compact line 479 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 2',
                                 'Eip712.compact line 479 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 3',
                                 'Eip712.compact line 479 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 4',
                                 'Eip712.compact line 479 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 5',
                                 'Eip712.compact line 479 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 6',
                                 'Eip712.compact line 479 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(recipient_contract_0.buffer instanceof ArrayBuffer && recipient_contract_0.BYTES_PER_ELEMENT === 1 && recipient_contract_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 7',
                                 'Eip712.compact line 479 char 3',
                                 'Bytes<32>',
                                 recipient_contract_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_withdraw_shielded_to_contract',
                                 'argument 8',
                                 'Eip712.compact line 479 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_withdraw_shielded_to_contract_0(account_0,
                                                                      salt_0,
                                                                      owner_0,
                                                                      auth_nonce_value_0,
                                                                      color_0,
                                                                      amount_0,
                                                                      recipient_contract_0,
                                                                      challenge_0);
  },
  evm_digest_append_inbox: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`evm_digest_append_inbox: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const entry_hash_0 = args_0[4];
    const challenge_0 = args_0[5];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_append_inbox',
                                 'argument 1',
                                 'Eip712.compact line 495 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_append_inbox',
                                 'argument 2',
                                 'Eip712.compact line 495 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_append_inbox',
                                 'argument 3',
                                 'Eip712.compact line 495 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_append_inbox',
                                 'argument 4',
                                 'Eip712.compact line 495 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(entry_hash_0.buffer instanceof ArrayBuffer && entry_hash_0.BYTES_PER_ELEMENT === 1 && entry_hash_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_append_inbox',
                                 'argument 5',
                                 'Eip712.compact line 495 char 3',
                                 'Bytes<32>',
                                 entry_hash_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_append_inbox',
                                 'argument 6',
                                 'Eip712.compact line 495 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_append_inbox_0(account_0,
                                                     salt_0,
                                                     owner_0,
                                                     auth_nonce_value_0,
                                                     entry_hash_0,
                                                     challenge_0);
  },
  evm_digest_rotate_enc_key: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`evm_digest_rotate_enc_key: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const new_key_0 = args_0[4];
    const challenge_0 = args_0[5];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_rotate_enc_key',
                                 'argument 1',
                                 'Eip712.compact line 509 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_rotate_enc_key',
                                 'argument 2',
                                 'Eip712.compact line 509 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_rotate_enc_key',
                                 'argument 3',
                                 'Eip712.compact line 509 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_rotate_enc_key',
                                 'argument 4',
                                 'Eip712.compact line 509 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_rotate_enc_key',
                                 'argument 5',
                                 'Eip712.compact line 509 char 3',
                                 'Bytes<32>',
                                 new_key_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_rotate_enc_key',
                                 'argument 6',
                                 'Eip712.compact line 509 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_rotate_enc_key_0(account_0,
                                                       salt_0,
                                                       owner_0,
                                                       auth_nonce_value_0,
                                                       new_key_0,
                                                       challenge_0);
  },
  evm_digest_add_device: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`evm_digest_add_device: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const new_entry_0 = args_0[4];
    const challenge_0 = args_0[5];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_add_device',
                                 'argument 1',
                                 'Eip712.compact line 523 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_add_device',
                                 'argument 2',
                                 'Eip712.compact line 523 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_add_device',
                                 'argument 3',
                                 'Eip712.compact line 523 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_add_device',
                                 'argument 4',
                                 'Eip712.compact line 523 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_add_device',
                                 'argument 5',
                                 'Eip712.compact line 523 char 3',
                                 'Bytes<32>',
                                 new_entry_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_add_device',
                                 'argument 6',
                                 'Eip712.compact line 523 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_add_device_0(account_0,
                                                   salt_0,
                                                   owner_0,
                                                   auth_nonce_value_0,
                                                   new_entry_0,
                                                   challenge_0);
  },
  evm_digest_open_swap_shielded: (...args_0) => {
    if (args_0.length !== 13) {
      throw new __compactRuntime.CompactError(`evm_digest_open_swap_shielded: expected 13 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const give_color_0 = args_0[4];
    const give_amount_0 = args_0[5];
    const recipient_kind_0 = args_0[6];
    const recipient_0 = args_0[7];
    const want_nonce_0 = args_0[8];
    const want_color_0 = args_0[9];
    const want_amount_0 = args_0[10];
    const valid_until_0 = args_0[11];
    const challenge_0 = args_0[12];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 1',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 2',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 3',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 4',
                                 'Eip712.compact line 537 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 5',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 give_color_0)
    }
    if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 6',
                                 'Eip712.compact line 537 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 give_amount_0)
    }
    if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 7',
                                 'Eip712.compact line 537 char 3',
                                 'Uint<0..256>',
                                 recipient_kind_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 8',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(want_nonce_0.buffer instanceof ArrayBuffer && want_nonce_0.BYTES_PER_ELEMENT === 1 && want_nonce_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 9',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 want_nonce_0)
    }
    if (!(want_color_0.buffer instanceof ArrayBuffer && want_color_0.BYTES_PER_ELEMENT === 1 && want_color_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 10',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 want_color_0)
    }
    if (!(typeof(want_amount_0) === 'bigint' && want_amount_0 >= 0n && want_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 11',
                                 'Eip712.compact line 537 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 want_amount_0)
    }
    if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 12',
                                 'Eip712.compact line 537 char 3',
                                 'Uint<0..18446744073709551616>',
                                 valid_until_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_open_swap_shielded',
                                 'argument 13',
                                 'Eip712.compact line 537 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_open_swap_shielded_0(account_0,
                                                           salt_0,
                                                           owner_0,
                                                           auth_nonce_value_0,
                                                           give_color_0,
                                                           give_amount_0,
                                                           recipient_kind_0,
                                                           recipient_0,
                                                           want_nonce_0,
                                                           want_color_0,
                                                           want_amount_0,
                                                           valid_until_0,
                                                           challenge_0);
  },
  evm_digest_remove_device: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`evm_digest_remove_device: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const entry_0 = args_0[4];
    const challenge_0 = args_0[5];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_remove_device',
                                 'argument 1',
                                 'Eip712.compact line 560 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_remove_device',
                                 'argument 2',
                                 'Eip712.compact line 560 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_remove_device',
                                 'argument 3',
                                 'Eip712.compact line 560 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_remove_device',
                                 'argument 4',
                                 'Eip712.compact line 560 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_remove_device',
                                 'argument 5',
                                 'Eip712.compact line 560 char 3',
                                 'Bytes<32>',
                                 entry_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_remove_device',
                                 'argument 6',
                                 'Eip712.compact line 560 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_remove_device_0(account_0,
                                                      salt_0,
                                                      owner_0,
                                                      auth_nonce_value_0,
                                                      entry_0,
                                                      challenge_0);
  },
  evm_digest_bridge_deposit_start: (...args_0) => {
    if (args_0.length !== 12) {
      throw new __compactRuntime.CompactError(`evm_digest_bridge_deposit_start: expected 12 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const erc20_0 = args_0[4];
    const amount_0 = args_0[5];
    const evm_nonce_0 = args_0[6];
    const gas_limit_0 = args_0[7];
    const max_fee_0 = args_0[8];
    const max_priority_fee_0 = args_0[9];
    const key_version_0 = args_0[10];
    const challenge_0 = args_0[11];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 1',
                                 'Eip712.compact line 574 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 2',
                                 'Eip712.compact line 574 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 3',
                                 'Eip712.compact line 574 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 4',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(erc20_0.buffer instanceof ArrayBuffer && erc20_0.BYTES_PER_ELEMENT === 1 && erc20_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 5',
                                 'Eip712.compact line 574 char 3',
                                 'Bytes<20>',
                                 erc20_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 6',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 7',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..18446744073709551616>',
                                 evm_nonce_0)
    }
    if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 8',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..18446744073709551616>',
                                 gas_limit_0)
    }
    if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 9',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_fee_0)
    }
    if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 10',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_priority_fee_0)
    }
    if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 11',
                                 'Eip712.compact line 574 char 3',
                                 'Uint<0..256>',
                                 key_version_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_deposit_start',
                                 'argument 12',
                                 'Eip712.compact line 574 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_bridge_deposit_start_0(account_0,
                                                             salt_0,
                                                             owner_0,
                                                             auth_nonce_value_0,
                                                             erc20_0,
                                                             amount_0,
                                                             evm_nonce_0,
                                                             gas_limit_0,
                                                             max_fee_0,
                                                             max_priority_fee_0,
                                                             key_version_0,
                                                             challenge_0);
  },
  evm_digest_bridge_withdraw_start: (...args_0) => {
    if (args_0.length !== 13) {
      throw new __compactRuntime.CompactError(`evm_digest_bridge_withdraw_start: expected 13 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const account_0 = args_0[0];
    const salt_0 = args_0[1];
    const owner_0 = args_0[2];
    const auth_nonce_value_0 = args_0[3];
    const dest_0 = args_0[4];
    const color_0 = args_0[5];
    const amount_0 = args_0[6];
    const evm_nonce_0 = args_0[7];
    const gas_limit_0 = args_0[8];
    const max_fee_0 = args_0[9];
    const max_priority_fee_0 = args_0[10];
    const key_version_0 = args_0[11];
    const challenge_0 = args_0[12];
    if (!(account_0.buffer instanceof ArrayBuffer && account_0.BYTES_PER_ELEMENT === 1 && account_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 1',
                                 'Eip712.compact line 595 char 3',
                                 'Bytes<32>',
                                 account_0)
    }
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 2',
                                 'Eip712.compact line 595 char 3',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(owner_0.buffer instanceof ArrayBuffer && owner_0.BYTES_PER_ELEMENT === 1 && owner_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 3',
                                 'Eip712.compact line 595 char 3',
                                 'Bytes<20>',
                                 owner_0)
    }
    if (!(typeof(auth_nonce_value_0) === 'bigint' && auth_nonce_value_0 >= 0n && auth_nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 4',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..18446744073709551616>',
                                 auth_nonce_value_0)
    }
    if (!(dest_0.buffer instanceof ArrayBuffer && dest_0.BYTES_PER_ELEMENT === 1 && dest_0.length === 20)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 5',
                                 'Eip712.compact line 595 char 3',
                                 'Bytes<20>',
                                 dest_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 6',
                                 'Eip712.compact line 595 char 3',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 7',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 8',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..18446744073709551616>',
                                 evm_nonce_0)
    }
    if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 9',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..18446744073709551616>',
                                 gas_limit_0)
    }
    if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 10',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_fee_0)
    }
    if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 11',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_priority_fee_0)
    }
    if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 12',
                                 'Eip712.compact line 595 char 3',
                                 'Uint<0..256>',
                                 key_version_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('evm_digest_bridge_withdraw_start',
                                 'argument 13',
                                 'Eip712.compact line 595 char 3',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._evm_digest_bridge_withdraw_start_0(account_0,
                                                              salt_0,
                                                              owner_0,
                                                              auth_nonce_value_0,
                                                              dest_0,
                                                              color_0,
                                                              amount_0,
                                                              evm_nonce_0,
                                                              gas_limit_0,
                                                              max_fee_0,
                                                              max_priority_fee_0,
                                                              key_version_0,
                                                              challenge_0);
  },
  zswapNullifierOf: (...args_0) => {
    if (args_0.length !== 2) {
      throw new __compactRuntime.CompactError(`zswapNullifierOf: expected 2 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const coin_0 = args_0[0];
    const addr_0 = args_0[1];
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('zswapNullifierOf',
                                 'argument 1',
                                 'ZswapPrimitives.compact line 91 char 3',
                                 'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                 coin_0)
    }
    if (!(typeof(addr_0) === 'object' && addr_0.bytes.buffer instanceof ArrayBuffer && addr_0.bytes.BYTES_PER_ELEMENT === 1 && addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('zswapNullifierOf',
                                 'argument 2',
                                 'ZswapPrimitives.compact line 91 char 3',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 addr_0)
    }
    return _dummyContract._zswapNullifierOf_0(coin_0, addr_0);
  },
  zswapCommitmentOf: (...args_0) => {
    if (args_0.length !== 2) {
      throw new __compactRuntime.CompactError(`zswapCommitmentOf: expected 2 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const coin_0 = args_0[0];
    const recipient_0 = args_0[1];
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('zswapCommitmentOf',
                                 'argument 1',
                                 'ZswapPrimitives.compact line 95 char 3',
                                 'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                 coin_0)
    }
    if (!(typeof(recipient_0) === 'object' && typeof(recipient_0.is_left) === 'boolean' && typeof(recipient_0.left) === 'object' && recipient_0.left.bytes.buffer instanceof ArrayBuffer && recipient_0.left.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.left.bytes.length === 32 && typeof(recipient_0.right) === 'object' && recipient_0.right.bytes.buffer instanceof ArrayBuffer && recipient_0.right.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.right.bytes.length === 32)) {
      __compactRuntime.typeError('zswapCommitmentOf',
                                 'argument 2',
                                 'ZswapPrimitives.compact line 95 char 3',
                                 'struct Either<is_left: Boolean, left: struct ZswapCoinPublicKey<bytes: Bytes<32>>, right: struct ContractAddress<bytes: Bytes<32>>>',
                                 recipient_0)
    }
    return _dummyContract._zswapCommitmentOf_0(coin_0, recipient_0);
  },
  derive_boot_commitment_with_jubjub: (...args_0) => {
    if (args_0.length !== 2) {
      throw new __compactRuntime.CompactError(`derive_boot_commitment_with_jubjub: expected 2 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const salt_0 = args_0[0];
    const pk_0 = args_0[1];
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('derive_boot_commitment_with_jubjub',
                                 'argument 1',
                                 'account.compact line 578 char 1',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('derive_boot_commitment_with_jubjub',
                                 'argument 2',
                                 'account.compact line 578 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    return _dummyContract._derive_boot_commitment_with_jubjub_0(salt_0, pk_0);
  },
  derive_boot_commitment_with_k256: (...args_0) => {
    if (args_0.length !== 3) {
      throw new __compactRuntime.CompactError(`derive_boot_commitment_with_k256: expected 3 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const salt_0 = args_0[0];
    const pk_0 = args_0[1];
    const envelope_0 = args_0[2];
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('derive_boot_commitment_with_k256',
                                 'argument 1',
                                 'account.compact line 589 char 1',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
      __compactRuntime.typeError('derive_boot_commitment_with_k256',
                                 'argument 2',
                                 'account.compact line 589 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
      __compactRuntime.typeError('derive_boot_commitment_with_k256',
                                 'argument 3',
                                 'account.compact line 589 char 1',
                                 'Uint<0..256>',
                                 envelope_0)
    }
    return _dummyContract._derive_boot_commitment_with_k256_0(salt_0,
                                                              pk_0,
                                                              envelope_0);
  },
  derive_boot_commitment_with_evm: (...args_0) => {
    if (args_0.length !== 2) {
      throw new __compactRuntime.CompactError(`derive_boot_commitment_with_evm: expected 2 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const salt_0 = args_0[0];
    const address_0 = args_0[1];
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('derive_boot_commitment_with_evm',
                                 'argument 1',
                                 'account.compact line 604 char 1',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('derive_boot_commitment_with_evm',
                                 'argument 2',
                                 'account.compact line 604 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    return _dummyContract._derive_boot_commitment_with_evm_0(salt_0, address_0);
  },
  derive_device_entry_with_jubjub: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`derive_device_entry_with_jubjub: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const epoch_0 = args_0[2];
    const counter_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('derive_device_entry_with_jubjub',
                                 'argument 1',
                                 'account.compact line 624 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('derive_device_entry_with_jubjub',
                                 'argument 2',
                                 'account.compact line 624 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(typeof(epoch_0) === 'bigint' && epoch_0 >= 0n && epoch_0 <= 4294967295n)) {
      __compactRuntime.typeError('derive_device_entry_with_jubjub',
                                 'argument 3',
                                 'account.compact line 624 char 1',
                                 'Uint<0..4294967296>',
                                 epoch_0)
    }
    if (!(typeof(counter_0) === 'bigint' && counter_0 >= 0n && counter_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('derive_device_entry_with_jubjub',
                                 'argument 4',
                                 'account.compact line 624 char 1',
                                 'Uint<0..18446744073709551616>',
                                 counter_0)
    }
    return _dummyContract._derive_device_entry_with_jubjub_0(self_addr_0,
                                                             pk_0,
                                                             epoch_0,
                                                             counter_0);
  },
  derive_device_entry_with_k256: (...args_0) => {
    if (args_0.length !== 5) {
      throw new __compactRuntime.CompactError(`derive_device_entry_with_k256: expected 5 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const envelope_0 = args_0[2];
    const epoch_0 = args_0[3];
    const counter_0 = args_0[4];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('derive_device_entry_with_k256',
                                 'argument 1',
                                 'account.compact line 649 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
      __compactRuntime.typeError('derive_device_entry_with_k256',
                                 'argument 2',
                                 'account.compact line 649 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
      __compactRuntime.typeError('derive_device_entry_with_k256',
                                 'argument 3',
                                 'account.compact line 649 char 1',
                                 'Uint<0..256>',
                                 envelope_0)
    }
    if (!(typeof(epoch_0) === 'bigint' && epoch_0 >= 0n && epoch_0 <= 4294967295n)) {
      __compactRuntime.typeError('derive_device_entry_with_k256',
                                 'argument 4',
                                 'account.compact line 649 char 1',
                                 'Uint<0..4294967296>',
                                 epoch_0)
    }
    if (!(typeof(counter_0) === 'bigint' && counter_0 >= 0n && counter_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('derive_device_entry_with_k256',
                                 'argument 5',
                                 'account.compact line 649 char 1',
                                 'Uint<0..18446744073709551616>',
                                 counter_0)
    }
    return _dummyContract._derive_device_entry_with_k256_0(self_addr_0,
                                                           pk_0,
                                                           envelope_0,
                                                           epoch_0,
                                                           counter_0);
  },
  derive_device_entry_with_evm: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`derive_device_entry_with_evm: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const epoch_0 = args_0[2];
    const counter_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('derive_device_entry_with_evm',
                                 'argument 1',
                                 'account.compact line 682 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('derive_device_entry_with_evm',
                                 'argument 2',
                                 'account.compact line 682 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(typeof(epoch_0) === 'bigint' && epoch_0 >= 0n && epoch_0 <= 4294967295n)) {
      __compactRuntime.typeError('derive_device_entry_with_evm',
                                 'argument 3',
                                 'account.compact line 682 char 1',
                                 'Uint<0..4294967296>',
                                 epoch_0)
    }
    if (!(typeof(counter_0) === 'bigint' && counter_0 >= 0n && counter_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('derive_device_entry_with_evm',
                                 'argument 4',
                                 'account.compact line 682 char 1',
                                 'Uint<0..18446744073709551616>',
                                 counter_0)
    }
    return _dummyContract._derive_device_entry_with_evm_0(self_addr_0,
                                                          address_0,
                                                          epoch_0,
                                                          counter_0);
  },
  envelope_digest: (...args_0) => {
    if (args_0.length !== 2) {
      throw new __compactRuntime.CompactError(`envelope_digest: expected 2 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const envelope_0 = args_0[0];
    const challenge_0 = args_0[1];
    if (!(typeof(envelope_0) === 'bigint' && envelope_0 >= 0n && envelope_0 <= 255n)) {
      __compactRuntime.typeError('envelope_digest',
                                 'argument 1',
                                 'account.compact line 728 char 1',
                                 'Uint<0..256>',
                                 envelope_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('envelope_digest',
                                 'argument 2',
                                 'account.compact line 728 char 1',
                                 'Bytes<32>',
                                 challenge_0)
    }
    return _dummyContract._envelope_digest_0(envelope_0, challenge_0);
  },
  compute_public_point_with_jubjub: (...args_0) => {
    if (args_0.length !== 1) {
      throw new __compactRuntime.CompactError(`compute_public_point_with_jubjub: expected 1 argument (as invoked from Typescript), received ${args_0.length}`);
    }
    const scalar_0 = args_0[0];
    if (!(typeof(scalar_0) === 'bigint' && scalar_0 >= 0 && scalar_0 <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('compute_public_point_with_jubjub',
                                 'argument 1',
                                 'account.compact line 741 char 1',
                                 'Field',
                                 scalar_0)
    }
    return _dummyContract._compute_public_point_with_jubjub_0(scalar_0);
  },
  compute_public_point_with_k256: (...args_0) => {
    if (args_0.length !== 1) {
      throw new __compactRuntime.CompactError(`compute_public_point_with_k256: expected 1 argument (as invoked from Typescript), received ${args_0.length}`);
    }
    const scalar_0 = args_0[0];
    if (!(typeof(scalar_0) === 'bigint' && scalar_0 >= 0 && scalar_0 <= __compactRuntime.MAX_SECP256K1_SCALAR)) {
      __compactRuntime.typeError('compute_public_point_with_k256',
                                 'argument 1',
                                 'account.compact line 745 char 1',
                                 'Secp256k1Scalar',
                                 scalar_0)
    }
    return _dummyContract._compute_public_point_with_k256_0(scalar_0);
  },
  challenge_withdraw_unshielded_with_jubjub: (...args_0) => {
    if (args_0.length !== 8) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_unshielded_with_jubjub: expected 8 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const recipient_0 = args_0[5];
    const nonce_value_0 = args_0[6];
    const grind_nonce_0 = args_0[7];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 1',
                                 'account.compact line 762 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 2',
                                 'account.compact line 762 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 3',
                                 'account.compact line 762 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 4',
                                 'account.compact line 762 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 5',
                                 'account.compact line 762 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 6',
                                 'account.compact line 762 char 1',
                                 'struct UserAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 7',
                                 'account.compact line 762 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_jubjub',
                                 'argument 8',
                                 'account.compact line 762 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_withdraw_unshielded_with_jubjub_0(self_addr_0,
                                                                       sig_r_0,
                                                                       pk_0,
                                                                       color_0,
                                                                       amount_0,
                                                                       recipient_0,
                                                                       nonce_value_0,
                                                                       grind_nonce_0);
  },
  challenge_withdraw_shielded_with_jubjub: (...args_0) => {
    if (args_0.length !== 9) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_with_jubjub: expected 9 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const recipient_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const coin_0 = args_0[6];
    const nonce_value_0 = args_0[7];
    const grind_nonce_0 = args_0[8];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 1',
                                 'account.compact line 784 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 2',
                                 'account.compact line 784 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 3',
                                 'account.compact line 784 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 4',
                                 'account.compact line 784 char 1',
                                 'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 5',
                                 'account.compact line 784 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 6',
                                 'account.compact line 784 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 7',
                                 'account.compact line 784 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 8',
                                 'account.compact line 784 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_jubjub',
                                 'argument 9',
                                 'account.compact line 784 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_withdraw_shielded_with_jubjub_0(self_addr_0,
                                                                     sig_r_0,
                                                                     pk_0,
                                                                     recipient_0,
                                                                     color_0,
                                                                     amount_0,
                                                                     coin_0,
                                                                     nonce_value_0,
                                                                     grind_nonce_0);
  },
  challenge_withdraw_shielded_to_contract_with_jubjub: (...args_0) => {
    if (args_0.length !== 9) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_to_contract_with_jubjub: expected 9 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const recipient_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const coin_0 = args_0[6];
    const nonce_value_0 = args_0[7];
    const grind_nonce_0 = args_0[8];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 1',
                                 'account.compact line 803 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 2',
                                 'account.compact line 803 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 3',
                                 'account.compact line 803 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 4',
                                 'account.compact line 803 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 5',
                                 'account.compact line 803 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 6',
                                 'account.compact line 803 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 7',
                                 'account.compact line 803 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 8',
                                 'account.compact line 803 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_jubjub',
                                 'argument 9',
                                 'account.compact line 803 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_withdraw_shielded_to_contract_with_jubjub_0(self_addr_0,
                                                                                 sig_r_0,
                                                                                 pk_0,
                                                                                 recipient_0,
                                                                                 color_0,
                                                                                 amount_0,
                                                                                 coin_0,
                                                                                 nonce_value_0,
                                                                                 grind_nonce_0);
  },
  challenge_append_inbox_with_jubjub: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`challenge_append_inbox_with_jubjub: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const entry_0 = args_0[3];
    const nonce_value_0 = args_0[4];
    const grind_nonce_0 = args_0[5];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_append_inbox_with_jubjub',
                                 'argument 1',
                                 'account.compact line 822 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_append_inbox_with_jubjub',
                                 'argument 2',
                                 'account.compact line 822 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_append_inbox_with_jubjub',
                                 'argument 3',
                                 'account.compact line 822 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_append_inbox_with_jubjub',
                                 'argument 4',
                                 'account.compact line 822 char 1',
                                 'Bytes<192>',
                                 entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_append_inbox_with_jubjub',
                                 'argument 5',
                                 'account.compact line 822 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_append_inbox_with_jubjub',
                                 'argument 6',
                                 'account.compact line 822 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_append_inbox_with_jubjub_0(self_addr_0,
                                                                sig_r_0,
                                                                pk_0,
                                                                entry_0,
                                                                nonce_value_0,
                                                                grind_nonce_0);
  },
  challenge_rotate_enc_key_with_jubjub: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`challenge_rotate_enc_key_with_jubjub: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const new_key_0 = args_0[3];
    const nonce_value_0 = args_0[4];
    const grind_nonce_0 = args_0[5];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_jubjub',
                                 'argument 1',
                                 'account.compact line 838 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_jubjub',
                                 'argument 2',
                                 'account.compact line 838 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_jubjub',
                                 'argument 3',
                                 'account.compact line 838 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_jubjub',
                                 'argument 4',
                                 'account.compact line 838 char 1',
                                 'Bytes<32>',
                                 new_key_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_jubjub',
                                 'argument 5',
                                 'account.compact line 838 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_jubjub',
                                 'argument 6',
                                 'account.compact line 838 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_rotate_enc_key_with_jubjub_0(self_addr_0,
                                                                  sig_r_0,
                                                                  pk_0,
                                                                  new_key_0,
                                                                  nonce_value_0,
                                                                  grind_nonce_0);
  },
  challenge_add_device_with_jubjub: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`challenge_add_device_with_jubjub: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const new_entry_0 = args_0[3];
    const nonce_value_0 = args_0[4];
    const grind_nonce_0 = args_0[5];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_add_device_with_jubjub',
                                 'argument 1',
                                 'account.compact line 858 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_add_device_with_jubjub',
                                 'argument 2',
                                 'account.compact line 858 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_add_device_with_jubjub',
                                 'argument 3',
                                 'account.compact line 858 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
      __compactRuntime.typeError('challenge_add_device_with_jubjub',
                                 'argument 4',
                                 'account.compact line 858 char 1',
                                 'Bytes<32>',
                                 new_entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_add_device_with_jubjub',
                                 'argument 5',
                                 'account.compact line 858 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_add_device_with_jubjub',
                                 'argument 6',
                                 'account.compact line 858 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_add_device_with_jubjub_0(self_addr_0,
                                                              sig_r_0,
                                                              pk_0,
                                                              new_entry_0,
                                                              nonce_value_0,
                                                              grind_nonce_0);
  },
  challenge_remove_device_with_jubjub: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`challenge_remove_device_with_jubjub: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const entry_0 = args_0[3];
    const nonce_value_0 = args_0[4];
    const grind_nonce_0 = args_0[5];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_remove_device_with_jubjub',
                                 'argument 1',
                                 'account.compact line 874 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_remove_device_with_jubjub',
                                 'argument 2',
                                 'account.compact line 874 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_remove_device_with_jubjub',
                                 'argument 3',
                                 'account.compact line 874 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
      __compactRuntime.typeError('challenge_remove_device_with_jubjub',
                                 'argument 4',
                                 'account.compact line 874 char 1',
                                 'Bytes<32>',
                                 entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_remove_device_with_jubjub',
                                 'argument 5',
                                 'account.compact line 874 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_remove_device_with_jubjub',
                                 'argument 6',
                                 'account.compact line 874 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_remove_device_with_jubjub_0(self_addr_0,
                                                                 sig_r_0,
                                                                 pk_0,
                                                                 entry_0,
                                                                 nonce_value_0,
                                                                 grind_nonce_0);
  },
  challenge_open_swap_shielded_with_jubjub: (...args_0) => {
    if (args_0.length !== 14) {
      throw new __compactRuntime.CompactError(`challenge_open_swap_shielded_with_jubjub: expected 14 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const sig_r_0 = args_0[1];
    const pk_0 = args_0[2];
    const give_color_0 = args_0[3];
    const give_amount_0 = args_0[4];
    const recipient_kind_0 = args_0[5];
    const recipient_0 = args_0[6];
    const want_0 = args_0[7];
    const want_entry_0 = args_0[8];
    const change_entry_0 = args_0[9];
    const valid_until_0 = args_0[10];
    const coin_0 = args_0[11];
    const nonce_value_0 = args_0[12];
    const grind_nonce_0 = args_0[13];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 1',
                                 'account.compact line 895 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(typeof(sig_r_0.x) === 'bigint' && sig_r_0.x >= 0n && sig_r_0.x <= __compactRuntime.MAX_FIELD && typeof(sig_r_0.y) === 'bigint' && sig_r_0.y >= 0n && sig_r_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 2',
                                 'account.compact line 895 char 1',
                                 'JubjubPoint',
                                 sig_r_0)
    }
    if (!(typeof(pk_0.x) === 'bigint' && pk_0.x >= 0n && pk_0.x <= __compactRuntime.MAX_FIELD && typeof(pk_0.y) === 'bigint' && pk_0.y >= 0n && pk_0.y <= __compactRuntime.MAX_FIELD)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 3',
                                 'account.compact line 895 char 1',
                                 'JubjubPoint',
                                 pk_0)
    }
    if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 4',
                                 'account.compact line 895 char 1',
                                 'Bytes<32>',
                                 give_color_0)
    }
    if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 5',
                                 'account.compact line 895 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 give_amount_0)
    }
    if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 6',
                                 'account.compact line 895 char 1',
                                 'Uint<0..256>',
                                 recipient_kind_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 7',
                                 'account.compact line 895 char 1',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(typeof(want_0) === 'object' && want_0.nonce.buffer instanceof ArrayBuffer && want_0.nonce.BYTES_PER_ELEMENT === 1 && want_0.nonce.length === 32 && want_0.color.buffer instanceof ArrayBuffer && want_0.color.BYTES_PER_ELEMENT === 1 && want_0.color.length === 32 && typeof(want_0.value) === 'bigint' && want_0.value >= 0n && want_0.value <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 8',
                                 'account.compact line 895 char 1',
                                 'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                 want_0)
    }
    if (!(want_entry_0.buffer instanceof ArrayBuffer && want_entry_0.BYTES_PER_ELEMENT === 1 && want_entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 9',
                                 'account.compact line 895 char 1',
                                 'Bytes<192>',
                                 want_entry_0)
    }
    if (!(change_entry_0.buffer instanceof ArrayBuffer && change_entry_0.BYTES_PER_ELEMENT === 1 && change_entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 10',
                                 'account.compact line 895 char 1',
                                 'Bytes<192>',
                                 change_entry_0)
    }
    if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 11',
                                 'account.compact line 895 char 1',
                                 'Uint<0..18446744073709551616>',
                                 valid_until_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 12',
                                 'account.compact line 895 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 13',
                                 'account.compact line 895 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(grind_nonce_0) === 'bigint' && grind_nonce_0 >= 0n && grind_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_jubjub',
                                 'argument 14',
                                 'account.compact line 895 char 1',
                                 'Uint<0..18446744073709551616>',
                                 grind_nonce_0)
    }
    return _dummyContract._challenge_open_swap_shielded_with_jubjub_0(self_addr_0,
                                                                      sig_r_0,
                                                                      pk_0,
                                                                      give_color_0,
                                                                      give_amount_0,
                                                                      recipient_kind_0,
                                                                      recipient_0,
                                                                      want_0,
                                                                      want_entry_0,
                                                                      change_entry_0,
                                                                      valid_until_0,
                                                                      coin_0,
                                                                      nonce_value_0,
                                                                      grind_nonce_0);
  },
  challenge_withdraw_unshielded_with_k256: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_unshielded_with_k256: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const color_0 = args_0[2];
    const amount_0 = args_0[3];
    const recipient_0 = args_0[4];
    const nonce_value_0 = args_0[5];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_k256',
                                 'argument 1',
                                 'account.compact line 929 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_k256',
                                 'argument 2',
                                 'account.compact line 929 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_k256',
                                 'argument 3',
                                 'account.compact line 929 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_k256',
                                 'argument 4',
                                 'account.compact line 929 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_k256',
                                 'argument 5',
                                 'account.compact line 929 char 1',
                                 'struct UserAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_k256',
                                 'argument 6',
                                 'account.compact line 929 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_unshielded_with_k256_0(self_addr_0,
                                                                     pk_0,
                                                                     color_0,
                                                                     amount_0,
                                                                     recipient_0,
                                                                     nonce_value_0);
  },
  challenge_withdraw_shielded_with_k256: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_with_k256: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const recipient_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const coin_0 = args_0[5];
    const nonce_value_0 = args_0[6];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 1',
                                 'account.compact line 947 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 2',
                                 'account.compact line 947 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 3',
                                 'account.compact line 947 char 1',
                                 'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 4',
                                 'account.compact line 947 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 5',
                                 'account.compact line 947 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 6',
                                 'account.compact line 947 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_k256',
                                 'argument 7',
                                 'account.compact line 947 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_shielded_with_k256_0(self_addr_0,
                                                                   pk_0,
                                                                   recipient_0,
                                                                   color_0,
                                                                   amount_0,
                                                                   coin_0,
                                                                   nonce_value_0);
  },
  challenge_withdraw_shielded_to_contract_with_k256: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_to_contract_with_k256: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const recipient_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const coin_0 = args_0[5];
    const nonce_value_0 = args_0[6];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 1',
                                 'account.compact line 966 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 2',
                                 'account.compact line 966 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 3',
                                 'account.compact line 966 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 4',
                                 'account.compact line 966 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 5',
                                 'account.compact line 966 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 6',
                                 'account.compact line 966 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_k256',
                                 'argument 7',
                                 'account.compact line 966 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_shielded_to_contract_with_k256_0(self_addr_0,
                                                                               pk_0,
                                                                               recipient_0,
                                                                               color_0,
                                                                               amount_0,
                                                                               coin_0,
                                                                               nonce_value_0);
  },
  challenge_append_inbox_with_k256: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_append_inbox_with_k256: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const entry_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_append_inbox_with_k256',
                                 'argument 1',
                                 'account.compact line 985 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
      __compactRuntime.typeError('challenge_append_inbox_with_k256',
                                 'argument 2',
                                 'account.compact line 985 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_append_inbox_with_k256',
                                 'argument 3',
                                 'account.compact line 985 char 1',
                                 'Bytes<192>',
                                 entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_append_inbox_with_k256',
                                 'argument 4',
                                 'account.compact line 985 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_append_inbox_with_k256_0(self_addr_0,
                                                              pk_0,
                                                              entry_0,
                                                              nonce_value_0);
  },
  challenge_rotate_enc_key_with_k256: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_rotate_enc_key_with_k256: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const new_key_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_k256',
                                 'argument 1',
                                 'account.compact line 1001 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_k256',
                                 'argument 2',
                                 'account.compact line 1001 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_k256',
                                 'argument 3',
                                 'account.compact line 1001 char 1',
                                 'Bytes<32>',
                                 new_key_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_k256',
                                 'argument 4',
                                 'account.compact line 1001 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_rotate_enc_key_with_k256_0(self_addr_0,
                                                                pk_0,
                                                                new_key_0,
                                                                nonce_value_0);
  },
  challenge_add_device_with_k256: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_add_device_with_k256: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const new_entry_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_add_device_with_k256',
                                 'argument 1',
                                 'account.compact line 1017 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
      __compactRuntime.typeError('challenge_add_device_with_k256',
                                 'argument 2',
                                 'account.compact line 1017 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
      __compactRuntime.typeError('challenge_add_device_with_k256',
                                 'argument 3',
                                 'account.compact line 1017 char 1',
                                 'Bytes<32>',
                                 new_entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_add_device_with_k256',
                                 'argument 4',
                                 'account.compact line 1017 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_add_device_with_k256_0(self_addr_0,
                                                            pk_0,
                                                            new_entry_0,
                                                            nonce_value_0);
  },
  challenge_remove_device_with_k256: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_remove_device_with_k256: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const entry_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_remove_device_with_k256',
                                 'argument 1',
                                 'account.compact line 1033 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidSecp256k1Point(pk_0))) {
      __compactRuntime.typeError('challenge_remove_device_with_k256',
                                 'argument 2',
                                 'account.compact line 1033 char 1',
                                 'Secp256k1Point',
                                 pk_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
      __compactRuntime.typeError('challenge_remove_device_with_k256',
                                 'argument 3',
                                 'account.compact line 1033 char 1',
                                 'Bytes<32>',
                                 entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_remove_device_with_k256',
                                 'argument 4',
                                 'account.compact line 1033 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_remove_device_with_k256_0(self_addr_0,
                                                               pk_0,
                                                               entry_0,
                                                               nonce_value_0);
  },
  challenge_withdraw_unshielded_with_evm: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_unshielded_with_evm: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const color_0 = args_0[2];
    const amount_0 = args_0[3];
    const recipient_0 = args_0[4];
    const nonce_value_0 = args_0[5];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_evm',
                                 'argument 1',
                                 'account.compact line 1065 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_evm',
                                 'argument 2',
                                 'account.compact line 1065 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_evm',
                                 'argument 3',
                                 'account.compact line 1065 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_evm',
                                 'argument 4',
                                 'account.compact line 1065 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_evm',
                                 'argument 5',
                                 'account.compact line 1065 char 1',
                                 'struct UserAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_evm',
                                 'argument 6',
                                 'account.compact line 1065 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_unshielded_with_evm_0(self_addr_0,
                                                                    address_0,
                                                                    color_0,
                                                                    amount_0,
                                                                    recipient_0,
                                                                    nonce_value_0);
  },
  challenge_withdraw_shielded_with_evm: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_with_evm: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const recipient_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const coin_0 = args_0[5];
    const nonce_value_0 = args_0[6];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 1',
                                 'account.compact line 1081 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 2',
                                 'account.compact line 1081 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 3',
                                 'account.compact line 1081 char 1',
                                 'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 4',
                                 'account.compact line 1081 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 5',
                                 'account.compact line 1081 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 6',
                                 'account.compact line 1081 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_evm',
                                 'argument 7',
                                 'account.compact line 1081 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_shielded_with_evm_0(self_addr_0,
                                                                  address_0,
                                                                  recipient_0,
                                                                  color_0,
                                                                  amount_0,
                                                                  coin_0,
                                                                  nonce_value_0);
  },
  challenge_withdraw_shielded_to_contract_with_evm: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_to_contract_with_evm: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const recipient_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const coin_0 = args_0[5];
    const nonce_value_0 = args_0[6];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 1',
                                 'account.compact line 1098 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 2',
                                 'account.compact line 1098 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 3',
                                 'account.compact line 1098 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 4',
                                 'account.compact line 1098 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 5',
                                 'account.compact line 1098 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 6',
                                 'account.compact line 1098 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_evm',
                                 'argument 7',
                                 'account.compact line 1098 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_shielded_to_contract_with_evm_0(self_addr_0,
                                                                              address_0,
                                                                              recipient_0,
                                                                              color_0,
                                                                              amount_0,
                                                                              coin_0,
                                                                              nonce_value_0);
  },
  challenge_append_inbox_with_evm: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_append_inbox_with_evm: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const entry_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_append_inbox_with_evm',
                                 'argument 1',
                                 'account.compact line 1115 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_append_inbox_with_evm',
                                 'argument 2',
                                 'account.compact line 1115 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_append_inbox_with_evm',
                                 'argument 3',
                                 'account.compact line 1115 char 1',
                                 'Bytes<192>',
                                 entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_append_inbox_with_evm',
                                 'argument 4',
                                 'account.compact line 1115 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_append_inbox_with_evm_0(self_addr_0,
                                                             address_0,
                                                             entry_0,
                                                             nonce_value_0);
  },
  challenge_rotate_enc_key_with_evm: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_rotate_enc_key_with_evm: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const new_key_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_evm',
                                 'argument 1',
                                 'account.compact line 1129 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_evm',
                                 'argument 2',
                                 'account.compact line 1129 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_evm',
                                 'argument 3',
                                 'account.compact line 1129 char 1',
                                 'Bytes<32>',
                                 new_key_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_evm',
                                 'argument 4',
                                 'account.compact line 1129 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_rotate_enc_key_with_evm_0(self_addr_0,
                                                               address_0,
                                                               new_key_0,
                                                               nonce_value_0);
  },
  challenge_add_device_with_evm: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_add_device_with_evm: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const new_entry_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_add_device_with_evm',
                                 'argument 1',
                                 'account.compact line 1143 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_add_device_with_evm',
                                 'argument 2',
                                 'account.compact line 1143 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(new_entry_0.buffer instanceof ArrayBuffer && new_entry_0.BYTES_PER_ELEMENT === 1 && new_entry_0.length === 32)) {
      __compactRuntime.typeError('challenge_add_device_with_evm',
                                 'argument 3',
                                 'account.compact line 1143 char 1',
                                 'Bytes<32>',
                                 new_entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_add_device_with_evm',
                                 'argument 4',
                                 'account.compact line 1143 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_add_device_with_evm_0(self_addr_0,
                                                           address_0,
                                                           new_entry_0,
                                                           nonce_value_0);
  },
  challenge_remove_device_with_evm: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`challenge_remove_device_with_evm: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const entry_0 = args_0[2];
    const nonce_value_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_remove_device_with_evm',
                                 'argument 1',
                                 'account.compact line 1157 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_remove_device_with_evm',
                                 'argument 2',
                                 'account.compact line 1157 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 32)) {
      __compactRuntime.typeError('challenge_remove_device_with_evm',
                                 'argument 3',
                                 'account.compact line 1157 char 1',
                                 'Bytes<32>',
                                 entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_remove_device_with_evm',
                                 'argument 4',
                                 'account.compact line 1157 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_remove_device_with_evm_0(self_addr_0,
                                                              address_0,
                                                              entry_0,
                                                              nonce_value_0);
  },
  challenge_open_swap_shielded_with_evm: (...args_0) => {
    if (args_0.length !== 12) {
      throw new __compactRuntime.CompactError(`challenge_open_swap_shielded_with_evm: expected 12 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const give_color_0 = args_0[2];
    const give_amount_0 = args_0[3];
    const recipient_kind_0 = args_0[4];
    const recipient_0 = args_0[5];
    const want_0 = args_0[6];
    const want_entry_0 = args_0[7];
    const change_entry_0 = args_0[8];
    const valid_until_0 = args_0[9];
    const coin_0 = args_0[10];
    const nonce_value_0 = args_0[11];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 1',
                                 'account.compact line 1176 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 2',
                                 'account.compact line 1176 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 3',
                                 'account.compact line 1176 char 1',
                                 'Bytes<32>',
                                 give_color_0)
    }
    if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 4',
                                 'account.compact line 1176 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 give_amount_0)
    }
    if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 5',
                                 'account.compact line 1176 char 1',
                                 'Uint<0..256>',
                                 recipient_kind_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 6',
                                 'account.compact line 1176 char 1',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(typeof(want_0) === 'object' && want_0.nonce.buffer instanceof ArrayBuffer && want_0.nonce.BYTES_PER_ELEMENT === 1 && want_0.nonce.length === 32 && want_0.color.buffer instanceof ArrayBuffer && want_0.color.BYTES_PER_ELEMENT === 1 && want_0.color.length === 32 && typeof(want_0.value) === 'bigint' && want_0.value >= 0n && want_0.value <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 7',
                                 'account.compact line 1176 char 1',
                                 'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                 want_0)
    }
    if (!(want_entry_0.buffer instanceof ArrayBuffer && want_entry_0.BYTES_PER_ELEMENT === 1 && want_entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 8',
                                 'account.compact line 1176 char 1',
                                 'Bytes<192>',
                                 want_entry_0)
    }
    if (!(change_entry_0.buffer instanceof ArrayBuffer && change_entry_0.BYTES_PER_ELEMENT === 1 && change_entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 9',
                                 'account.compact line 1176 char 1',
                                 'Bytes<192>',
                                 change_entry_0)
    }
    if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 10',
                                 'account.compact line 1176 char 1',
                                 'Uint<0..18446744073709551616>',
                                 valid_until_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 11',
                                 'account.compact line 1176 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_evm',
                                 'argument 12',
                                 'account.compact line 1176 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_open_swap_shielded_with_evm_0(self_addr_0,
                                                                   address_0,
                                                                   give_color_0,
                                                                   give_amount_0,
                                                                   recipient_kind_0,
                                                                   recipient_0,
                                                                   want_0,
                                                                   want_entry_0,
                                                                   change_entry_0,
                                                                   valid_until_0,
                                                                   coin_0,
                                                                   nonce_value_0);
  },
  challenge_bridge_deposit_start_with_evm: (...args_0) => {
    if (args_0.length !== 10) {
      throw new __compactRuntime.CompactError(`challenge_bridge_deposit_start_with_evm: expected 10 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const erc20_0 = args_0[2];
    const amount_0 = args_0[3];
    const evm_nonce_0 = args_0[4];
    const gas_limit_0 = args_0[5];
    const max_fee_0 = args_0[6];
    const max_priority_fee_0 = args_0[7];
    const key_version_0 = args_0[8];
    const nonce_value_0 = args_0[9];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 1',
                                 'account.compact line 1212 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 2',
                                 'account.compact line 1212 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(erc20_0.buffer instanceof ArrayBuffer && erc20_0.BYTES_PER_ELEMENT === 1 && erc20_0.length === 20)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 3',
                                 'account.compact line 1212 char 1',
                                 'Bytes<20>',
                                 erc20_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 4',
                                 'account.compact line 1212 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 5',
                                 'account.compact line 1212 char 1',
                                 'Uint<0..18446744073709551616>',
                                 evm_nonce_0)
    }
    if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 6',
                                 'account.compact line 1212 char 1',
                                 'Uint<0..18446744073709551616>',
                                 gas_limit_0)
    }
    if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 7',
                                 'account.compact line 1212 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_fee_0)
    }
    if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 8',
                                 'account.compact line 1212 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_priority_fee_0)
    }
    if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 9',
                                 'account.compact line 1212 char 1',
                                 'Uint<0..256>',
                                 key_version_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_deposit_start_with_evm',
                                 'argument 10',
                                 'account.compact line 1212 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_bridge_deposit_start_with_evm_0(self_addr_0,
                                                                     address_0,
                                                                     erc20_0,
                                                                     amount_0,
                                                                     evm_nonce_0,
                                                                     gas_limit_0,
                                                                     max_fee_0,
                                                                     max_priority_fee_0,
                                                                     key_version_0,
                                                                     nonce_value_0);
  },
  challenge_bridge_withdraw_start_with_evm: (...args_0) => {
    if (args_0.length !== 13) {
      throw new __compactRuntime.CompactError(`challenge_bridge_withdraw_start_with_evm: expected 13 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const address_0 = args_0[1];
    const dest_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const evm_nonce_0 = args_0[5];
    const gas_limit_0 = args_0[6];
    const max_fee_0 = args_0[7];
    const max_priority_fee_0 = args_0[8];
    const key_version_0 = args_0[9];
    const erc20_0 = args_0[10];
    const coin_0 = args_0[11];
    const nonce_value_0 = args_0[12];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 1',
                                 'account.compact line 1255 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(address_0.buffer instanceof ArrayBuffer && address_0.BYTES_PER_ELEMENT === 1 && address_0.length === 20)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 2',
                                 'account.compact line 1255 char 1',
                                 'Bytes<20>',
                                 address_0)
    }
    if (!(dest_0.buffer instanceof ArrayBuffer && dest_0.BYTES_PER_ELEMENT === 1 && dest_0.length === 20)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 3',
                                 'account.compact line 1255 char 1',
                                 'Bytes<20>',
                                 dest_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 4',
                                 'account.compact line 1255 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 5',
                                 'account.compact line 1255 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(evm_nonce_0) === 'bigint' && evm_nonce_0 >= 0n && evm_nonce_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 6',
                                 'account.compact line 1255 char 1',
                                 'Uint<0..18446744073709551616>',
                                 evm_nonce_0)
    }
    if (!(typeof(gas_limit_0) === 'bigint' && gas_limit_0 >= 0n && gas_limit_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 7',
                                 'account.compact line 1255 char 1',
                                 'Uint<0..18446744073709551616>',
                                 gas_limit_0)
    }
    if (!(typeof(max_fee_0) === 'bigint' && max_fee_0 >= 0n && max_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 8',
                                 'account.compact line 1255 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_fee_0)
    }
    if (!(typeof(max_priority_fee_0) === 'bigint' && max_priority_fee_0 >= 0n && max_priority_fee_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 9',
                                 'account.compact line 1255 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 max_priority_fee_0)
    }
    if (!(typeof(key_version_0) === 'bigint' && key_version_0 >= 0n && key_version_0 <= 255n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 10',
                                 'account.compact line 1255 char 1',
                                 'Uint<0..256>',
                                 key_version_0)
    }
    if (!(erc20_0.buffer instanceof ArrayBuffer && erc20_0.BYTES_PER_ELEMENT === 1 && erc20_0.length === 20)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 11',
                                 'account.compact line 1255 char 1',
                                 'Bytes<20>',
                                 erc20_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 12',
                                 'account.compact line 1255 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_bridge_withdraw_start_with_evm',
                                 'argument 13',
                                 'account.compact line 1255 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_bridge_withdraw_start_with_evm_0(self_addr_0,
                                                                      address_0,
                                                                      dest_0,
                                                                      color_0,
                                                                      amount_0,
                                                                      evm_nonce_0,
                                                                      gas_limit_0,
                                                                      max_fee_0,
                                                                      max_priority_fee_0,
                                                                      key_version_0,
                                                                      erc20_0,
                                                                      coin_0,
                                                                      nonce_value_0);
  },
  assert_open_swap_terms: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`assert_open_swap_terms: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const give_color_0 = args_0[0];
    const give_amount_0 = args_0[1];
    const recipient_kind_0 = args_0[2];
    const recipient_0 = args_0[3];
    const want_0 = args_0[4];
    const coin_color_0 = args_0[5];
    const coin_value_0 = args_0[6];
    if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 1',
                                 'account.compact line 1546 char 1',
                                 'Bytes<32>',
                                 give_color_0)
    }
    if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 2',
                                 'account.compact line 1546 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 give_amount_0)
    }
    if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 3',
                                 'account.compact line 1546 char 1',
                                 'Uint<0..256>',
                                 recipient_kind_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 4',
                                 'account.compact line 1546 char 1',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(typeof(want_0) === 'object' && want_0.nonce.buffer instanceof ArrayBuffer && want_0.nonce.BYTES_PER_ELEMENT === 1 && want_0.nonce.length === 32 && want_0.color.buffer instanceof ArrayBuffer && want_0.color.BYTES_PER_ELEMENT === 1 && want_0.color.length === 32 && typeof(want_0.value) === 'bigint' && want_0.value >= 0n && want_0.value <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 5',
                                 'account.compact line 1546 char 1',
                                 'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                 want_0)
    }
    if (!(coin_color_0.buffer instanceof ArrayBuffer && coin_color_0.BYTES_PER_ELEMENT === 1 && coin_color_0.length === 32)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 6',
                                 'account.compact line 1546 char 1',
                                 'Bytes<32>',
                                 coin_color_0)
    }
    if (!(typeof(coin_value_0) === 'bigint' && coin_value_0 >= 0n && coin_value_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('assert_open_swap_terms',
                                 'argument 7',
                                 'account.compact line 1546 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 coin_value_0)
    }
    return _dummyContract._assert_open_swap_terms_0(give_color_0,
                                                    give_amount_0,
                                                    recipient_kind_0,
                                                    recipient_0,
                                                    want_0,
                                                    coin_color_0,
                                                    coin_value_0);
  },
  swap_change_nonce: (...args_0) => {
    if (args_0.length !== 1) {
      throw new __compactRuntime.CompactError(`swap_change_nonce: expected 1 argument (as invoked from Typescript), received ${args_0.length}`);
    }
    const coin_nonce_0 = args_0[0];
    if (!(coin_nonce_0.buffer instanceof ArrayBuffer && coin_nonce_0.BYTES_PER_ELEMENT === 1 && coin_nonce_0.length === 32)) {
      __compactRuntime.typeError('swap_change_nonce',
                                 'argument 1',
                                 'account.compact line 1585 char 1',
                                 'Bytes<32>',
                                 coin_nonce_0)
    }
    return _dummyContract._swap_change_nonce_0(coin_nonce_0);
  },
  derive_boot_commitment_with_ed25519: (...args_0) => {
    if (args_0.length !== 2) {
      throw new __compactRuntime.CompactError(`derive_boot_commitment_with_ed25519: expected 2 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const salt_0 = args_0[0];
    const pk_0 = args_0[1];
    if (!(salt_0.buffer instanceof ArrayBuffer && salt_0.BYTES_PER_ELEMENT === 1 && salt_0.length === 32)) {
      __compactRuntime.typeError('derive_boot_commitment_with_ed25519',
                                 'argument 1',
                                 'account.compact line 2437 char 1',
                                 'Bytes<32>',
                                 salt_0)
    }
    if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
      __compactRuntime.typeError('derive_boot_commitment_with_ed25519',
                                 'argument 2',
                                 'account.compact line 2437 char 1',
                                 'Curve25519Point',
                                 pk_0)
    }
    return _dummyContract._derive_boot_commitment_with_ed25519_0(salt_0, pk_0);
  },
  derive_device_entry_with_ed25519: (...args_0) => {
    if (args_0.length !== 4) {
      throw new __compactRuntime.CompactError(`derive_device_entry_with_ed25519: expected 4 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const epoch_0 = args_0[2];
    const counter_0 = args_0[3];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('derive_device_entry_with_ed25519',
                                 'argument 1',
                                 'account.compact line 2443 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
      __compactRuntime.typeError('derive_device_entry_with_ed25519',
                                 'argument 2',
                                 'account.compact line 2443 char 1',
                                 'Curve25519Point',
                                 pk_0)
    }
    if (!(typeof(epoch_0) === 'bigint' && epoch_0 >= 0n && epoch_0 <= 4294967295n)) {
      __compactRuntime.typeError('derive_device_entry_with_ed25519',
                                 'argument 3',
                                 'account.compact line 2443 char 1',
                                 'Uint<0..4294967296>',
                                 epoch_0)
    }
    if (!(typeof(counter_0) === 'bigint' && counter_0 >= 0n && counter_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('derive_device_entry_with_ed25519',
                                 'argument 4',
                                 'account.compact line 2443 char 1',
                                 'Uint<0..18446744073709551616>',
                                 counter_0)
    }
    return _dummyContract._derive_device_entry_with_ed25519_0(self_addr_0,
                                                              pk_0,
                                                              epoch_0,
                                                              counter_0);
  },
  challenge_withdraw_unshielded_with_ed25519: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_unshielded_with_ed25519: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const network_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const recipient_0 = args_0[5];
    const nonce_value_0 = args_0[6];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_ed25519',
                                 'argument 1',
                                 'account.compact line 2474 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_ed25519',
                                 'argument 2',
                                 'account.compact line 2474 char 1',
                                 'Curve25519Point',
                                 pk_0)
    }
    if (!(network_0.buffer instanceof ArrayBuffer && network_0.BYTES_PER_ELEMENT === 1 && network_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_ed25519',
                                 'argument 3',
                                 'account.compact line 2474 char 1',
                                 'Bytes<32>',
                                 network_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_ed25519',
                                 'argument 4',
                                 'account.compact line 2474 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_ed25519',
                                 'argument 5',
                                 'account.compact line 2474 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_ed25519',
                                 'argument 6',
                                 'account.compact line 2474 char 1',
                                 'struct UserAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_unshielded_with_ed25519',
                                 'argument 7',
                                 'account.compact line 2474 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_unshielded_with_ed25519_0(self_addr_0,
                                                                        pk_0,
                                                                        network_0,
                                                                        color_0,
                                                                        amount_0,
                                                                        recipient_0,
                                                                        nonce_value_0);
  },
  challenge_withdraw_shielded_with_ed25519: (...args_0) => {
    if (args_0.length !== 8) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_with_ed25519: expected 8 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const network_0 = args_0[2];
    const recipient_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const coin_0 = args_0[6];
    const nonce_value_0 = args_0[7];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_ed25519',
                                 'argument 1',
                                 'account.compact line 2484 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_ed25519',
                                 'argument 2',
                                 'account.compact line 2484 char 1',
                                 'Curve25519Point',
                                 pk_0)
    }
    if (!(network_0.buffer instanceof ArrayBuffer && network_0.BYTES_PER_ELEMENT === 1 && network_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_ed25519',
                                 'argument 3',
                                 'account.compact line 2484 char 1',
                                 'Bytes<32>',
                                 network_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_ed25519',
                                 'argument 4',
                                 'account.compact line 2484 char 1',
                                 'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_ed25519',
                                 'argument 5',
                                 'account.compact line 2484 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_ed25519',
                                 'argument 6',
                                 'account.compact line 2484 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_ed25519',
                                 'argument 7',
                                 'account.compact line 2484 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_with_ed25519',
                                 'argument 8',
                                 'account.compact line 2484 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_shielded_with_ed25519_0(self_addr_0,
                                                                      pk_0,
                                                                      network_0,
                                                                      recipient_0,
                                                                      color_0,
                                                                      amount_0,
                                                                      coin_0,
                                                                      nonce_value_0);
  },
  challenge_withdraw_shielded_to_contract_with_ed25519: (...args_0) => {
    if (args_0.length !== 8) {
      throw new __compactRuntime.CompactError(`challenge_withdraw_shielded_to_contract_with_ed25519: expected 8 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const network_0 = args_0[2];
    const recipient_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const coin_0 = args_0[6];
    const nonce_value_0 = args_0[7];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_ed25519',
                                 'argument 1',
                                 'account.compact line 2495 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_ed25519',
                                 'argument 2',
                                 'account.compact line 2495 char 1',
                                 'Curve25519Point',
                                 pk_0)
    }
    if (!(network_0.buffer instanceof ArrayBuffer && network_0.BYTES_PER_ELEMENT === 1 && network_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_ed25519',
                                 'argument 3',
                                 'account.compact line 2495 char 1',
                                 'Bytes<32>',
                                 network_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_ed25519',
                                 'argument 4',
                                 'account.compact line 2495 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_ed25519',
                                 'argument 5',
                                 'account.compact line 2495 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_ed25519',
                                 'argument 6',
                                 'account.compact line 2495 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_ed25519',
                                 'argument 7',
                                 'account.compact line 2495 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_withdraw_shielded_to_contract_with_ed25519',
                                 'argument 8',
                                 'account.compact line 2495 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_withdraw_shielded_to_contract_with_ed25519_0(self_addr_0,
                                                                                  pk_0,
                                                                                  network_0,
                                                                                  recipient_0,
                                                                                  color_0,
                                                                                  amount_0,
                                                                                  coin_0,
                                                                                  nonce_value_0);
  },
  challenge_append_inbox_with_ed25519: (...args_0) => {
    if (args_0.length !== 5) {
      throw new __compactRuntime.CompactError(`challenge_append_inbox_with_ed25519: expected 5 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const network_0 = args_0[2];
    const entry_0 = args_0[3];
    const nonce_value_0 = args_0[4];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_append_inbox_with_ed25519',
                                 'argument 1',
                                 'account.compact line 2506 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
      __compactRuntime.typeError('challenge_append_inbox_with_ed25519',
                                 'argument 2',
                                 'account.compact line 2506 char 1',
                                 'Curve25519Point',
                                 pk_0)
    }
    if (!(network_0.buffer instanceof ArrayBuffer && network_0.BYTES_PER_ELEMENT === 1 && network_0.length === 32)) {
      __compactRuntime.typeError('challenge_append_inbox_with_ed25519',
                                 'argument 3',
                                 'account.compact line 2506 char 1',
                                 'Bytes<32>',
                                 network_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_append_inbox_with_ed25519',
                                 'argument 4',
                                 'account.compact line 2506 char 1',
                                 'Bytes<192>',
                                 entry_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_append_inbox_with_ed25519',
                                 'argument 5',
                                 'account.compact line 2506 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_append_inbox_with_ed25519_0(self_addr_0,
                                                                 pk_0,
                                                                 network_0,
                                                                 entry_0,
                                                                 nonce_value_0);
  },
  challenge_rotate_enc_key_with_ed25519: (...args_0) => {
    if (args_0.length !== 5) {
      throw new __compactRuntime.CompactError(`challenge_rotate_enc_key_with_ed25519: expected 5 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const network_0 = args_0[2];
    const new_key_0 = args_0[3];
    const nonce_value_0 = args_0[4];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_ed25519',
                                 'argument 1',
                                 'account.compact line 2516 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_ed25519',
                                 'argument 2',
                                 'account.compact line 2516 char 1',
                                 'Curve25519Point',
                                 pk_0)
    }
    if (!(network_0.buffer instanceof ArrayBuffer && network_0.BYTES_PER_ELEMENT === 1 && network_0.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_ed25519',
                                 'argument 3',
                                 'account.compact line 2516 char 1',
                                 'Bytes<32>',
                                 network_0)
    }
    if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_ed25519',
                                 'argument 4',
                                 'account.compact line 2516 char 1',
                                 'Bytes<32>',
                                 new_key_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_rotate_enc_key_with_ed25519',
                                 'argument 5',
                                 'account.compact line 2516 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_rotate_enc_key_with_ed25519_0(self_addr_0,
                                                                   pk_0,
                                                                   network_0,
                                                                   new_key_0,
                                                                   nonce_value_0);
  },
  challenge_open_swap_shielded_with_ed25519: (...args_0) => {
    if (args_0.length !== 13) {
      throw new __compactRuntime.CompactError(`challenge_open_swap_shielded_with_ed25519: expected 13 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const pk_0 = args_0[1];
    const network_0 = args_0[2];
    const give_color_0 = args_0[3];
    const give_amount_0 = args_0[4];
    const recipient_kind_0 = args_0[5];
    const recipient_0 = args_0[6];
    const want_0 = args_0[7];
    const want_entry_0 = args_0[8];
    const change_entry_0 = args_0[9];
    const valid_until_0 = args_0[10];
    const coin_0 = args_0[11];
    const nonce_value_0 = args_0[12];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_ed25519',
                                 'argument 1',
                                 'account.compact line 2528 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(__compactRuntime.isValidCurve25519Point(pk_0))) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_ed25519',
                                 'argument 2',
                                 'account.compact line 2528 char 1',
                                 'Curve25519Point',
                                 pk_0)
    }
    if (!(network_0.buffer instanceof ArrayBuffer && network_0.BYTES_PER_ELEMENT === 1 && network_0.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_ed25519',
                                 'argument 3',
                                 'account.compact line 2528 char 1',
                                 'Bytes<32>',
                                 network_0)
    }
    if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_ed25519',
                                 'argument 4',
                                 'account.compact line 2528 char 1',
                                 'Bytes<32>',
                                 give_color_0)
    }
    if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_ed25519',
                                 'argument 5',
                                 'account.compact line 2528 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 give_amount_0)
    }
    if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_ed25519',
                                 'argument 6',
                                 'account.compact line 2528 char 1',
                                 'Uint<0..256>',
                                 recipient_kind_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_ed25519',
                                 'argument 7',
                                 'account.compact line 2528 char 1',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(typeof(want_0) === 'object' && want_0.nonce.buffer instanceof ArrayBuffer && want_0.nonce.BYTES_PER_ELEMENT === 1 && want_0.nonce.length === 32 && want_0.color.buffer instanceof ArrayBuffer && want_0.color.BYTES_PER_ELEMENT === 1 && want_0.color.length === 32 && typeof(want_0.value) === 'bigint' && want_0.value >= 0n && want_0.value <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_ed25519',
                                 'argument 8',
                                 'account.compact line 2528 char 1',
                                 'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                 want_0)
    }
    if (!(want_entry_0.buffer instanceof ArrayBuffer && want_entry_0.BYTES_PER_ELEMENT === 1 && want_entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_ed25519',
                                 'argument 9',
                                 'account.compact line 2528 char 1',
                                 'Bytes<192>',
                                 want_entry_0)
    }
    if (!(change_entry_0.buffer instanceof ArrayBuffer && change_entry_0.BYTES_PER_ELEMENT === 1 && change_entry_0.length === 192)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_ed25519',
                                 'argument 10',
                                 'account.compact line 2528 char 1',
                                 'Bytes<192>',
                                 change_entry_0)
    }
    if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_ed25519',
                                 'argument 11',
                                 'account.compact line 2528 char 1',
                                 'Uint<0..18446744073709551616>',
                                 valid_until_0)
    }
    if (!(typeof(coin_0) === 'object' && coin_0.nonce.buffer instanceof ArrayBuffer && coin_0.nonce.BYTES_PER_ELEMENT === 1 && coin_0.nonce.length === 32 && coin_0.color.buffer instanceof ArrayBuffer && coin_0.color.BYTES_PER_ELEMENT === 1 && coin_0.color.length === 32 && typeof(coin_0.value) === 'bigint' && coin_0.value >= 0n && coin_0.value <= 340282366920938463463374607431768211455n && typeof(coin_0.mt_index) === 'bigint' && coin_0.mt_index >= 0n && coin_0.mt_index <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_ed25519',
                                 'argument 12',
                                 'account.compact line 2528 char 1',
                                 'struct QualifiedShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>, mt_index: Uint<0..18446744073709551616>>',
                                 coin_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('challenge_open_swap_shielded_with_ed25519',
                                 'argument 13',
                                 'account.compact line 2528 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    return _dummyContract._challenge_open_swap_shielded_with_ed25519_0(self_addr_0,
                                                                       pk_0,
                                                                       network_0,
                                                                       give_color_0,
                                                                       give_amount_0,
                                                                       recipient_kind_0,
                                                                       recipient_0,
                                                                       want_0,
                                                                       want_entry_0,
                                                                       change_entry_0,
                                                                       valid_until_0,
                                                                       coin_0,
                                                                       nonce_value_0);
  },
  ed25519_message_withdraw_unshielded: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`ed25519_message_withdraw_unshielded: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const challenge_0 = args_0[1];
    const nonce_value_0 = args_0[2];
    const color_0 = args_0[3];
    const amount_0 = args_0[4];
    const recipient_0 = args_0[5];
    const show_0 = args_0[6];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('ed25519_message_withdraw_unshielded',
                                 'argument 1',
                                 'account.compact line 2729 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('ed25519_message_withdraw_unshielded',
                                 'argument 2',
                                 'account.compact line 2729 char 1',
                                 'Bytes<32>',
                                 challenge_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('ed25519_message_withdraw_unshielded',
                                 'argument 3',
                                 'account.compact line 2729 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('ed25519_message_withdraw_unshielded',
                                 'argument 4',
                                 'account.compact line 2729 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('ed25519_message_withdraw_unshielded',
                                 'argument 5',
                                 'account.compact line 2729 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('ed25519_message_withdraw_unshielded',
                                 'argument 6',
                                 'account.compact line 2729 char 1',
                                 'struct UserAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(typeof(show_0) === 'object' && Array.isArray(show_0.label) && show_0.label.length === 24 && show_0.label.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.nonce) && show_0.nonce.length === 20 && show_0.nonce.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.amount) === 'object' && Array.isArray(show_0.amount.units) && show_0.amount.units.length === 24 && show_0.amount.units.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.amount.site) && show_0.amount.site.length === 34 && show_0.amount.site.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n))) {
      __compactRuntime.typeError('ed25519_message_withdraw_unshielded',
                                 'argument 7',
                                 'account.compact line 2729 char 1',
                                 'struct EdShowAmount<label: Vector<24, Uint<0..256>>, nonce: Vector<20, Uint<0..256>>, amount: struct EdAmount<units: Vector<24, Uint<0..256>>, site: Vector<34, Uint<0..256>>>>',
                                 show_0)
    }
    return _dummyContract._ed25519_message_withdraw_unshielded_0(self_addr_0,
                                                                 challenge_0,
                                                                 nonce_value_0,
                                                                 color_0,
                                                                 amount_0,
                                                                 recipient_0,
                                                                 show_0);
  },
  ed25519_message_withdraw_shielded: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`ed25519_message_withdraw_shielded: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const challenge_0 = args_0[1];
    const nonce_value_0 = args_0[2];
    const recipient_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const show_0 = args_0[6];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded',
                                 'argument 1',
                                 'account.compact line 2739 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded',
                                 'argument 2',
                                 'account.compact line 2739 char 1',
                                 'Bytes<32>',
                                 challenge_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded',
                                 'argument 3',
                                 'account.compact line 2739 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded',
                                 'argument 4',
                                 'account.compact line 2739 char 1',
                                 'struct ZswapCoinPublicKey<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded',
                                 'argument 5',
                                 'account.compact line 2739 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded',
                                 'argument 6',
                                 'account.compact line 2739 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(show_0) === 'object' && Array.isArray(show_0.label) && show_0.label.length === 24 && show_0.label.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.nonce) && show_0.nonce.length === 20 && show_0.nonce.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.amount) === 'object' && Array.isArray(show_0.amount.units) && show_0.amount.units.length === 24 && show_0.amount.units.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.amount.site) && show_0.amount.site.length === 34 && show_0.amount.site.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n))) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded',
                                 'argument 7',
                                 'account.compact line 2739 char 1',
                                 'struct EdShowAmount<label: Vector<24, Uint<0..256>>, nonce: Vector<20, Uint<0..256>>, amount: struct EdAmount<units: Vector<24, Uint<0..256>>, site: Vector<34, Uint<0..256>>>>',
                                 show_0)
    }
    return _dummyContract._ed25519_message_withdraw_shielded_0(self_addr_0,
                                                               challenge_0,
                                                               nonce_value_0,
                                                               recipient_0,
                                                               color_0,
                                                               amount_0,
                                                               show_0);
  },
  ed25519_message_withdraw_shielded_to_contract: (...args_0) => {
    if (args_0.length !== 7) {
      throw new __compactRuntime.CompactError(`ed25519_message_withdraw_shielded_to_contract: expected 7 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const challenge_0 = args_0[1];
    const nonce_value_0 = args_0[2];
    const recipient_0 = args_0[3];
    const color_0 = args_0[4];
    const amount_0 = args_0[5];
    const show_0 = args_0[6];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded_to_contract',
                                 'argument 1',
                                 'account.compact line 2749 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded_to_contract',
                                 'argument 2',
                                 'account.compact line 2749 char 1',
                                 'Bytes<32>',
                                 challenge_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded_to_contract',
                                 'argument 3',
                                 'account.compact line 2749 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(typeof(recipient_0) === 'object' && recipient_0.bytes.buffer instanceof ArrayBuffer && recipient_0.bytes.BYTES_PER_ELEMENT === 1 && recipient_0.bytes.length === 32)) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded_to_contract',
                                 'argument 4',
                                 'account.compact line 2749 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 recipient_0)
    }
    if (!(color_0.buffer instanceof ArrayBuffer && color_0.BYTES_PER_ELEMENT === 1 && color_0.length === 32)) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded_to_contract',
                                 'argument 5',
                                 'account.compact line 2749 char 1',
                                 'Bytes<32>',
                                 color_0)
    }
    if (!(typeof(amount_0) === 'bigint' && amount_0 >= 0n && amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded_to_contract',
                                 'argument 6',
                                 'account.compact line 2749 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 amount_0)
    }
    if (!(typeof(show_0) === 'object' && Array.isArray(show_0.label) && show_0.label.length === 24 && show_0.label.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.nonce) && show_0.nonce.length === 20 && show_0.nonce.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.amount) === 'object' && Array.isArray(show_0.amount.units) && show_0.amount.units.length === 24 && show_0.amount.units.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.amount.site) && show_0.amount.site.length === 34 && show_0.amount.site.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n))) {
      __compactRuntime.typeError('ed25519_message_withdraw_shielded_to_contract',
                                 'argument 7',
                                 'account.compact line 2749 char 1',
                                 'struct EdShowAmount<label: Vector<24, Uint<0..256>>, nonce: Vector<20, Uint<0..256>>, amount: struct EdAmount<units: Vector<24, Uint<0..256>>, site: Vector<34, Uint<0..256>>>>',
                                 show_0)
    }
    return _dummyContract._ed25519_message_withdraw_shielded_to_contract_0(self_addr_0,
                                                                           challenge_0,
                                                                           nonce_value_0,
                                                                           recipient_0,
                                                                           color_0,
                                                                           amount_0,
                                                                           show_0);
  },
  ed25519_message_append_inbox: (...args_0) => {
    if (args_0.length !== 5) {
      throw new __compactRuntime.CompactError(`ed25519_message_append_inbox: expected 5 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const challenge_0 = args_0[1];
    const nonce_value_0 = args_0[2];
    const entry_0 = args_0[3];
    const show_0 = args_0[4];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('ed25519_message_append_inbox',
                                 'argument 1',
                                 'account.compact line 2759 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('ed25519_message_append_inbox',
                                 'argument 2',
                                 'account.compact line 2759 char 1',
                                 'Bytes<32>',
                                 challenge_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('ed25519_message_append_inbox',
                                 'argument 3',
                                 'account.compact line 2759 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(entry_0.buffer instanceof ArrayBuffer && entry_0.BYTES_PER_ELEMENT === 1 && entry_0.length === 192)) {
      __compactRuntime.typeError('ed25519_message_append_inbox',
                                 'argument 4',
                                 'account.compact line 2759 char 1',
                                 'Bytes<192>',
                                 entry_0)
    }
    if (!(typeof(show_0) === 'object' && Array.isArray(show_0.label) && show_0.label.length === 24 && show_0.label.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.nonce) && show_0.nonce.length === 20 && show_0.nonce.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n))) {
      __compactRuntime.typeError('ed25519_message_append_inbox',
                                 'argument 5',
                                 'account.compact line 2759 char 1',
                                 'struct EdShow<label: Vector<24, Uint<0..256>>, nonce: Vector<20, Uint<0..256>>>',
                                 show_0)
    }
    return _dummyContract._ed25519_message_append_inbox_0(self_addr_0,
                                                          challenge_0,
                                                          nonce_value_0,
                                                          entry_0,
                                                          show_0);
  },
  ed25519_message_rotate_enc_key: (...args_0) => {
    if (args_0.length !== 6) {
      throw new __compactRuntime.CompactError(`ed25519_message_rotate_enc_key: expected 6 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const challenge_0 = args_0[1];
    const nonce_value_0 = args_0[2];
    const new_key_0 = args_0[3];
    const current_key_0 = args_0[4];
    const show_0 = args_0[5];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('ed25519_message_rotate_enc_key',
                                 'argument 1',
                                 'account.compact line 2770 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('ed25519_message_rotate_enc_key',
                                 'argument 2',
                                 'account.compact line 2770 char 1',
                                 'Bytes<32>',
                                 challenge_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('ed25519_message_rotate_enc_key',
                                 'argument 3',
                                 'account.compact line 2770 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(new_key_0.buffer instanceof ArrayBuffer && new_key_0.BYTES_PER_ELEMENT === 1 && new_key_0.length === 32)) {
      __compactRuntime.typeError('ed25519_message_rotate_enc_key',
                                 'argument 4',
                                 'account.compact line 2770 char 1',
                                 'Bytes<32>',
                                 new_key_0)
    }
    if (!(current_key_0.buffer instanceof ArrayBuffer && current_key_0.BYTES_PER_ELEMENT === 1 && current_key_0.length === 32)) {
      __compactRuntime.typeError('ed25519_message_rotate_enc_key',
                                 'argument 5',
                                 'account.compact line 2770 char 1',
                                 'Bytes<32>',
                                 current_key_0)
    }
    if (!(typeof(show_0) === 'object' && Array.isArray(show_0.label) && show_0.label.length === 24 && show_0.label.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.nonce) && show_0.nonce.length === 20 && show_0.nonce.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n))) {
      __compactRuntime.typeError('ed25519_message_rotate_enc_key',
                                 'argument 6',
                                 'account.compact line 2770 char 1',
                                 'struct EdShow<label: Vector<24, Uint<0..256>>, nonce: Vector<20, Uint<0..256>>>',
                                 show_0)
    }
    return _dummyContract._ed25519_message_rotate_enc_key_0(self_addr_0,
                                                            challenge_0,
                                                            nonce_value_0,
                                                            new_key_0,
                                                            current_key_0,
                                                            show_0);
  },
  ed25519_message_open_swap_shielded: (...args_0) => {
    if (args_0.length !== 10) {
      throw new __compactRuntime.CompactError(`ed25519_message_open_swap_shielded: expected 10 arguments (as invoked from Typescript), received ${args_0.length}`);
    }
    const self_addr_0 = args_0[0];
    const challenge_0 = args_0[1];
    const nonce_value_0 = args_0[2];
    const give_color_0 = args_0[3];
    const give_amount_0 = args_0[4];
    const recipient_kind_0 = args_0[5];
    const recipient_0 = args_0[6];
    const want_0 = args_0[7];
    const valid_until_0 = args_0[8];
    const show_0 = args_0[9];
    if (!(typeof(self_addr_0) === 'object' && self_addr_0.bytes.buffer instanceof ArrayBuffer && self_addr_0.bytes.BYTES_PER_ELEMENT === 1 && self_addr_0.bytes.length === 32)) {
      __compactRuntime.typeError('ed25519_message_open_swap_shielded',
                                 'argument 1',
                                 'account.compact line 2789 char 1',
                                 'struct ContractAddress<bytes: Bytes<32>>',
                                 self_addr_0)
    }
    if (!(challenge_0.buffer instanceof ArrayBuffer && challenge_0.BYTES_PER_ELEMENT === 1 && challenge_0.length === 32)) {
      __compactRuntime.typeError('ed25519_message_open_swap_shielded',
                                 'argument 2',
                                 'account.compact line 2789 char 1',
                                 'Bytes<32>',
                                 challenge_0)
    }
    if (!(typeof(nonce_value_0) === 'bigint' && nonce_value_0 >= 0n && nonce_value_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('ed25519_message_open_swap_shielded',
                                 'argument 3',
                                 'account.compact line 2789 char 1',
                                 'Uint<0..18446744073709551616>',
                                 nonce_value_0)
    }
    if (!(give_color_0.buffer instanceof ArrayBuffer && give_color_0.BYTES_PER_ELEMENT === 1 && give_color_0.length === 32)) {
      __compactRuntime.typeError('ed25519_message_open_swap_shielded',
                                 'argument 4',
                                 'account.compact line 2789 char 1',
                                 'Bytes<32>',
                                 give_color_0)
    }
    if (!(typeof(give_amount_0) === 'bigint' && give_amount_0 >= 0n && give_amount_0 <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('ed25519_message_open_swap_shielded',
                                 'argument 5',
                                 'account.compact line 2789 char 1',
                                 'Uint<0..340282366920938463463374607431768211456>',
                                 give_amount_0)
    }
    if (!(typeof(recipient_kind_0) === 'bigint' && recipient_kind_0 >= 0n && recipient_kind_0 <= 255n)) {
      __compactRuntime.typeError('ed25519_message_open_swap_shielded',
                                 'argument 6',
                                 'account.compact line 2789 char 1',
                                 'Uint<0..256>',
                                 recipient_kind_0)
    }
    if (!(recipient_0.buffer instanceof ArrayBuffer && recipient_0.BYTES_PER_ELEMENT === 1 && recipient_0.length === 32)) {
      __compactRuntime.typeError('ed25519_message_open_swap_shielded',
                                 'argument 7',
                                 'account.compact line 2789 char 1',
                                 'Bytes<32>',
                                 recipient_0)
    }
    if (!(typeof(want_0) === 'object' && want_0.nonce.buffer instanceof ArrayBuffer && want_0.nonce.BYTES_PER_ELEMENT === 1 && want_0.nonce.length === 32 && want_0.color.buffer instanceof ArrayBuffer && want_0.color.BYTES_PER_ELEMENT === 1 && want_0.color.length === 32 && typeof(want_0.value) === 'bigint' && want_0.value >= 0n && want_0.value <= 340282366920938463463374607431768211455n)) {
      __compactRuntime.typeError('ed25519_message_open_swap_shielded',
                                 'argument 8',
                                 'account.compact line 2789 char 1',
                                 'struct ShieldedCoinInfo<nonce: Bytes<32>, color: Bytes<32>, value: Uint<0..340282366920938463463374607431768211456>>',
                                 want_0)
    }
    if (!(typeof(valid_until_0) === 'bigint' && valid_until_0 >= 0n && valid_until_0 <= 18446744073709551615n)) {
      __compactRuntime.typeError('ed25519_message_open_swap_shielded',
                                 'argument 9',
                                 'account.compact line 2789 char 1',
                                 'Uint<0..18446744073709551616>',
                                 valid_until_0)
    }
    if (!(typeof(show_0) === 'object' && Array.isArray(show_0.label) && show_0.label.length === 24 && show_0.label.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.nonce) && show_0.nonce.length === 20 && show_0.nonce.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.give) === 'object' && Array.isArray(show_0.give.units) && show_0.give.units.length === 24 && show_0.give.units.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.give.site) && show_0.give.site.length === 34 && show_0.give.site.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.want) === 'object' && Array.isArray(show_0.want.units) && show_0.want.units.length === 24 && show_0.want.units.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && Array.isArray(show_0.want.site) && show_0.want.site.length === 34 && show_0.want.site.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.until) === 'object' && Array.isArray(show_0.until.digits) && show_0.until.digits.length === 14 && show_0.until.digits.every((t) => typeof(t) === 'bigint' && t >= 0n && t <= 255n) && typeof(show_0.until.q4) === 'bigint' && show_0.until.q4 >= 0n && show_0.until.q4 <= 65535n && typeof(show_0.until.q100) === 'bigint' && show_0.until.q100 >= 0n && show_0.until.q100 <= 65535n && typeof(show_0.until.q400) === 'bigint' && show_0.until.q400 >= 0n && show_0.until.q400 <= 65535n)) {
      __compactRuntime.typeError('ed25519_message_open_swap_shielded',
                                 'argument 10',
                                 'account.compact line 2789 char 1',
                                 'struct EdShowSwap<label: Vector<24, Uint<0..256>>, nonce: Vector<20, Uint<0..256>>, give: struct EdAmount<units: Vector<24, Uint<0..256>>, site: Vector<34, Uint<0..256>>>, want: struct EdAmount<units: Vector<24, Uint<0..256>>, site: Vector<34, Uint<0..256>>>, until: struct EdDeadline<digits: Vector<14, Uint<0..256>>, q4: Uint<0..65536>, q100: Uint<0..65536>, q400: Uint<0..65536>>>',
                                 show_0)
    }
    return _dummyContract._ed25519_message_open_swap_shielded_0(self_addr_0,
                                                                challenge_0,
                                                                nonce_value_0,
                                                                give_color_0,
                                                                give_amount_0,
                                                                recipient_kind_0,
                                                                recipient_0,
                                                                want_0,
                                                                valid_until_0,
                                                                show_0);
  }
};
export const expectedVk = {};

export const circuitSignatures = {
  'evm_account_alias': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 20}},
  'evm_domain_separator_for': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_struct_hash_withdraw_unshielded': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_struct_hash_withdraw_shielded': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_struct_hash_withdraw_shielded_to_contract': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_struct_hash_append_inbox': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_struct_hash_rotate_enc_key': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_struct_hash_add_device': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_struct_hash_remove_device': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_struct_hash_open_swap_shielded': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_struct_hash_bridge_deposit_start': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_struct_hash_bridge_withdraw_start': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 20}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_digest_withdraw_unshielded': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_digest_withdraw_shielded': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_digest_withdraw_shielded_to_contract': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_digest_append_inbox': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_digest_rotate_enc_key': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_digest_add_device': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_digest_open_swap_shielded': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_digest_remove_device': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_digest_bridge_deposit_start': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'evm_digest_bridge_withdraw_start': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 20}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'zswapNullifierOf': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}], resultType: {tag: 'Bytes', length: 32}},
  'zswapCommitmentOf': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Struct', name: 'Either', elements: [{name: 'is_left', type: {tag: 'Boolean'}}, {name: 'left', type: {tag: 'Struct', name: 'ZswapCoinPublicKey', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}}, {name: 'right', type: {tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}}]}], resultType: {tag: 'Bytes', length: 32}},
  'activate_initial_device_with_jubjub': {pure: false, provable: true, argumentTypes: [{tag: 'JubjubPoint'}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Tuple', types: []}},
  'activate_initial_device_with_k256': {pure: false, provable: true, argumentTypes: [{tag: 'Secp256k1Point'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '255'}], resultType: {tag: 'Tuple', types: []}},
  'activate_initial_device_with_evm': {pure: false, provable: true, argumentTypes: [{tag: 'Secp256k1Point'}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Tuple', types: []}},
  'derive_boot_commitment_with_jubjub': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'JubjubPoint'}], resultType: {tag: 'Bytes', length: 32}},
  'derive_boot_commitment_with_k256': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '255'}], resultType: {tag: 'Bytes', length: 32}},
  'derive_boot_commitment_with_evm': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 20}], resultType: {tag: 'Bytes', length: 32}},
  'derive_device_entry_with_jubjub': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'JubjubPoint'}, {tag: 'Uint', maxval: '4294967295'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'derive_device_entry_with_k256': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '255'}, {tag: 'Uint', maxval: '4294967295'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'derive_device_entry_with_evm': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '4294967295'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'envelope_digest': {pure: true, provable: false, argumentTypes: [{tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'compute_public_point_with_jubjub': {pure: true, provable: false, argumentTypes: [{tag: 'Field'}], resultType: {tag: 'JubjubPoint'}},
  'compute_public_point_with_k256': {pure: true, provable: false, argumentTypes: [{tag: 'Secp256k1Scalar'}], resultType: {tag: 'Secp256k1Point'}},
  'challenge_withdraw_unshielded_with_jubjub': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'JubjubPoint'}, {tag: 'JubjubPoint'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'UserAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_withdraw_shielded_with_jubjub': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'JubjubPoint'}, {tag: 'JubjubPoint'}, {tag: 'Struct', name: 'ZswapCoinPublicKey', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'QualifiedShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}, {name: 'mt_index', type: {tag: 'Uint', maxval: '18446744073709551615'}}]}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_withdraw_shielded_to_contract_with_jubjub': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'JubjubPoint'}, {tag: 'JubjubPoint'}, {tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'QualifiedShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}, {name: 'mt_index', type: {tag: 'Uint', maxval: '18446744073709551615'}}]}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_append_inbox_with_jubjub': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'JubjubPoint'}, {tag: 'JubjubPoint'}, {tag: 'Bytes', length: 192}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_rotate_enc_key_with_jubjub': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'JubjubPoint'}, {tag: 'JubjubPoint'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_add_device_with_jubjub': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'JubjubPoint'}, {tag: 'JubjubPoint'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_remove_device_with_jubjub': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'JubjubPoint'}, {tag: 'JubjubPoint'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_open_swap_shielded_with_jubjub': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'JubjubPoint'}, {tag: 'JubjubPoint'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}, {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Bytes', length: 192}, {tag: 'Bytes', length: 192}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'QualifiedShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}, {name: 'mt_index', type: {tag: 'Uint', maxval: '18446744073709551615'}}]}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_withdraw_unshielded_with_k256': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Secp256k1Point'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'UserAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_withdraw_shielded_with_k256': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Secp256k1Point'}, {tag: 'Struct', name: 'ZswapCoinPublicKey', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'QualifiedShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}, {name: 'mt_index', type: {tag: 'Uint', maxval: '18446744073709551615'}}]}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_withdraw_shielded_to_contract_with_k256': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Secp256k1Point'}, {tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'QualifiedShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}, {name: 'mt_index', type: {tag: 'Uint', maxval: '18446744073709551615'}}]}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_append_inbox_with_k256': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Secp256k1Point'}, {tag: 'Bytes', length: 192}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_rotate_enc_key_with_k256': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Secp256k1Point'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_add_device_with_k256': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Secp256k1Point'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_remove_device_with_k256': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Secp256k1Point'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_withdraw_unshielded_with_evm': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 20}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'UserAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_withdraw_shielded_with_evm': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 20}, {tag: 'Struct', name: 'ZswapCoinPublicKey', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'QualifiedShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}, {name: 'mt_index', type: {tag: 'Uint', maxval: '18446744073709551615'}}]}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_withdraw_shielded_to_contract_with_evm': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 20}, {tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'QualifiedShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}, {name: 'mt_index', type: {tag: 'Uint', maxval: '18446744073709551615'}}]}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_append_inbox_with_evm': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 20}, {tag: 'Bytes', length: 192}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_rotate_enc_key_with_evm': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 20}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_add_device_with_evm': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 20}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_remove_device_with_evm': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 20}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_open_swap_shielded_with_evm': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 20}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}, {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Bytes', length: 192}, {tag: 'Bytes', length: 192}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'QualifiedShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}, {name: 'mt_index', type: {tag: 'Uint', maxval: '18446744073709551615'}}]}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_bridge_deposit_start_with_evm': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 20}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_bridge_withdraw_start_with_evm': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 20}, {tag: 'Bytes', length: 20}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 20}, {tag: 'Struct', name: 'QualifiedShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}, {name: 'mt_index', type: {tag: 'Uint', maxval: '18446744073709551615'}}]}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'assert_open_swap_terms': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}, {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}], resultType: {tag: 'Tuple', types: []}},
  'swap_change_nonce': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}], resultType: {tag: 'Bytes', length: 32}},
  'deposit_unshielded': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}], resultType: {tag: 'Tuple', types: []}},
  'withdraw_unshielded_with_jubjub': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'UserAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'JubjubPoint'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'JubjubPoint'}, {tag: 'Field'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Tuple', types: []}},
  'withdraw_unshielded_with_k256': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'UserAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}, {tag: 'Uint', maxval: '255'}], resultType: {tag: 'Tuple', types: []}},
  'withdraw_unshielded_with_evm': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'UserAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}], resultType: {tag: 'Tuple', types: []}},
  'deposit_shielded': {pure: false, provable: true, argumentTypes: [{tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Bytes', length: 192}], resultType: {tag: 'Tuple', types: []}},
  'append_inbox_with_jubjub': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 192}, {tag: 'JubjubPoint'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'JubjubPoint'}, {tag: 'Field'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Tuple', types: []}},
  'append_inbox_with_k256': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 192}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}, {tag: 'Uint', maxval: '255'}], resultType: {tag: 'Tuple', types: []}},
  'append_inbox_with_evm': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 192}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}], resultType: {tag: 'Tuple', types: []}},
  'withdraw_shielded_with_jubjub': {pure: false, provable: true, argumentTypes: [{tag: 'Struct', name: 'ZswapCoinPublicKey', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'JubjubPoint'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'JubjubPoint'}, {tag: 'Field'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}},
  'withdraw_shielded_with_k256': {pure: false, provable: true, argumentTypes: [{tag: 'Struct', name: 'ZswapCoinPublicKey', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}, {tag: 'Uint', maxval: '255'}], resultType: {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}},
  'withdraw_shielded_with_evm': {pure: false, provable: true, argumentTypes: [{tag: 'Struct', name: 'ZswapCoinPublicKey', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}], resultType: {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}},
  'withdraw_shielded_to_contract_with_jubjub': {pure: false, provable: true, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'JubjubPoint'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'JubjubPoint'}, {tag: 'Field'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Tuple', types: [{tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}]}},
  'withdraw_shielded_to_contract_with_k256': {pure: false, provable: true, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}, {tag: 'Uint', maxval: '255'}], resultType: {tag: 'Tuple', types: [{tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}]}},
  'withdraw_shielded_to_contract_with_evm': {pure: false, provable: true, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}], resultType: {tag: 'Tuple', types: [{tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}]}},
  'rotate_enc_key_with_jubjub': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'JubjubPoint'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'JubjubPoint'}, {tag: 'Field'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Tuple', types: []}},
  'rotate_enc_key_with_k256': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}, {tag: 'Uint', maxval: '255'}], resultType: {tag: 'Tuple', types: []}},
  'rotate_enc_key_with_evm': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}], resultType: {tag: 'Tuple', types: []}},
  'add_device_with_jubjub': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'JubjubPoint'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'JubjubPoint'}, {tag: 'Field'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Tuple', types: []}},
  'add_device_with_k256': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}, {tag: 'Uint', maxval: '255'}], resultType: {tag: 'Tuple', types: []}},
  'add_device_with_evm': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}], resultType: {tag: 'Tuple', types: []}},
  'remove_device_with_jubjub': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'JubjubPoint'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'JubjubPoint'}, {tag: 'Field'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Tuple', types: []}},
  'remove_device_with_k256': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}, {tag: 'Uint', maxval: '255'}], resultType: {tag: 'Tuple', types: []}},
  'remove_device_with_evm': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}], resultType: {tag: 'Tuple', types: []}},
  'open_swap_shielded_with_jubjub': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}, {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Bytes', length: 192}, {tag: 'Bytes', length: 192}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'JubjubPoint'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'JubjubPoint'}, {tag: 'Field'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}},
  'open_swap_shielded_with_evm': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}, {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Bytes', length: 192}, {tag: 'Bytes', length: 192}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}], resultType: {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}},
  'derive_boot_commitment_with_ed25519': {pure: true, provable: false, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Curve25519Point'}], resultType: {tag: 'Bytes', length: 32}},
  'derive_device_entry_with_ed25519': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Curve25519Point'}, {tag: 'Uint', maxval: '4294967295'}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'activate_initial_device_with_ed25519': {pure: false, provable: true, argumentTypes: [{tag: 'Curve25519Point'}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Tuple', types: []}},
  'challenge_withdraw_unshielded_with_ed25519': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Curve25519Point'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'UserAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_withdraw_shielded_with_ed25519': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Curve25519Point'}, {tag: 'Bytes', length: 32}, {tag: 'Struct', name: 'ZswapCoinPublicKey', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'QualifiedShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}, {name: 'mt_index', type: {tag: 'Uint', maxval: '18446744073709551615'}}]}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_withdraw_shielded_to_contract_with_ed25519': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Curve25519Point'}, {tag: 'Bytes', length: 32}, {tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'QualifiedShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}, {name: 'mt_index', type: {tag: 'Uint', maxval: '18446744073709551615'}}]}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_append_inbox_with_ed25519': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Curve25519Point'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 192}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_rotate_enc_key_with_ed25519': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Curve25519Point'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'challenge_open_swap_shielded_with_ed25519': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Curve25519Point'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}, {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Bytes', length: 192}, {tag: 'Bytes', length: 192}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'QualifiedShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}, {name: 'mt_index', type: {tag: 'Uint', maxval: '18446744073709551615'}}]}, {tag: 'Uint', maxval: '18446744073709551615'}], resultType: {tag: 'Bytes', length: 32}},
  'ed25519_message_withdraw_unshielded': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'UserAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Struct', name: 'EdShowAmount', elements: [{name: 'label', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'nonce', type: {tag: 'Vector', length: 20, type: {tag: 'Uint', maxval: '255'}}}, {name: 'amount', type: {tag: 'Struct', name: 'EdAmount', elements: [{name: 'units', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'site', type: {tag: 'Vector', length: 34, type: {tag: 'Uint', maxval: '255'}}}]}}]}], resultType: {tag: 'Bytes', length: 365}},
  'ed25519_message_withdraw_shielded': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'ZswapCoinPublicKey', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'EdShowAmount', elements: [{name: 'label', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'nonce', type: {tag: 'Vector', length: 20, type: {tag: 'Uint', maxval: '255'}}}, {name: 'amount', type: {tag: 'Struct', name: 'EdAmount', elements: [{name: 'units', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'site', type: {tag: 'Vector', length: 34, type: {tag: 'Uint', maxval: '255'}}}]}}]}], resultType: {tag: 'Bytes', length: 359}},
  'ed25519_message_withdraw_shielded_to_contract': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'EdShowAmount', elements: [{name: 'label', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'nonce', type: {tag: 'Vector', length: 20, type: {tag: 'Uint', maxval: '255'}}}, {name: 'amount', type: {tag: 'Struct', name: 'EdAmount', elements: [{name: 'units', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'site', type: {tag: 'Vector', length: 34, type: {tag: 'Uint', maxval: '255'}}}]}}]}], resultType: {tag: 'Bytes', length: 367}},
  'ed25519_message_append_inbox': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 192}, {tag: 'Struct', name: 'EdShow', elements: [{name: 'label', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'nonce', type: {tag: 'Vector', length: 20, type: {tag: 'Uint', maxval: '255'}}}]}], resultType: {tag: 'Bytes', length: 192}},
  'ed25519_message_rotate_enc_key': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 32}, {tag: 'Struct', name: 'EdShow', elements: [{name: 'label', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'nonce', type: {tag: 'Vector', length: 20, type: {tag: 'Uint', maxval: '255'}}}]}], resultType: {tag: 'Bytes', length: 202}},
  'ed25519_message_open_swap_shielded': {pure: true, provable: false, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}, {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'EdShowSwap', elements: [{name: 'label', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'nonce', type: {tag: 'Vector', length: 20, type: {tag: 'Uint', maxval: '255'}}}, {name: 'give', type: {tag: 'Struct', name: 'EdAmount', elements: [{name: 'units', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'site', type: {tag: 'Vector', length: 34, type: {tag: 'Uint', maxval: '255'}}}]}}, {name: 'want', type: {tag: 'Struct', name: 'EdAmount', elements: [{name: 'units', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'site', type: {tag: 'Vector', length: 34, type: {tag: 'Uint', maxval: '255'}}}]}}, {name: 'until', type: {tag: 'Struct', name: 'EdDeadline', elements: [{name: 'digits', type: {tag: 'Vector', length: 14, type: {tag: 'Uint', maxval: '255'}}}, {name: 'q4', type: {tag: 'Uint', maxval: '65535'}}, {name: 'q100', type: {tag: 'Uint', maxval: '65535'}}, {name: 'q400', type: {tag: 'Uint', maxval: '65535'}}]}}]}], resultType: {tag: 'Bytes', length: 564}},
  'withdraw_unshielded_with_ed25519': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'UserAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Curve25519Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Ed25519Signature', elements: [{name: 'r', type: {tag: 'Curve25519Point'}}, {name: 's', type: {tag: 'Curve25519Scalar'}}]}, {tag: 'Struct', name: 'EdShowAmount', elements: [{name: 'label', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'nonce', type: {tag: 'Vector', length: 20, type: {tag: 'Uint', maxval: '255'}}}, {name: 'amount', type: {tag: 'Struct', name: 'EdAmount', elements: [{name: 'units', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'site', type: {tag: 'Vector', length: 34, type: {tag: 'Uint', maxval: '255'}}}]}}]}], resultType: {tag: 'Tuple', types: []}},
  'append_inbox_with_ed25519': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 192}, {tag: 'Curve25519Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Ed25519Signature', elements: [{name: 'r', type: {tag: 'Curve25519Point'}}, {name: 's', type: {tag: 'Curve25519Scalar'}}]}, {tag: 'Struct', name: 'EdShow', elements: [{name: 'label', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'nonce', type: {tag: 'Vector', length: 20, type: {tag: 'Uint', maxval: '255'}}}]}], resultType: {tag: 'Tuple', types: []}},
  'withdraw_shielded_with_ed25519': {pure: false, provable: true, argumentTypes: [{tag: 'Struct', name: 'ZswapCoinPublicKey', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Curve25519Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Ed25519Signature', elements: [{name: 'r', type: {tag: 'Curve25519Point'}}, {name: 's', type: {tag: 'Curve25519Scalar'}}]}, {tag: 'Struct', name: 'EdShowAmount', elements: [{name: 'label', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'nonce', type: {tag: 'Vector', length: 20, type: {tag: 'Uint', maxval: '255'}}}, {name: 'amount', type: {tag: 'Struct', name: 'EdAmount', elements: [{name: 'units', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'site', type: {tag: 'Vector', length: 34, type: {tag: 'Uint', maxval: '255'}}}]}}]}], resultType: {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}},
  'withdraw_shielded_to_contract_with_ed25519': {pure: false, provable: true, argumentTypes: [{tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Curve25519Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Ed25519Signature', elements: [{name: 'r', type: {tag: 'Curve25519Point'}}, {name: 's', type: {tag: 'Curve25519Scalar'}}]}, {tag: 'Struct', name: 'EdShowAmount', elements: [{name: 'label', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'nonce', type: {tag: 'Vector', length: 20, type: {tag: 'Uint', maxval: '255'}}}, {name: 'amount', type: {tag: 'Struct', name: 'EdAmount', elements: [{name: 'units', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'site', type: {tag: 'Vector', length: 34, type: {tag: 'Uint', maxval: '255'}}}]}}]}], resultType: {tag: 'Tuple', types: [{tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}]}},
  'rotate_enc_key_with_ed25519': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Curve25519Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Ed25519Signature', elements: [{name: 'r', type: {tag: 'Curve25519Point'}}, {name: 's', type: {tag: 'Curve25519Scalar'}}]}, {tag: 'Struct', name: 'EdShow', elements: [{name: 'label', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'nonce', type: {tag: 'Vector', length: 20, type: {tag: 'Uint', maxval: '255'}}}]}], resultType: {tag: 'Tuple', types: []}},
  'open_swap_shielded_with_ed25519': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 32}, {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Bytes', length: 192}, {tag: 'Bytes', length: 192}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Curve25519Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Ed25519Signature', elements: [{name: 'r', type: {tag: 'Curve25519Point'}}, {name: 's', type: {tag: 'Curve25519Scalar'}}]}, {tag: 'Struct', name: 'EdShowSwap', elements: [{name: 'label', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'nonce', type: {tag: 'Vector', length: 20, type: {tag: 'Uint', maxval: '255'}}}, {name: 'give', type: {tag: 'Struct', name: 'EdAmount', elements: [{name: 'units', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'site', type: {tag: 'Vector', length: 34, type: {tag: 'Uint', maxval: '255'}}}]}}, {name: 'want', type: {tag: 'Struct', name: 'EdAmount', elements: [{name: 'units', type: {tag: 'Vector', length: 24, type: {tag: 'Uint', maxval: '255'}}}, {name: 'site', type: {tag: 'Vector', length: 34, type: {tag: 'Uint', maxval: '255'}}}]}}, {name: 'until', type: {tag: 'Struct', name: 'EdDeadline', elements: [{name: 'digits', type: {tag: 'Vector', length: 14, type: {tag: 'Uint', maxval: '255'}}}, {name: 'q4', type: {tag: 'Uint', maxval: '65535'}}, {name: 'q100', type: {tag: 'Uint', maxval: '65535'}}, {name: 'q400', type: {tag: 'Uint', maxval: '65535'}}]}}]}], resultType: {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}},
  'bridge_deposit_start_with_evm': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}], resultType: {tag: 'Tuple', types: []}},
  'bridge_deposit_complete': {pure: false, provable: true, argumentTypes: [{tag: 'Alias', name: 'RequestId', type: {tag: 'Bytes', length: 32}}, {tag: 'Struct', name: 'RespondBidirectionalEvent', elements: [{name: 'signature', type: {tag: 'Struct', name: 'Signature', elements: [{name: 'bigR', type: {tag: 'Struct', name: 'AffinePoint', elements: [{name: 'x', type: {tag: 'Bytes', length: 32}}, {name: 'y', type: {tag: 'Bytes', length: 32}}]}}, {name: 's', type: {tag: 'Bytes', length: 32}}, {name: 'recoveryId', type: {tag: 'Uint', maxval: '255'}}]}}]}, {tag: 'Bytes', length: 1}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 192}], resultType: {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}},
  'bridge_withdraw_start_with_evm': {pure: false, provable: true, argumentTypes: [{tag: 'Bytes', length: 20}, {tag: 'Bytes', length: 32}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 20}, {tag: 'Bytes', length: 192}, {tag: 'Secp256k1Point'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Struct', name: 'Secp256k1EcdsaSignature', elements: [{name: 'r', type: {tag: 'Secp256k1Scalar'}}, {name: 's', type: {tag: 'Secp256k1Scalar'}}]}], resultType: {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}},
  'bridge_withdraw_complete': {pure: false, provable: true, argumentTypes: [{tag: 'Alias', name: 'RequestId', type: {tag: 'Bytes', length: 32}}, {tag: 'Struct', name: 'RespondBidirectionalEvent', elements: [{name: 'signature', type: {tag: 'Struct', name: 'Signature', elements: [{name: 'bigR', type: {tag: 'Struct', name: 'AffinePoint', elements: [{name: 'x', type: {tag: 'Bytes', length: 32}}, {name: 'y', type: {tag: 'Bytes', length: 32}}]}}, {name: 's', type: {tag: 'Bytes', length: 32}}, {name: 'recoveryId', type: {tag: 'Uint', maxval: '255'}}]}}]}, {tag: 'Bytes', length: 1}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 192}], resultType: {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}},
  'bridge_withdraw_refund': {pure: false, provable: true, argumentTypes: [{tag: 'Alias', name: 'RequestId', type: {tag: 'Bytes', length: 32}}, {tag: 'Struct', name: 'RespondBidirectionalEvent', elements: [{name: 'signature', type: {tag: 'Struct', name: 'Signature', elements: [{name: 'bigR', type: {tag: 'Struct', name: 'AffinePoint', elements: [{name: 'x', type: {tag: 'Bytes', length: 32}}, {name: 'y', type: {tag: 'Bytes', length: 32}}]}}, {name: 's', type: {tag: 'Bytes', length: 32}}, {name: 'recoveryId', type: {tag: 'Uint', maxval: '255'}}]}}]}, {tag: 'Bytes', length: 5}, {tag: 'Bytes', length: 32}, {tag: 'Bytes', length: 192}], resultType: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}},
};

export const declaredInterfaces = {
  'Erc20Vault': {'startDeposit': {pure: false, argumentTypes: [{tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Struct', name: 'Either', elements: [{name: 'is_left', type: {tag: 'Boolean'}}, {name: 'left', type: {tag: 'Struct', name: 'ZswapCoinPublicKey', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}}, {name: 'right', type: {tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}}]}], resultType: {tag: 'Tuple', types: []}}, 'completeDeposit': {pure: false, argumentTypes: [{tag: 'Alias', name: 'RequestId', type: {tag: 'Bytes', length: 32}}, {tag: 'Struct', name: 'RespondBidirectionalEvent', elements: [{name: 'signature', type: {tag: 'Struct', name: 'Signature', elements: [{name: 'bigR', type: {tag: 'Struct', name: 'AffinePoint', elements: [{name: 'x', type: {tag: 'Bytes', length: 32}}, {name: 'y', type: {tag: 'Bytes', length: 32}}]}}, {name: 's', type: {tag: 'Bytes', length: 32}}, {name: 'recoveryId', type: {tag: 'Uint', maxval: '255'}}]}}]}, {tag: 'Bytes', length: 1}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}}, 'startWithdraw': {pure: false, argumentTypes: [{tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '18446744073709551615'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Uint', maxval: '255'}, {tag: 'Bytes', length: 20}, {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}, {tag: 'Bytes', length: 20}, {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}, {tag: 'Struct', name: 'Either', elements: [{name: 'is_left', type: {tag: 'Boolean'}}, {name: 'left', type: {tag: 'Struct', name: 'ZswapCoinPublicKey', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}}, {name: 'right', type: {tag: 'Struct', name: 'ContractAddress', elements: [{name: 'bytes', type: {tag: 'Bytes', length: 32}}]}}]}], resultType: {tag: 'Tuple', types: []}}, 'completeWithdraw': {pure: false, argumentTypes: [{tag: 'Alias', name: 'RequestId', type: {tag: 'Bytes', length: 32}}, {tag: 'Struct', name: 'RespondBidirectionalEvent', elements: [{name: 'signature', type: {tag: 'Struct', name: 'Signature', elements: [{name: 'bigR', type: {tag: 'Struct', name: 'AffinePoint', elements: [{name: 'x', type: {tag: 'Bytes', length: 32}}, {name: 'y', type: {tag: 'Bytes', length: 32}}]}}, {name: 's', type: {tag: 'Bytes', length: 32}}, {name: 'recoveryId', type: {tag: 'Uint', maxval: '255'}}]}}]}, {tag: 'Bytes', length: 1}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Struct', name: 'Maybe', elements: [{name: 'is_some', type: {tag: 'Boolean'}}, {name: 'value', type: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}]}}, 'refundWithdraw': {pure: false, argumentTypes: [{tag: 'Alias', name: 'RequestId', type: {tag: 'Bytes', length: 32}}, {tag: 'Struct', name: 'RespondBidirectionalEvent', elements: [{name: 'signature', type: {tag: 'Struct', name: 'Signature', elements: [{name: 'bigR', type: {tag: 'Struct', name: 'AffinePoint', elements: [{name: 'x', type: {tag: 'Bytes', length: 32}}, {name: 'y', type: {tag: 'Bytes', length: 32}}]}}, {name: 's', type: {tag: 'Bytes', length: 32}}, {name: 'recoveryId', type: {tag: 'Uint', maxval: '255'}}]}}]}, {tag: 'Bytes', length: 5}, {tag: 'Bytes', length: 32}], resultType: {tag: 'Struct', name: 'ShieldedCoinInfo', elements: [{name: 'nonce', type: {tag: 'Bytes', length: 32}}, {name: 'color', type: {tag: 'Bytes', length: 32}}, {name: 'value', type: {tag: 'Uint', maxval: '340282366920938463463374607431768211455'}}]}}},
};

//# sourceMappingURL=index.js.map
